import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type AcceptOrderInput = {
  acceptedPONumber?: InputMaybe<Scalars['String']['input']>;
  acceptedProducts?: InputMaybe<Array<AcceptedProductInput>>;
  chatId: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  deliveryDate: Scalars['AWSTimestamp']['input'];
  orderId: Scalars['ID']['input'];
  /** @deprecated use acceptedProducts */
  products?: InputMaybe<Array<OrderedProductInput>>;
  supplierId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  validationMode?: InputMaybe<OrderValidationMode>;
};

export type AcceptOrderResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | InvalidProductsFailure | MinimumOrderableAmountFailure | Order | OrderAlreadyAccepted | OrderCreatedError | OrderValidationFailures | ProductLeadTimeFailure | ProductsUnavailableFailure;

export type AcceptedProduct = {
  __typename?: 'AcceptedProduct';
  acceptedAmount: Scalars['Float']['output'];
  acceptedProductId: Scalars['String']['output'];
  acceptedProductPrice?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['ID']['output'];
  omnichannelOrderId: Scalars['String']['output'];
};

export type AcceptedProductInput = {
  acceptedProductPrice?: InputMaybe<Scalars['Int']['input']>;
  acceptedPurchasedPrice?: InputMaybe<MoneyInput>;
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignoreEdits?: InputMaybe<Array<IgnoreEdits>>;
  /**
   * Flag indicating whether the price for this product was edited by the vendor during order review.
   * When true, it means the vendor modified the original price of the product.
   * The price referenced here is the acceptedProductPrice.
   */
  isPriceEditedByVendor?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use lineItemId */
  parsedProductId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AccessPackage =
  | 'free'
  | 'leadGen'
  | 'premium'
  | 'trial'
  | 'verified'
  | '%future added value';

export type ActionExportMethod =
  | 'POLLING'
  | 'WEBHOOK'
  | '%future added value';

export type Ad = AdInterface & {
  __typename?: 'Ad';
  adMetadata: AdMetadata;
  campaignId: Scalars['String']['output'];
  /** union type of all available ad type custom template contents */
  content: AdContent;
  id: Scalars['ID']['output'];
  /** Buyer segment ID */
  segmentId: Scalars['ID']['output'];
  /** Choco Ad type : Kevel custom template enum */
  tracking: AdTracking;
};

export type AdCategory =
  | 'Info'
  | 'Shoppable'
  | '%future added value';

export type AdContent = MobileHomePageBannerInfoFullWidthContent | MobileHomePageBannerShoppableFullWidthContent | MobileHomePagePopupInfoFullPageContent | MobileOrderGuideBannerShoppableFullWidthContent | MobilePostOrderPopupInfoFullPageContent | WebHomePageBannerInfoFullWidthContent | WebHomePageBannerInfoHalfWidthContent | WebHomePageBannerShoppableFullWidthContent | WebHomePageBannerShoppableHalfWidthContent | WebHomePagePopupInfoFullPageContent | WebPostOrderPopupInfoFullPageContent;

export type AdInterface = {
  adMetadata: AdMetadata;
  campaignId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdMetadata = {
  __typename?: 'AdMetadata';
  /** URL to track ad clicks */
  clickUrl?: Maybe<Scalars['String']['output']>;
  /** URL to track ad impressions */
  impressionUrl?: Maybe<Scalars['String']['output']>;
};

export type AdTracking = {
  __typename?: 'AdTracking';
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
  metadata: AdTrackingMetadata;
};

export type AdTrackingMetadata = {
  __typename?: 'AdTrackingMetadata';
  adCategory: AdCategory;
  adId: Scalars['String']['output'];
  adPlatform: Platform;
  adType: Scalars['String']['output'];
  adZone: AdZone;
  advertiserId: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  buyerId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  creativeId: Scalars['String']['output'];
  flightId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AdZone =
  /** LEGACY! Full page advertisement = PostOrderPopup */
  | 'FullPageAd'
  /** Banner ad displayed on the home page */
  | 'HomePageBanner'
  /** Popup ad displayed on Home Page */
  | 'HomePagePopup'
  /** Banner ad displayed in the order guide */
  | 'OrderGuideBanner'
  /** Popup ad displayed after order is placed */
  | 'PostOrderPopup'
  | '%future added value';

export type AddBuyerStockInventoryProductFailure = {
  __typename?: 'AddBuyerStockInventoryProductFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type AddBuyerStockInventoryProductInput = {
  buyerId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<MoneyInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AddBuyerStockInventoryProductResponse = AddBuyerStockInventoryProductFailure | AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound;

export type AddMarketingProductsToCartInput = {
  /** The amounts of products items to add or remove from the cart */
  amount: Scalars['Float']['input'];
  /** The id of the product */
  productId: Scalars['ID']['input'];
};

export type AddMarketingProductsToCartResponse = AddMarketingProductsToCartSuccess | AuthorizationFailure | InputValidationFailure;

export type AddMarketingProductsToCartSuccess = {
  __typename?: 'AddMarketingProductsToCartSuccess';
  responseType: ResponseType;
  teamCartData: AddMarketingProductsToCartTeamCartData;
};

export type AddMarketingProductsToCartTeamCartData = TeamCartExists | TeamCartNotFound;

export type AddProductToOrderGuidesInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

export type AddProductsToOrderGuidesInput = {
  chatIds: Array<Scalars['ID']['input']>;
  products: Array<AddProductToOrderGuidesInput>;
  sourceChatId: Scalars['ID']['input'];
};

export type AddProductsToOrderGuidesResponse = AddProductsToOrderGuidesResult | AuthorizationFailure | InputValidationFailure;

export type AddProductsToOrderGuidesResult = AppsyncResponse & {
  __typename?: 'AddProductsToOrderGuidesResult';
  locations: Array<LocationProductsResult>;
  responseType: ResponseType;
  transactionId: Scalars['String']['output'];
};

export type AddSalesRepDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference: Array<AddSalesRepOrderPref>;
  phoneNumber: Scalars['String']['input'];
};

export type AddSalesRepError = AppsyncError & AppsyncResponse & {
  __typename?: 'AddSalesRepError';
  errorCode?: Maybe<AddSalesRepErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type AddSalesRepErrorCode =
  | 'genericError'
  | 'phoneIsLandlineError'
  | 'userExistsAndBelongsToBuyerError'
  | 'userExistsAndBelongsToDifferentSupplierError'
  | 'userExistsAndHasNoOrderPreferenceError'
  | '%future added value';

export type AddSalesRepOrderPref =
  | 'email'
  | 'sms'
  | 'whatsApp'
  | '%future added value';

export type AddSalesRepRequestToJoinInput = {
  chatId: Scalars['String']['input'];
  salesRepDetails: AddSalesRepDetailsInput;
};

export type AddSalesRepRequestToJoinResponse = AddSalesRepError | AddSalesRepSuccess | AuthorizationFailure | InputValidationFailure;

export type AddSalesRepSuccess = {
  __typename?: 'AddSalesRepSuccess';
  addSalesRepRequestId: Scalars['String']['output'];
  salesRepUserId: Scalars['String']['output'];
};

export type AddSellerToPurchasingBusinessFailure = {
  __typename?: 'AddSellerToPurchasingBusinessFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type AddSellerToPurchasingBusinessInput = {
  buyerId: Scalars['ID']['input'];
  seller: PurchasingBusinessInput;
};

export type AddSellerToPurchasingBusinessResponse = AddSellerToPurchasingBusinessFailure | AddSellerToPurchasingBusinessSuccess | AuthorizationFailure | InputValidationFailure | NotFoundError;

export type AddSellerToPurchasingBusinessSuccess = {
  __typename?: 'AddSellerToPurchasingBusinessSuccess';
  businessId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type AddressSource =
  | 'custom'
  | 'google'
  | '%future added value';

export type AdminProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerPrice?: InputMaybe<MoneyInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = '135'
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = '135'
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = '1300'
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = '135'
   *    currency = 'GNF'
   *
   * Products with the cost:'135.45' will be considered invalid
   */
  cost?: InputMaybe<Scalars['String']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  variantTypes?: InputMaybe<Scalars['String']['input']>;
};

export type AdvanceSalesFunnelLeadInput = {
  leadId: Scalars['ID']['input'];
  /** Note, not the name, the unique identifier */
  newStateId: Scalars['ID']['input'];
};

export type AdvanceSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type AliasAlreadyLinked = {
  __typename?: 'AliasAlreadyLinked';
  /** Indicates the email address or phone number that the alias is already linked to. Will always be masked (e.g. ab***@****.com, +123****5678) */
  linkedAccount?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AliasExists = {
  __typename?: 'AliasExists';
  aliasType?: Maybe<AliasType>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AliasType =
  | 'email'
  | 'phone'
  | '%future added value';

export type ApplicationData = {
  __typename?: 'ApplicationData';
  appName: Scalars['String']['output'];
  data?: Maybe<CredentialsData>;
  status: Scalars['String']['output'];
};

export type AppliedChatDeliverySetting = {
  __typename?: 'AppliedChatDeliverySetting';
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: Maybe<Scalars['Int']['output']>;
  cutoffTimes: WeekdayBasedCutoffSettings;
  exceptions?: Maybe<Array<DeliverySettingException>>;
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
};

export type AppliedChatDeliverySettingResponse = AppliedChatDeliverySetting | NotFoundError;

export type AppsyncError = {
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type AppsyncResponse = {
  responseType: ResponseType;
};

export type AssignOrderToUserForReviewInput = {
  omnichannelOrderId: Scalars['ID']['input'];
};

export type AssignOrderToUserForReviewResponse = AssignOrderToUserForReviewResponseError | AssignOrderToUserForReviewResponseSuccess;

export type AssignOrderToUserForReviewResponseError = AppsyncError & AppsyncResponse & {
  __typename?: 'AssignOrderToUserForReviewResponseError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type AssignOrderToUserForReviewResponseSuccess = {
  __typename?: 'AssignOrderToUserForReviewResponseSuccess';
  omnichannelOrderId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type AssignSalesFunnelLeadInput = {
  leadId: Scalars['ID']['input'];
  /** ID of the new sales rep owning this lead. */
  newAssigneeUserId: Scalars['ID']['input'];
};

export type AssignSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type Attachment = BroadcastAttachment | Event | Media;

export type AttachmentOrderRef = AudioAttachmentRef | CsvAttachmentRef | HtmlAttachmentRef | ImageAttachmentRef | PdfAttachmentRef | TextAttachmentRef | XlsxAttachmentRef;

/** deprecated: use attachment.status instead */
export type AttachmentState =
  | 'completed'
  | 'none'
  | 'pending'
  | 'rejected'
  | '%future added value';

export type AttachmentStatus =
  | 'completed'
  | 'none'
  | 'pending'
  | 'rejected'
  | '%future added value';

export type AttemptToChangeAdapterAuthType = AppsyncError & AppsyncResponse & {
  __typename?: 'AttemptToChangeAdapterAuthType';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type AttemptToReduceIntegrationAdapterScope = AppsyncError & AppsyncResponse & {
  __typename?: 'AttemptToReduceIntegrationAdapterScope';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type AudioAttachmentRef = {
  __typename?: 'AudioAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  timeRange: AudioTimeRange;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type AudioTimeRange = {
  __typename?: 'AudioTimeRange';
  endMilliseconds: Scalars['Int']['output'];
  startMilliseconds: Scalars['Int']['output'];
};

export type AudioTranscript = {
  __typename?: 'AudioTranscript';
  transcript: Scalars['String']['output'];
  words: Array<Word>;
};

export type AuthorizationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'AuthorizationFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** ResponseType.Error */
  responseType: ResponseType;
};

export type AutoPilotBugReport = {
  __typename?: 'AutoPilotBugReport';
  message?: Maybe<Scalars['String']['output']>;
  omnichannelOrderId: Scalars['ID']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  report?: Maybe<Array<Maybe<ReportTypes>>>;
};

export type AutoPilotBugReportInput = {
  customerMatchingIssue?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDateIssue?: InputMaybe<Scalars['Boolean']['input']>;
  disableAutoPilotForCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  omnichannelOrderId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  productMatchingIssue?: InputMaybe<Scalars['Boolean']['input']>;
  productQuantityIssue?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseOrderNumberIssue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutoPilotBugReportResponse = AuthorizationFailure | AutoPilotBugReport | InputValidationFailure | NotFoundError;

export type AutomaticOrderProcessingThresholdSetting = {
  __typename?: 'AutomaticOrderProcessingThresholdSetting';
  chatId?: Maybe<Scalars['ID']['output']>;
  confidenceSetting: Array<ConfidenceSetting>;
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
};

export type AutomaticOrderProcessingThresholdSettingInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  confidenceSetting: Array<ConfidenceSettingInput>;
  supplierId: Scalars['ID']['input'];
};

export type AutomaticOrderProcessingThresholdSettingResponse = AuthorizationFailure | AutomaticOrderProcessingThresholdSetting | InputValidationFailure | NotFoundError;

export type AutomationLevel =
  | 'conservative'
  | 'optimized'
  | '%future added value';

export type AutopilotOrderCreatedNotification = {
  __typename?: 'AutopilotOrderCreatedNotification';
  orderId: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
};

export type AutopilotThreshold = {
  __typename?: 'AutopilotThreshold';
  createdAt: Scalars['String']['output'];
  options: Array<AutomationLevel>;
  preference: AutomationLevel;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type AvailableDeliveryDate = {
  __typename?: 'AvailableDeliveryDate';
  /**
   * date is in format YYYY-MM-DD
   * dates are not subject to timezone conversion
   */
  date: Scalars['AWSDate']['output'];
  /**
   * leadTimeAdjustedCutoff is in format YYYY-MM-DDThh:mm:ss.sssZ
   * leadTimeAdjustedCutoff is created in supplier TZ, adjusted by leadTime and returned in UTC
   * leadTimeAdjustedCutoff is the deadline for the order submission
   */
  leadTimeAdjustedCutoff?: Maybe<Scalars['AWSDateTime']['output']>;
  type: CutOffTimeType;
};

export type BannerDistributorPromoAd = AdInterface & {
  __typename?: 'BannerDistributorPromoAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** Links to the campaign, used to fetch Promotion Page content */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this distributor promo on the ad banner - made optional on purpose to support future checkout flow */
  chat?: Maybe<Chat>;
  /** The home page banner image like "Premium Sauces" */
  homePageBannerImageUrl: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The promo page/easy ordering page banner image like "Premium Sauces" */
  promoPageBannerImageUrl: Scalars['String']['output'];
  /** The promo page description for extended information about the campaign */
  promoPageDescription: Scalars['String']['output'];
  /** The promo page title to show on home page and promo page */
  promoPageTitle: Scalars['String']['output'];
  /** The supplier of the VendorItemUnit */
  supplier: Supplier;
  /** Lists all promoted product variants. Always returns a list, which can be empty. */
  supplierVariants: Array<SupplierVendorItemUnitVariant>;
};

export type BannerInformationalAd = AdInterface & {
  __typename?: 'BannerInformationalAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** The main banner image URL like "Premium Frappe Mix" */
  bannerImageUrl: Scalars['String']['output'];
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Hex value for the background color of the Call to Action button */
  ctaBackgroundColor: Scalars['String']['output'];
  /** Call to Action Label that the user will see */
  ctaLabel: Scalars['String']['output'];
  /** URL for the Call to Action button */
  ctaLink: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
};

export type BannerShoppableAd = AdInterface & {
  __typename?: 'BannerShoppableAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** Links to the campaign, used to fetch Promotion Page content */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this VIU on the ad card - made optional on purpose to support future checkout flow */
  chat?: Maybe<Chat>;
  /** The specific VendorItemUnit shown on the ad */
  featuredVendorItemUnitId: Scalars['ID']['output'];
  /** The home page banner image like "Premium Sauces" */
  homePageBannerImageUrl: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The promo page banner image like "Premium Sauces" */
  promoPageBannerImageUrl: Scalars['String']['output'];
  /** The promo page description "Premium Sauces for your next meal bla bla bla" */
  promoPageDescription: Scalars['String']['output'];
  /** The promo page title "Brand Name" */
  promoPageTitle: Scalars['String']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
  /** The supplier of the VendorItemUnit */
  supplier: Supplier;
  /** Lists all specific product variants. Always returns a list, which can be empty. */
  supplierVariants: Array<SupplierVendorItemUnitVariant>;
};

export type BatchOrderConfirmError = AppsyncError & AppsyncResponse & {
  __typename?: 'BatchOrderConfirmError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BatchOrderConfirmResponse = BatchOrderConfirmError | BatchOrderConfirmSuccess;

export type BatchOrderConfirmSuccess = AppsyncResponse & {
  __typename?: 'BatchOrderConfirmSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BatchUpdateOrderSupplier = {
  __typename?: 'BatchUpdateOrderSupplier';
  chatId?: Maybe<Scalars['String']['output']>;
  /** Number of orders updated with new supplier */
  orderCount?: Maybe<Scalars['Int']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

export type BatchUpdateOrderSupplierInput = {
  chatId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  supplierPhone: Scalars['String']['input'];
  supplierRefId: Scalars['String']['input'];
};

export type BillingAddressInput = {
  city: Scalars['String']['input'];
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};

export type BillingDocument = {
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['AWSTimestamp']['output'];
  vendor: BillingDocumentVendor;
};

export type BillingDocumentCustomer = {
  __typename?: 'BillingDocumentCustomer';
  directPaymentCustomer?: Maybe<DirectPayPaymentCustomer>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
};

export type BillingDocumentDownloadUrlFailure = {
  __typename?: 'BillingDocumentDownloadUrlFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentDownloadUrlFileDoesNotExistFailure = {
  __typename?: 'BillingDocumentDownloadUrlFileDoesNotExistFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentDownloadUrlInput = {
  documentId: Scalars['ID']['input'];
  format?: InputMaybe<BillingDocumentExportFormat>;
};

export type BillingDocumentDownloadUrlResponse = AuthorizationFailure | BillingDocumentDownloadUrlFailure | BillingDocumentDownloadUrlFileDoesNotExistFailure | BillingDocumentDownloadUrlSuccess | InputValidationFailure;

export type BillingDocumentDownloadUrlSuccess = {
  __typename?: 'BillingDocumentDownloadUrlSuccess';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BillingDocumentExportCompleted = {
  __typename?: 'BillingDocumentExportCompleted';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BillingDocumentExportCreateFailure = {
  __typename?: 'BillingDocumentExportCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentExportCreateInput = {
  /**
   * Optional to allow for future expansion of additional filters
   * Can contain Invoice or Credit Note IDs
   */
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  format?: InputMaybe<BillingDocumentExportFormat>;
};

export type BillingDocumentExportCreateResponse = AuthorizationFailure | BillingDocumentExportCreateFailure | BillingDocumentExportCreateSuccess | BillingDocumentExportInvalidDocumentsFailure | BillingDocumentExportSizeLimitExceededFailure | BillingDocumentExportTooManyDocsFailure | InputValidationFailure;

export type BillingDocumentExportCreateSuccess = {
  __typename?: 'BillingDocumentExportCreateSuccess';
  jobId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BillingDocumentExportFailure = {
  __typename?: 'BillingDocumentExportFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentExportFailureDocumentDetails = {
  __typename?: 'BillingDocumentExportFailureDocumentDetails';
  /** Missing when document itself could not be found */
  documentNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BillingDocumentExportFormat =
  | 'CSV'
  | 'PDF'
  | '%future added value';

export type BillingDocumentExportInProgress = {
  __typename?: 'BillingDocumentExportInProgress';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BillingDocumentExportInvalidDocumentsFailure = {
  __typename?: 'BillingDocumentExportInvalidDocumentsFailure';
  documents: Array<BillingDocumentExportFailureDocumentDetails>;
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentExportSizeLimitExceededFailure = {
  __typename?: 'BillingDocumentExportSizeLimitExceededFailure';
  maxSizeInBytes: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  requestedSizeInBytes: Scalars['Int']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentExportStatusInput = {
  jobId: Scalars['ID']['input'];
};

export type BillingDocumentExportStatusResponse = AuthorizationFailure | BillingDocumentExportCompleted | BillingDocumentExportFailure | BillingDocumentExportInProgress | InputValidationFailure;

export type BillingDocumentExportTooManyDocsFailure = {
  __typename?: 'BillingDocumentExportTooManyDocsFailure';
  maxDocumentCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  requestedDocumentCount: Scalars['Int']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentResultEdge = Edge & {
  __typename?: 'BillingDocumentResultEdge';
  cursor: Scalars['String']['output'];
  node: BillingDocumentResultNode;
};

export type BillingDocumentResultNode = Node & {
  __typename?: 'BillingDocumentResultNode';
  document: BillingDocument;
  id: Scalars['ID']['output'];
};

export type BillingDocumentSearchFailure = {
  __typename?: 'BillingDocumentSearchFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BillingDocumentSearchFilter = {
  documentType?: InputMaybe<Array<BillingDocumentType>>;
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type BillingDocumentSearchInput = {
  filter?: InputMaybe<BillingDocumentSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type BillingDocumentSearchResponse = AuthorizationFailure | BillingDocumentSearchFailure | BillingDocumentSearchSuccess | InputValidationFailure;

export type BillingDocumentSearchSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'BillingDocumentSearchSuccess';
  edges: Array<BillingDocumentResultEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType;
  total: Scalars['Int']['output'];
};

export type BillingDocumentType =
  | 'CREDIT_NOTE'
  | 'INVOICE'
  | '%future added value';

export type BillingDocumentVendor = {
  __typename?: 'BillingDocumentVendor';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BlockedAutoPilotCustomersConnection = Connection & {
  __typename?: 'BlockedAutoPilotCustomersConnection';
  edges: Array<BlockedAutoPilotCustomersEdge>;
  pageInfo: PageInfo;
};

export type BlockedAutoPilotCustomersEdge = Edge & {
  __typename?: 'BlockedAutoPilotCustomersEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type BlockedEmail = Node & {
  __typename?: 'BlockedEmail';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type BlockedEmailConnection = Connection & {
  __typename?: 'BlockedEmailConnection';
  edges?: Maybe<Array<BlockedEmailEdge>>;
};

export type BlockedEmailEdge = Edge & {
  __typename?: 'BlockedEmailEdge';
  cursor: Scalars['String']['output'];
  node: BlockedEmail;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

/** Represents a circular geometry defined by a radius and a center point. */
export type BoundingCircleInput = {
  /** Center point of the circle around which we want to filter leads. */
  point: CoordinateInput;
  /** Radius of the circle around the center point. */
  radius: GeographicDistanceInput;
};

/**
 * Represents a rectangular geometry defined by two cartesian coordinate points.
 * Contains either exactly a top left and bottom right point or a southwest and northeast point.
 * Any other parameter combinations are invalid.
 */
export type BoundingRectangleInput = {
  /** Bottom right of the rectangle. */
  bottomRight?: InputMaybe<CoordinateInput>;
  /** Northeast or "top right" of the bounding rectangle. */
  northeast?: InputMaybe<CoordinateInput>;
  /**
   * Southwest or "bottom left" of the bounding rectangle.
   * Some APIs also call this "low".
   */
  southwest?: InputMaybe<CoordinateInput>;
  /** Top left of the rectangle. */
  topLeft?: InputMaybe<CoordinateInput>;
};

/** How to interpret the bounding rectangle search. */
export type BoundingRectangleSearchType =
  /**
   * Bias the search towards the bounding input geometry. If the query is
   * clearly for a prospect outside the geometry, it will ignore
   * the geometry and return the best result.
   */
  | 'Bias'
  /** Restrict the search to the bounding input geometry unconditionally. */
  | 'Restriction'
  | '%future added value';

export type BroadCastEndsAt = {
  __typename?: 'BroadCastEndsAt';
  date?: Maybe<Scalars['AWSDate']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Broadcast = Node & {
  __typename?: 'Broadcast';
  analytics?: Maybe<BroadcastAnalytics>;
  attachment?: Maybe<BroadcastMediaAttachment>;
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
  chatLabels?: Maybe<Array<Scalars['String']['output']>>;
  chats?: Maybe<Array<Chat>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  customerPerformance?: Maybe<BroadcastCustomerPerformanceResult>;
  endsAt?: Maybe<BroadCastEndsAt>;
  id: Scalars['ID']['output'];
  media?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextScheduledDispatch?: Maybe<Scalars['AWSTimestamp']['output']>;
  pdfName?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  productPerformance?: Maybe<BroadcastProductPerformanceResult>;
  /** @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  products?: Maybe<Array<Product>>;
  recipientCount?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<OneTimeBroadcastSchedule>;
  sendToAll?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<User>;
  senderUserId?: Maybe<Scalars['ID']['output']>;
  status: BroadcastStatus;
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type BroadcastChatsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type BroadcastCustomerPerformanceArgs = {
  filter?: InputMaybe<BroadcastCustomerPerformanceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};


export type BroadcastProductPerformanceArgs = {
  sort?: InputMaybe<Sort>;
};


export type BroadcastProductsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BroadcastAnalytics = {
  __typename?: 'BroadcastAnalytics';
  hasProducts: Scalars['Boolean']['output'];
  numChats: Scalars['Int']['output'];
  numChatsAddedProductsToOrderGuide: Scalars['Int']['output'];
  numChatsClicked: Scalars['Int']['output'];
  numChatsOpened: Scalars['Int']['output'];
  numChatsProductsOrdered: Scalars['Int']['output'];
  reportUpdatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
};

export type BroadcastAttachment = {
  __typename?: 'BroadcastAttachment';
  attachment?: Maybe<BroadcastMediaAttachment>;
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  products?: Maybe<Array<Product>>;
};

export type BroadcastCustomerPerformance = {
  __typename?: 'BroadcastCustomerPerformance';
  chat: Chat;
  chatId: Scalars['String']['output'];
  countOrdersWithProducts: Scalars['Int']['output'];
  isChatFirstOrder: Scalars['Boolean']['output'];
  isClicked: Scalars['Boolean']['output'];
  isOpened: Scalars['Boolean']['output'];
  isReactivatedChat: Scalars['Boolean']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type BroadcastCustomerPerformanceFilterInput = {
  hasOrdersWithProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isClicked?: InputMaybe<Scalars['Boolean']['input']>;
  isOpened?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastCustomerPerformanceResult = {
  __typename?: 'BroadcastCustomerPerformanceResult';
  data: Array<BroadcastCustomerPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastFilter = {
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<InputMaybe<BroadcastStatus>>>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type BroadcastInput = {
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  endsAt?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** name of PDF to be uploaded */
  pdfName?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose?: InputMaybe<BroadcastPurposeInput>;
  schedule?: InputMaybe<OneTimeBroadcastScheduleInput>;
  sendToAll?: InputMaybe<Scalars['Boolean']['input']>;
  status: BroadcastStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastMedia = {
  __typename?: 'BroadcastMedia';
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BroadcastMediaAttachment = {
  __typename?: 'BroadcastMediaAttachment';
  image?: Maybe<BroadcastMedia>;
  pdf?: Maybe<BroadcastPdfMedia>;
};

export type BroadcastPdfMedia = {
  __typename?: 'BroadcastPdfMedia';
  pdfName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BroadcastProductPerformance = {
  __typename?: 'BroadcastProductPerformance';
  countOrdersWithProducts: Scalars['Int']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type BroadcastProductPerformanceResult = {
  __typename?: 'BroadcastProductPerformanceResult';
  data: Array<BroadcastProductPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastPurposeInput = {
  customValue?: InputMaybe<Scalars['String']['input']>;
  predefinedValue: PredefinedBroadcastPurpose;
};

export type BroadcastScheduleType =
  | 'oneTimeBroadcast'
  | '%future added value';

export type BroadcastStatus =
  | 'archived'
  | 'cancelled'
  | 'draft'
  | 'processing'
  | 'scheduled'
  | 'sent'
  | '%future added value';

export type BroadcastUpdatePurposeResult = {
  __typename?: 'BroadcastUpdatePurposeResult';
  customValue?: Maybe<Scalars['String']['output']>;
  predefinedValue: PredefinedBroadcastPurpose;
};

export type BrowseCatalogFilterInput = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subCatalogIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrowseCatalogForChatFilterInput = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BrowseCatalogForChatInput = {
  /** Cursor from a previous page to request the next one */
  after?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Chat */
  chatId: Scalars['String']['input'];
  /** Additional filters */
  filter?: InputMaybe<BrowseCatalogForChatFilterInput>;
  /** Maximum number of Products to return. Cannot exceed 50 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, returns unit variants grouped together with `variantsInCatalog` field.
   * Otherwise they are returned as separate entries.
   */
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, also returns products that are not available in the chat. Defaults to false */
  includeUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order of the returned Products */
  sort?: InputMaybe<Sort>;
  /** If true, only returns products without categories */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to false, the `subCatalogs` field will not be returned. Defaults to true */
  withSubCatalogs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogForChatResponse = AuthorizationFailure | CatalogNotFound | CatalogProductsConnection;

export type BrowseCatalogInput = {
  /** Cursor from a previous page to request the next one */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Additional filters */
  filter?: InputMaybe<BrowseCatalogFilterInput>;
  /** Maximum number of Products to return. Cannot exceed 50 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, returns unit variants grouped together with `variantsInCatalog` field.
   * Otherwise they are returned as separate entries.
   */
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order of the returned Products */
  sort?: InputMaybe<Sort>;
  /** ID of the Supplier */
  supplierId: Scalars['String']['input'];
  /** If true, only returns products without categories */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided as `false`, the `subCatalogs` field is not returned */
  withSubCatalogs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogResponse = AuthorizationFailure | CatalogProductsConnection;

export type BugReport = {
  __typename?: 'BugReport';
  omnichannelOrderId: Scalars['ID']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  /** A list of the reported issues */
  report?: Maybe<Array<Maybe<ReportTypes>>>;
};

export type BulkDeclineOrdersInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeclineOrdersResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | OrdersBulkDeclined;

export type BulkInviteTransmissionFailure = {
  __typename?: 'BulkInviteTransmissionFailure';
  inviteeId: Scalars['String']['output'];
};

export type BulkInviteTransmissionSuccess = {
  __typename?: 'BulkInviteTransmissionSuccess';
  failures: Array<BulkInviteTransmissionFailure>;
  id: Scalars['ID']['output'];
};

export type BulkOrderRejectedNotification = {
  __typename?: 'BulkOrderRejectedNotification';
  ids: Array<Scalars['ID']['output']>;
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type BulkOrderedProductDeliveryCheckSubmissionResponse = AuthorizationFailure | BulkOrderedProductDeliveryCheckSubmissionResult | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryItemsMismatched | OrderNotFound;

export type BulkOrderedProductDeliveryCheckSubmissionResult = {
  __typename?: 'BulkOrderedProductDeliveryCheckSubmissionResult';
  result: Array<Maybe<OrderedProductDeliveryCheck>>;
};

export type BulkSendInviteInvitee = {
  invitedToEntityId: Scalars['String']['input'];
  inviteeId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type BulkSendInviteTransmissionInput = {
  channel: InviteChannel;
  invitees: Array<BulkSendInviteInvitee>;
  locale: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type BulkSendInviteTransmissionResponse = AuthorizationFailure | BulkInviteTransmissionSuccess | InputValidationFailure;

export type BulkSubmitOrderedProductDeliveryCheckInput = {
  deliveryCheckProducts?: InputMaybe<Array<InputMaybe<DeliveryCheckProductInput>>>;
  orderId: Scalars['ID']['input'];
};

/** Represents the business status of an prospect. */
export type BusinessStatus =
  | 'ClosedTemporarily'
  | 'Open'
  | '%future added value';

export type Buyer = Node & {
  __typename?: 'Buyer';
  addressSource: AddressSource;
  administrativeAreaLevelOne?: Maybe<Scalars['String']['output']>;
  chats?: Maybe<BuyerChatConnection>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdContext?: Maybe<BuyerCreatedContext>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  deliveryComment?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  googlePlaceAddressId?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceRecipientEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  /** True if buyer is a test buyer on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rolesEnabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BuyerStatus>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  users?: Maybe<BuyerUserConnection>;
  /** offset from UTC in minutes */
  utcOffset?: Maybe<Scalars['Int']['output']>;
};


export type BuyerChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerAddSupplier = {
  __typename?: 'BuyerAddSupplier';
  buyerId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  supplierId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type BuyerAddSupplierError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerAddSupplierError';
  errorCode?: Maybe<BuyerAddSupplierErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerAddSupplierErrorCode =
  | 'duplicateBuyerAddSupplierRequest'
  | 'supplierAlreadyConnected'
  | 'supplierNotAcceptingNewCustomers'
  | 'userNotMemberOfBuyer'
  | '%future added value';

export type BuyerAddSupplierInput = {
  buyerId: Scalars['String']['input'];
  requestType: BuyerAddSupplierRequestType;
  supplierId: Scalars['String']['input'];
};

export type BuyerAddSupplierRequestType =
  | 'existingCustomer'
  | 'newCustomer'
  | '%future added value';

export type BuyerAddSupplierResponse = AuthorizationFailure | BuyerAddSupplier | BuyerAddSupplierError | InputValidationFailure;

export type BuyerBillingDocumentSearchFailure = {
  __typename?: 'BuyerBillingDocumentSearchFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerBillingDocumentSearchFilter = {
  documentType?: InputMaybe<Array<BillingDocumentType>>;
  issueDate?: InputMaybe<DateFilter>;
};

export type BuyerBillingDocumentSearchInput = {
  buyerIds: Array<Scalars['ID']['input']>;
  filter?: InputMaybe<BuyerBillingDocumentSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerBillingDocumentSearchResponse = AuthorizationFailure | BuyerBillingDocumentSearchFailure | BuyerBillingDocumentSearchSuccess | InputValidationFailure;

export type BuyerBillingDocumentSearchSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'BuyerBillingDocumentSearchSuccess';
  edges: Array<BillingDocumentResultEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType;
  total: Scalars['Int']['output'];
};

export type BuyerChatConnection = Connection & {
  __typename?: 'BuyerChatConnection';
  edges: Array<BuyerChatEdge>;
};

export type BuyerChatEdge = Edge & {
  __typename?: 'BuyerChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type BuyerChatsConnection = {
  __typename?: 'BuyerChatsConnection';
  /** Null cursor indicates the end of the list. */
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<BuyerChatsEdge>;
};

export type BuyerChatsEdge = {
  __typename?: 'BuyerChatsEdge';
  node: Chat;
};

export type BuyerChatsNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerChatsNotFound';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerChatsProductListEmpty = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerChatsProductListEmpty';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerContactInfos = {
  __typename?: 'BuyerContactInfos';
  buyerContactInfos: Array<Scalars['String']['output']>;
};

export type BuyerCreateInput = {
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource: AddressSource;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdContext?: InputMaybe<BuyerCreatedContext>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** set this flag to enroll this buyer as a test buyer on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<BuyerStatus>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerCreatedContext =
  | 'addAnotherBusiness'
  | 'buyerConcierge'
  | 'buyerCreatedFromAdmin'
  | 'buyerCreatedFromChocoAi'
  | 'customerMassAccountCreator'
  | 'organicSignUp'
  | 'supplierInvitesBuyer'
  | '%future added value';

export type BuyerDisableRolesResponse = Buyer | NotFoundError;

export type BuyerEdge = Edge & {
  __typename?: 'BuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
};

export type BuyerExists = {
  __typename?: 'BuyerExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerExternalVendor = {
  __typename?: 'BuyerExternalVendor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BuyerFacetsResponse = {
  __typename?: 'BuyerFacetsResponse';
  cities?: Maybe<Array<CityWithOffsets>>;
  country?: Maybe<Scalars['String']['output']>;
};

export type BuyerFilter = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerInventoryProduct = {
  __typename?: 'BuyerInventoryProduct';
  chatId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  productId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

export type BuyerNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type BuyerProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
};

export type BuyerReport = {
  __typename?: 'BuyerReport';
  buyerReportUploadStatus: BuyerReportUploadStatus;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  type: BuyerReportType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type BuyerReportGenerationError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportGenerationError';
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerReportNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportNotFoundError';
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerReportSchedule = {
  __typename?: 'BuyerReportSchedule';
  buyerIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdBy: Scalars['String']['output'];
  emailBody?: Maybe<Scalars['String']['output']>;
  emailRecipients: Array<Scalars['String']['output']>;
  frequency: ScheduledBuyerReportFrequency;
  id: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  nextExecutionAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  startAt: Scalars['AWSTimestamp']['output'];
  supplierIds: Array<Scalars['String']['output']>;
  timeframe: ScheduledBuyerReportFrequency;
  timeframeType: ScheduledBuyerReportTimeframeType;
  title?: Maybe<Scalars['String']['output']>;
  type: BuyerReportType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BuyerReportScheduleNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportScheduleNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerReportSchedules = {
  __typename?: 'BuyerReportSchedules';
  result: Array<BuyerReportSchedule>;
};

export type BuyerReportType =
  | 'delivery'
  | 'order'
  | 'product'
  | '%future added value';

export type BuyerReportUploadStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | '%future added value';

export type BuyerSegmentContent = {
  __typename?: 'BuyerSegmentContent';
  chat?: Maybe<Chat>;
  featuredVendorItemUnitIds: Array<Scalars['ID']['output']>;
  supplier?: Maybe<Supplier>;
};

export type BuyerStatus =
  | 'active'
  | 'pending'
  | '%future added value';

export type BuyerStockCount = Node & {
  __typename?: 'BuyerStockCount';
  buyerId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  countedProducts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<BuyerStockCountStatus>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
};

export type BuyerStockCountConnection = Connection & {
  __typename?: 'BuyerStockCountConnection';
  edges?: Maybe<Array<BuyerStockCountEdge>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type BuyerStockCountEdge = Edge & {
  __typename?: 'BuyerStockCountEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockCount;
};

export type BuyerStockCountFailure = {
  __typename?: 'BuyerStockCountFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerStockCountProduct = {
  __typename?: 'BuyerStockCountProduct';
  buyerId: Scalars['ID']['output'];
  createdBy: Scalars['ID']['output'];
  /** @deprecated Works correctly for LOX Suppliers only when the `x-choco-is-lox` header is sent. Avoid using in the new code. Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  estimatedTotalValue?: Maybe<Money>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Money>;
  productId?: Maybe<Scalars['ID']['output']>;
  status: BuyerStockCountStatus;
  stockCountId?: Maybe<Scalars['ID']['output']>;
  stockInventoryProductId: Scalars['ID']['output'];
  stockQuantity: Scalars['Float']['output'];
  supplierId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type BuyerStockCountResponse = AuthorizationFailure | BuyerStockCountFailure | BuyerStockCountSuccess | InputValidationFailure;

export type BuyerStockCountStatus =
  | 'completed'
  | 'draft'
  | '%future added value';

export type BuyerStockCountSuccess = {
  __typename?: 'BuyerStockCountSuccess';
  products?: Maybe<Array<BuyerStockCountProduct>>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type BuyerStockCountsFailure = {
  __typename?: 'BuyerStockCountsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerStockCountsResponse = AuthorizationFailure | BuyerStockCountsFailure | BuyerStockCountsSuccess | InputValidationFailure;

export type BuyerStockCountsSuccess = {
  __typename?: 'BuyerStockCountsSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  stockCounts: BuyerStockCountConnection;
};

export type BuyerStockInventory = {
  __typename?: 'BuyerStockInventory';
  buyerId: Scalars['String']['output'];
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastCountedBy?: Maybe<User>;
  lastCountedById?: Maybe<Scalars['ID']['output']>;
  products: BuyerStockInventoryProductConnection;
  status?: Maybe<BuyerStockInventoryGenerationStatus>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
};

export type BuyerStockInventoryExportUrlFailure = {
  __typename?: 'BuyerStockInventoryExportUrlFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerStockInventoryExportUrlResponse = AuthorizationFailure | BuyerStockInventoryExportUrlFailure | BuyerStockInventoryExportUrlSuccess | BuyerStockInventoryNotFound | InputValidationFailure;

export type BuyerStockInventoryExportUrlSuccess = {
  __typename?: 'BuyerStockInventoryExportUrlSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  url: Scalars['String']['output'];
};

export type BuyerStockInventoryFailure = {
  __typename?: 'BuyerStockInventoryFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerStockInventoryGenerationStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | '%future added value';

export type BuyerStockInventoryNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerStockInventoryNotFound';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type BuyerStockInventoryProduct = Node & {
  __typename?: 'BuyerStockInventoryProduct';
  buyerId: Scalars['ID']['output'];
  chatId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Works correctly for LOX Suppliers only when the `x-choco-is-lox` header is sent. Avoid using in the new code. Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  estimatedTotalValue?: Maybe<Money>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Does not work for LOX Suppliers */
  orderGuideCategories: Array<ProductCategory>;
  price?: Maybe<Money>;
  productId?: Maybe<Scalars['ID']['output']>;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  supplier?: Maybe<Supplier>;
  type: BuyerStockInventoryProductType;
  unit?: Maybe<Scalars['String']['output']>;
};

export type BuyerStockInventoryProductConnection = Connection & {
  __typename?: 'BuyerStockInventoryProductConnection';
  edges?: Maybe<Array<BuyerStockInventoryProductEdge>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type BuyerStockInventoryProductEdge = Edge & {
  __typename?: 'BuyerStockInventoryProductEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockInventoryProduct;
};

export type BuyerStockInventoryProductType =
  | 'catalogProduct'
  | 'customInventoryProduct'
  | 'orderGuideProduct'
  | '%future added value';

export type BuyerStockInventoryResponse = AuthorizationFailure | BuyerStockInventory | BuyerStockInventoryFailure | BuyerStockInventoryNotFound | InputValidationFailure;

export type BuyerUpdateInput = {
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource?: InputMaybe<AddressSource>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BuyerStatus>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerUser = {
  __typename?: 'BuyerUser';
  buyer?: Maybe<Buyer>;
  buyerId: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type BuyerUserConnection = Connection & {
  __typename?: 'BuyerUserConnection';
  edges: Array<BuyerUserEdge>;
};

export type BuyerUserEdge = Edge & {
  __typename?: 'BuyerUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
  role?: Maybe<Scalars['String']['output']>;
};

export type BuyerUserInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type BuyerUserRoleInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Campaign attachment to be used for adding attachments to the channel message */
export type CampaignAttachment = {
  __typename?: 'CampaignAttachment';
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

/** Input type for attachments of a marketing campaign */
export type CampaignAttachmentInput = {
  /** Attachment file Id used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Attachment file name */
  name: Scalars['String']['input'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['input'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['input'];
};

export type CampaignChannel =
  | 'CHAT'
  | 'EMAIL'
  | 'PROMO'
  | 'PROMO_PREFERRED_PRODUCTS'
  | '%future added value';

/** Campaign attachment to be used for adding attachments to the channel message */
export type CampaignChatAttachment = {
  __typename?: 'CampaignChatAttachment';
  /** Signed download URL for the attachment file */
  downloadUrl: Scalars['String']['output'];
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

export type CampaignTarget = TargetAll | TargetChats;

export type CancelCartOptionsInput = {
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
};

export type CancelCartResponse = AuthorizationFailure | CancelCartResult | CartAlreadyCancelledError | CartAlreadySubmittedError | CartNotFoundError | CartVersionConstraintError | InputValidationFailure;

export type CancelCartResult = {
  __typename?: 'CancelCartResult';
  /** the cart ID */
  id: Scalars['ID']['output'];
};

/** Input type for canceling a marketing campaign */
export type CancelMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

export type CardBrand =
  | 'MASTERCARD'
  | 'VISA'
  | '%future added value';

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  brand: CardBrand;
  cardHolderName: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastFourDigits: Scalars['String']['output'];
  status: PaymentMethodStatus;
};

export type Cart = {
  __typename?: 'Cart';
  /** order-level comment from the buyer */
  body?: Maybe<Scalars['String']['output']>;
  /** One cart per chat. the cart id is the same as the id of its parent chat */
  id: Scalars['ID']['output'];
  /** computed field; returns true if the cart has non-empty lineItems */
  isOpen: Scalars['Boolean']['output'];
  lineItems: Array<Maybe<CartLineItem>>;
  /** Purchase Order number from the buyer */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** the version number of the cart for managing concurrency */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type CartAllProductsUnavailableError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAllProductsUnavailableError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
  unavailableProductCount: Scalars['Int']['output'];
};

export type CartAlreadyCancelledError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAlreadyCancelledError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartAlreadySubmittedError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAlreadySubmittedError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartCanceled = {
  __typename?: 'CartCanceled';
  name?: Maybe<Scalars['String']['output']>;
};

export type CartInvalidProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartInvalidProductsError';
  invalidProductCount: Scalars['Int']['output'];
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  remainingProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  amount: Scalars['Float']['output'];
  /** Optional comment from the buyer for this line item */
  buyerComment?: Maybe<Scalars['String']['output']>;
  /**
   * This will be resolved only for suppliers that were not migrated to LOX and will be null for suppliers that are already migrated to LOX.
   * Do not fetch this field if the supplier has the lox-mvp feature flag enabled.
   * @deprecated Does not work for LOX Suppliers. Use `CartLineItem.vendorItemUnit` instead
   */
  product?: Maybe<Product>;
  productId: Scalars['ID']['output'];
  /** @deprecated is ignored in the backend, will always return null */
  productMeta?: Maybe<CartProductMetadata>;
  /**
   * This will be resolved only for suppliers that are already migrated to LOX and will be null for suppliers that were not migrated to LOX.
   * Do not fetch this field if the supplier has the lox-mvp feature flag disabled.
   */
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type CartLineItemUpdateInput = {
  /** is this an operation to add or remove a product item */
  action: UserCartAction;
  /**
   * The amounts of products items to add or remove from the cart.
   * Set to 0 if you want to just update the buyer comment.
   */
  amount: Scalars['Float']['input'];
  /**
   * Optional comment from the buyer for this line item.
   * - If sent as undefined or null: will be ignored (preserves existing comment if any)
   * - If sent as empty string: removes the existing comment if any
   * - If provided with value: updates the existing comment
   */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** The id of the product */
  productId: Scalars['ID']['input'];
  /**
   * The meta data of the product
   * @deprecated is ignored in the backend
   */
  productMeta?: InputMaybe<CartProductMetadataInput>;
};

export type CartNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartNotFoundError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartOpened = {
  __typename?: 'CartOpened';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartProductMetadata = {
  __typename?: 'CartProductMetadata';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type CartProductMetadataInput = {
  /** The external id of the product */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product */
  name: Scalars['String']['input'];
  /** The unit of measurement of the product item */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CartRecommendation = {
  __typename?: 'CartRecommendation';
  vendorItemUnit: VendorItemUnitRef;
};

export type CartRecommendationMetadata = {
  __typename?: 'CartRecommendationMetadata';
  numberOfOrders: Scalars['Int']['output'];
};

export type CartRecommendationsInput = {
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorItemUnitIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CartRecommendationsResponse = AuthorizationFailure | CartRecommendationsResult | InputValidationFailure;

export type CartRecommendationsResult = {
  __typename?: 'CartRecommendationsResult';
  metadata: CartRecommendationMetadata;
  recommendations: Array<CartRecommendation>;
};

export type CartResponse = AuthorizationFailure | Cart;

export type CartSubmissionError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartSubmissionError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartSubmissionOptions = {
  /**
   * This parameter determines which order create version to use
   * @deprecated with orderCreateV2 being rolled out, we don't need to use the old version anymore and this will now be ignored.
   */
  apiVersion?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The body of the order message.
   * This is Optional order-level comment from the buyer.
   * - If sent as undefined or null: will be ignored (preserves existing comment if any)
   * - If sent as empty string: removes the existing comment if any
   * - If provided with value: updates the existing comment
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
  /** The requested delivery date for the order */
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** The estimated order value */
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  /** Is this a test order */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum order value currency */
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The minimum order value set by the supplier */
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  /** The estimated order value currency */
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The id of the order to create from the cart */
  orderId: Scalars['ID']['input'];
  /**
   * The Purchase Order number from the buyer (optional).
   * - If sent as undefined or null: will be ignored (preserves existing poNumber if any)
   * - If sent as empty string: removes the existing poNumber if any
   * - If provided with value: updates the existing poNumber
   */
  poNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CartSubmissionResponse = AuthorizationFailure | CartAllProductsUnavailableError | CartAlreadyCancelledError | CartAlreadySubmittedError | CartInvalidProductsError | CartNotFoundError | CartSubmissionError | CartSubmissionResult | CartSubmittedEmptyError | CartVersionConstraintError | CreateMessageError | ExistingOrderError | ForbiddenError | InputValidationFailure | MinimumOrderableAmountError | ProductBuyerCommentsNotAllowedError | ProductLeadTimeError;

export type CartSubmissionResult = {
  __typename?: 'CartSubmissionResult';
  cart?: Maybe<Cart>;
  /** the cart ID */
  id: Scalars['ID']['output'];
  /** the message item created from the cart submission */
  message?: Maybe<Message>;
};

export type CartSubmitted = {
  __typename?: 'CartSubmitted';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartSubmittedEmptyError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartSubmittedEmptyError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CartUpdateResponse = AuthorizationFailure | Cart | CartNotFoundError | CartVersionConstraintError | InputValidationFailure | NegativeAmountError;

export type CartUpdated = {
  __typename?: 'CartUpdated';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartVersionConstraintError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartVersionConstraintError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CatalogAttribute = {
  __typename?: 'CatalogAttribute';
  id: Scalars['ID']['output'];
  type: CatalogAttributeType;
  values?: Maybe<Array<CatalogAttributeValue>>;
};

/**
 * Input for filtering by attribute values.
 * Exactly one of `valueCodes` or `valueIds` must be provided, not both or neither.
 */
export type CatalogAttributeFilterItem = {
  type: CatalogAttributeType;
  /**
   * List of value codes for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of value IDs for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CatalogAttributeType =
  | 'ALLERGEN_CONTAINS'
  | 'ALLERGEN_FREE_FROM'
  | 'ALLERGEN_MAY_CONTAIN'
  | 'DIETARY_CERTIFICATION'
  | 'DIETARY_LIFESTYLE'
  | '%future added value';

export type CatalogAttributeUpdateInput = {
  mode: CatalogAttributeUpdateMode;
  type: CatalogAttributeType;
  values: Array<CatalogAttributeValueInput>;
  vendorId: Scalars['ID']['input'];
};

export type CatalogAttributeUpdateMode =
  | 'Replace'
  | 'Update'
  | '%future added value';

export type CatalogAttributeUpdateResponse = AuthorizationFailure | CatalogAttributeUpdateResult | InputValidationFailure;

export type CatalogAttributeUpdateResult = AppsyncResponse & {
  __typename?: 'CatalogAttributeUpdateResult';
  attribute: CatalogAttribute;
  responseType: ResponseType;
};

export type CatalogAttributeValue = {
  __typename?: 'CatalogAttributeValue';
  /** Type of the attribute (allergen or dietary preference) */
  attributeType: CatalogAttributeType;
  /** Code of the attribute (e.g., "milk", "vegan") */
  code: Scalars['String']['output'];
  /** Unique identifier of the attribute */
  id: Scalars['ID']['output'];
  /** Best translation name based on Accept-Language header and locale preferences */
  name: Scalars['String']['output'];
  /** All available translations of the attribute name */
  translations?: Maybe<Array<CatalogAttributeValueTranslation>>;
};

export type CatalogAttributeValueInput = {
  code: Scalars['String']['input'];
  translations: Array<CatalogAttributeValueTranslationInput>;
};

export type CatalogAttributeValueTranslation = {
  __typename?: 'CatalogAttributeValueTranslation';
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['output'];
  /** Translated name of the attribute */
  name: Scalars['String']['output'];
};

export type CatalogAttributeValueTranslationInput = {
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['input'];
  /** Name in the specified locale */
  name: Scalars['String']['input'];
};

export type CatalogAttributesInput = {
  /** If provided, only returns selected attributes */
  types?: InputMaybe<Array<CatalogAttributeType>>;
  vendorId: Scalars['ID']['input'];
};

export type CatalogAttributesResponse = AuthorizationFailure | CatalogAttributesResult | InputValidationFailure;

export type CatalogAttributesResult = {
  __typename?: 'CatalogAttributesResult';
  attributes: Array<CatalogAttribute>;
  responseType: ResponseType;
};

export type CatalogCategoriesResponse = {
  __typename?: 'CatalogCategoriesResponse';
  catalogCategories: Array<CatalogCategory>;
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  clientImageKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryCatalogCategories?: Maybe<Array<Scalars['String']['output']>>;
};

export type CatalogExportJob = CatalogExportJobSucceeded | JobFailed | JobInProgress | JobQueued;

/** Represents a catalog export job that succeeded. */
export type CatalogExportJobSucceeded = {
  __typename?: 'CatalogExportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** URL where the output file of the catalog export job can be downloaded from. */
  outputDownloadUrl: Scalars['String']['output'];
};

/** Input for the `catalogExportStart` mutation. */
export type CatalogExportStartInput = {
  /** Indicates whether the export should include items with all statuses (e.g. OutOfStock) or just the items in stock; the default is false. */
  exportWithAllStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the vendor for whom the catalog is being exported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogExportStartResponse = AuthorizationFailure | CatalogExportStartResult | InputValidationFailure;

export type CatalogExportStartResult = AppsyncResponse & {
  __typename?: 'CatalogExportStartResult';
  /** The catalog export job. */
  job: CatalogExportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CatalogExportStatusResponse = AuthorizationFailure | CatalogExportStatusResult | InputValidationFailure;

export type CatalogExportStatusResult = AppsyncResponse & {
  __typename?: 'CatalogExportStatusResult';
  /** The catalog export job. */
  job: CatalogExportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/**
 * Known failure codes:
 * - InvalidFile
 */
export type CatalogImportJob = CatalogImportJobSucceeded | JobFailed | JobInProgress | JobWaitingForInput;

/** Summarizes the import process, providing details about the items processed during the import. */
export type CatalogImportJobResponse = {
  __typename?: 'CatalogImportJobResponse';
  /** The number of new vendor item units created during the import. */
  itemsCreated: Scalars['Int']['output'];
  /** The number of vendor item units marked as out of stock during the import. */
  itemsMarkedOutOfStock: Scalars['Int']['output'];
  /** The number of vendor item units updated during the import. */
  itemsUpdated: Scalars['Int']['output'];
  /** The number of vendor item units that failed to import due to validation errors. */
  itemsWithErrors: Scalars['Int']['output'];
};

/** Represents a catalog import job that succeeded, including partial successes. */
export type CatalogImportJobSucceeded = {
  __typename?: 'CatalogImportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Indicates whether the import was a partial success, such as some items failing to import due to validation errors. */
  isPartialSuccess: Scalars['Boolean']['output'];
  /** URL where the output file of the import job can be downloaded. */
  outputDownloadUrl: Scalars['String']['output'];
  /** A summary response of the import job detailing the outcome of the import process. */
  response: CatalogImportJobResponse;
};

/** Mode of the CatalogImport defines how unmatched products are handled during the import process. */
export type CatalogImportMode =
  /** New item units are created, matched item units are updated, and unmatched item units are marked as out of stock. */
  | 'Replace'
  /** New item units are created, matched item units are updated, and unmatched item units are left unchanged. */
  | 'Update'
  | '%future added value';

export type CatalogImportNode = Node & {
  __typename?: 'CatalogImportNode';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** The details about the catalog import job. */
  job: CatalogImportJob;
};

/** Input for the `catalogImportStart` mutation. */
export type CatalogImportStartInput = {
  /** Indicates whether the import should be a dry run. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job used in dry run mode to upload the input file for the actual import. */
  inputFromJobId?: InputMaybe<Scalars['ID']['input']>;
  /** The mode of the import, controlling the behavior of the import process. */
  mode: CatalogImportMode;
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogImportStartResponse = AuthorizationFailure | CatalogImportStartResult | InputValidationFailure;

/** The result of starting a catalog import job. */
export type CatalogImportStartResult = AppsyncResponse & {
  __typename?: 'CatalogImportStartResult';
  /** The catalog import job created as a result of the mutation. */
  job: CatalogImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CatalogImportStatusResponse = AuthorizationFailure | CatalogImportStatusResult | InputValidationFailure;

export type CatalogImportStatusResult = AppsyncResponse & {
  __typename?: 'CatalogImportStatusResult';
  /** The catalog import job. */
  job: CatalogImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CatalogImportTemplateResponse = AuthorizationFailure | CatalogImportTemplateResult;

/** The response type for CatalogImport Template. */
export type CatalogImportTemplateResult = AppsyncResponse & {
  __typename?: 'CatalogImportTemplateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** URL for the catalog import template. */
  url: Scalars['AWSURL']['output'];
};

export type CatalogImportsFilter = {
  status?: InputMaybe<Array<JobStatus>>;
};

export type CatalogImportsInput = {
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<CatalogImportsFilter>;
  /** Pagination filter. */
  pagination?: InputMaybe<PaginationInputV2>;
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogImportsResponse = AuthorizationFailure | CatalogImportsResult | InputValidationFailure;

export type CatalogImportsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CatalogImportsResult';
  /** The edges of the response. */
  edges: Array<CatalogImportsResultEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CatalogImportsResultEdge = Edge & {
  __typename?: 'CatalogImportsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** A "CatalogImportsResultEdge" node containing the actual data. */
  node: CatalogImportNode;
};

export type CatalogNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'CatalogNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CatalogProductsConnection = Connection & {
  __typename?: 'CatalogProductsConnection';
  edges: Array<CatalogProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CatalogProductsEdge = Edge & {
  __typename?: 'CatalogProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type CatalogSearchMetadata = {
  __typename?: 'CatalogSearchMetadata';
  /** The version used to return the result set. */
  searchVersion: Scalars['String']['output'];
};

export type CategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryProducts = Node & {
  __typename?: 'CategoryProducts';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Product>>;
};

export type Chat = Node & {
  __typename?: 'Chat';
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  additionalEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated use supplierEntityId instead */
  botUserId?: Maybe<Scalars['ID']['output']>;
  buyer?: Maybe<Buyer>;
  cart?: Maybe<Cart>;
  chatName?: Maybe<Scalars['String']['output']>;
  churn?: Maybe<ChatChurn>;
  contacts: Array<CustomerContact>;
  createdBy?: Maybe<CreatedBy>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** delivery settings of chat which was previously used from supplierDeliveryDateSettings query */
  deliveryDateSettings?: Maybe<SupplierDeliveryDateSettings>;
  enabled: Scalars['Boolean']['output'];
  hasMessages?: Maybe<Scalars['Boolean']['output']>;
  hasOrderTransmission?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent, but will not get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  hasRequestedOrderGuide?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true if there is at least one vendor catalog item in the scope of visibility of this chat.
   * This does not include custom vendor items.
   */
  hasVendorCatalog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<InviteTransmission>;
  /** Status of the most advanced invite sent for this chat; there could be many invites for one chat, but we pick the most advanced invote */
  inviteStatus?: Maybe<InviteStatus>;
  /** True if chat is a test chat on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isUserInChat?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  messages: ChatMessageConnection;
  /**
   * The note associated with the lead.
   * It is up to backend policy to determine which note this is.
   * Null if and only if there is no note attached to the lead.
   */
  note?: Maybe<DistributorNote>;
  orderGuide?: Maybe<OrderGuideV2Ref>;
  orderingSettings?: Maybe<ChatOrderingSettings>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2ItemUnits` instead */
  products?: Maybe<Array<Product>>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  sendBuyerOrderConfirmation?: Maybe<Scalars['Boolean']['output']>;
  status: ChatStatus;
  /** @deprecated Does not work for LOX Suppliers. See notice for `customCatalogsForChat` */
  subCatalog?: Maybe<SubCatalog>;
  subCatalogId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated use supplierEntity instead */
  supplier?: Maybe<User>;
  supplierCustomerName?: Maybe<Scalars['String']['output']>;
  supplierEntity?: Maybe<Supplier>;
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  /**
   * A task associated with the chat. It is up to backend policy to determine
   * which task this is.
   */
  task?: Maybe<DistributorTask>;
  type?: Maybe<ChatType>;
  users: ChatUserConnection;
  usesExtendedCatalog?: Maybe<Scalars['Boolean']['output']>;
};


export type ChatIsUserInChatArgs = {
  userId: Scalars['ID']['input'];
};


export type ChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<MessageGroupFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatChurn = {
  __typename?: 'ChatChurn';
  lastOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastOrderId?: Maybe<Scalars['String']['output']>;
  orderFrequency?: Maybe<ChatChurnOrderFrequency>;
  orderingTrend?: Maybe<ChatChurnOrdersTrend>;
  ordersTrend?: Maybe<Scalars['Float']['output']>;
  predictedNextOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  status: ChatChurnStatus;
};

export type ChatChurnOrderFrequency =
  | 'biMonthly'
  | 'biWeekly'
  | 'daily'
  | 'monthly'
  | 'quarterly'
  | 'weekly'
  | '%future added value';

export type ChatChurnOrdersTrend =
  | 'decreasing'
  | 'increasing'
  | 'noChange'
  | 'significantDecrease'
  | 'significantIncrease'
  | '%future added value';

export type ChatChurnStatus =
  | 'active'
  | 'churnRisk'
  | 'churned'
  | 'earlyOrdering'
  | 'firstOrder'
  | 'noOrdersYet'
  | 'nonActive'
  | 'ordering'
  | '%future added value';

export type ChatCreateInput = {
  addBuyerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  createdContext?: InputMaybe<CreatedContext>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  /** set this flag to enroll this chat as a test chat on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<AdminProductInput>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChatStatus>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  supplierCustomerName?: InputMaybe<Scalars['String']['input']>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use supplierEntityId instead */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ChatType>;
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ChatCreated = {
  __typename?: 'ChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatEventTypes = CartCanceled | CartOpened | CartSubmitted | CartUpdated | ChatCreated | ChatNameUpdated | OrderEdited | OrderGuideCreated | OrderGuideRequested | ReconciliationRequestConfirmed | RequestedChatActivated | RequestedChatCreated | UserAddedToChat | UserRemovedFromChat;

export type ChatFilter = {
  additionalEmail?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChatStatus>;
  /** used in conjunction with labels filter and used by infra to fetch supplier chatLabels */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** userId for salesReps and botUserId for supplierAdmins; applicable for infra or admin */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatHasSupplierEmailSupportResponse = AuthorizationFailure | ChatHasSupplierEmailSupportResult | ChatNotFoundError | InputValidationFailure;

export type ChatHasSupplierEmailSupportResult = {
  __typename?: 'ChatHasSupplierEmailSupportResult';
  hasEmailSupport: Scalars['Boolean']['output'];
};

export type ChatInviteInput = {
  channel?: InputMaybe<InviteChannel>;
  /** existing chat id to use, a new chat will be created if not given */
  chatId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceName?: InputMaybe<Scalars['String']['input']>;
  googlefullAddress?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use message and channel */
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatInviteLoginMethod =
  | 'Email'
  | 'Phone'
  | '%future added value';

export type ChatInviteRecipient = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/**
 * If type is Email, email is required and phone is optional.
 * If type is Phone, phone is required and email is optional.
 */
export type ChatInviteRecipientV2 = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: ChatInviteLoginMethod;
};

export type ChatLabel = {
  __typename?: 'ChatLabel';
  chatCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ChatLabelsResult = {
  __typename?: 'ChatLabelsResult';
  count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ChatMatchedBy =
  | 'cache'
  | 'orderInput'
  | 'phoneLookup'
  | 'search'
  | '%future added value';

export type ChatMessageConnection = Connection & {
  __typename?: 'ChatMessageConnection';
  edges?: Maybe<Array<ChatMessageEdge>>;
};

export type ChatMessageEdge = Edge & {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type ChatNameUpdated = {
  __typename?: 'ChatNameUpdated';
  /** @deprecated we no longer support it */
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'ChatNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ChatNotificationInput = {
  /** chat ID */
  id: Scalars['ID']['input'];
  newMessage?: InputMaybe<ChatNotificationUserListsInput>;
  newOrder?: InputMaybe<ChatNotificationUserListsInput>;
};

/** supplier new order and new message notification preferences on a chat level */
export type ChatNotificationPreferences = {
  __typename?: 'ChatNotificationPreferences';
  /** chat ID */
  id: Scalars['ID']['output'];
  /** API defaults this to newOrder prefs */
  newMessage?: Maybe<ChatNotificationUserLists>;
  newOrder?: Maybe<ChatNotificationUserLists>;
};

export type ChatNotificationUserLists = {
  __typename?: 'ChatNotificationUserLists';
  deselectedUsers: Array<User>;
  /** the users who are deselected from the supplier's chat-level notification preferences */
  deselectedUsersList: Array<Scalars['ID']['output']>;
  extraUsers?: Maybe<Array<User>>;
  /** the users who want to receive new order/message notifications but are not a supplier */
  extraUsersList?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ChatNotificationUserListsInput = {
  deselectedUsersList: Array<Scalars['ID']['input']>;
  extraUsersList?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ChatOrderingSettings = {
  __typename?: 'ChatOrderingSettings';
  /**
   * Whether the ecommerce PO number is enabled for the chat.
   * If not set specifically for this chat, supplier level settings will be returned.
   */
  isEcommercePoNumberEnabled: Scalars['Boolean']['output'];
  /** Whether the ecommerce PO number is required for the chat. This setting should only be used if isEcommercePoNumberEnabled is true. */
  isEcommercePoNumberRequired: Scalars['Boolean']['output'];
};

export type ChatOrderingSettingsInput = {
  chatId: Scalars['String']['input'];
  /**
   * Whether the ecommerce PO number is enabled for the chat.
   * If not set, the supplier level settings will be used.
   * If set, it will override supplier level settings.
   */
  isEcommercePoNumberEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the ecommerce PO number is required for the chat. This setting will only be used if isEcommercePoNumberEnabled is true. */
  isEcommercePoNumberRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatOrderingSettingsUpdateResponse = AuthorizationFailure | ChatOrderingSettings | InputValidationFailure;

export type ChatPricesVisibilityResponse = AuthorizationFailure | ChatPricesVisibilitySuccess | InputValidationFailure;

/** Success response of the `chatPricesVisibility` query */
export type ChatPricesVisibilitySuccess = AppsyncResponse & {
  __typename?: 'ChatPricesVisibilitySuccess';
  displayPricesOverride?: Maybe<Scalars['Boolean']['output']>;
  responseType: ResponseType;
};

export type ChatPricesVisibilityUpdateInput = {
  chatId: Scalars['ID']['input'];
  /**
   * The value of the override for the prices visibility of a chat.
   *
   * If the field is not sent, the prices visibility will be set to NULL and the prices
   * resolving will fallback to the Supplier-level settings.
   *
   * Otherwise, the override value will be set for the chat and takes priority
   * over the Supplier-level settings when resolving the prices.
   *
   * If set to `true`, the product prices will be displayed to the buyers.
   * If set to `false`, the product prices will not be displayed to the buyers.
   * In that case, buyers will only see their Buyer My Price values.
   */
  displayPricesOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatPricesVisibilityUpdateResponse = AuthorizationFailure | ChatPricesVisibilitySuccess | InputValidationFailure;

export type ChatProductFeatures = {
  __typename?: 'ChatProductFeatures';
  currentPurchasingPrice?: Maybe<Scalars['Float']['output']>;
  lastOrderCurrency?: Maybe<Scalars['String']['output']>;
  lastOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastOrderPrice?: Maybe<Scalars['Float']['output']>;
  lastOrderPurchasingPrice?: Maybe<Scalars['Float']['output']>;
  minProfitMargin?: Maybe<Scalars['Float']['output']>;
};

export type ChatRef = Node & RefEdge & {
  __typename?: 'ChatRef';
  /** Id of the referenced chat */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual chat by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<Chat>;
};

export type ChatStatus =
  | 'active'
  | 'archived'
  | 'pending'
  | 'requested'
  | '%future added value';

export type ChatSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'ChatSubCatalogProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ChatSubCatalogProductsInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<ProductFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type ChatSubCatalogProductsResponse = ChatNotFoundError | ChatSubCatalogProductsError | ProductSearchResult | ValidationError;

export type ChatSuppliersByLocations = {
  __typename?: 'ChatSuppliersByLocations';
  result?: Maybe<Array<Maybe<SupplierDetails>>>;
  supplierIds: Array<Maybe<Scalars['ID']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChatType =
  | 'ordering'
  | 'support'
  | '%future added value';

export type ChatUpdateCreatedByInput = {
  createdContext?: InputMaybe<CreatedContext>;
};

export type ChatUpdateInput = {
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<ChatUpdateCreatedByInput>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  sendBuyerOrderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChatStatus>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatUser = {
  __typename?: 'ChatUser';
  chatId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChatUserConnection = Connection & {
  __typename?: 'ChatUserConnection';
  edges?: Maybe<Array<ChatUserEdge>>;
};

export type ChatUserEdge = Edge & {
  __typename?: 'ChatUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Chat users of the supplier */
export type ChatUsers = {
  __typename?: 'ChatUsers';
  /** Chat ID of the users */
  chatId: Scalars['String']['output'];
  /** Chat user IDs to target for the campaign */
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ChatsConnection = Connection & {
  __typename?: 'ChatsConnection';
  edges: Array<ChatsEdge>;
};

export type ChatsEdge = Edge & {
  __typename?: 'ChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type ChocoEntityNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ChocoEntityNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type ChocoEntityType =
  | 'SUPPLIER'
  | '%future added value';

export type ChocoVendor = {
  __typename?: 'ChocoVendor';
  id: Scalars['ID']['output'];
};

export type CityWithOffsets = {
  __typename?: 'CityWithOffsets';
  city?: Maybe<Scalars['String']['output']>;
  utcOffsets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ClaimOnboardingChecklistRewardError = AppsyncError & AppsyncResponse & {
  __typename?: 'ClaimOnboardingChecklistRewardError';
  errorCode?: Maybe<ClaimOnboardingChecklistRewardErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ClaimOnboardingChecklistRewardErrorCode =
  | 'genericError'
  | 'noMonetizedChatPresent'
  | 'notCompletedChecklist'
  | 'notFoundChecklist'
  | 'rewardAlreadyClaimed'
  | '%future added value';

export type ClaimOnboardingChecklistRewardResponse = AuthorizationFailure | ClaimOnboardingChecklistRewardError | ClaimOnboardingChecklistRewardSuccess;

export type ClaimOnboardingChecklistRewardSuccess = {
  __typename?: 'ClaimOnboardingChecklistRewardSuccess';
  id: Scalars['ID']['output'];
  isRewardClaimed: Scalars['Boolean']['output'];
};

export type CognitoAttribute = {
  __typename?: 'CognitoAttribute';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CognitoStateUser = {
  __typename?: 'CognitoStateUser';
  attributes: Array<Maybe<CognitoAttribute>>;
  groups: Array<Maybe<Scalars['String']['output']>>;
  status: CognitoSyncStatus;
};

export type CognitoStateUsers = {
  __typename?: 'CognitoStateUsers';
  email?: Maybe<CognitoStateUser>;
  phone?: Maybe<CognitoStateUser>;
};

/**
 * The status of the user in cognito.
 *   NotCreated - user not created in cognito
 *   Created - user created in cognito, but not synced
 *   Synced - user synced correctly in cognito, including attributes and groups
 *   Corrupted - user exists in cognito, but attributes or groups are incorrect
 */
export type CognitoSyncStatus =
  | 'Corrupted'
  | 'Created'
  | 'NotCreated'
  | 'Synced'
  | '%future added value';

export type CompanyDetailsTwoIncProxy = {
  __typename?: 'CompanyDetailsTwoIncProxy';
  /** Returns full address details for the company or null if any of the fields are missing. */
  address?: Maybe<CompanyDetailsTwoIncProxyAddress>;
  /** Country code as alpha-2 ISO 3166 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The unique canonical ID for the company defined by two.inc */
  id: Scalars['String']['output'];
  /** Legal name of the company */
  name: Scalars['String']['output'];
};

export type CompanyDetailsTwoIncProxyAddress = {
  __typename?: 'CompanyDetailsTwoIncProxyAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  /** State/Region/Province. */
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type CompanyDetailsTwoIncProxyFailure = {
  __typename?: 'CompanyDetailsTwoIncProxyFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CompanyDetailsTwoIncProxyResponse = AuthorizationFailure | CompanyDetailsTwoIncProxyFailure | CompanyDetailsTwoIncProxySuccess | InputValidationFailure;

export type CompanyDetailsTwoIncProxySuccess = {
  __typename?: 'CompanyDetailsTwoIncProxySuccess';
  companyDetails: CompanyDetailsTwoIncProxy;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type ConfidenceSetting = {
  __typename?: 'ConfidenceSetting';
  threshold: Scalars['Float']['output'];
  type: ConfidenceThresholdType;
};

export type ConfidenceSettingInput = {
  threshold: Scalars['Float']['input'];
  type: ConfidenceThresholdType;
};

export type ConfidenceThresholdType =
  | 'customer'
  | 'order'
  | 'product'
  | 'productQuantity'
  | '%future added value';

export type ConfirmAccountLinkingError = AppsyncError & AppsyncResponse & {
  __typename?: 'ConfirmAccountLinkingError';
  errorCode?: Maybe<ConfirmAccountLinkingErrorCode>;
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type ConfirmAccountLinkingErrorCode =
  | 'INVALID_OTP'
  | 'OTP_EXPIRED'
  | 'SOURCE_USER_NOT_FOUND'
  | 'TARGET_USER_NOT_FOUND'
  | 'USER_MERGE_FAILED'
  | 'VERIFICATION_NOT_FOUND'
  | '%future added value';

export type ConfirmAccountLinkingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  otpCode: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmAccountLinkingResponse = AuthorizationFailure | ConfirmAccountLinkingError | ConfirmAccountLinkingSuccess | InputValidationFailure;

export type ConfirmAccountLinkingSuccess = {
  __typename?: 'ConfirmAccountLinkingSuccess';
  message: Scalars['String']['output'];
};

export type ConfirmDeliveryCheckReconciliationResponse = AuthorizationFailure | DeliveryCheckReconciliationRequest | DeliveryCheckReconciliationRequestAlreadyConfirmed | DeliveryCheckReconciliationRequestNotFound | InputValidationFailure | OrderDeliveryCheckReconciliationRequestIdNotMatched;

/** Input type for confirming the save of the email editor state. */
export type ConfirmSaveEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** The S3 URI of the saved email editor state. */
  editorStateUri: Scalars['String']['input'];
  /** The S3 URI of the email template preview image. */
  previewImageUri: Scalars['String']['input'];
};

/** Response type for confirming the save of the email editor state. */
export type ConfirmSaveEmailEditorStateResponse = AuthorizationFailure | ConfirmSaveEmailEditorStateResult | InputValidationFailure;

/** Success result indicating the confirmation of the email editor state save. */
export type ConfirmSaveEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'ConfirmSaveEmailEditorStateResult';
  /** The pre-signed download URL for the email editor state. */
  editorStateDownloadUrl: Scalars['String']['output'];
  /** The pre-signed download URL for the email template preview image. */
  previewImageDownloadUrl: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Indicates whether the confirmation was successful. */
  success: Scalars['Boolean']['output'];
};

export type ConfirmationSource =
  | 'android'
  | 'email'
  | 'ios'
  | 'lobster'
  | 'sms'
  | 'web'
  | 'whatsapp'
  | '%future added value';

export type ConnectAccountError = AppsyncError & AppsyncResponse & {
  __typename?: 'ConnectAccountError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ConnectAccountResponse = ConnectAccountError | ConnectAccountUrl;

export type ConnectAccountUrl = {
  __typename?: 'ConnectAccountUrl';
  clientSecret?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ConnectIntegrationAdapterInput = {
  adapterId: Scalars['ID']['input'];
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectIntegrationAdapterResponse = AuthorizationFailure | ChocoEntityNotFound | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionBaseResult | IntegrationAdapterNotFound | UnsupportedIntegrationAdapterType;

export type ConnectedAccount = Node & {
  __typename?: 'ConnectedAccount';
  appName: Scalars['String']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ConnectedAccountConnection = Connection & {
  __typename?: 'ConnectedAccountConnection';
  edges: Array<ConnectedAccountEdge>;
};

export type ConnectedAccountEdge = Edge & {
  __typename?: 'ConnectedAccountEdge';
  cursor: Scalars['String']['output'];
  node: ConnectedAccount;
};

export type ConnectedAccountInput = {
  refId: Scalars['ID']['input'];
};

export type Connection = {
  edges?: Maybe<Array<Edge>>;
};

/** Represents a contact's information including their contact details and communication channel */
export type ContactDetail = {
  __typename?: 'ContactDetail';
  /** The communication channel type (e.g., email, sms, whatsApp) */
  channel: Scalars['String']['output'];
  /** The contact information (e.g., email address, phone number) */
  contactInfo: Scalars['String']['output'];
};

export type ContactInfos = {
  __typename?: 'ContactInfos';
  /** List of contact details including both contact info and channel */
  contacts: Array<ContactDetail>;
};

/** Input for retrieving contact information with filtering and search capabilities */
export type ContactInfosInput = {
  /**
   * The type of contacts to include in the search results.
   * When not specified, the system defaults to Both.
   */
  contactType?: InputMaybe<ContactType>;
  /** The search term to filter contact information */
  searchTerm: Scalars['String']['input'];
  /** The ID of the supplier to search contact information for */
  supplierId: Scalars['ID']['input'];
};

/** Enumeration of contact types that can be filtered when searching for contact information */
export type ContactType =
  /** Include both buyer and supplier contacts */
  | 'Both'
  /** Filter for buyer contacts only */
  | 'Buyer'
  /** Filter for supplier contacts only */
  | 'Supplier'
  | '%future added value';

/** Input type for getting content upload link */
export type ContentLinkInput = {
  /** File ID used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Content file name */
  name: Scalars['String']['input'];
  /** Content file type */
  type: Scalars['String']['input'];
};

/** Content upload link to be used for uploading html content */
export type ContentUploadLink = {
  __typename?: 'ContentUploadLink';
  /** Media ID used to identify the file in frontend and in bucket */
  fileId: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
  /** S3 URI for the content file */
  uri: Scalars['String']['output'];
};

/** Success result containing content upload link */
export type ContentUploadLinkResult = AppsyncResponse & {
  __typename?: 'ContentUploadLinkResult';
  /** Content upload link */
  link: ContentUploadLink;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CountDetails = {
  __typename?: 'CountDetails';
  estimatedValues: Array<StockItemPrice>;
  stockCountItems: Array<StockItem>;
};

export type CreateBuyerReportScheduleInput = {
  buyerIds: Array<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailRecipients: Array<Scalars['String']['input']>;
  frequency: ScheduledBuyerReportFrequency;
  locale?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['AWSTimestamp']['input'];
  supplierIds: Array<Scalars['String']['input']>;
  timeframe: ScheduledBuyerReportFrequency;
  timeframeType: ScheduledBuyerReportTimeframeType;
  title?: InputMaybe<Scalars['String']['input']>;
  type: BuyerReportType;
};

export type CreateBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportSchedule | InputValidationFailure;

/** Input for creating a new note. */
export type CreateDistributorNoteInput = {
  /** The plain-text content of the note */
  noteBody: Scalars['String']['input'];
  /** The entity this note will be associated with */
  target: DistributorNoteTargetEntity;
  /** Optional title for the note */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDistributorNoteResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

/** Input for creating a new distributor task */
export type CreateDistributorTaskInput = {
  /** Optional objective/goal */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt: DistributorTaskDueAtInput;
  /** Entity to associate the task with */
  targetEntity: DistributorTaskTargetEntityInput;
  /** Title of the task */
  title: Scalars['String']['input'];
};

export type CreateDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type CreateDocumentScanInput = {
  leadId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  /** Logged in user id, not bot user id. */
  userId: Scalars['ID']['input'];
};

export type CreateDocumentScanResponse = AuthorizationFailure | DocumentScanUpdateResult | InputValidationFailure;

export type CreateEmailListResponse = AuthorizationFailure | EmailListCreated | InputValidationFailure;

/** Input type for creating a new marketing campaign */
export type CreateMarketingCampaignInput = {
  /** Channels to be used for the marketing campaign */
  channels: Array<CampaignChannel>;
  /** Title of the marketing campaign as seen by the supplier */
  title: Scalars['String']['input'];
};

export type CreateMenuScanInput = {
  leadId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  /** Logged in user id, not bot user id. */
  userId: Scalars['ID']['input'];
};

export type CreateMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScanUpdateResult;

export type CreateMessageError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateMessageError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreateOrderDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
};

export type CreateOrderDeskEmailList = {
  emailList: Array<OrderDeskEmail>;
  supplierId: Scalars['ID']['input'];
  type: OrderDestEmailListType;
};

export type CreateOrderUploadFailure = {
  __typename?: 'CreateOrderUploadFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreateOrderUploadInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  mediaElements: Array<OrderUploadMediaElementInput>;
};

export type CreateOrderUploadResponse = AuthorizationFailure | CreateOrderUploadFailure | CreateOrderUploadSuccess | InputValidationFailure;

export type CreateOrderUploadSuccess = {
  __typename?: 'CreateOrderUploadSuccess';
  mediaElements: Array<UploadedOrderMediaElement>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
  uploadedOrderId: Scalars['String']['output'];
};

export type CreateProfileError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateProfileError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreateProfileInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProfileResponse = AliasAlreadyLinked | AliasExists | BuyerExists | CreateProfileError | User;

export type CreatePurchasingBusinessFailure = {
  __typename?: 'CreatePurchasingBusinessFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreatePurchasingBusinessResponse = AuthorizationFailure | CreatePurchasingBusinessFailure | CreatePurchasingBusinessSuccess | InputValidationFailure;

export type CreatePurchasingBusinessSuccess = {
  __typename?: 'CreatePurchasingBusinessSuccess';
  businessId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type CreatePurchasingTransmissionFailure = {
  __typename?: 'CreatePurchasingTransmissionFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreatePurchasingTransmissionResponse = AuthorizationFailure | CreatePurchasingTransmissionFailure | CreatePurchasingTransmissionSuccess | InputValidationFailure;

export type CreatePurchasingTransmissionSuccess = {
  __typename?: 'CreatePurchasingTransmissionSuccess';
  files: Array<PurchasingTransmissionFile>;
  purchasingTransmissionId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type CreatePushEndpointInput = {
  /** indicates whether a user would like to recieve message notifications */
  message: Scalars['Boolean']['input'];
  /** indicates whether a user would like to recieve order notifications */
  order: Scalars['Boolean']['input'];
  /** unique identifier created by the notification service for an app on a device */
  token: Scalars['String']['input'];
  type: PushNotificationPlatform;
};

export type CreateReferralInput = {
  referrerUserId: Scalars['ID']['input'];
};

export type CreateReferralResponse = AuthorizationFailure | InputValidationFailure | Referral | ReferralCodeGenerationError | UserHasReferralCode;

export type CreateSalesFunnelInput = {
  name: Scalars['String']['input'];
  /** Names of the states in the sales funnel. This can be appended later. */
  stateNames: Array<Scalars['String']['input']>;
  /**
   * The supplier who will own the sales funnel.
   * For supplier admins, this should be their own supplierId (provided by frontend).
   * For Choco admins, this can be any supplierId.
   */
  supplierId: Scalars['ID']['input'];
};

export type CreateSalesFunnelLeadInput = {
  /**
   * The user ID of the sales rep assigned to this lead.
   * If a sales rep is creating a lead, this must be their own user ID.
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional name of the contact person at the business */
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the business */
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the business */
  businessName: Scalars['String']['input'];
  /** The phone number of the business */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment text to add more context to the lead. */
  commentText?: InputMaybe<Scalars['String']['input']>;
  /** The geographic identifier for the lead. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifierInput;
  /** Optional alias for the lead */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional possible revenue of the lead */
  revenue?: InputMaybe<MoneyV2Input>;
  salesFunnelId: Scalars['ID']['input'];
};

export type CreateSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type CreateSalesFunnelResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelAlreadyExistsError | SalesFunnelDefinition;

export type CreateSalesFunnelStateInput = {
  name: Scalars['String']['input'];
  salesFunnelId: Scalars['ID']['input'];
};

export type CreateSalesFunnelStateResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelDefinition;

export type CreateStorageItemFailure = {
  __typename?: 'CreateStorageItemFailure';
  message: Scalars['String']['output'];
  responseType?: Maybe<ResponseType>;
};

export type CreateStorageItemInput = {
  buyerId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  inventoryItemExternalId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemName: Scalars['String']['input'];
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  storageAreaId?: InputMaybe<Scalars['ID']['input']>;
  unit: Scalars['String']['input'];
};

export type CreateStorageItemResponse = AuthorizationFailure | CreateStorageItemFailure | CreateStorageItemSuccess | InputValidationFailure;

export type CreateStorageItemSuccess = {
  __typename?: 'CreateStorageItemSuccess';
  responseType?: Maybe<ResponseType>;
  storageItem: StorageItem;
};

export type CreateSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreateSupplierContactInput = {
  phoneNumber: Scalars['String']['input'];
  requireOrderReview?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId: Scalars['ID']['input'];
};

export type CreateSupplierContactResponse = AuthorizationFailure | InputValidationFailure | SupplierContact;

export type CreateUpdateSupplierProductResponse = DuplicateProductError | InputValidationFailure | Product | ProductNotFoundError;

export type CreatedBy = {
  __typename?: 'CreatedBy';
  createdContext?: Maybe<CreatedContext>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type CreatedContext =
  | 'addAnotherBusiness'
  | 'buyerAddSupplier'
  | 'buyerAddsVerifiedSupplierNewCustomer'
  | 'buyerRequestsSupplierExistingCustomer'
  | 'buyerRequestsSupplierNewCustomer'
  | 'chatCreatedFromAdmin'
  | 'chatCreatedFromBuyerConcierge'
  | 'chatCreatedFromChocoAi'
  | 'customerMassAccountCreator'
  | 'inviteLink'
  | 'supplierInvitesBuyer'
  | '%future added value';

export type CreatedOrCompletedByNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'CreatedOrCompletedByNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CredentialsData = QbdCredentials;

export type CreditCheckApproved = {
  __typename?: 'CreditCheckApproved';
  monthlyCreditLimit: MoneyV2;
  /** Always ResponseType.Success */
  responseType: ResponseType;
  /** Always CreditCheckStatus.APPROVED */
  status: CreditCheckStatus;
};

export type CreditCheckClientFailure = {
  __typename?: 'CreditCheckClientFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreditCheckDeclined = {
  __typename?: 'CreditCheckDeclined';
  minimumCreditAmount?: Maybe<MoneyV2>;
  monthlyCreditLimit?: Maybe<MoneyV2>;
  reasonCode: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
  /** Always CreditCheckStatus.DECLINED */
  status: CreditCheckStatus;
};

export type CreditCheckFailure = {
  __typename?: 'CreditCheckFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreditCheckInput = {
  organizationNumber: Scalars['ID']['input'];
};

export type CreditCheckResponse = AuthorizationFailure | CreditCheckApproved | CreditCheckClientFailure | CreditCheckDeclined | CreditCheckFailure | CreditCheckTooManyRequestsFailure | InputValidationFailure;

export type CreditCheckStatus =
  | 'APPROVED'
  | 'DECLINED'
  | '%future added value';

export type CreditCheckTooManyRequestsFailure = {
  __typename?: 'CreditCheckTooManyRequestsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreditNoteAlreadyExistsFailure = {
  __typename?: 'CreditNoteAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreditNoteBillingDocument = BillingDocument & {
  __typename?: 'CreditNoteBillingDocument';
  creditNoteNumber: Scalars['String']['output'];
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['AWSTimestamp']['output'];
  totalGrossAmount: MoneyV2;
  vendor: BillingDocumentVendor;
};

export type CreditNoteCreateFailure = {
  __typename?: 'CreditNoteCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type CreditNoteCreateInput = {
  buyerId: Scalars['ID']['input'];
  creditNoteNumber: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  issuedAt: Scalars['AWSTimestamp']['input'];
  items: Array<CreditNoteLineItemInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taxSubtotals: Array<CreditNoteTaxSubtotalInput>;
  totalGrossAmount: MoneyV2Input;
  totalNetAmount: MoneyV2Input;
  totalTaxAmount: MoneyV2Input;
  vendorId: Scalars['ID']['input'];
};

export type CreditNoteCreateResponse = AuthorizationFailure | CreditNoteAlreadyExistsFailure | CreditNoteCreateFailure | CreditNoteCreateSuccess | InputValidationFailure;

export type CreditNoteCreateSuccess = {
  __typename?: 'CreditNoteCreateSuccess';
  creditNoteId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type CreditNoteLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  grossAmount: MoneyV2Input;
  name: Scalars['String']['input'];
  netAmount: MoneyV2Input;
  position: Scalars['Int']['input'];
  productRef: InvoiceProductRefInput;
  quantity: Scalars['Float']['input'];
  taxDetails: CreditNoteLineItemTaxDetailsInput;
  unit: Scalars['String']['input'];
  unitPrice: MoneyV2Input;
};

export type CreditNoteLineItemTaxDetailsInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export type CreditNoteTaxSubtotalInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export type CsvAttachmentRef = {
  __typename?: 'CsvAttachmentRef';
  hasHeaders?: Maybe<Scalars['Boolean']['output']>;
  omnichannelOrderId: Scalars['ID']['output'];
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type CurrencyConfiguration = {
  __typename?: 'CurrencyConfiguration';
  currency: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
};

export type CurrencyConfigurationInput = {
  currency: Scalars['String']['input'];
  decimals: Scalars['Int']['input'];
};

export type CustomCatalog = Node & {
  __typename?: 'CustomCatalog';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Input parameters for the `customCatalogChats` query */
export type CustomCatalogChatsInput = {
  /** Id of the vendor whose custom catalogs are being queried */
  customCatalogId: Scalars['ID']['input'];
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type CustomCatalogChatsResponse = AuthorizationFailure | CustomCatalogChatsResult | InputValidationFailure;

export type CustomCatalogChatsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CustomCatalogChatsResult';
  edges: Array<CustomCatalogChatsResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CustomCatalogChatsResultEdge = Edge & {
  __typename?: 'CustomCatalogChatsResultEdge';
  cursor: Scalars['String']['output'];
  node: ChatRef;
};

export type CustomCatalogFullImportJob = CustomCatalogFullImportJobSucceeded | JobFailed | JobInProgress | JobWaitingForInput;

/** Summarizes the import process, providing details about the items processed during the import. */
export type CustomCatalogFullImportJobResponse = {
  __typename?: 'CustomCatalogFullImportJobResponse';
  /** The number of vendor item units assigned to the customCatalog during the import. */
  itemsAssigned: Scalars['Int']['output'];
  /** The number of new vendor item units created during the import. */
  itemsCreated: Scalars['Int']['output'];
  /** The number of vendor item units unassigned to the customCatalog during the import. */
  itemsUnassigned: Scalars['Int']['output'];
  /** The number of vendor item units unchanged during the import. */
  itemsUnchanged: Scalars['Int']['output'];
  /** The number of vendor item units updated during the import. */
  itemsUpdated: Scalars['Int']['output'];
  /** The number of vendor item units that failed to import due to validation errors. */
  itemsWithErrors: Scalars['Int']['output'];
};

/** Represents a customCatalog import job that succeeded, including partial successes. */
export type CustomCatalogFullImportJobSucceeded = {
  __typename?: 'CustomCatalogFullImportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Indicates whether the import was a partial success, such as some items failing to import due to validation errors. */
  isPartialSuccess: Scalars['Boolean']['output'];
  /** URL where the output file of the import job can be downloaded. */
  outputDownloadUrl: Scalars['String']['output'];
  /** A summary response of the import job detailing the outcome of the import process. */
  response: CustomCatalogFullImportJobResponse;
};

export type CustomCatalogFullImportStartResponse = AuthorizationFailure | CustomCatalogFullImportStartResult | InputValidationFailure;

/** The result of starting a catalog import job. */
export type CustomCatalogFullImportStartResult = AppsyncResponse & {
  __typename?: 'CustomCatalogFullImportStartResult';
  /** The catalog import job created as a result of the mutation. */
  job: CustomCatalogFullImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CustomCatalogFullImportStatusResponse = AuthorizationFailure | CustomCatalogFullImportStatusResult | InputValidationFailure;

export type CustomCatalogFullImportStatusResult = AppsyncResponse & {
  __typename?: 'CustomCatalogFullImportStatusResult';
  /** The catalog import job. */
  job: CustomCatalogFullImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Input for the `customCatalogFullImportStart` mutation. */
export type CustomCatalogFullStartInput = {
  /** The ID of the customCatalog to which the catalog is been assigned to. */
  customCatalogId: Scalars['ID']['input'];
  /** Indicates whether the import should be a dry run. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job used in dry run mode to upload the input file for the actual import. */
  inputFromJobId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

/** Error details for a failed update operation */
export type CustomCatalogItemUnitsBatchUpdateError = {
  __typename?: 'CustomCatalogItemUnitsBatchUpdateError';
  /** Error code for programmatic handling */
  code: Scalars['String']['output'];
  /** ID of the custom catalog where the error occurred */
  customCatalogId: Scalars['String']['output'];
  /** Path to the element that caused the error, e.g. 'customCatalogs[2].add[4]' */
  path: Scalars['String']['output'];
  /** Human-readable description of the error */
  reason: Scalars['String']['output'];
  /** ID of the vendor item unit that couldn't be added or removed */
  vendorItemUnitId: Scalars['String']['output'];
};

/** Input parameters for a single custom catalog update */
export type CustomCatalogItemUnitsBatchUpdateInputItem = {
  /** Array of vendor item unit IDs to add to the custom catalog */
  add: Array<Scalars['String']['input']>;
  /** ID of the custom catalog to update */
  customCatalogId: Scalars['String']['input'];
  /** Array of vendor item unit IDs to remove from the custom catalog */
  remove: Array<Scalars['String']['input']>;
};

/** Filter input for the `customCatalogsForVendor` query */
export type CustomCatalogsForVendorFilter = {
  /** If provided, only returns custom catalogs that are assigned to the given chat. */
  chatId?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for the `customCatalogsForVendor` query */
export type CustomCatalogsForVendorInput = {
  /** Additional filter to narrow down the list of the returned custom catalogs */
  filter?: InputMaybe<CustomCatalogsForVendorFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose custom catalogs are being queried */
  vendorId: Scalars['ID']['input'];
};

export type CustomCatalogsForVendorResponse = AuthorizationFailure | CustomCatalogsForVendorResult | InputValidationFailure;

export type CustomCatalogsForVendorResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CustomCatalogsForVendorResult';
  edges: Array<CustomCatalogsForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CustomCatalogsForVendorResultEdge = Edge & {
  __typename?: 'CustomCatalogsForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: CustomCatalog;
};

/** Input parameters for the `CustomCatalogs` query */
export type CustomCatalogsInput = {
  /**
   * An array of the custom catalog ids to fetch.
   * Maximum of 50 ids can be fetched at once.
   */
  ids: Array<Scalars['ID']['input']>;
};

/** Input parameters for batch updating items in custom catalogs */
export type CustomCatalogsItemUnitsBatchUpdateInput = {
  /** Array of custom catalogs to update with their respective item units to add and remove */
  customCatalogs: Array<CustomCatalogItemUnitsBatchUpdateInputItem>;
};

/** Response for the customCatalogItemUnitsBatchUpdate mutation */
export type CustomCatalogsItemUnitsBatchUpdateResponse = AuthorizationFailure | CustomCatalogsItemUnitsBatchUpdateResult | InputValidationFailure;

/** Result of a successful batch update operation */
export type CustomCatalogsItemUnitsBatchUpdateResult = AppsyncResponse & {
  __typename?: 'CustomCatalogsItemUnitsBatchUpdateResult';
  /** Errors that occurred during the update operation */
  errors: Array<CustomCatalogItemUnitsBatchUpdateError>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CustomCatalogsResponse = AuthorizationFailure | CustomCatalogsResult | InputValidationFailure;

export type CustomCatalogsResult = {
  __typename?: 'CustomCatalogsResult';
  customCatalogs: Array<CustomCatalog>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type CustomerChatsConnection = Connection & {
  __typename?: 'CustomerChatsConnection';
  edges: Array<CustomerChatsEdge>;
  total: Scalars['Int']['output'];
};

export type CustomerChatsEdge = Edge & {
  __typename?: 'CustomerChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

/** Contact data representing a customer who may or may not be on the platform yet. */
export type CustomerContact = {
  __typename?: 'CustomerContact';
  /**  Email of the contact  */
  email: Scalars['AWSEmail']['output'];
  /**  Name of the contact  */
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerInsights = {
  __typename?: 'CustomerInsights';
  averageLineItemsByMonth?: Maybe<CustomerInsightsAverageLineItemsByMonth>;
  chatId: Scalars['ID']['output'];
  grossProfitMarginTrend?: Maybe<CustomerInsightsOrderingTrend>;
  hasGrossProfitMarginInformation?: Maybe<Scalars['Boolean']['output']>;
  hasRevenueInformation?: Maybe<Scalars['Boolean']['output']>;
  healthMetrics?: Maybe<CustomerInsightsHealthMetrics>;
  isFullErpChat?: Maybe<Scalars['Boolean']['output']>;
  last6OrdersAvgGrossProfitMargin?: Maybe<MoneyV2>;
  last6OrdersAvgLineItems?: Maybe<Scalars['Float']['output']>;
  last6OrdersAvgRevenue?: Maybe<MoneyV2>;
  lastOrderGrossProfitMargin?: Maybe<MoneyV2>;
  lastOrderLineItems?: Maybe<Scalars['Float']['output']>;
  lastOrderRevenue?: Maybe<MoneyV2>;
  lineItemsTrend?: Maybe<CustomerInsightsOrderingTrend>;
  revenueTrend?: Maybe<CustomerInsightsOrderingTrend>;
  totalsByMonth?: Maybe<CustomerInsightsTotalsByMonth>;
};

export type CustomerInsightsAverageLineItemsByMonth = {
  __typename?: 'CustomerInsightsAverageLineItemsByMonth';
  averageLineItemsMonth1?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth2?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth3?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth4?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth5?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth6?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth7?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth8?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth9?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth10?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth11?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth12?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonthCurrent?: Maybe<Scalars['Float']['output']>;
};

export type CustomerInsightsHealthMetrics = CustomerInsightsTotalGrossProfitMargin | CustomerInsightsTotalRevenue;

export type CustomerInsightsNotification = Node & {
  __typename?: 'CustomerInsightsNotification';
  chat: Chat;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  data: CustomerInsightsNotificationData;
  id: Scalars['ID']['output'];
  markedReadAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  userId: Scalars['String']['output'];
};

export type CustomerInsightsNotificationConnection = Connection & {
  __typename?: 'CustomerInsightsNotificationConnection';
  /** Next page of results. Null indicates no more results. */
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<CustomerInsightsNotificationsEdge>;
  total: Scalars['Int']['output'];
};

export type CustomerInsightsNotificationData = CustomerOrderingTrendChangeNotificationData | CustomerStatusChangeNotificationData;

export type CustomerInsightsNotificationFilter = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CustomerInsightsNotificationType>;
};

export type CustomerInsightsNotificationSubscriptionResponse = AuthorizationFailure | CustomerInsightsNotification;

export type CustomerInsightsNotificationType =
  | 'CustomerChurnStatusChangeNotification'
  | 'CustomerOrderingTrendChangeNotification'
  | '%future added value';

export type CustomerInsightsNotificationsEdge = Edge & {
  __typename?: 'CustomerInsightsNotificationsEdge';
  cursor: Scalars['String']['output'];
  node: CustomerInsightsNotification;
};

export type CustomerInsightsOrderingTrend =
  | 'decreasing'
  | 'increasing'
  | 'noChange'
  | 'significantlyDecrease'
  | 'significantlyIncrease'
  | '%future added value';

export type CustomerInsightsResponse = AuthorizationFailure | CustomerInsightsResponseFailure | CustomerInsightsResponseSuccess | InputValidationFailure;

export type CustomerInsightsResponseFailure = {
  __typename?: 'CustomerInsightsResponseFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type CustomerInsightsResponseSuccess = {
  __typename?: 'CustomerInsightsResponseSuccess';
  customerInsights: CustomerInsights;
  responseType: ResponseType;
};

export type CustomerInsightsTotalGrossProfitMargin = {
  __typename?: 'CustomerInsightsTotalGrossProfitMargin';
  currentMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  currentMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
  lastMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  lastMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
  lastYearSameMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  lastYearSameMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
};

export type CustomerInsightsTotalGrossProfitMarginByMonth = {
  __typename?: 'CustomerInsightsTotalGrossProfitMarginByMonth';
  totalGrossProfitMarginMonth1?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth2?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth3?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth4?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth5?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth6?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth7?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth8?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth9?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth10?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth11?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth12?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonthCurrent?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalRevenue = {
  __typename?: 'CustomerInsightsTotalRevenue';
  currentMonthTotalRevenue?: Maybe<MoneyV2>;
  lastMonthTotalRevenue?: Maybe<MoneyV2>;
  lastYearSameMonthTotalRevenue?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalRevenueByMonth = {
  __typename?: 'CustomerInsightsTotalRevenueByMonth';
  totalRevenueMonth1?: Maybe<MoneyV2>;
  totalRevenueMonth2?: Maybe<MoneyV2>;
  totalRevenueMonth3?: Maybe<MoneyV2>;
  totalRevenueMonth4?: Maybe<MoneyV2>;
  totalRevenueMonth5?: Maybe<MoneyV2>;
  totalRevenueMonth6?: Maybe<MoneyV2>;
  totalRevenueMonth7?: Maybe<MoneyV2>;
  totalRevenueMonth8?: Maybe<MoneyV2>;
  totalRevenueMonth9?: Maybe<MoneyV2>;
  totalRevenueMonth10?: Maybe<MoneyV2>;
  totalRevenueMonth11?: Maybe<MoneyV2>;
  totalRevenueMonth12?: Maybe<MoneyV2>;
  totalRevenueMonthCurrent?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalsByMonth = CustomerInsightsTotalGrossProfitMarginByMonth | CustomerInsightsTotalRevenueByMonth;

export type CustomerMatchingConfidence = {
  __typename?: 'CustomerMatchingConfidence';
  isCustomerCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPONumberCorrect?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerOrderInsight = {
  __typename?: 'CustomerOrderInsight';
  status?: Maybe<InsightsStatus>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderInsightsResponseFailure = {
  __typename?: 'CustomerOrderInsightsResponseFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type CustomerOrderInsightsResponseSuccess = {
  __typename?: 'CustomerOrderInsightsResponseSuccess';
  customerOrderInsights: Array<Maybe<CustomerOrderInsight>>;
  responseType: ResponseType;
};

export type CustomerOrderInsightsResponseSuccessV2 = {
  __typename?: 'CustomerOrderInsightsResponseSuccessV2';
  averageBasketSizeTrend: Scalars['String']['output'];
  fallOffProducts: Array<Maybe<FallOffProduct>>;
  productGrowthRates: Array<Maybe<ProductGrowthRate>>;
  responseType: ResponseType;
};

export type CustomerOrderingTrendChangeNotificationData = {
  __typename?: 'CustomerOrderingTrendChangeNotificationData';
  orderingTrend: ChatChurnOrdersTrend;
  ordersTrend: Scalars['Float']['output'];
};

export type CustomerOrdersInsightsInput = {
  chatId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerOrdersInsightsInputV2 = {
  chatId: Scalars['ID']['input'];
};

export type CustomerOrdersInsightsResponse = AuthorizationFailure | CustomerOrderInsightsResponseFailure | CustomerOrderInsightsResponseSuccess | InputValidationFailure;

export type CustomerOrdersInsightsResponseV2 = AuthorizationFailure | CustomerOrderInsightsResponseFailure | CustomerOrderInsightsResponseSuccessV2 | InputValidationFailure;

export type CustomerStatusChangeNotificationData = {
  __typename?: 'CustomerStatusChangeNotificationData';
  churnStatus: ChatChurnStatus;
  lastOrderDate: Scalars['AWSTimestamp']['output'];
};

export type CutOffTime = {
  __typename?: 'CutOffTime';
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['output'];
  type: CutOffTimeType;
};

export type CutOffTimeInput = {
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['input'];
  type: CutOffTimeType;
};

export type CutOffTimeType =
  | 'flexible'
  | 'noCutoff'
  | 'strict'
  | '%future added value';

export type CutoffSetting = NoCutoffSetting | WithCutoffSetting;

export type CutoffSettingInput = {
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  /** in days */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  type: CutOffTimeType;
};

export type DateFilter = {
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/**
 * Represents a fixed-point decimal number, e.g. 12.34
 * Please take care when parsing this string to not lose the precision
 */
export type Decimal = {
  __typename?: 'Decimal';
  /** Regex: /^[+-]?\d+(\.\d+)?$/ */
  amount: Scalars['String']['output'];
};

export type DeclineOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeclineOrderResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | OrderDeclined;

export type DeleteBuyerReportScheduleError = AppsyncError & AppsyncResponse & {
  __typename?: 'DeleteBuyerReportScheduleError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeleteBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportScheduleNotFound | DeleteBuyerReportScheduleError | DeleteBuyerReportScheduleSuccess | InputValidationFailure;

export type DeleteBuyerReportScheduleSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerReportScheduleSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeleteBuyerStockInventoryProductsFailure = {
  __typename?: 'DeleteBuyerStockInventoryProductsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeleteBuyerStockInventoryProductsInput = {
  buyerId: Scalars['ID']['input'];
  stockInventoryProductIds: Array<Scalars['ID']['input']>;
};

export type DeleteBuyerStockInventoryProductsResponse = AuthorizationFailure | DeleteBuyerStockInventoryProductsFailure | DeleteBuyerStockInventoryProductsSuccess | InputValidationFailure;

export type DeleteBuyerStockInventoryProductsSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerStockInventoryProductsSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

/** Input for deleting an existing note. */
export type DeleteDistributorNoteInput = {
  /** The ID of the note to delete */
  noteId: Scalars['ID']['input'];
};

export type DeleteDistributorNoteResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

export type DeleteDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type DeleteInventoryItemsFailure = {
  __typename?: 'DeleteInventoryItemsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType?: Maybe<ResponseType>;
};

export type DeleteInventoryItemsInput = {
  buyerId: Scalars['ID']['input'];
};

export type DeleteInventoryItemsResponse = AuthorizationFailure | DeleteInventoryItemsFailure | DeleteInventoryItemsSuccess | InputValidationFailure;

export type DeleteInventoryItemsSuccess = {
  __typename?: 'DeleteInventoryItemsSuccess';
  responseType?: Maybe<ResponseType>;
};

export type DeleteParsedPurchaseOrdersFailure = {
  __typename?: 'DeleteParsedPurchaseOrdersFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeleteParsedPurchaseOrdersInput = {
  parsedPurchaseOrderIds: Array<Scalars['ID']['input']>;
};

export type DeleteParsedPurchaseOrdersResponse = AuthorizationFailure | DeleteParsedPurchaseOrdersFailure | DeleteParsedPurchaseOrdersSuccess | InputValidationFailure | NotFoundError;

export type DeleteParsedPurchaseOrdersSuccess = {
  __typename?: 'DeleteParsedPurchaseOrdersSuccess';
  parsedPurchaseOrderIds: Array<Scalars['ID']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeleteProductImageInput = {
  productId: Scalars['ID']['input'];
};

export type DeletePurchaseOrdersFailure = {
  __typename?: 'DeletePurchaseOrdersFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeletePurchaseOrdersInput = {
  purchaseOrderIds: Array<Scalars['ID']['input']>;
};

export type DeletePurchaseOrdersResponse = AuthorizationFailure | DeletePurchaseOrdersFailure | DeletePurchaseOrdersSuccess | InputValidationFailure | NotFoundError;

export type DeletePurchaseOrdersSuccess = {
  __typename?: 'DeletePurchaseOrdersSuccess';
  purchaseOrderIds: Array<Scalars['ID']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeletePurchasingBusinessFailure = {
  __typename?: 'DeletePurchasingBusinessFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeletePurchasingBusinessInput = {
  businessIds: Array<Scalars['ID']['input']>;
};

export type DeletePurchasingBusinessResponse = AuthorizationFailure | DeletePurchasingBusinessFailure | DeletePurchasingBusinessSuccess | InputValidationFailure;

export type DeletePurchasingBusinessSuccess = {
  __typename?: 'DeletePurchasingBusinessSuccess';
  businessIds: Array<Scalars['ID']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeleteSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'DeleteSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeleteSubCatalogSuccess = AppsyncResponse & {
  __typename?: 'DeleteSubCatalogSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DeleteSupplierNegotiatedPriceResult = {
  __typename?: 'DeleteSupplierNegotiatedPriceResult';
  success: Scalars['Boolean']['output'];
};

export type DeletedChatSetting = {
  __typename?: 'DeletedChatSetting';
  /** chat ID of the deleted deliverySetting */
  id: Scalars['ID']['output'];
};

export type DeletedSupplierNegotiatedPriceResponse = AuthorizationFailure | DeleteSupplierNegotiatedPriceResult;

export type DeliveryCheckProblem = {
  __typename?: 'DeliveryCheckProblem';
  /** @deprecated use value instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** @deprecated use imageUrls instead */
  image?: Maybe<Scalars['String']['output']>;
  problemType?: Maybe<OrderedProductDeliveryCheckProblemType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryCheckProblemInput = {
  /** @deprecated use value instead */
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use imageIds instead */
  image?: InputMaybe<Scalars['String']['input']>;
  problemType?: InputMaybe<OrderedProductDeliveryCheckProblemType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type DeliveryCheckProductInput = {
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
  productId: Scalars['ID']['input'];
};

export type DeliveryCheckReconciliationRequest = {
  __typename?: 'DeliveryCheckReconciliationRequest';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  dateOfDelivery?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** @deprecated use dateOfDelivery instead */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: DeliveryCheckReconciliationRequestStatus;
  statusHistory?: Maybe<Array<Maybe<DeliveryCheckReconciliationRequestStatusHistory>>>;
  type: DeliveryCheckReconciliationRequestType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type DeliveryCheckReconciliationRequestAlreadyConfirmed = AppsyncError & AppsyncResponse & {
  __typename?: 'DeliveryCheckReconciliationRequestAlreadyConfirmed';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeliveryCheckReconciliationRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dateOfDelivery?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated use dateOfDelivery instead */
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  type: DeliveryCheckReconciliationRequestType;
};

export type DeliveryCheckReconciliationRequestNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'DeliveryCheckReconciliationRequestNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DeliveryCheckReconciliationRequestStatus =
  | 'confirmed'
  | 'requested'
  | '%future added value';

export type DeliveryCheckReconciliationRequestStatusHistory = {
  __typename?: 'DeliveryCheckReconciliationRequestStatusHistory';
  status: DeliveryCheckReconciliationRequestStatus;
  timestamp: Scalars['AWSTimestamp']['output'];
};

export type DeliveryCheckReconciliationRequestType =
  | 'creditNote'
  | 'other'
  | 'replacement'
  | '%future added value';

export type DeliveryDateContext =
  | 'checkout'
  | 'orderAgent'
  | 'orderDesk'
  | '%future added value';

export type DeliveryExceptionCutoffSettingInput = {
  leadTimeAdjustedCutoff?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: CutOffTimeType;
};

export type DeliveryExceptionInput = {
  cutoff?: InputMaybe<DeliveryExceptionCutoffSettingInput>;
  date: Scalars['AWSDate']['input'];
  type: DeliveryExceptionInputType;
};

export type DeliveryExceptionInputType =
  | 'noDeliveryException'
  | 'singleDayDeliveryException'
  | '%future added value';

export type DeliverySettingException = NoDeliveryException | SingleDayDeliveryExceptionWithCutoff | SingleDayDeliveryExceptionWithoutCutoff;

export type DeliverySettingExceptionUpdateBehavior =
  | 'additionalDelivery'
  | 'cutoffChanged'
  | '%future added value';

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  name: Scalars['String']['output'];
  points: Array<Coordinate>;
};

export type DeliveryZoneInput = {
  name: Scalars['String']['input'];
  points: Array<CoordinateInput>;
};

export type DerivedPriceForOrderGuide = {
  __typename?: 'DerivedPriceForOrderGuide';
  price: Money;
  priceBeforeDiscount?: Maybe<Money>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type DerivedPriceForOrderGuideResponse = AuthorizationFailure | DerivedPriceForOrderGuide | InputValidationFailure;

export type DirectPayActivationStatus =
  | 'ACTIVE'
  | 'DISABLED'
  | '%future added value';

export type DirectPayCustomerAlreadyOnboardedFailure = {
  __typename?: 'DirectPayCustomerAlreadyOnboardedFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayCustomerDetailsInput = {
  buyerId: Scalars['ID']['input'];
  contacts: Array<PaymentCustomerContactInput>;
  name: Scalars['String']['input'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
};

export type DirectPayCustomerOnboardFailure = {
  __typename?: 'DirectPayCustomerOnboardFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayCustomerOnboardInput = {
  customerDetails: DirectPayCustomerDetailsInput;
  profileDetails: DirectPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type DirectPayCustomerOnboardResponse = AuthorizationFailure | DirectPayCustomerAlreadyOnboardedFailure | DirectPayCustomerOnboardFailure | DirectPayCustomerOnboardSuccess | InputValidationFailure;

export type DirectPayCustomerOnboardSuccess = {
  __typename?: 'DirectPayCustomerOnboardSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DirectPayCustomerStatusUpdateFailure = {
  __typename?: 'DirectPayCustomerStatusUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayCustomerStatusUpdateInput = {
  paymentCustomerId: Scalars['ID']['input'];
  status: DirectPayActivationStatus;
  vendorId: Scalars['ID']['input'];
};

export type DirectPayCustomerStatusUpdateResponse = AuthorizationFailure | DirectPayCustomerStatusUpdateFailure | DirectPayCustomerStatusUpdateSuccess | InputValidationFailure | PaymentCustomerNotFound;

export type DirectPayCustomerStatusUpdateSuccess = {
  __typename?: 'DirectPayCustomerStatusUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DirectPayDeclineReasonCode =
  | 'AUTHENTICATION_FAILED'
  | 'BANK_ISSUE'
  | 'CANCELLED'
  | 'CARD_ISSUE'
  | 'GENERIC_DECLINE'
  | 'INSUFFICIENT_FUNDS'
  | 'UNSPECIFIED'
  | '%future added value';

export type DirectPayPaymentCustomer = {
  __typename?: 'DirectPayPaymentCustomer';
  activationStatus: DirectPayActivationStatus;
  contacts: Array<PaymentCustomerContact>;
  id: Scalars['ID']['output'];
  paymentMethods: Array<PaymentMethod>;
  paymentProfileId: Scalars['ID']['output'];
};

export type DirectPayPaymentMethodDeleteFailure = {
  __typename?: 'DirectPayPaymentMethodDeleteFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayPaymentMethodDeleteInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type DirectPayPaymentMethodDeleteResponse = AuthorizationFailure | DirectPayPaymentMethodDeleteFailure | DirectPayPaymentMethodDeleteSuccess | InputValidationFailure;

export type DirectPayPaymentMethodDeleteSuccess = {
  __typename?: 'DirectPayPaymentMethodDeleteSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DirectPayPaymentMethodSetDefaultFailure = {
  __typename?: 'DirectPayPaymentMethodSetDefaultFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayPaymentMethodSetDefaultInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type DirectPayPaymentMethodSetDefaultResponse = AuthorizationFailure | DirectPayPaymentMethodSetDefaultFailure | DirectPayPaymentMethodSetDefaultSuccess | InputValidationFailure;

export type DirectPayPaymentMethodSetDefaultSuccess = {
  __typename?: 'DirectPayPaymentMethodSetDefaultSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DirectPayPaymentSubmitDeclinedFailure = {
  __typename?: 'DirectPayPaymentSubmitDeclinedFailure';
  message: Scalars['String']['output'];
  reasonCode: DirectPayDeclineReasonCode;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayPaymentSubmitFailure = {
  __typename?: 'DirectPayPaymentSubmitFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DirectPayPaymentSubmitInput = {
  billingDocumentId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type DirectPayPaymentSubmitResponse = AuthorizationFailure | DirectPayPaymentSubmitDeclinedFailure | DirectPayPaymentSubmitFailure | DirectPayPaymentSubmitSuccess | InputValidationFailure | PaymentCustomerNotFound;

export type DirectPayPaymentSubmitSuccess = {
  __typename?: 'DirectPayPaymentSubmitSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type DirectPayProfileDetailsInput = {
  chatCustomerNumber: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
};

export type DisconnectAccountError = AppsyncError & AppsyncResponse & {
  __typename?: 'DisconnectAccountError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type DisconnectAccountResponse = DisconnectAccountError | DisconnectAccountStatus;

export type DisconnectAccountStatus = {
  __typename?: 'DisconnectAccountStatus';
  appName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DisconnectIntegrationAdapterInput = {
  id: Scalars['ID']['input'];
};

export type DisconnectIntegrationAdapterResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionBaseResult | IntegrationAdapterConnectionNotFound;

export type DistanceUnitOfMeasure =
  | 'Feet'
  | 'Meters'
  | '%future added value';

export type DistributorNote = {
  __typename?: 'DistributorNote';
  /** The date that the note was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The user who created the note. */
  createdByUser: User;
  /** The user who created the note. */
  createdByUserId: Scalars['String']['output'];
  /**
   * The last date that the note text was edited, or the time
   * that the note was created.
   */
  editedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The user who last edited the note text or title. */
  editedByUser?: Maybe<User>;
  /** The user who last edited the note text or title. */
  editedByUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The body content of the note. Currently only supports plain text.
   * Future support for rich text and other formats should be added through
   * a union type on this field (e.g., union NoteBody = PlainTextBody | RichTextBody)
   */
  noteBody: PlainTextBody;
  /** Optional title for the note */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The last date that any operation was performed on the note,
   * or the time that the note was created.
   */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type DistributorNoteConnection = {
  __typename?: 'DistributorNoteConnection';
  /**
   * The cursor at the end of the connection. Null if and only if there are no more notes
   * to retrieve.
   */
  cursor?: Maybe<Scalars['String']['output']>;
  notes: Array<DistributorNote>;
};

export type DistributorNoteEntityType =
  | 'CUSTOMER'
  | 'LEAD'
  | '%future added value';

/**
 * Represents the entity (e.g., LEAD, CUSTOMER) that a note is or will be associated with.
 * This type is used only in operations where a specific note is not yet identified
 * (like creation or querying all notes for an entity).
 */
export type DistributorNoteTargetEntity = {
  /** The ID of the entity (e.g., the lead ID or customer ID) */
  entityId: Scalars['ID']['input'];
  /** The type of entity this ID refers to */
  entityType: DistributorNoteEntityType;
};

export type DistributorNoteUpdateResult = AppsyncResponse & {
  __typename?: 'DistributorNoteUpdateResult';
  /** Updated distributor note */
  distributorNote: DistributorNote;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType;
};

/** Promo preferred products content */
export type DistributorPromoPreferredProducts = {
  __typename?: 'DistributorPromoPreferredProducts';
  /** Marketing campaign ID associated with this promotion */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this preferred products, kept optional to support future checkout flow */
  chat?: Maybe<Chat>;
  /** Unique identifier for the promoted content target */
  id: Scalars['ID']['output'];
  /** Lists all promoted product variants. Always returns a list, which can be empty. */
  promotedSupplierVariants: Array<PromotedVendorItemUnitVariant>;
  /** The promoted title for the preferred products */
  promotedTitle: Scalars['String']['output'];
  /** The supplier of the promoted products */
  supplier: Supplier;
};

/** Union type for distributor promoted content, allowing for future extensibility */
export type DistributorPromotedContent = DistributorPromoPreferredProducts;

/** Returned when no distributor promoted content is found */
export type DistributorPromotedContentNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'DistributorPromotedContentNotFound';
  /** Optional message explaining why no content was found */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType;
};

/** Represents a task created by a distributor user, associated with either a customer or lead */
export type DistributorTask = {
  __typename?: 'DistributorTask';
  /** Optional objective/goal of the task */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the task was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** User who created the task */
  createdByUser: User;
  /** ID of the user who created the task */
  createdByUserId: Scalars['String']['output'];
  /** When the task is due */
  dueAt: DistributorTaskDueAt;
  id: Scalars['ID']['output'];
  /** Current status of the task */
  status: DistributorTaskStatus;
  /** The entity this task is associated with */
  targetEntity: DistributorTaskTargetEntity;
  /**
   * Target entity details to be displayed (lead or customer)
   * @deprecated Use targetEntity.entityDetails instead
   */
  targetEntityDetails: DistributorTaskTargetEntityDetails;
  /** Title of the task */
  title: Scalars['String']['output'];
};

/** Connection type for paginated task results */
export type DistributorTaskConnection = {
  __typename?: 'DistributorTaskConnection';
  /** Cursor for pagination. If null, there are no more tasks to retrieve. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The tasks */
  tasks: Array<DistributorTask>;
};

/**
 * When a task is due, represented as a date plus an optional time. Both
 * values are local to the specified timezone.
 */
export type DistributorTaskDueAt = {
  __typename?: 'DistributorTaskDueAt';
  /** The date the task is due. Relative to the provided timezone. */
  date: Scalars['AWSDate']['output'];
  /**
   * Optional time the task is due. Provided as local time (HH:mm).
   * Relative to the provided timezone.
   */
  time?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * The timezone to which the task has been localized. Provided
   * in IANA format.
   */
  timezone: Scalars['String']['output'];
};

/** Input for specifying when a task is due */
export type DistributorTaskDueAtInput = {
  /**
   * Context for the due date and due time.
   * Default is SupplierTimezone.
   */
  context?: InputMaybe<DistributorTaskDueAtTimeContext>;
  /** Local date in the supplier's timezone that task is due. */
  date: Scalars['AWSDate']['input'];
  /**
   * Local time in the supplier's timezone that the task is due.
   * Provided as HH:mm.
   */
  time?: InputMaybe<Scalars['AWSTime']['input']>;
};

/** Provides context for the due date and due time of a task. */
export type DistributorTaskDueAtTimeContext =
  /** The date and time are relative to the supplier's timezone */
  | 'SupplierTimezone'
  | '%future added value';

/** Types of entities that can have tasks */
export type DistributorTaskEntityType =
  | 'CUSTOMER'
  | 'LEAD'
  | '%future added value';

/** Available task statuses */
export type DistributorTaskStatus =
  | 'COMPLETED'
  | 'OUTSTANDING'
  | '%future added value';

/** The entity a task is associated with */
export type DistributorTaskTargetEntity = {
  __typename?: 'DistributorTaskTargetEntity';
  /** Entity details to be displayed (lead or customer) */
  entityDetails: DistributorTaskTargetEntityDetails;
  /** ID of the entity (customer or lead) */
  entityId: Scalars['ID']['output'];
  /** Type of entity */
  entityType: DistributorTaskEntityType;
};

export type DistributorTaskTargetEntityDetails = {
  __typename?: 'DistributorTaskTargetEntityDetails';
  displayName?: Maybe<Scalars['String']['output']>;
};

/** Input for specifying which entity to associate a task with */
export type DistributorTaskTargetEntityInput = {
  /** ID of the entity (customer or lead) */
  entityId: Scalars['ID']['input'];
  /** Type of entity */
  entityType: DistributorTaskEntityType;
};

export type DocumentScan = Node & {
  __typename?: 'DocumentScan';
  /** Timestamp of when the document scan job was started */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * The list of files attached to this scan
   * We only support one file for now
   * Can be empty if no files have been uploaded yet
   */
  attachments?: Maybe<Array<DocumentScanAttachment>>;
  /** Timestamp of when the scan was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /** The id of the lead associated with the scan */
  leadId: Scalars['ID']['output'];
  /** File scan result */
  scanResult?: Maybe<DocumentScanResult>;
  /** Job processing status */
  status: DocumentScanStatus;
  /** The supplier related to the document scan */
  supplierId: Scalars['ID']['output'];
  /** Timestamp of when the scan was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who activated the document scan job */
  userId: Scalars['ID']['output'];
};

export type DocumentScanAttachment = {
  __typename?: 'DocumentScanAttachment';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The scan this file belongs to */
  documentScanId: Scalars['ID']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DocumentScanAttachmentInput = {
  contentType: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type DocumentScanAttachmentUploadLink = {
  __typename?: 'DocumentScanAttachmentUploadLink';
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['output'];
  /** Attachment ID used to identify the file in the bucket */
  fileId: Scalars['String']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
};

export type DocumentScanAttachmentUploadLinkInput = {
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['input'];
  /** Attachment file name */
  fileName: Scalars['String']['input'];
};

export type DocumentScanAttachmentUploadLinkResult = AppsyncResponse & {
  __typename?: 'DocumentScanAttachmentUploadLinkResult';
  /** Updated links for the document scan attachments */
  links?: Maybe<Array<DocumentScanAttachmentUploadLink>>;
  responseType: ResponseType;
};

export type DocumentScanConnection = Connection & {
  __typename?: 'DocumentScanConnection';
  edges: Array<DocumentScanEdge>;
  total: Scalars['Int']['output'];
};

export type DocumentScanEdge = Edge & {
  __typename?: 'DocumentScanEdge';
  cursor: Scalars['String']['output'];
  node: DocumentScan;
};

export type DocumentScanResult = {
  __typename?: 'DocumentScanResult';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
};

export type DocumentScanStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING'
  | '%future added value';

export type DocumentScanUpdateResult = AppsyncResponse & {
  __typename?: 'DocumentScanUpdateResult';
  /** Updated document scan */
  documentScan: DocumentScan;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType;
};

/** Campaign attachment to be used for adding attachments to the channel message */
export type DownloadableCampaignAttachment = {
  __typename?: 'DownloadableCampaignAttachment';
  /** Signed download URL for the attachment file */
  downloadUrl: Scalars['String']['output'];
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

export type DuplicateProductError = AppsyncError & AppsyncResponse & {
  __typename?: 'DuplicateProductError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type EchoInput = {
  message: Scalars['String']['input'];
};

export type EchoResponse = {
  __typename?: 'EchoResponse';
  message: Scalars['String']['output'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EditBuyerReportScheduleInput = {
  buyerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  frequency?: InputMaybe<ScheduledBuyerReportFrequency>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeframe?: InputMaybe<ScheduledBuyerReportFrequency>;
  timeframeType?: InputMaybe<ScheduledBuyerReportTimeframeType>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BuyerReportType>;
};

export type EditBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportSchedule | BuyerReportScheduleNotFound | InputValidationFailure;

/** Input for the editSalesFunnelLead mutation. */
export type EditSalesFunnelLeadInput = {
  /** Optional name of the contact person at the business */
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the business */
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the business */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment text to add more context to the lead. */
  commentText?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the lead to edit */
  id: Scalars['ID']['input'];
  /** Optional possible revenue of the lead */
  revenue?: InputMaybe<MoneyV2Input>;
};

export type EditSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

/** order editing Input */
export type EditedOrderProductsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  productId: Scalars['String']['input'];
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/** Email content to be used for sending emails */
export type EmailContent = {
  __typename?: 'EmailContent';
  /** Email body message */
  bodyMessage: Scalars['String']['output'];
  /** Email image URL */
  imageURL?: Maybe<Scalars['String']['output']>;
  /** Email subject */
  subject: Scalars['String']['output'];
  /** Email title */
  title: Scalars['String']['output'];
};

export type EmailEditorStateFileInput = {
  /** Content file name */
  name: Scalars['String']['input'];
  /** Content file type */
  type: Scalars['String']['input'];
};

/** Response type for when the email editor state is not found. */
export type EmailEditorStateNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailEditorStateNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to `error` */
  responseType: ResponseType;
};

export type EmailFromBuyerReportScheduleRemoved = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailFromBuyerReportScheduleRemoved';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type EmailInBuyerReportScheduleNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailInBuyerReportScheduleNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type EmailList = {
  __typename?: 'EmailList';
  emails: Array<Scalars['String']['output']>;
  type: OrderDestEmailListType;
};

export type EmailListCreated = {
  __typename?: 'EmailListCreated';
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
  type: OrderDestEmailListType;
};

export type EmailLists = {
  __typename?: 'EmailLists';
  emailLists: Array<EmailList>;
};

/** Email HTML and template to be used for compiling the emails */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  /** S3 URI for the email HTML content */
  htmlUri: Scalars['String']['output'];
};

export type EmbedDashboardUrlResponse = {
  __typename?: 'EmbedDashboardUrlResponse';
  embedUrl: Scalars['String']['output'];
};

export type EntityIdentity = IntegrationEntityIdentity | InternalEntityIdentity;

/** Authentication methods supported for SFTP user access */
export type ErpSftpAuthMethod =
  /** Username and password authentication */
  | 'PASSWORD'
  /** SSH public key authentication */
  | 'SSH_KEY'
  | '%future added value';

/** Defines permission settings for a specific folder path, including the user's role within that folder */
export type ErpSftpFolderPermission = {
  __typename?: 'ErpSftpFolderPermission';
  /** Timestamp when this permission was granted in ISO 8601 format */
  createdAt: Scalars['String']['output'];
  /** The folder path for which the permission applies. for example "edeka" will give access for "/edeka". */
  folderPath: Scalars['String']['output'];
  /** The role/permission level the user has for this specific folder */
  role: ErpSftpUserRole;
  /** Timestamp when this permission was last updated in ISO 8601 format */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for defining folder-level permissions */
export type ErpSftpFolderPermissionInput = {
  /** The folder path for which to set permissions. Should be an absolute path starting with '/'. */
  folderPath: Scalars['String']['input'];
  /** The role/permission level to grant for this folder */
  role: ErpSftpUserRole;
};

/**
 * Represents an ERP SFTP user with authentication credentials and folder permissions.
 * Users can authenticate via password or SSH key and have role-based access to specific folders.
 */
export type ErpSftpUser = Node & {
  __typename?: 'ErpSftpUser';
  /** Authentication method configured for this user */
  authMethod: ErpSftpAuthMethod;
  /** Timestamp when the user was created in ISO 8601 format */
  createdAt: Scalars['String']['output'];
  /** Unique identifier for the SFTP user */
  id: Scalars['ID']['output'];
  /** Indicate if the user account is active and can be used for SFTP access */
  isActive: Scalars['Boolean']['output'];
  /**
   * List of folder permissions defining which folders the user can access and their role in each folder.
   * The maximum size is 100.
   */
  permissions: Array<ErpSftpFolderPermission>;
  /**
   * SSH public key for authentication when using SSH_KEY auth method.
   * Required when authMethod is SSH_KEY, null when using PASSWORD.
   */
  sshPublicKey?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the user was last updated in ISO 8601 format */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Username for SFTP login. Must be unique across all SFTP users. */
  username: Scalars['String']['output'];
};

/** Input parameters for creating a new SFTP user */
export type ErpSftpUserCreateInput = {
  /** Authentication method to configure for this user */
  authMethod: ErpSftpAuthMethod;
  /**
   * Whether the user should be created in an active state.
   *
   * If the user is not active, the user will not get access to the sftp server
   *
   * Defaults to true if not specified.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Password for authentication when using PASSWORD auth method.
   * Required when authMethod is PASSWORD, ignored when using SSH_KEY.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial folder permissions to grant to the user.
   * If not provided, user will be created without any folder access.
   */
  permissions?: InputMaybe<Array<ErpSftpFolderPermissionInput>>;
  /**
   * SSH public key for authentication when using SSH_KEY auth method.
   * Required when authMethod is SSH_KEY, ignored when using PASSWORD.
   */
  sshPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** Desired username for the new user. Must be unique and follow system naming conventions. */
  username: Scalars['String']['input'];
};

export type ErpSftpUserCreateResponse = AuthorizationFailure | ErpSftpUserCreateSuccess | InputValidationFailure;

export type ErpSftpUserCreateSuccess = AppsyncResponse & {
  __typename?: 'ErpSftpUserCreateSuccess';
  /** The newly created SFTP user */
  erpSftpUser: ErpSftpUser;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Role-based permissions for SFTP users determining their access level */
export type ErpSftpUserRole =
  /** Full read-write access to folders and files */
  | 'EDITOR'
  /** Read-only access to folders and files */
  | 'VIEWER'
  | '%future added value';

/** Input parameters for updating an existing SFTP user */
export type ErpSftpUserUpdateInput = {
  /**
   * Authentication method to update for this user.
   * Changing this will require appropriate password or sshPublicKey to be provided.
   */
  authMethod?: InputMaybe<ErpSftpAuthMethod>;
  /** Whether the user account should be active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New password for the user (will be securely hashed). */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sets folder permissions for the user.
   * If an empty array is passed, no changes will be made to existing permissions.
   * This will replace the entire permission set for the user
   */
  permissions?: InputMaybe<Array<ErpSftpFolderPermissionInput>>;
  /**
   * New SSH public key for the user.
   * Only processed when authMethod is SSH_KEY.
   */
  sshPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** Username of the user to update. Used to identify the target user. */
  username: Scalars['String']['input'];
};

export type ErpSftpUserUpdateResponse = AuthorizationFailure | ErpSftpUserUpdateSuccess | InputValidationFailure;

export type ErpSftpUserUpdateSuccess = AppsyncResponse & {
  __typename?: 'ErpSftpUserUpdateSuccess';
  /** The updated SFTP user with current data */
  erpSftpUser: ErpSftpUser;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Filter criteria for querying SFTP users */
export type ErpSftpUsersFilterInput = {
  /** Filter by specific usernames. If provided, only users with these exact usernames will be returned. */
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ErpSftpUsersInput = {
  /** Optional filter criteria to narrow down the results */
  filter?: InputMaybe<ErpSftpUsersFilterInput>;
  /** Pagination parameters to control result set size and offset */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type ErpSftpUsersResponse = AuthorizationFailure | ErpSftpUsersSuccess;

export type ErpSftpUsersResultEdge = Edge & {
  __typename?: 'ErpSftpUsersResultEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The SFTP user data for this edge */
  node: ErpSftpUser;
};

/** Successful response for SFTP users query containing paginated results */
export type ErpSftpUsersSuccess = AppsyncResponse & Page & {
  __typename?: 'ErpSftpUsersSuccess';
  /** List of SFTP user result edges containing the actual user data */
  edges: Array<ErpSftpUsersResultEdge>;
  /** Pagination information for the result set */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type Event = {
  __typename?: 'Event';
  chatEventType: ChatEventTypes;
  /** @deprecated use chatEventType instead */
  eventType?: Maybe<EventType>;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export type EventChat = {
  __typename?: 'EventChat';
  chatId?: Maybe<Scalars['ID']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<EventUser>;
};

export type EventDeliveryCheckReconciliationRequest = {
  __typename?: 'EventDeliveryCheckReconciliationRequest';
  orderId?: Maybe<Scalars['ID']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
  reconciliationRequestType?: Maybe<DeliveryCheckReconciliationRequestType>;
};

export type EventOrder = {
  __typename?: 'EventOrder';
  comment?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  orderCreatedAt?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
};

export type EventTarget = EventChat | EventDeliveryCheckReconciliationRequest | EventOrder | EventUser;

export type EventType =
  | 'chatCreated'
  | 'chatNameUpdated'
  | 'reconciliationRequestConfirmed'
  | 'userAddedToChat'
  | 'userRemovedFromChat'
  | '%future added value';

export type EventUser = {
  __typename?: 'EventUser';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ExecutionUrlOutput = {
  __typename?: 'ExecutionUrlOutput';
  url: Scalars['String']['output'];
};

export type ExistingInvitedUser = AppsyncError & AppsyncResponse & {
  __typename?: 'ExistingInvitedUser';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type ExistingOrderError = AppsyncError & AppsyncResponse & {
  __typename?: 'ExistingOrderError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** ID of Existing Order */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ExportPurchaseOrderJob = {
  __typename?: 'ExportPurchaseOrderJob';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  purchaseOrderId: Scalars['ID']['output'];
  status: ExportPurchaseOrderJobStatus;
};

export type ExportPurchaseOrderJobStatus =
  | 'completed'
  | 'failed'
  | 'inProgress'
  | 'pending'
  | '%future added value';

export type FallOffProduct = {
  __typename?: 'FallOffProduct';
  lastOrderDate: Scalars['AWSDate']['output'];
  lastOrderDateTimestamp: Scalars['AWSTimestamp']['output'];
  orderedProductPrice?: Maybe<MoneyV2>;
  product: ProductRef;
  productId: Scalars['ID']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  flags: Array<Maybe<FeatureFlag>>;
};

export type FetchBuyerReportDownloadUrlInput = {
  id: Scalars['String']['input'];
};

export type FetchBuyerReportDownloadUrlResponse = AuthorizationFailure | BuyerReport | BuyerReportGenerationError | BuyerReportNotFoundError | InputValidationFailure;

export type FetchCatalogCategoriesForChatResponse = CatalogCategoriesResponse | CatalogNotFound;

export type FieldConfiguration = {
  __typename?: 'FieldConfiguration';
  category: FieldConfigurationCategories;
  primaryLineItemFields: Array<PrimaryFieldConfiguration>;
  secondaryLineItemFields: Array<SecondaryFieldConfiguration>;
};

export type FieldConfigurationCategories =
  | 'meat'
  | '%future added value';

export type FieldConfigurationInput = {
  category: FieldConfigurationCategories;
  primaryLineItemFields: Array<PrimaryFieldConfigurationInput>;
  secondaryLineItemFields: Array<SecondaryFieldConfigurationInput>;
};

export type FieldValidationError = {
  __typename?: 'FieldValidationError';
  fieldName: Scalars['String']['output'];
  /** Computer readable error message */
  reason: Scalars['String']['output'];
};

export type ForbiddenError = AppsyncError & AppsyncResponse & {
  __typename?: 'ForbiddenError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

/**
 * For queries that only support pagination in one direction.
 *
 * Could be expanded to support a limit count on the page, but the only use
 * case requires a full enumeration of the data set, so there is no need to
 * add that complexity.
 */
export type ForwardPaginationInput = {
  /** The cursor to start the query from. Provide null to start from the beginning. */
  startCursor?: InputMaybe<Scalars['String']['input']>;
};

export type FullPageInformationalAd = AdInterface & {
  __typename?: 'FullPageInformationalAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Hex value for the background color of the Call to Action button (optional) */
  ctaBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Call to Action Label that the user will see */
  ctaLabel: Scalars['String']['output'];
  /** URL for the Call to Action button */
  ctaLink: Scalars['String']['output'];
  /** The main full page image URL like "Premium Frappe Mix" */
  fullPageImageUrl: Scalars['String']['output'];
  /** Title displayed on the full page ad, e.g., "Premium Frappe Mix" */
  fullPageTitle?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
};

export type GenerateBuyerReportInput = {
  buyerIds: Array<Scalars['String']['input']>;
  from: Scalars['AWSTimestamp']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  supplierIds: Array<Scalars['String']['input']>;
  to: Scalars['AWSTimestamp']['input'];
  type: BuyerReportType;
};

export type GenerateBuyerReportResponse = AuthorizationFailure | BuyerReport | InputValidationFailure;

/** Represents a distance in a geography. */
export type GeographicDistanceInput = {
  /** The distance value. */
  distance: Scalars['Float']['input'];
  /** The distance unit of measure. */
  unitOfMeasure: DistanceUnitOfMeasure;
};

export type GeographicIdentifierInputType =
  | 'GooglePlace'
  | '%future added value';

export type GetAdContextFilterInput = {
  /** Optional: for Order Guide ads to filter by chat context */
  chatId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAdContextInput = {
  /** The zone of the ad, e.g. Banner, FullPage */
  adZone: AdZone;
  /** The ID of the current buyer */
  currentBuyerId: Scalars['ID']['input'];
  /** Optional: for context-specific filtering */
  filter?: InputMaybe<GetAdContextFilterInput>;
  /** Mobile or WEB defaults to Mobile */
  platform?: InputMaybe<Platform>;
};

export type GetAdContextResponse = AuthorizationFailure | GetAdContextResult | InputValidationFailure;

export type GetAdContextResult = AppsyncResponse & {
  __typename?: 'GetAdContextResult';
  /** List of ads matching the criteria */
  ads?: Maybe<Array<AdInterface>>;
  /** Optional message providing additional context */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type GetAllBuyerReportSchedulesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type GetAllBuyerReportSchedulesResponse = AuthorizationFailure | BuyerReportSchedules | InputValidationFailure;

export type GetAllChatsByBuyerFilter = {
  buyerId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ChatStatus>>;
};

export type GetAllChatsByBuyerInput = {
  filter: GetAllChatsByBuyerFilter;
  pagination?: InputMaybe<ForwardPaginationInput>;
};

export type GetAllChatsByBuyerResponse = AuthorizationFailure | BuyerChatsConnection | InputValidationFailure;

export type GetAllChatsBySupplierFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ChatStatus>>;
  supplierEntityId: Scalars['String']['input'];
};

export type GetAllChatsBySupplierInput = {
  filter: GetAllChatsBySupplierFilter;
  pagination?: InputMaybe<ForwardPaginationInput>;
};

export type GetAllChatsBySupplierResponse = AuthorizationFailure | InputValidationFailure | SupplierChatsConnection;

export type GetBuyerContactInfosInput = {
  search: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export type GetBuyerContactInfosResponse = AuthorizationFailure | BuyerContactInfos | NotFoundError;

export type GetBuyerSegmentContentByChatInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
};

export type GetBuyerSegmentContentByChatResponse = AuthorizationFailure | GetBuyerSegmentContentByChatResult | InputValidationFailure;

export type GetBuyerSegmentContentByChatResult = AppsyncResponse & {
  __typename?: 'GetBuyerSegmentContentByChatResult';
  content: BuyerSegmentContent;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
  success: Scalars['Boolean']['output'];
};

export type GetBuyerStockCountFilterInput = {
  buyerId: Scalars['ID']['input'];
  status: Array<BuyerStockCountStatus>;
};

export type GetBuyerStockCountInput = {
  buyerId: Scalars['String']['input'];
  status: Array<BuyerStockCountStatus>;
  stockCountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetBuyerStockCountsInput = {
  filter: GetBuyerStockCountFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};

export type GetBuyerStockInventoryExportUrlInput = {
  buyerId: Scalars['ID']['input'];
};

export type GetBuyerStockInventoryProductsFilterInput = {
  buyerId: Scalars['ID']['input'];
};

export type GetCatalogUploadUrlResponse = GetCatalogUploadUrlResult | SupplierNotFound;

export type GetCatalogUploadUrlResult = {
  __typename?: 'GetCatalogUploadUrlResult';
  catalogUploadToken?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type GetChatCountByCcEmailReport = {
  __typename?: 'GetChatCountByCCEmailReport';
  numberOfChats: Scalars['Int']['output'];
};

export type GetChatCountByCcEmailResponse = AuthorizationFailure | GetChatCountByCcEmailReport;

export type GetChatSuppliersByLocationsInput = {
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetChatSuppliersByLocationsResponse = AuthorizationFailure | ChatSuppliersByLocations | InputValidationFailure;

export type GetChatsByChatIdsResponse = AuthorizationFailure | ChatsConnection | InputValidationFailure;

export type GetChatsForSubCatalogResponse = AuthorizationFailure | GetChatsForSubCatalogResult | SubCatalogNotFoundError;

export type GetChatsForSubCatalogResult = {
  __typename?: 'GetChatsForSubCatalogResult';
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetClientDebuggableArtifactUploadUrl = {
  __typename?: 'GetClientDebuggableArtifactUploadUrl';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type GetClientDebuggableArtifactUploadUrlError = AppsyncError & AppsyncResponse & {
  __typename?: 'GetClientDebuggableArtifactUploadUrlError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type GetClientDebuggableArtifactUploadUrlInput = {
  filename: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetClientDebuggableArtifactUploadUrlResponse = GetClientDebuggableArtifactUploadUrl | GetClientDebuggableArtifactUploadUrlError;

export type GetConnectedAccountsResponse = AuthorizationFailure | ConnectedAccountConnection | InputValidationFailure;

export type GetConnectedIntegrationAdaptersInput = {
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType>;
};

export type GetConnectedIntegrationAdaptersResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResultConnection | IntegrationAdapterConnectionBaseResultConnection;

export type GetContactInfosResponse = AuthorizationFailure | ContactInfos | InputValidationFailure;

export type GetCustomerInsightsInput = {
  chatId: Scalars['ID']['input'];
};

export type GetCustomerInsightsNotificationInput = {
  id: Scalars['ID']['input'];
};

export type GetCustomerInsightsNotificationResponse = AuthorizationFailure | CustomerInsightsNotification | InputValidationFailure;

export type GetCustomerInsightsNotificationsInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerInsightsNotificationFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
};

export type GetCustomerInsightsNotificationsResponse = AuthorizationFailure | CustomerInsightsNotificationConnection | InputValidationFailure;

export type GetCustomerLabelsV2Input = {
  after?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for querying a specific note by its ID.
 * Note: target entity is not needed as the note already contains this information.
 */
export type GetDistributorNoteQueryInput = {
  /** The ID of the specific note to retrieve */
  noteId: Scalars['ID']['input'];
};

export type GetDistributorNoteQueryResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

/** Input for querying all notes associated with a specific entity. */
export type GetDistributorNotesQueryInput = {
  /** The cursor to start from. If not provided, the query will start from the beginning. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of notes to retrieve */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The entity whose notes we want to retrieve */
  target: DistributorNoteTargetEntity;
};

export type GetDistributorNotesQueryResponse = AuthorizationFailure | DistributorNoteConnection | InputValidationFailure | NotFoundError;

/** Input for retrieving distributor promoted content for display in buyer apps */
export type GetDistributorPromotedContentInput = {
  /** The ID of the buyer requesting the content */
  buyerId: Scalars['ID']['input'];
  /** Supplier IDs: Mandatory for white label apps, Optional for choco app, to filter content by specific suppliers */
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Response containing distributor promoted content */
export type GetDistributorPromotedContentResponse = AuthorizationFailure | DistributorPromotedContentNotFound | GetDistributorPromotedContentResult | InputValidationFailure;

/** Successful result containing distributor promoted content */
export type GetDistributorPromotedContentResult = AppsyncResponse & {
  __typename?: 'GetDistributorPromotedContentResult';
  /** Optional message providing additional context */
  message?: Maybe<Scalars['String']['output']>;
  /** Promoted content for the buyer */
  promotedContent: DistributorPromotedContent;
  /** Type of response returned */
  responseType: ResponseType;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type GetDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

/** Input for getting tasks by filters */
export type GetDistributorTasksInput = {
  /** Filter by the user who created the task */
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination cursor. Null starts at the beginning */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by entity type */
  entityType?: InputMaybe<DistributorTaskEntityType>;
  /** Maximum number of tasks to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for tasks due before this date/time (inclusive) */
  maxDueAt?: InputMaybe<DistributorTaskDueAtInput>;
  /** Filter for tasks due after this date/time (inclusive) */
  minDueAt?: InputMaybe<DistributorTaskDueAtInput>;
  /** Filter by status */
  status?: InputMaybe<Array<DistributorTaskStatus>>;
  /** Filter by target entity */
  targetEntity?: InputMaybe<DistributorTaskTargetEntityInput>;
};

export type GetDistributorTasksResponse = AuthorizationFailure | DistributorTaskConnection | InputValidationFailure | NotFoundError;

export type GetDocumentScanAttachmentUploadLinkInput = {
  attachments: Array<DocumentScanAttachmentUploadLinkInput>;
  documentScanId: Scalars['ID']['input'];
};

export type GetDocumentScanAttachmentUploadLinkResponse = AuthorizationFailure | DocumentScanAttachmentUploadLinkResult | InputValidationFailure | NotFoundError;

export type GetDocumentScanListInput = {
  /** The id of the lead associated with the scan */
  leadId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDocumentScanListResponse = AuthorizationFailure | DocumentScanConnection | InputValidationFailure;

export type GetDocumentScanResponse = AuthorizationFailure | DocumentScan | InputValidationFailure | NotFoundError;

/** Input type for retrieving the email editor state download URL. */
export type GetEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Response type for retrieving the email editor state download URL. */
export type GetEmailEditorStateResponse = AuthorizationFailure | EmailEditorStateNotFound | GetEmailEditorStateResult | InputValidationFailure;

/** Success result containing the download URL for the email editor state. */
export type GetEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'GetEmailEditorStateResult';
  /** The pre-signed download URL for the email editor state. */
  editorStateDownloadUrl: Scalars['String']['output'];
  /** The pre-signed download URL for the email template preview image. */
  previewImageDownloadUrl: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type GetEmailListsInput = {
  supplierId: Scalars['String']['input'];
  types: Array<OrderDestEmailListType>;
};

export type GetEmailListsResponse = AuthorizationFailure | EmailLists;

export type GetExportPurchaseOrderJobInput = {
  purchaseOrderId: Scalars['ID']['input'];
};

export type GetExportPurchaseOrderJobResponse = AuthorizationFailure | GetExportPurchaseOrderJobSuccess | InputValidationFailure | NotFoundError;

export type GetExportPurchaseOrderJobSuccess = {
  __typename?: 'GetExportPurchaseOrderJobSuccess';
  job: ExportPurchaseOrderJob;
  purchaseOrderId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type GetFeatureFlagsResponse = AuthorizationFailure | FeatureFlags;

export type GetIntegrationAdaptersInput = {
  type: IntegrationAdapterType;
};

export type GetIntegrationAdaptersResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResultConnection | IntegrationAdapterBaseResultConnection;

export type GetInviteTransmissionStatus = {
  chatId: Scalars['ID']['input'];
};

export type GetInviteTransmissionStatusResponse = AuthorizationFailure | InputValidationFailure | InviteTransmissionStatus;

export type GetInviteeBuyersResponse = InviteeBuyers | InviteeNotFound;

/** Input type for getting content upload url */
export type GetMarketingCampaignContentUploadLinkInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Content to be uploaded */
  content: ContentLinkInput;
};

/** Response type for getting the content upload link */
export type GetMarketingCampaignContentUploadLinkResponse = AuthorizationFailure | ContentUploadLinkResult | InputValidationFailure;

/** Response type for getting a marketing campaign email sender */
export type GetMarketingCampaignEmailSenderResponse = AuthorizationFailure | MarketingCampaignEmailSenderNotFound | MarketingCampaignEmailSenderResult;

/** Input type for getting a marketing campaign details */
export type GetMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Response type for getting a marketing campaign */
export type GetMarketingCampaignResponse = AuthorizationFailure | GetMarketingCampaignResult | InputValidationFailure;

/** Result containing the marketing campaign information */
export type GetMarketingCampaignResult = AppsyncResponse & {
  __typename?: 'GetMarketingCampaignResult';
  /** Marketing campaign information */
  marketingCampaign: MarketingCampaign;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Input type for getting media upload url in CDN */
export type GetMediaUploadLinkInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Media to be uploaded */
  medias: Array<MediaLinkInput>;
};

/** Response type for getting media upload links in CDN */
export type GetMediaUploadLinkResponse = AuthorizationFailure | InputValidationFailure | MediaUploadLinkResult;

export type GetMenuScanAttachmentUploadLinkInput = {
  attachments: Array<MenuScanAttachmentUploadLinkInput>;
  menuScanId: Scalars['ID']['input'];
};

export type GetMenuScanAttachmentUploadLinkResponse = AuthorizationFailure | InputValidationFailure | MenuScanAttachmentUploadLinkResult | NotFoundError;

export type GetMenuScanListInput = {
  /** The id of the lead associated with the scan */
  leadId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetMenuScanListResponse = AuthorizationFailure | InputValidationFailure | MenuScanConnection;

export type GetMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScan | NotFoundError;

export type GetOcoRerankedProductsInput = {
  chatId: Scalars['String']['input'];
  omnichannelOrderId: Scalars['ID']['input'];
};

export type GetOcoRerankedProductsResponse = AuthorizationFailure | NotFoundError | OcoRerankedProducts;

export type GetOmniChannelOrderInput = {
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetOmniChannelOrderResponse = AuthorizationFailure | NotFoundError | OmnichannelOrder;

export type GetOnboardingChecklistResponse = AuthorizationFailure | OnboardingChecklist;

export type GetOrderChannelContactInfosInput = {
  supplierId: Scalars['ID']['input'];
};

export type GetOrderChannelContactInfosResponse = AuthorizationFailure | NotFoundError | OrderChannelContactInfos;

export type GetOrderDeliveryCheckResponse = AuthorizationFailure | CreatedOrCompletedByNotFound | InputValidationFailure | OrderDeliveryCheckDetails;

export type GetOrderGuideUploadUrl = {
  __typename?: 'GetOrderGuideUploadUrl';
  buyerId?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type GetOrderGuideUploadUrlError = AppsyncError & AppsyncResponse & {
  __typename?: 'GetOrderGuideUploadUrlError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type GetOrderGuideUploadUrlInput = {
  filename: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetOrderGuideUploadUrlResponse = GetOrderGuideUploadUrl | GetOrderGuideUploadUrlError;

export type GetOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetProductsForChatFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetProductsForChatInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<GetProductsForChatFilter>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetProductsForChatResponse = AuthorizationFailure | ChatNotFoundError | GetProductsForChatResult | SupplierNotFound;

export type GetProductsForChatResult = {
  __typename?: 'GetProductsForChatResult';
  invalidProducts?: Maybe<Array<InvalidProduct>>;
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetPurchaseOrderInput = {
  purchaseOrderId: Scalars['ID']['input'];
};

export type GetPurchaseOrderResponse = AuthorizationFailure | GetPurchaseOrderSuccess | InputValidationFailure | NotFoundError;

export type GetPurchaseOrderSuccess = {
  __typename?: 'GetPurchaseOrderSuccess';
  purchaseOrder: PurchaseOrder;
  purchaseOrderId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type GetPurchasingBusinessByExternalIdInput = {
  externalId: Scalars['String']['input'];
};

export type GetPurchasingBusinessByExternalIdResponse = AuthorizationFailure | GetPurchasingBusinessByExternalIdSuccess | InputValidationFailure | NotFoundError;

export type GetPurchasingBusinessByExternalIdSuccess = {
  __typename?: 'GetPurchasingBusinessByExternalIdSuccess';
  business: PurchasingBusiness;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type GetPurchasingPartnersFailure = {
  __typename?: 'GetPurchasingPartnersFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type GetPurchasingPartnersInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type GetPurchasingPartnersResponse = AuthorizationFailure | GetPurchasingPartnersFailure | GetPurchasingPartnersSuccess | InputValidationFailure;

export type GetPurchasingPartnersSuccess = {
  __typename?: 'GetPurchasingPartnersSuccess';
  businesses: Array<Maybe<PurchasingBusiness>>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type GetQboCustomersAndOrderGuidesToImportResponse = AuthorizationFailure | InputValidationFailure | QboCustomersAndOrderGuidesToImport;

export type GetReconciliationRequestPlanBySupplierIdResponse = InputValidationFailure | ReconciliationRequestPlan | ReconciliationRequestPlanBySupplierIdNotFound;

export type GetReferralInput = {
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referrerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReferralResponse = NotFoundError | Referral;

export type GetRequestsToJoinFilter = {
  status?: InputMaybe<JoinRequestStatus>;
};

export type GetRequestsToJoinInput = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetRequestsToJoinFilter>;
  /** One of the following two parameters must be provided */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type GetRequestsToJoinResponse = AuthorizationFailure | InputValidationFailure | RequestsToJoinConnection;

export type GetSalesFunnelDefinitionInput = {
  /** If not provided, will return the default sales funnel */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetSalesFunnelDefinitionQueryResponse = {
  __typename?: 'GetSalesFunnelDefinitionQueryResponse';
  salesFunnel: SalesFunnelDefinition;
};

export type GetSalesFunnelLeadQueryInput = {
  /** ID of the lead to get */
  id: Scalars['ID']['input'];
};

export type GetSalesFunnelLeadQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type GetSalesFunnelLeadsConnection = Connection & {
  __typename?: 'GetSalesFunnelLeadsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSalesFunnelLeadsEdge>;
  pageInfo: PageInfo;
};

export type GetSalesFunnelLeadsEdge = Edge & {
  __typename?: 'GetSalesFunnelLeadsEdge';
  cursor: Scalars['String']['output'];
  node: SalesFunnelLead;
};

export type GetSalesFunnelLeadsForMapConnection = Connection & {
  __typename?: 'GetSalesFunnelLeadsForMapConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSalesFunnelLeadsForMapEdge>;
  pageInfo: PageInfo;
};

export type GetSalesFunnelLeadsForMapEdge = Edge & {
  __typename?: 'GetSalesFunnelLeadsForMapEdge';
  cursor: Scalars['String']['output'];
  node: SalesFunnelLeadForMap;
};

export type GetSalesFunnelLeadsForMapQueryResponse = AuthorizationFailure | GetSalesFunnelLeadsForMapConnection | InputValidationFailure;

/** Input for the getSalesFunnelLeads query. */
export type GetSalesFunnelLeadsQueryInput = {
  /**
   * Allows you to filter by assignee, i.e. only see tickets assigned to
   * a specified list of users. Supports multiselect. Both no value and an empty
   * array indicate no filtering.
   * Note: If a supplier sales rep is querying, they must either provide their
   * own userId or not provide any value. Both cases return the same result.
   * And any other userId value will trigger an access exception.
   */
  assigneeFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter to limit leads which satisfy some geographic criteria. */
  geographicFilter?: InputMaybe<SalesFunnelLeadGeographicFilterInput>;
  /** Optional filter to show only archived or non-archived leads. If not provided, shows all leads. */
  isArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requested ordering of the lead results. */
  orderBy?: InputMaybe<LeadOrderBy>;
  /** Information for paginating the results. If not provided, reads the first page. */
  paginationInput?: InputMaybe<PaginationInputV2>;
  /** ID of the sales funnel to get leads for. */
  salesFunnelId: Scalars['ID']['input'];
  /** Allows you to filter by search term. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Allows you to filter by state, i.e. only see tickets in a specified list of states. */
  stateIdFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetSalesFunnelLeadsQueryResponse = AuthorizationFailure | GetSalesFunnelLeadsConnection | InputValidationFailure;

export type GetSalesFunnelProspectFromPlaceIdQueryInput = {
  /** Place ID from Google Places API. */
  googlePlaceId: Scalars['String']['input'];
  /** Language code for query results. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the funnel to get prospects for. */
  salesFunnelId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for the getSalesFunnelProspectsFromFreeText query. */
export type GetSalesFunnelProspectsFromFreeTextQueryFilter = {
  /** Whether to exclude existing accounts and leads from the search results. */
  excludeExistingAccountsAndLeads: Scalars['Boolean']['input'];
  /** The ID of the funnel to get prospects for. */
  salesFunnelId: Scalars['ID']['input'];
};

/** Input to the getProspects query. */
export type GetSalesFunnelProspectsFromFreeTextQueryInput = {
  /** How to interpret the viewport search. */
  boundingRectangleSearchType: BoundingRectangleSearchType;
  /** Filter for the search results. Null/unspecified means no filter. */
  filter?: InputMaybe<GetSalesFunnelProspectsFromFreeTextQueryFilter>;
  /** Language code for query results. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Free text search query. */
  queryText: Scalars['String']['input'];
  /** The area to which the query should be restricted. */
  viewport: BoundingRectangleInput;
};

export type GetSalesFunnelProspectsFromFreeTextQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelProspectsResults;

export type GetSalesFunnelProspectsFromPlaceIdQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelProspect;

/** The input to the getSalesFunnelStatesStatistics query. */
export type GetSalesFunnelStatisticsQueryInput = {
  /**
   * Optional scope to filter by assignee, i.e. only statistics scoped to
   * the provided user.
   * null or empty array indicates no filtering.
   * must be provided by supplier sales reps and set to their own userId
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional filter to show only archived or non-archived leads. If not provided, shows all leads. */
  isArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the sales funnel to get statistics for. */
  salesFunnelId: Scalars['ID']['input'];
};

export type GetSalesFunnelStatisticsQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelStatistics;

/** Here are all functions for managing and accessing sales funnels and distributor notes */
export type GetSalesFunnelsQueryInput = {
  supplierId: Scalars['ID']['input'];
};

export type GetSalesFunnelsQueryResponse = {
  __typename?: 'GetSalesFunnelsQueryResponse';
  defaultSalesFunnel?: Maybe<SalesFunnelDefinition>;
  salesFunnels: Array<SalesFunnelDefinition>;
};

export type GetSimilarSalesFunnelLeadsConnection = {
  __typename?: 'GetSimilarSalesFunnelLeadsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSimilarSalesFunnelLeadsEdge>;
};

export type GetSimilarSalesFunnelLeadsEdge = {
  __typename?: 'GetSimilarSalesFunnelLeadsEdge';
  node: SalesFunnelLead;
};

/** Input for the getSimilarSalesFunnelLeads query. */
export type GetSimilarSalesFunnelLeadsQueryInput = {
  /** The customer defined business name for the new lead. */
  businessName: Scalars['String']['input'];
  /** The external geographic identifier for the new lead. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifierInput;
  /** ID of the sales funnel to get leads for. */
  salesFunnelId: Scalars['ID']['input'];
};

export type GetSmsMessageByMessageSidResponse = AuthorizationFailure | GetSmsMessageByMessageSidSuccess;

export type GetSmsMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessageByMessageSidSuccess';
  responseType: ResponseType;
  smsMessage?: Maybe<SmsMessage>;
};

export type GetSmsMessagesFromPhoneNumberResponse = AuthorizationFailure | GetSmsMessagesFromPhoneNumberSuccess;

export type GetSmsMessagesFromPhoneNumberSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessagesFromPhoneNumberSuccess';
  messages?: Maybe<Array<SmsMessage>>;
  responseType: ResponseType;
};

export type GetSubCatalogResponse = NotFoundError | SubCatalog;

export type GetSubCatalogsForChatResponse = AuthorizationFailure | ChatNotFoundError | GetSubCatalogsForChatResult;

export type GetSubCatalogsForChatResult = {
  __typename?: 'GetSubCatalogsForChatResult';
  subCatalogs: Array<SubCatalog>;
};

export type GetSuggestedProductsErrorResponse = AppsyncError & {
  __typename?: 'GetSuggestedProductsErrorResponse';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type GetSupplierApplicationsInput = {
  refId: Scalars['ID']['input'];
};

export type GetSupplierApplicationsResponse = AuthorizationFailure | InputValidationFailure | SupplierApplications;

export type GetSupplierProductsInput = {
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetSupplierProductsResponse = AuthorizationFailure | GetSupplierProductsResult;

export type GetSupplierProductsResult = {
  __typename?: 'GetSupplierProductsResult';
  invalidProducts?: Maybe<Array<InvalidProduct>>;
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetTransmissionBySesMessageIdInput = {
  sesMessageId: Scalars['ID']['input'];
};

export type GetTransmissionBySesMessageIdResponse = AuthorizationFailure | NotFoundError | Transmission;

export type GetTransmissionInput = {
  id: Scalars['ID']['input'];
};

export type GetTransmissionResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | Transmission;

export type GetUnconnectedBuyerIdsResult = NoUnconnectedBuyers | UnconnectedBuyers;

export type GetUploadedOrderResponse = AuthorizationFailure | GetUploadedOrderSuccess | InputValidationFailure;

export type GetUploadedOrderSuccess = {
  __typename?: 'GetUploadedOrderSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
  uploadedOrder?: Maybe<UploadedOrder>;
};

export type GetWhatsAppMessageByMessageSidResponse = AuthorizationFailure | GetWhatsAppMessageByMessageSidSuccess;

export type GetWhatsAppMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetWhatsAppMessageByMessageSidSuccess';
  responseType: ResponseType;
  whatsAppMessage?: Maybe<WhatsAppMessage>;
};

export type GooglePlaceEstablishment = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

/** Represents the details of a Google prospect photo. */
export type GoogleProspectPhotoDetails = {
  __typename?: 'GoogleProspectPhotoDetails';
  /** The reference to the photo. */
  resourceName: Scalars['String']['output'];
};

export type GroupIdsInput = {
  /** Id representing a delivery check reconciliation request */
  reconciliationRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type HtmlAttachmentRef = {
  __typename?: 'HTMLAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  selector?: Maybe<Scalars['String']['output']>;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type HasCompletedDeliveryCheckResult = {
  __typename?: 'HasCompletedDeliveryCheckResult';
  earliestOrderId?: Maybe<Scalars['ID']['output']>;
  hasCompletedDeliveryCheck: Scalars['Boolean']['output'];
  latestOrderId?: Maybe<Scalars['ID']['output']>;
};

export type HasUserCompletedDeliveryCheckResponse = AuthorizationFailure | HasCompletedDeliveryCheckResult | InputValidationFailure | OrderNotFound;

export type IgnoreEdits =
  | 'productId'
  | 'productQuantity'
  | '%future added value';

export type ImageAsset = {
  __typename?: 'ImageAsset';
  /**
   * The resolver returns a read URL of the image asset for a given size and device pixel ratio.
   * The image is resized in the 'contain' mode, preserving the aspect-ratio, so the final image size might not match the requested size.
   * If none of the parameters are passed, the default size is returned.
   * In case of an error, null can be returned in which case the client should handle gracefully e.g. by falling back to a default broken image icon.
   */
  url?: Maybe<ImageAssetUrl>;
};


export type ImageAssetUrlArgs = {
  devicePixelRatio?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageAssetUrl = {
  __typename?: 'ImageAssetUrl';
  /** The URL of the image asset */
  url: Scalars['AWSURL']['output'];
};

export type ImageAttachmentRef = {
  __typename?: 'ImageAttachmentRef';
  boundingBox: BoundingBox;
  omnichannelOrderId: Scalars['ID']['output'];
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type ImportSupplierProductsReport = {
  __typename?: 'ImportSupplierProductsReport';
  /** Number of products that will be disabled */
  disabled?: Maybe<Scalars['Int']['output']>;
  /** Number of products that have failed validation */
  invalid?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be created */
  new?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will not be affected */
  unchanged?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be updated */
  updated?: Maybe<Scalars['Int']['output']>;
};

export type InitInventoryDownloadFailure = {
  __typename?: 'InitInventoryDownloadFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InitInventoryDownloadInput = {
  buyerId: Scalars['String']['input'];
};

export type InitInventoryDownloadResponse = AuthorizationFailure | InitInventoryDownloadFailure | InitInventoryDownloadSuccess;

export type InitInventoryDownloadSuccess = {
  __typename?: 'InitInventoryDownloadSuccess';
  jobId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InitInventoryUploadFailure = {
  __typename?: 'InitInventoryUploadFailure';
  message?: Maybe<Scalars['String']['output']>;
  responseType?: Maybe<ResponseType>;
};

export type InitInventoryUploadInput = {
  buyerId: Scalars['ID']['input'];
};

export type InitInventoryUploadResponse = AuthorizationFailure | InitInventoryUploadFailure | InitInventoryUploadSuccess | InputValidationFailure;

export type InitInventoryUploadSuccess = {
  __typename?: 'InitInventoryUploadSuccess';
  jobId: Scalars['ID']['output'];
  responseType?: Maybe<ResponseType>;
  uploadUrl: Scalars['String']['output'];
};

export type InitiateAccountLinkingError = AppsyncError & AppsyncResponse & {
  __typename?: 'InitiateAccountLinkingError';
  errorCode?: Maybe<InitiateAccountLinkingErrorCode>;
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type InitiateAccountLinkingErrorCode =
  | 'ALREADY_LINKED'
  | 'OTP_SEND_FAILURE'
  | 'PHONE_NUMBER_INVALID'
  | 'TARGET_ACCOUNT_NOT_FOUND'
  | 'USER_NOT_FOUND'
  | '%future added value';

export type InitiateAccountLinkingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InitiateAccountLinkingResponse = AuthorizationFailure | InitiateAccountLinkingError | InitiateAccountLinkingSuccess | InputValidationFailure;

export type InitiateAccountLinkingSuccess = {
  __typename?: 'InitiateAccountLinkingSuccess';
  message?: Maybe<Scalars['String']['output']>;
};

export type InputValidationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'InputValidationFailure';
  invalidFields?: Maybe<Array<FieldValidationError>>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InsertOrUpdateSupplierContactInput = {
  /**  Chat ID which owns the contact  */
  chatId: Scalars['String']['input'];
  /**  Email of the contact  */
  email: Scalars['AWSEmail']['input'];
  /**  Name of the contact  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ID of the owner of the contact  */
  supplierId: Scalars['ID']['input'];
};

export type InsertOrUpdateSupplierContactResponse = AuthorizationFailure | CustomerContact | InputValidationFailure;

export type InsightsStatus =
  | 'fall'
  | 'growth'
  | 'unchanged'
  | '%future added value';

export type InstantPayCustomerAlreadyOnboardedFailure = {
  __typename?: 'InstantPayCustomerAlreadyOnboardedFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InstantPayCustomerInvitationSendFailure = {
  __typename?: 'InstantPayCustomerInvitationSendFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InstantPayCustomerInvitationSendInput = {
  invitationType?: InputMaybe<InstantPayCustomerInvitationType>;
  paymentCustomerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type InstantPayCustomerInvitationSendResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerInvitationSendFailure | InstantPayCustomerInvitationSendSuccess;

export type InstantPayCustomerInvitationSendSuccess = {
  __typename?: 'InstantPayCustomerInvitationSendSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InstantPayCustomerInvitationType =
  | 'ACCOUNT_BUILDER'
  | 'USER_VERIFICATION'
  | '%future added value';

export type InstantPayCustomerOnboardFailure = {
  __typename?: 'InstantPayCustomerOnboardFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InstantPayCustomerOnboardInput = {
  customerDetails: PaymentCustomerDetailsInput;
  legalEntityDetails: LegalEntityDetailsInput;
  options?: InputMaybe<InstantPayProfileOptionsInput>;
  profileDetails: InstantPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type InstantPayCustomerOnboardResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerAlreadyOnboardedFailure | InstantPayCustomerOnboardFailure | InstantPayCustomerOnboardSuccess | LegalEntityAlreadyExistsFailure;

export type InstantPayCustomerOnboardSuccess = {
  __typename?: 'InstantPayCustomerOnboardSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InstantPayProfileDetailsInput = {
  /** The ERP customer number */
  chatCustomerNumber: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
  paymentTerms?: InputMaybe<InstantPayVendorConfigPaymentTermInput>;
};

export type InstantPayProfileOptionsInput = {
  sendInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InstantPayTermSchedule =
  | 'BIWEEKLY'
  | 'DAILY'
  | 'MONTHLY'
  | 'WEEKLY'
  | '%future added value';

export type InstantPayVendorConfig = {
  __typename?: 'InstantPayVendorConfig';
  allowedPaymentTerms: Array<InstantPayVendorConfigPaymentTerm>;
};

export type InstantPayVendorConfigInput = {
  allowedPaymentTerms: Array<InstantPayVendorConfigPaymentTermInput>;
};

export type InstantPayVendorConfigPaymentTerm = {
  __typename?: 'InstantPayVendorConfigPaymentTerm';
  dueInDays: Scalars['Int']['output'];
  schedule: InstantPayTermSchedule;
};

export type InstantPayVendorConfigPaymentTermInput = {
  dueInDays: Scalars['Int']['input'];
  schedule: InstantPayTermSchedule;
};

export type InstantPayVendorCreateFailure = {
  __typename?: 'InstantPayVendorCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InstantPayVendorCreateInput = {
  config: InstantPayVendorConfigInput;
  contacts: Array<VendorContactInput>;
  vendorId: Scalars['ID']['input'];
};

export type InstantPayVendorCreateResponse = AuthorizationFailure | InputValidationFailure | InstantPayVendorCreateFailure | InstantPayVendorCreateSuccess;

export type InstantPayVendorCreateSuccess = {
  __typename?: 'InstantPayVendorCreateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InstantPaymentCustomerProfile = {
  __typename?: 'InstantPaymentCustomerProfile';
  chatCustomerNumber: Scalars['String']['output'];
  lastStatusUpdate: Scalars['AWSTimestamp']['output'];
  status: InstantPaymentProfileStatus;
};

export type InstantPaymentProfileStatus =
  | 'ACTIVE'
  | 'DECLINED'
  | 'DISABLED'
  | 'ON_HOLD'
  | 'PENDING_VERIFICATION'
  | 'RISK_OF_ACCOUNT_HOLD'
  | '%future added value';

export type IntegrationAdapterApiKeyAuth = {
  __typename?: 'IntegrationAdapterAPIKeyAuth';
  apiKey: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterApiKeyAuthBase = {
  __typename?: 'IntegrationAdapterAPIKeyAuthBase';
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterAdminResult = Node & {
  __typename?: 'IntegrationAdapterAdminResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
  auth: IntegrationAdapterAuth;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: Array<Maybe<Scalars['String']['output']>>;
  type: IntegrationAdapterType;
  updatedAt: Scalars['AWSTimestamp']['output'];
  webhook?: Maybe<IntegrationAdapterWebhook>;
};

export type IntegrationAdapterAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterAdminResultConnection';
  edges: Array<IntegrationAdapterAdminResultEdge>;
};

export type IntegrationAdapterAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterAdminResult;
};

export type IntegrationAdapterAuth = IntegrationAdapterApiKeyAuth | IntegrationAdapterAuthorizationCodeAuth | IntegrationAdapterClientCredentialsAuth;

export type IntegrationAdapterAuthBase = IntegrationAdapterApiKeyAuthBase | IntegrationAdapterAuthorizationCodeAuthBase | IntegrationAdapterClientCredentialsAuthBase;

export type IntegrationAdapterAuthInput = {
  /**  TODO: remove apiKey after MVP  */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  connectUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signoutUrl?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterAuthenticationType =
  | 'API_KEY'
  | 'AUTHORIZATION_CODE'
  | 'CLIENT_CREDENTIALS'
  | '%future added value';

export type IntegrationAdapterAuthorizationCodeAuth = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuth';
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Maybe<Scalars['String']['output']>>;
  secret: Scalars['String']['output'];
  signoutUrl: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterAuthorizationCodeAuthBase = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuthBase';
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Scalars['String']['output']>;
  signoutUrl: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterBaseResult = Node & {
  __typename?: 'IntegrationAdapterBaseResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
  auth: IntegrationAdapterAuthBase;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scope: Array<Maybe<Scalars['String']['output']>>;
  type: IntegrationAdapterType;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type IntegrationAdapterBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterBaseResultConnection';
  edges: Array<IntegrationAdapterBaseResultEdge>;
};

export type IntegrationAdapterBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterBaseResult;
};

export type IntegrationAdapterClientCredentialsAuth = {
  __typename?: 'IntegrationAdapterClientCredentialsAuth';
  secret: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterClientCredentialsAuthBase = {
  __typename?: 'IntegrationAdapterClientCredentialsAuthBase';
  type: IntegrationAdapterAuthenticationType;
};

export type IntegrationAdapterConnectionAdminResult = Node & {
  __typename?: 'IntegrationAdapterConnectionAdminResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
  adapterId: Scalars['ID']['output'];
  chocoEntityId: Scalars['ID']['output'];
  chocoEntityType: ChocoEntityType;
  createdAt: Scalars['AWSTimestamp']['output'];
  creatorUserId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  scope?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationAdapterConnectionStatus;
  updatedAt: Scalars['AWSTimestamp']['output'];
  webhook?: Maybe<IntegrationAdapterConnectionWebhook>;
};

export type IntegrationAdapterConnectionAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionAdminResultConnection';
  edges: Array<IntegrationAdapterConnectionAdminResultEdge>;
};

export type IntegrationAdapterConnectionAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionAdminResult;
};

export type IntegrationAdapterConnectionAuthInput = {
  loginChallenge: Scalars['String']['input'];
};

export type IntegrationAdapterConnectionAuthRedirect = {
  __typename?: 'IntegrationAdapterConnectionAuthRedirect';
  redirectUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionAuthResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAuthRedirect;

export type IntegrationAdapterConnectionBaseResult = Node & {
  __typename?: 'IntegrationAdapterConnectionBaseResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod>;
  adapterId: Scalars['ID']['output'];
  authorizationCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  scope?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationAdapterConnectionStatus;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type IntegrationAdapterConnectionBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionBaseResultConnection';
  edges: Array<IntegrationAdapterConnectionBaseResultEdge>;
};

export type IntegrationAdapterConnectionBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionBaseResult;
};

export type IntegrationAdapterConnectionConsentChallenge = {
  __typename?: 'IntegrationAdapterConnectionConsentChallenge';
  adapterId: Scalars['String']['output'];
  consentChallenge: Scalars['String']['output'];
  requestedScopes: Array<Scalars['String']['output']>;
};

export type IntegrationAdapterConnectionConsentInput = {
  consentChallenge: Scalars['String']['input'];
  grantedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationAdapterConnectionConsentRedirect = {
  __typename?: 'IntegrationAdapterConnectionConsentRedirect';
  connectionId: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionConsentResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionConsentChallenge | IntegrationAdapterConnectionConsentRedirect;

export type IntegrationAdapterConnectionCreateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  adapterId: Scalars['ID']['input'];
  chocoEntityId: Scalars['ID']['input'];
  chocoEntityType: ChocoEntityType;
  scope: Array<Scalars['String']['input']>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterConnectionCreateResponse = AuthorizationFailure | ChocoEntityNotFound | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterNotFound | IntegrationAdapterScopeInsufficient | UnsupportedIntegrationAdapterType;

export type IntegrationAdapterConnectionNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterConnectionNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type IntegrationAdapterConnectionStatus =
  /**  Connection is live and operational. Can transition to DISCONNECTED or ERROR  */
  | 'CONNECTED'
  /**  Connection was disconnected by user. Final state  */
  | 'DISCONNECTED'
  /**  There is a problem with this connection and it needs to be reconnected. Final state  */
  | 'ERROR'
  /**  Connection was stuck in a pending state for too long. Final state  */
  | 'EXPIRED'
  /**  Connection has been initiated but has not finished yet. Can transition to any other state  */
  | 'PENDING'
  | '%future added value';

export type IntegrationAdapterConnectionUpdateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  id: Scalars['ID']['input'];
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterConnectionUpdateResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionNotFound | IntegrationAdapterScopeInsufficient;

export type IntegrationAdapterConnectionWebhook = {
  __typename?: 'IntegrationAdapterConnectionWebhook';
  deliveryUrl: Scalars['String']['output'];
};

export type IntegrationAdapterCreateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  auth: IntegrationAdapterAuthInput;
  developerName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  scope: Array<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationAdapterType;
  webhook?: InputMaybe<IntegrationAdapterCreateWebhookInput>;
};

export type IntegrationAdapterCreateResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResult | IntegrationAdapterExists;

export type IntegrationAdapterCreateWebhookInput = {
  auth: WebhookAuthenticationInput;
  deliveryUrl: Scalars['String']['input'];
};

export type IntegrationAdapterExists = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterExists';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type IntegrationAdapterNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type IntegrationAdapterScopeInsufficient = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterScopeInsufficient';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type IntegrationAdapterType =
  | 'CUSTOM'
  | 'PLUGIN'
  | '%future added value';

export type IntegrationAdapterUpdateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod>;
  auth?: InputMaybe<IntegrationAdapterAuthInput>;
  developerName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<IntegrationAdapterUpdateWebhookInput>;
};

export type IntegrationAdapterUpdateResponse = AttemptToChangeAdapterAuthType | AttemptToReduceIntegrationAdapterScope | AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResult | IntegrationAdapterNotFound;

export type IntegrationAdapterUpdateWebhookInput = {
  auth?: InputMaybe<WebhookAuthenticationInput>;
  deliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterWebhook = {
  __typename?: 'IntegrationAdapterWebhook';
  auth: IntegrationAdapterWebhookAuth;
  deliveryUrl: Scalars['String']['output'];
};

export type IntegrationAdapterWebhookAuth = IntegrationAdapterWebhookBasicAuth | IntegrationAdapterWebhookSignatureAuth;

export type IntegrationAdapterWebhookBasicAuth = {
  __typename?: 'IntegrationAdapterWebhookBasicAuth';
  password: Scalars['String']['output'];
  type: WebhookAuthenticationType;
  username: Scalars['String']['output'];
};

export type IntegrationAdapterWebhookSignatureAuth = {
  __typename?: 'IntegrationAdapterWebhookSignatureAuth';
  token: Scalars['String']['output'];
  type: WebhookAuthenticationType;
};

export type IntegrationEmailOption = {
  __typename?: 'IntegrationEmailOption';
  complaintEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated emailAddress is deprecated and will be removed in the future; use complaintEmails, orderEmails or messageEmails */
  emailAddress?: Maybe<Scalars['String']['output']>;
  messageEmails?: Maybe<Array<Scalars['String']['output']>>;
  orderEmails?: Maybe<Array<Scalars['String']['output']>>;
  pdf: Scalars['Boolean']['output'];
  type: IntegrationType;
  xlsx: Scalars['Boolean']['output'];
};

export type IntegrationEmailOptionInput = {
  complaintEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated emailAddress is deprecated and will be removed in the future; use complaintEmails, orderEmails or messageEmails */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  messageEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  orderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  pdf: Scalars['Boolean']['input'];
  type: IntegrationType;
  xlsx: Scalars['Boolean']['input'];
};

export type IntegrationEntityIdentity = {
  __typename?: 'IntegrationEntityIdentity';
  appName: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  type: IntegrationEntityIdentityType;
};

export type IntegrationEntityIdentityType =
  | 'integration'
  | '%future added value';

export type IntegrationFaxOption = {
  __typename?: 'IntegrationFaxOption';
  phone: Scalars['String']['output'];
  type: IntegrationType;
};

export type IntegrationFaxOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType;
};

export type IntegrationOption = IntegrationEmailOption | IntegrationFaxOption | IntegrationSmsOption | IntegrationWhatsAppOption;

export type IntegrationOptionInput = {
  email?: InputMaybe<IntegrationEmailOptionInput>;
  /** @deprecated fax is no longer supported */
  fax?: InputMaybe<IntegrationFaxOptionInput>;
  sms?: InputMaybe<IntegrationSmsOptionInput>;
  whatsApp?: InputMaybe<IntegrationWhatsAppOptionInput>;
};

export type IntegrationSmsOption = {
  __typename?: 'IntegrationSmsOption';
  phone: Scalars['String']['output'];
  type: IntegrationType;
};

export type IntegrationSmsOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType;
};

export type IntegrationType =
  | 'email'
  | 'fax'
  | 'sms'
  | 'whatsApp'
  | '%future added value';

export type IntegrationWebhookRetryFailure = {
  __typename?: 'IntegrationWebhookRetryFailure';
  entitySyncActionId: Scalars['ID']['output'];
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

export type IntegrationWebhookRetryInput = {
  entitySyncActionIds: Array<Scalars['ID']['input']>;
};

export type IntegrationWebhookRetryResponse = AuthorizationFailure | InputValidationFailure | IntegrationWebhookRetryResults;

export type IntegrationWebhookRetryResult = IntegrationWebhookRetryFailure | IntegrationWebhookRetrySuccess;

export type IntegrationWebhookRetryResults = {
  __typename?: 'IntegrationWebhookRetryResults';
  results: Array<IntegrationWebhookRetryResult>;
};

export type IntegrationWebhookRetrySuccess = {
  __typename?: 'IntegrationWebhookRetrySuccess';
  entitySyncActionId: Scalars['ID']['output'];
};

export type IntegrationWhatsAppOption = {
  __typename?: 'IntegrationWhatsAppOption';
  phone: Scalars['String']['output'];
  type: IntegrationType;
};

export type IntegrationWhatsAppOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType;
};

export type InternalEntityIdentity = {
  __typename?: 'InternalEntityIdentity';
  type?: Maybe<InternalEntityIdentityType>;
  userId: Scalars['String']['output'];
};

export type InternalEntityIdentityType =
  | 'user'
  | '%future added value';

export type InternalInviteUsersResponse = AuthorizationFailure | UsersList | ValidationError;

export type InternalServerError = {
  __typename?: 'InternalServerError';
  message: Scalars['String']['output'];
};

export type InvalidCursor = AppsyncError & AppsyncResponse & {
  __typename?: 'InvalidCursor';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type InvalidInvitedPhoneNumber = AppsyncError & AppsyncResponse & {
  __typename?: 'InvalidInvitedPhoneNumber';
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InvalidProduct = {
  __typename?: 'InvalidProduct';
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type InvalidProductsFailure = {
  __typename?: 'InvalidProductsFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type InvalidSubCatalogChat = {
  __typename?: 'InvalidSubCatalogChat';
  chatId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  subCatalogId: Scalars['ID']['output'];
};

export type InventoryDownloadJob = {
  __typename?: 'InventoryDownloadJob';
  id: Scalars['ID']['output'];
  report?: Maybe<InventoryDownloadJobReport>;
  status: InventoryDownloadJobStatus;
};

export type InventoryDownloadJobCompleted = {
  __typename?: 'InventoryDownloadJobCompleted';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InventoryDownloadJobFailed = {
  __typename?: 'InventoryDownloadJobFailed';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InventoryDownloadJobReport = InventoryDownloadJobCompleted | InventoryDownloadJobFailed;

export type InventoryDownloadJobStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | '%future added value';

export type InventoryDownloadJobsFailure = {
  __typename?: 'InventoryDownloadJobsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InventoryDownloadJobsFilter = {
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<InventoryDownloadJobStatus>>;
};

export type InventoryDownloadJobsInput = {
  buyerId: Scalars['String']['input'];
  filter?: InputMaybe<InventoryDownloadJobsFilter>;
};

export type InventoryDownloadJobsResponse = AuthorizationFailure | InputValidationFailure | InventoryDownloadJobsFailure | InventoryDownloadJobsSuccess;

export type InventoryDownloadJobsSuccess = {
  __typename?: 'InventoryDownloadJobsSuccess';
  jobs: Array<InventoryDownloadJob>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use 'vendor' instead */
  supplierId?: Maybe<Scalars['ID']['output']>;
  vendor?: Maybe<ItemVendor>;
};

export type InventorySupplier = {
  __typename?: 'InventorySupplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InventorySuppliersFailure = {
  __typename?: 'InventorySuppliersFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InventorySuppliersInput = {
  buyerId: Scalars['ID']['input'];
};

export type InventorySuppliersResponse = AuthorizationFailure | InputValidationFailure | InventorySuppliersFailure | InventorySuppliersSuccess;

export type InventorySuppliersSuccess = {
  __typename?: 'InventorySuppliersSuccess';
  responseType?: Maybe<ResponseType>;
  suppliers: Array<InventorySupplier>;
};

export type InventoryUploadJobFailure = {
  __typename?: 'InventoryUploadJobFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InventoryUploadJobInput = {
  buyerId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type InventoryUploadJobResponse = AuthorizationFailure | InputValidationFailure | InventoryUploadJobFailure | InventoryUploadJobSuccess;

export type InventoryUploadJobStatus =
  | 'Completed'
  | 'DuplicatesValidation'
  | 'Failed'
  | 'ItemsCreation'
  | 'ItemsValidation'
  | 'Pending'
  | 'Processing'
  | 'TemplateValidation'
  | '%future added value';

export type InventoryUploadJobSuccess = {
  __typename?: 'InventoryUploadJobSuccess';
  jobId: Scalars['ID']['output'];
  rawReport?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
  status: InventoryUploadJobStatus;
};

export type InventoryUploadTemplateInput = {
  buyerId: Scalars['ID']['input'];
};

export type InventoryUploadTemplateResponse = AuthorizationFailure | InputValidationFailure | InventoryUploadTemplateResponseFailure | InventoryUploadTemplateResponseSuccess;

export type InventoryUploadTemplateResponseFailure = {
  __typename?: 'InventoryUploadTemplateResponseFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InventoryUploadTemplateResponseSuccess = {
  __typename?: 'InventoryUploadTemplateResponseSuccess';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InviteChannel =
  | 'Email'
  | 'SMS'
  | 'Whatsapp'
  | '%future added value';

export type InviteInfo = {
  __typename?: 'InviteInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  googleFullAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  googlePlaceName?: Maybe<Scalars['String']['output']>;
  inviterUserId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type InviteStatus =
  | 'delivered'
  | 'failed'
  | 'initiated'
  | 'sent'
  | '%future added value';

export type InviteTransmission = Node & {
  __typename?: 'InviteTransmission';
  channel: InviteChannel;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  invitedToEntityId: Scalars['String']['output'];
  inviteeEntityId?: Maybe<Scalars['String']['output']>;
  inviteeEntityName?: Maybe<Scalars['String']['output']>;
  inviteeId: Scalars['String']['output'];
  inviteeName?: Maybe<Scalars['String']['output']>;
  invitorEntityName: Scalars['String']['output'];
  invitorId?: Maybe<Scalars['String']['output']>;
  invitorUserName?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  status: InviteStatus;
  to?: Maybe<Scalars['String']['output']>;
  transmissionEvents: Array<TransmissionEvent>;
};

export type InviteTransmissionStatus = {
  __typename?: 'InviteTransmissionStatus';
  inviteStatus?: Maybe<InviteStatus>;
};

export type InviteUserToBuyerError = AppsyncError & AppsyncResponse & {
  __typename?: 'InviteUserToBuyerError';
  errorCode?: Maybe<InviteUserToBuyerErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type InviteUserToBuyerErrorCode =
  | 'genericError'
  | 'userIsASupplierError'
  | 'userIsAlreadyConnectedToBuyerError'
  | '%future added value';

export type InviteUserToBuyerInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type InviteUserToBuyerInputV2 = {
  /** List of buyer chats to add the user to */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type InviteUserToBuyerResponse = AuthorizationFailure | BuyerUser | InputValidationFailure | InviteUserToBuyerError;

export type InviteeBuyers = {
  __typename?: 'InviteeBuyers';
  /** User Id of Invitee */
  id: Scalars['ID']['output'];
  /**
   * Invitee Buyers which the invitor does not have a chat with
   * Param first: number of user's buyers to check for connections
   * Param after: pagination cursor from UserBuyerEdge
   */
  unconnectedBuyers: UserBuyerConnection;
};


export type InviteeBuyersUnconnectedBuyersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Error thrown by getInviteeBuyers when user is not found
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type InviteeNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'InviteeNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InvitorNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'InvitorNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  attachment: InvoiceAttachment;
  /** @deprecated use attachment.status instead */
  attachmentState: AttachmentState;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issueDate: Scalars['AWSTimestamp']['output'];
  modifiedAt: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Possible values:
   *   - none
   *   - paid
   *   - scheduled
   *   - processing
   *   - failed
   *   - canceled
   *   - returned
   */
  paymentStatus: Scalars['String']['output'];
  paymentTerms: Scalars['AWSTimestamp']['output'];
  /** @deprecated use attachment instead */
  pdfAttachment: InvoiceFileUrls;
  /** total amount of invoice in cents */
  total: Scalars['Int']['output'];
  uploadedAt: Scalars['String']['output'];
};

export type InvoiceAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type InvoiceAlreadyExistsFailure = {
  __typename?: 'InvoiceAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InvoiceAttachment = {
  __typename?: 'InvoiceAttachment';
  /** signed url to download attachment */
  downloadUrl: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  /** status of attachment */
  status: AttachmentStatus;
  /** signed url to upload attachment */
  uploadUrl: Scalars['String']['output'];
};

export type InvoiceBillingDocument = BillingDocument & {
  __typename?: 'InvoiceBillingDocument';
  buyerPaymentStatus: InvoiceBuyerPaymentStatus;
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issuedAt: Scalars['AWSTimestamp']['output'];
  totalGrossAmount: MoneyV2;
  vendor: BillingDocumentVendor;
  vendorPaymentStatus: InvoiceVendorPaymentStatus;
};

export type InvoiceBuyerPaymentStatus =
  | 'NOT_PAID'
  | 'PAID'
  | 'PROCESSING'
  | 'UNKNOWN'
  | '%future added value';

export type InvoiceCreateFailure = {
  __typename?: 'InvoiceCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type InvoiceCreateInput = {
  buyerId: Scalars['ID']['input'];
  dueAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  invoiceNumber: Scalars['String']['input'];
  issuedAt: Scalars['AWSTimestamp']['input'];
  items: Array<InvoiceLineItemInput>;
  orderReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  shippedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  shippingAddress: InvoiceAddressInput;
  taxSubtotals: Array<InvoiceTaxSubtotalInput>;
  totalGrossAmount: MoneyV2Input;
  totalNetAmount: MoneyV2Input;
  totalTaxAmount: MoneyV2Input;
  vendorId: Scalars['ID']['input'];
};

export type InvoiceCreateResponse = AuthorizationFailure | InputValidationFailure | InvoiceAlreadyExistsFailure | InvoiceCreateFailure | InvoiceCreateSuccess;

export type InvoiceCreateSuccess = {
  __typename?: 'InvoiceCreateSuccess';
  invoiceId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type InvoiceFileUrls = {
  __typename?: 'InvoiceFileUrls';
  pdfUploadUrl: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItemDiscountInput = {
  amount: MoneyV2Input;
};

export type InvoiceLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<InvoiceLineItemDiscountInput>;
  grossAmount: MoneyV2Input;
  name: Scalars['String']['input'];
  netAmount: MoneyV2Input;
  position: Scalars['Int']['input'];
  productRef: InvoiceProductRefInput;
  quantity: Scalars['Float']['input'];
  taxDetails: InvoiceLineItemTaxDetailsInput;
  unit: Scalars['String']['input'];
  unitPrice: MoneyV2Input;
};

export type InvoiceLineItemTaxDetailsInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

/**
 * Identifies a product using an external reference, such as an ERP or
 * third-party catalog identifier, along with its unit.
 *
 * Use this when the product does **not** yet exist in Choco.
 *
 * This input is used within `InvoiceProductRefInput`. You must provide **either**
 * `byId` or `byExternalId` — not both.
 */
export type InvoiceProductRefByExternalIdInput = {
  externalId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

/**
 * Identifies a product using its Choco ID.
 *
 * This input is used within `InvoiceProductRefInput`. You must provide **either**
 * `byId` or `byExternalId` — not both.
 */
export type InvoiceProductRefByIdInput = {
  id: Scalars['ID']['input'];
};

/**
 * Represents a reference to a product, either by internal ID or by external identifier.
 *
 * Only **one** of the two fields should be provided per request:
 * - Use `byId` if the product exists in Choco
 * - Use `byExternalId` if the product is identified in the vendor's ERP system
 *
 * Providing both will result in a validation error.
 */
export type InvoiceProductRefInput = {
  byExternalId?: InputMaybe<InvoiceProductRefByExternalIdInput>;
  byId?: InputMaybe<InvoiceProductRefByIdInput>;
};

export type InvoiceTaxSubtotalInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export type InvoiceVendorPaymentStatus =
  | 'NOT_PAID'
  | 'PAID'
  | 'UNKNOWN'
  | '%future added value';

export type InvoicedProduct = {
  __typename?: 'InvoicedProduct';
  createdAt: Scalars['AWSTimestamp']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoicedPrice?: Maybe<Money>;
  orderId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type InvoicedProductInput = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoicedPrice?: InputMaybe<MoneyInput>;
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type InvoicedProducts = AppsyncResponse & {
  __typename?: 'InvoicedProducts';
  invoicedProducts: Array<InvoicedProduct>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type IsSelectedInOrderGuide = {
  __typename?: 'IsSelectedInOrderGuide';
  value: Scalars['Boolean']['output'];
};

export type IsSelectedInOrderGuideResponse = AuthorizationFailure | InputValidationFailure | IsSelectedInOrderGuide;

export type ItemPrice = {
  __typename?: 'ItemPrice';
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priceInCents: Scalars['Int']['output'];
};

export type ItemUnit = {
  __typename?: 'ItemUnit';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ItemVendor = BuyerExternalVendor | ChocoVendor;

/** Represents a job that has failed completely. */
export type JobFailed = {
  __typename?: 'JobFailed';
  /** Detailed information about the failure of the job, including a failure code and message. */
  failure: JobFailure;
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Provides detailed information about the failure of a job, including a specific error code and message. */
export type JobFailure = {
  __typename?: 'JobFailure';
  /** A code that identifies the type of failure that occurred. */
  code: Scalars['String']['output'];
  /** Additional JSON-formatted information about the failure, which may include details such as the fields that caused validation errors. */
  extra?: Maybe<Scalars['AWSJSON']['output']>;
  /** A human-readable message describing the failure. */
  message: Scalars['String']['output'];
};

/** Represents a job that is currently in progress. */
export type JobInProgress = {
  __typename?: 'JobInProgress';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Represents a job that is queued. */
export type JobQueued = {
  __typename?: 'JobQueued';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** JobStatus enum */
export type JobStatus =
  /** Job has failed. */
  | 'Failed'
  /** Job is in progress. */
  | 'InProgress'
  /** Job is queued and will soon be executed. */
  | 'Queued'
  /** Job has succeeded. */
  | 'Succeeded'
  /** Job is waiting for input file to be uploaded. */
  | 'WaitingForInput'
  | '%future added value';

/** Represents a job waiting for the input file upload to start the process. */
export type JobWaitingForInput = {
  __typename?: 'JobWaitingForInput';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** URL where the input file for the job should be uploaded. */
  inputUploadUrl: Scalars['String']['output'];
};

export type JoinRequestAllowedUpdateStatus =
  | 'approved'
  | 'denied'
  | '%future added value';

export type JoinRequestStatus =
  | 'approved'
  | 'autoApproved'
  | 'denied'
  | 'pending'
  | '%future added value';

/** Here are all functions for accessing and managing leads */
export type LeadOrderBy =
  | 'CreatedAt'
  | 'Name'
  | 'UpdatedAt'
  | '%future added value';

export type LegalContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type LegalEntityAddInstantPayCustomerFailure = {
  __typename?: 'LegalEntityAddInstantPayCustomerFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type LegalEntityAddInstantPayCustomerInput = {
  customerDetails: PaymentCustomerDetailsInput;
  legalEntityId: Scalars['ID']['input'];
  options?: InputMaybe<InstantPayProfileOptionsInput>;
  profileDetails: InstantPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type LegalEntityAddInstantPayCustomerResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerAlreadyOnboardedFailure | LegalEntityAddInstantPayCustomerFailure | LegalEntityAddInstantPayCustomerSuccess;

export type LegalEntityAddInstantPayCustomerSuccess = {
  __typename?: 'LegalEntityAddInstantPayCustomerSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type LegalEntityAlreadyExistsFailure = {
  __typename?: 'LegalEntityAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type LegalEntityDetailsInput = {
  address: BillingAddressInput;
  contact: LegalContactInput;
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  externalLegalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['ID']['output'];
  primaryProperties: LineItemPrimaryProperties;
  secondaryProperties: Array<LineItemSecondaryProperties>;
};

export type LineItemPrimaryProperties = {
  __typename?: 'LineItemPrimaryProperties';
  lineTotalPrice?: Maybe<MoneyV2>;
  name?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyV2>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sellerProductCode?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type LineItemSecondaryProperties = {
  __typename?: 'LineItemSecondaryProperties';
  animalIdOrReferenceNumber?: Maybe<Scalars['String']['output']>;
  countryOfBirth?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  countryOfRearing?: Maybe<Scalars['String']['output']>;
  cuttingCountry?: Maybe<Scalars['String']['output']>;
  cuttingEstablishmentNumber?: Maybe<Scalars['String']['output']>;
  lotCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originStatement?: Maybe<Scalars['String']['output']>;
  packagingDescription?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  slaughterCountry?: Maybe<Scalars['String']['output']>;
  slaughterEstablishmentNumber?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  weightKg?: Maybe<Scalars['String']['output']>;
};

export type ListProcessingTransmissionsInput = {
  filter?: InputMaybe<ProcessingTransmissionFilter>;
  supplierEntityId: Scalars['ID']['input'];
};

export type ListProcessingTransmissionsResponse = AuthorizationFailure | InputValidationFailure | TransmissionConnection;

export type ListPurchaseOrdersInput = {
  status?: InputMaybe<PurchaseOrderReviewStatus>;
};

export type ListPurchaseOrdersResponse = AuthorizationFailure | InputValidationFailure | ListPurchaseOrdersSuccess;

export type ListPurchaseOrdersSuccess = {
  __typename?: 'ListPurchaseOrdersSuccess';
  purchaseOrders: PurchaseOrderConnection;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type ListPurchasingTransmissionsFailure = {
  __typename?: 'ListPurchasingTransmissionsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ListPurchasingTransmissionsInput = {
  buyerId: Scalars['ID']['input'];
  status?: InputMaybe<PurchasingTransmissionStatus>;
};

export type ListPurchasingTransmissionsResponse = AuthorizationFailure | InputValidationFailure | ListPurchasingTransmissionsFailure | ListPurchasingTransmissionsSuccess;

export type ListPurchasingTransmissionsSuccess = {
  __typename?: 'ListPurchasingTransmissionsSuccess';
  purchasingTransmissions: Array<PurchasingTransmission>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type ListSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'ListSubCatalogProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ListSubCatalogProductsInput = {
  /**
   * Additional filters to narrow down the list
   * @deprecated Not supported for LOX Suppliers
   */
  filter?: InputMaybe<ProductFilter>;
  /**
   * Starting offset for the pagination
   * @deprecated Not supported for LOX Suppliers
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search query to look for a specific product
   * @deprecated Not supported for LOX Suppliers
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Size of a single page
   * @deprecated Not supported for LOX Suppliers
   */
  size?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Order of the returned products
   * @deprecated Not supported for LOX Suppliers
   */
  sort?: InputMaybe<Sort>;
  /** ID of the Custom Catalog whose products are fetched */
  subCatalogId: Scalars['ID']['input'];
};

export type ListSubCatalogProductsResponse = ListSubCatalogProductsError | ProductSearchResult;

export type ListSubCatalogsResponse = SubCatalogConnection | ValidationError;

export type ListTransmissionsInput = {
  filter?: InputMaybe<TransmissionFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  sortBy?: InputMaybe<TransmissionSortFields>;
  sortDirection?: InputMaybe<SortDirection>;
  supplierEntityId: Scalars['ID']['input'];
};

export type ListTransmissionsResponse = AuthorizationFailure | InputValidationFailure | TransmissionConnection;

export type LobbyBuyer = Node & {
  __typename?: 'LobbyBuyer';
  buyer: Buyer;
  chatIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type LocationBySupplier = {
  __typename?: 'LocationBySupplier';
  buyerEntityId: Scalars['ID']['output'];
  chatId: Scalars['ID']['output'];
  chatName?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
};

export type LocationProductResult = {
  __typename?: 'LocationProductResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  successfulOperation: Scalars['Boolean']['output'];
};

export type LocationProductsResult = {
  __typename?: 'LocationProductsResult';
  locationId: Scalars['String']['output'];
  products: Array<LocationProductResult>;
};

export type LocationsBySupplierResponse = AuthorizationFailure | InputValidationFailure | LocationsBySupplierSuccess;

export type LocationsBySupplierSuccess = {
  __typename?: 'LocationsBySupplierSuccess';
  result?: Maybe<Array<Maybe<LocationBySupplier>>>;
};

export type LoginMethod =
  | 'email'
  | 'emailAndPhone'
  | 'federated'
  | 'phone'
  | '%future added value';

export type LookupPhoneNumbersError = AppsyncError & AppsyncResponse & {
  __typename?: 'LookupPhoneNumbersError';
  errorCode?: Maybe<LookupPhoneNumbersErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type LookupPhoneNumbersErrorCode =
  | 'genericError'
  | '%future added value';

export type LookupPhoneNumbersResponse = LookupPhoneNumbersError | LookupPhoneNumbersSuccess;

export type LookupPhoneNumbersSuccess = {
  __typename?: 'LookupPhoneNumbersSuccess';
  lookups: Array<PhoneNumberLookup>;
};

export type MarkCustomerInsightsNotificationAsReadInput = {
  id: Scalars['ID']['input'];
};

export type MarkCustomerInsightsNotificationAsReadResponse = AuthorizationFailure | CustomerInsightsNotification | InputValidationFailure;

/** Marketing campaign node containing marketing campaign information */
export type MarketingCampaign = Node & {
  __typename?: 'MarketingCampaign';
  /** Marketing campaign activated date time */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The user who activated/sent the campaign. */
  activatedByUser?: Maybe<User>;
  /** Marketing campaign performance for the sent campaigns */
  analytics?: Maybe<MarketingCampaignAnalytics>;
  /** Marketing campaign attachments to be used for sending emails */
  attachments: Array<CampaignAttachment>;
  /** Marketing campaign cancelled date time */
  cancelledAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Marketing campaign channels to be used for the campaign */
  channels: Array<CampaignChannel>;
  /** Marketing campaign chat message content to be used for sending chat messages */
  chatMessageContent?: Maybe<MarketingCampaignChatMessageContent>;
  /** Marketing campaign chat target count */
  chatTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign created date time */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The user who created the campaign. */
  createdByUser: User;
  /** Marketing campaign email content to be used for sending emails */
  emailContent?: Maybe<EmailContent>;
  /** Marketing campaign email target count */
  emailTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign expiration date time (for PROMO campaigns) */
  expiresAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Marketing campaign home promo content to be used for home promotions */
  homePromoContent?: Maybe<MarketingCampaignPromoContent>;
  /** Marketing campaign ID */
  id: Scalars['ID']['output'];
  /** Marketing campaign preferred products content to be used for preferred products promotions */
  promoPreferredProductsContent?: Maybe<MarketingCampaignPromoPreferredProductsContent>;
  /** Marketing campaign promo target count */
  promoTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign state to show the current state of the campaign e.g. draft, active, finished etc. */
  state: MarketingCampaignState;
  /** Marketing campaign target rules to be used for sending emails */
  target?: Maybe<CampaignTarget>;
  /** Marketing campaign template to be used for sending emails */
  template?: Maybe<EmailTemplate>;
  /** Marketing campaign title for the supplier */
  title: Scalars['String']['output'];
  /** Marketing campaign vendor item units to be used for the campaign */
  vendorItemUnits: Array<VendorItemUnitRef>;
};

export type MarketingCampaignAnalytics = {
  __typename?: 'MarketingCampaignAnalytics';
  /** Marketing campaign chat message clicked count */
  chatMessageClickedCount: Scalars['Int']['output'];
  /** Marketing campaign chat message clicked rate based on the sent count */
  chatMessageClickedRate: Scalars['Float']['output'];
  /** Marketing campaign chat message conversion count */
  chatMessageConversionCount: Scalars['Int']['output'];
  /** Marketing campaign chat message conversion rate based on the sent count */
  chatMessageConversionRate: Scalars['Float']['output'];
  /** Marketing campaign chat message revenue */
  chatMessageRevenue: MoneyV2;
  /** Marketing campaign chat message sent count */
  chatMessageSentCount: Scalars['Int']['output'];
  /** Marketing campaign chat message viewed count */
  chatMessageViewedCount: Scalars['Int']['output'];
  /** Marketing campaign chat message viewed rate based on the sent count */
  chatMessageViewedRate: Scalars['Float']['output'];
  /** Marketing campaign conversion count from all channels */
  conversionCount: Scalars['Int']['output'];
  /** Marketing campaign conversion rate based on the sent count from all channels */
  conversionRate: Scalars['Float']['output'];
  /** Marketing campaign email bounced count */
  emailBouncedCount: Scalars['Int']['output'];
  /** Marketing campaign email bounced rate based on the sent count */
  emailBouncedRate: Scalars['Float']['output'];
  /** Marketing campaign email clicked count */
  emailClickedCount: Scalars['Int']['output'];
  /** Marketing campaign email clicked rate based on the delivered count */
  emailClickedRate: Scalars['Float']['output'];
  /** Marketing campaign email conversion count */
  emailConversionCount: Scalars['Int']['output'];
  /** Marketing campaign email conversion rate based on the delivered count */
  emailConversionRate: Scalars['Float']['output'];
  /** Marketing campaign email delivered count */
  emailDeliveredCount: Scalars['Int']['output'];
  /** Marketing campaign email delivered rate based on the sent count */
  emailDeliveredRate: Scalars['Float']['output'];
  /** Marketing campaign email opened count */
  emailOpenedCount: Scalars['Int']['output'];
  /** Marketing campaign email opened rate based on the delivered count */
  emailOpenedRate: Scalars['Float']['output'];
  /** Count of ordered products from the email marketing campaign */
  emailProductOrdersCount: Scalars['Int']['output'];
  /** Marketing campaign revenue from email channel */
  emailRevenue: MoneyV2;
  /** Marketing campaign email sent count */
  emailSentCount: Scalars['Int']['output'];
  /** Marketing campaign email reported spam count */
  emailSpamReportedCount: Scalars['Int']['output'];
  /** Marketing campaign email reported spam rate based on the delivered count */
  emailSpamReportedRate: Scalars['Float']['output'];
  /** Marketing campaign email unsubscribed count */
  emailUnsubscribedCount: Scalars['Int']['output'];
  /** Marketing campaign email unsubscribed rate based on the delivered count */
  emailUnsubscribedRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products added to order guide of chats count */
  preferredProductsAddedToChatOrderGuideCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products click count */
  preferredProductsClickedCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products clicked rate based on the target count */
  preferredProductsClickedRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products conversion count */
  preferredProductsConversionCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products conversion rate based on the view count */
  preferredProductsConversionRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products revenue */
  preferredProductsRevenue: MoneyV2;
  /** Marketing campaign preferred products initial target count */
  preferredProductsTargetCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products view count */
  preferredProductsViewedCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products viewed rate based on the target count */
  preferredProductsViewedRate: Scalars['Float']['output'];
  /** Marketing campaign promo click count */
  promoClickedCount: Scalars['Int']['output'];
  /** Marketing campaign promo clicked rate based on the target count */
  promoClickedRate: Scalars['Float']['output'];
  /** Marketing campaign promo conversion count */
  promoConversionCount: Scalars['Int']['output'];
  /** Marketing campaign promo conversion rate based on the view count */
  promoConversionRate: Scalars['Float']['output'];
  /** Marketing campaign promo revenue */
  promoRevenue: MoneyV2;
  /** Marketing campaign promo initial target count */
  promoTargetCount: Scalars['Int']['output'];
  /** Marketing campaign promo view count */
  promoViewedCount: Scalars['Int']['output'];
  /** Marketing campaign promo viewed rate based on the target count */
  promoViewedRate: Scalars['Float']['output'];
  /** Marketing campaign revenue from all channels */
  revenue: MoneyV2;
};

export type MarketingCampaignBuyerChatInput = {
  buyerId: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
};

export type MarketingCampaignChannelTargetInput = {
  /** Chat IDs to be used for the marketing campaign. Required if the type is `TargetChats` */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignTarget;
};

export type MarketingCampaignChatMessageContent = {
  __typename?: 'MarketingCampaignChatMessageContent';
  /** Chat message attachments */
  attachments?: Maybe<Array<CampaignChatAttachment>>;
  /** Chat message content */
  message: Scalars['String']['output'];
};

export type MarketingCampaignChatTarget =
  | 'ALL'
  | 'CHATS'
  | '%future added value';

export type MarketingCampaignChatTargetInput = {
  /** Chat IDs to be used for the marketing campaign. Required if the type is `TargetChats` */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignChatTarget;
};

export type MarketingCampaignChatUsersInput = {
  /** Chat ID to be used for the marketing campaign */
  chatId: Scalars['String']['input'];
  /** Chat user IDs to be used for the marketing campaign */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Connection type to list marketing campaign edges */
export type MarketingCampaignConnection = Connection & {
  __typename?: 'MarketingCampaignConnection';
  /** List of marketing campaign edges */
  edges: Array<MarketingCampaignEdge>;
  /** Total number of marketing campaign edges under this connection */
  total: Scalars['Int']['output'];
};

/** Edge type to show marketing campaign node and pagination cursor */
export type MarketingCampaignEdge = Edge & {
  __typename?: 'MarketingCampaignEdge';
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Marketing campaign node containing marketing campaign information */
  node: MarketingCampaign;
};

export type MarketingCampaignEmailSender = {
  __typename?: 'MarketingCampaignEmailSender';
  /** Marketing campaign email sender company legal details for footer */
  companyDetails: Scalars['String']['output'];
  /** Marketing campaign email sender address */
  email: Scalars['String']['output'];
  /** Marketing campaign email sender footer links, can be empty array */
  footerLinks: Array<MarketingCampaignEmailSenderFooterLink>;
  /** Marketing campaign email sender */
  name: Scalars['String']['output'];
  /** Marketing campaign email reply to address for the sender */
  replyToEmail: Scalars['String']['output'];
  /** Marketing campaign email reply to name */
  replyToName: Scalars['String']['output'];
  /** The status of sender configuration (generated, submitted, verified, active) */
  status?: Maybe<MarketingEmailSenderStatus>;
};

/** Marketing campaign email sender footer link */
export type MarketingCampaignEmailSenderFooterLink = {
  __typename?: 'MarketingCampaignEmailSenderFooterLink';
  /** Marketing campaign email sender footer link name */
  name: Scalars['String']['output'];
  /** Marketing campaign email sender footer link URL */
  url: Scalars['String']['output'];
};

export type MarketingCampaignEmailSenderNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'MarketingCampaignEmailSenderNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to `error` */
  responseType: ResponseType;
};

/** Email sender information to be used for sending emails */
export type MarketingCampaignEmailSenderResult = AppsyncResponse & {
  __typename?: 'MarketingCampaignEmailSenderResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Email sender for the marketing campaigns */
  sender: MarketingCampaignEmailSender;
};

export type MarketingCampaignEmailTarget =
  | 'ALL'
  | 'CHAT_USERS'
  | '%future added value';

export type MarketingCampaignEmailTargetInput = {
  /** Chat users to be used for email marketing campaign. Required if the type is `TargetChatUsers` */
  chatUsers?: InputMaybe<Array<MarketingCampaignChatUsersInput>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignEmailTarget;
};

/** Input type for filtering campaigns by expiration date */
export type MarketingCampaignExpirationFilter = {
  /** Filter campaigns expiring after this date */
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** Filter campaigns expiring before this date */
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/** Input type for filtering a list of marketing campaigns */
export type MarketingCampaignListFilter = {
  /** Filter by activatedUserId date range */
  activatedByUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by channel type */
  channel?: InputMaybe<Array<CampaignChannel>>;
  /** Filter by createdByUserId */
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by expiration date range */
  expiration?: InputMaybe<MarketingCampaignExpirationFilter>;
  /** Filter by state */
  state?: InputMaybe<Array<MarketingCampaignState>>;
};

/** Input type for getting a list of marketing campaigns */
export type MarketingCampaignListInput = {
  /** Filters campaign by different values */
  filter?: InputMaybe<MarketingCampaignListFilter>;
  /**
   * Filters campaign by state
   * @deprecated use filter instead
   */
  stateFilter?: InputMaybe<Array<MarketingCampaignState>>;
};

/** Response to list all marketing campaigns of a supplier or return error */
export type MarketingCampaignListResponse = AuthorizationFailure | InputValidationFailure | MarketingCampaignConnection;

/** Home promo content for marketing campaigns */
export type MarketingCampaignPromoContent = {
  __typename?: 'MarketingCampaignPromoContent';
  /** Home promo display image for the banner */
  displayImage?: Maybe<DownloadableCampaignAttachment>;
  /** Home promo display title shown to buyers */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Home promo ordering image for the detail page */
  orderingImage?: Maybe<DownloadableCampaignAttachment>;
  /** Home promo ordering message for the detail page */
  orderingMessage?: Maybe<Scalars['String']['output']>;
};

/** Preferred products content for marketing campaigns */
export type MarketingCampaignPromoPreferredProductsContent = {
  __typename?: 'MarketingCampaignPromoPreferredProductsContent';
  /** Preferred products title shown to buyers */
  title: Scalars['String']['output'];
};

export type MarketingCampaignPromoTarget =
  | 'ALL'
  | 'BUYER_CHATS'
  | '%future added value';

export type MarketingCampaignPromoTargetInput = {
  /** Buyer chat pairs to be used for home promo marketing campaign. Required if the type is `BUYER_CHATS` */
  buyerChats?: InputMaybe<Array<MarketingCampaignBuyerChatInput>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignPromoTarget;
};

export type MarketingCampaignState =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'DRAFT'
  | 'FINISHED'
  | '%future added value';

export type MarketingCampaignTarget =
  | 'ALL'
  | 'CHATS'
  | '%future added value';

/** Input type for targeting specific channels in a marketing campaign. At least one channel must be specified */
export type MarketingCampaignTargetInput = {
  /** Chat targeting rules */
  chat?: InputMaybe<MarketingCampaignChannelTargetInput>;
  /** Email targeting rules */
  email?: InputMaybe<MarketingCampaignChannelTargetInput>;
};

/** Input type for targeting specific channels in a marketing campaign. At least one channel must be specified */
export type MarketingCampaignTargetInputV2 = {
  /** Chat targeting rules */
  chat?: InputMaybe<MarketingCampaignChatTargetInput>;
  /** Email targeting rules */
  email?: InputMaybe<MarketingCampaignEmailTargetInput>;
  /** Home promo targeting rules */
  homePromo?: InputMaybe<MarketingCampaignPromoTargetInput>;
  /** Preferred products targeting rules, same as home promo targeting rules */
  promoPreferredProducts?: InputMaybe<MarketingCampaignPromoTargetInput>;
};

/** Response type for a marketing campaign update mutation or error */
export type MarketingCampaignUpdateResponse = AuthorizationFailure | InputValidationFailure | MarketingCampaignUpdateResult;

/** Success result of a marketing campaign update mutation */
export type MarketingCampaignUpdateResult = AppsyncResponse & {
  __typename?: 'MarketingCampaignUpdateResult';
  /** Updated marketing campaign information */
  marketingCampaign: MarketingCampaign;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Input type for marketing email sender footer link */
export type MarketingEmailSenderFooterLinkInput = {
  /** Footer link name */
  name: Scalars['String']['input'];
  /** Footer link URL */
  url: Scalars['String']['input'];
};

export type MarketingEmailSenderStatus =
  | 'ACTIVE'
  | 'GENERATED'
  | 'SUBMITTED'
  | 'VERIFIED'
  | '%future added value';

export type MarketingMessageRefinementTip = {
  __typename?: 'MarketingMessageRefinementTip';
  tip: Scalars['String']['output'];
};

export type MarketingMessageSuggestionsError = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type MarketingMessageSuggestionsErrorNoSuggestions = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorNoSuggestions';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type MarketingMessageSuggestionsErrorThrottling = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorThrottling';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type MarketingMessageSuggestionsResult = InputValidationFailure | MarketingMessageSuggestionsError | MarketingMessageSuggestionsErrorNoSuggestions | MarketingMessageSuggestionsErrorThrottling | MarketingMessageSuggestionsSuccess;

export type MarketingMessageSuggestionsSuccess = AppsyncResponse & {
  __typename?: 'MarketingMessageSuggestionsSuccess';
  improvedText: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
  tips: Array<MarketingMessageRefinementTip>;
};

export type MatchingConfidence = {
  __typename?: 'MatchingConfidence';
  customer?: Maybe<CustomerMatchingConfidence>;
  order?: Maybe<OrderMatchingConfidence>;
  products?: Maybe<Array<ProductMatchingConfidence>>;
};

export type Media = {
  __typename?: 'Media';
  contentType?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Media link to be used for uploading and accessing media from the CDN */
export type MediaLink = {
  __typename?: 'MediaLink';
  /** Media ID used to identify the media in frontend */
  fileId: Scalars['String']['output'];
  /** Public CDN URL for the media file, to be used in emails */
  publicUrl: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
  /** S3 URI for the media file */
  uri: Scalars['String']['output'];
};

/** Input type for getting media upload link */
export type MediaLinkInput = {
  /** File ID used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Media file name */
  name: Scalars['String']['input'];
  /** Media file type */
  type: Scalars['String']['input'];
};

/** Success result containing media upload links */
export type MediaUploadLinkResult = AppsyncResponse & {
  __typename?: 'MediaUploadLinkResult';
  /** Media upload and access links */
  links: Array<MediaLink>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type MenuScan = Node & {
  __typename?: 'MenuScan';
  /** Timestamp of when the menu scan job was started */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * The list of files attached to this scan
   * We only support one file for now
   * Can be empty if no files have been uploaded yet
   */
  attachments?: Maybe<Array<MenuScanAttachment>>;
  /** Timestamp of when the scan was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /** The id of the lead associated with the scan */
  leadId: Scalars['ID']['output'];
  /** File scan result */
  scanResult?: Maybe<MenuScanResult>;
  /** Job processing status */
  status: MenuScanStatus;
  /** The supplier related to the menu scan */
  supplierId: Scalars['ID']['output'];
  /** Timestamp of when the scan was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who activated the menu scan job */
  userId: Scalars['ID']['output'];
};

export type MenuScanAttachment = {
  __typename?: 'MenuScanAttachment';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The scan this file belongs to */
  menuScanId: Scalars['ID']['output'];
};

export type MenuScanAttachmentInput = {
  contentType: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type MenuScanAttachmentUploadLink = {
  __typename?: 'MenuScanAttachmentUploadLink';
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['output'];
  /** Attachment ID used to identify the file in the bucket */
  fileId: Scalars['String']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
};

export type MenuScanAttachmentUploadLinkInput = {
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['input'];
  /** Attachment file name */
  fileName: Scalars['String']['input'];
};

export type MenuScanAttachmentUploadLinkResult = AppsyncResponse & {
  __typename?: 'MenuScanAttachmentUploadLinkResult';
  /** Updated links for the menu scan attachments */
  links?: Maybe<Array<MenuScanAttachmentUploadLink>>;
  responseType: ResponseType;
};

export type MenuScanConnection = Connection & {
  __typename?: 'MenuScanConnection';
  edges: Array<MenuScanEdge>;
  total: Scalars['Int']['output'];
};

export type MenuScanEdge = Edge & {
  __typename?: 'MenuScanEdge';
  cursor: Scalars['String']['output'];
  node: MenuScan;
};

export type MenuScanResult = {
  __typename?: 'MenuScanResult';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
};

export type MenuScanStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING'
  | '%future added value';

export type MenuScanUpdateResult = AppsyncResponse & {
  __typename?: 'MenuScanUpdateResult';
  /** Updated menu scan */
  menuScan: MenuScan;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType;
};

export type Message = Node & {
  __typename?: 'Message';
  attachment?: Maybe<Attachment>;
  body: Scalars['String']['output'];
  broadcastId?: Maybe<Scalars['ID']['output']>;
  chat: Chat;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  user: User;
};

export type MessageEvent = {
  __typename?: 'MessageEvent';
  eventType?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export type MessageGroupFilter = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageInput = {
  body: Scalars['String']['input'];
  broadcastId?: InputMaybe<Scalars['String']['input']>;
  /** Used to group messages, e.g email replies to delivery check reconciliation requests */
  groupIds?: InputMaybe<GroupIdsInput>;
  id: Scalars['ID']['input'];
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  /** Flag to prevent message from sending to chat supplier */
  supplierOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only infra request can set the value, otherwise it should be undefined */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MessageStatus =
  | 'delivered'
  | 'pendingAttachment'
  | 'readyForDelivery'
  | '%future added value';

export type MessageType =
  | 'broadcast'
  | 'deliveryCheckReconciliationRequestConfirmed'
  | 'emailMessage'
  | 'event'
  | 'media'
  | 'order'
  | 'orderConfirmation'
  | 'text'
  | '%future added value';

/**
 * For internal use,
 * This type is kept exactly similar to the message table schema since it is used as is in choco-notification
 */
export type MessagesFromChatResult = {
  __typename?: 'MessagesFromChatResult';
  body: Scalars['String']['output'];
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  event?: Maybe<MessageEvent>;
  id: Scalars['String']['output'];
  media?: Maybe<Scalars['Boolean']['output']>;
  mediaContentType?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<MessageStatus>;
  supplierOptIn?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<MessageType>;
  userId: Scalars['String']['output'];
};

export type MetaLobbyResponse = InvalidCursor | MetaLobbyResult;

export type MetaLobbyResult = {
  __typename?: 'MetaLobbyResult';
  buyers: UserLobbyBuyerConnection;
  others?: Maybe<Array<Scalars['String']['output']>>;
};

export type MinOrder = {
  __typename?: 'MinOrder';
  price?: Maybe<Money>;
};

export type MinOrderInput = {
  price?: InputMaybe<MoneyInput>;
};

export type MinimumOrderValue = {
  __typename?: 'MinimumOrderValue';
  formattedMinimumOrderValue?: Maybe<Scalars['String']['output']>;
  minimumOrderValue?: Maybe<MinOrder>;
  type?: Maybe<MinimumOrderValueType>;
};

export type MinimumOrderValueFailure = {
  __typename?: 'MinimumOrderValueFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type MinimumOrderValueResponse = AuthorizationFailure | InputValidationFailure | MinimumOrderValue | MinimumOrderValueFailure;

export type MinimumOrderValueType =
  | 'customerLevel'
  | 'supplierLevel'
  | '%future added value';

export type MinimumOrderValueUpdate = {
  __typename?: 'MinimumOrderValueUpdate';
  success: Scalars['Boolean']['output'];
};

export type MinimumOrderValueUpdateResponse = AuthorizationFailure | InputValidationFailure | MinimumOrderValueFailure | MinimumOrderValueUpdate;

export type MinimumOrderableAmountDetail = {
  __typename?: 'MinimumOrderableAmountDetail';
  minimumOrderableAmount: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type MinimumOrderableAmountError = AppsyncError & AppsyncResponse & {
  __typename?: 'MinimumOrderableAmountError';
  message?: Maybe<Scalars['String']['output']>;
  /** The products that have ordered amount less than product minimum orderable amount */
  noMinimumOrderableAmountProducts: Array<NoMinimumOrderableAmountProduct>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type MinimumOrderableAmountFailure = {
  __typename?: 'MinimumOrderableAmountFailure';
  details: Array<MinimumOrderableAmountDetail>;
  message: Scalars['String']['output'];
};

export type MobileHomePageBannerInfoFullWidthContent = {
  __typename?: 'MobileHomePageBannerInfoFullWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
};

export type MobileHomePageBannerShoppableFullWidthContent = {
  __typename?: 'MobileHomePageBannerShoppableFullWidthContent';
  chat?: Maybe<Chat>;
  featuredVendorItemUnitId: Scalars['ID']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
  promoPageContent: PromoPageContent;
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type MobileHomePagePopupInfoFullPageContent = {
  __typename?: 'MobileHomePagePopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MobileOrderGuideBannerShoppableFullWidthContent = {
  __typename?: 'MobileOrderGuideBannerShoppableFullWidthContent';
  orderGuideBannerImageUrl: Scalars['String']['output'];
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type MobilePostOrderPopupInfoFullPageContent = {
  __typename?: 'MobilePostOrderPopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
};

/** Amount should be passed with the lowest denominations/cents */
export type MoneyInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  /** The amount without decimal point, e.g. 1234 for $12.34 */
  amount: Scalars['Int']['output'];
  /** The currency code, e.g. "USD" */
  currency: Scalars['String']['output'];
  /** The number of decimal places in the amount, e.g. 2 for $12.34 */
  decimalPlaces: Scalars['Int']['output'];
};

export type MoneyV2Input = {
  /** The amount without decimal point, e.g. 1234 for $12.34 */
  amount: Scalars['Int']['input'];
  /** The currency code, e.g. "USD" */
  currency: Scalars['String']['input'];
  /** The number of decimal places in the amount, e.g. 2 for $12.34 */
  decimalPlaces: Scalars['Int']['input'];
};

export type MoneyV2InputOptional = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiLocationOrderGuidesV2ItemUnitsRemoveInput = {
  /**
   * The chats that the items will be removed from their orderGuides.
   * Include the source chat if the items are to be removed from it as well.
   */
  chatIds: Array<Scalars['ID']['input']>;
  /** If set to true, the operation will be validated but not executed. */
  dryRun: Scalars['Boolean']['input'];
  /** The product IDs to be removed. */
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type MultiLocationOrderGuidesV2ItemUnitsRemoveResponse = AuthorizationFailure | InputValidationFailure | MultiLocationOrderGuidesV2ItemUnitsRemoveResult;

export type MultiLocationOrderGuidesV2ItemUnitsRemoveResult = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsRemoveResult';
  /** The removed order guide item units. */
  locations: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateInput = {
  /** The destination chats that the items will be copied to their orderGuides. */
  chatIds: Array<Scalars['ID']['input']>;
  /** If set to true, the operation will be validated but not executed. */
  dryRun: Scalars['Boolean']['input'];
  /** The items to update. */
  items: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateInputItem>;
  /** The source chat that the items will be copied from its orderGuide. */
  sourceChatId: Scalars['ID']['input'];
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateInputItem = {
  /**
   * The category name in the source order guide
   * If not provided, the item will be added/updated as uncategorized.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to update/add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | MultiLocationOrderGuidesV2ItemUnitsUpdateResult;

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResult = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResult';
  /** The updated order guide item units. */
  locations: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation';
  chatId: Scalars['ID']['output'];
  /** The updated order guide item units. */
  items: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem>;
  orderGuideId: Scalars['ID']['output'];
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem';
  /**
   * Should be one of the following:
   * - `Added`
   * - `Updated`
   * - `Removed`
   * If the operation was not successful, this field will no be returned.
   */
  action?: Maybe<Scalars['String']['output']>;
  /**
   * The error code if the operation was not successful.
   * Should be one of the following:
   * - `OG_NOT_FOUND`: The order guide was not found for the input chat, and can not be created.
   * - `VENDOR_ITEM_UNIT_NOT_FOUND`: The vendor item unit is not available or invalid for the destination chat.
   * - `BUYER_PROPERTIES_UPDATE_FAILED`: The vendor item unit was added/removed to/from the order guide, but the buyer properties update failed.
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  /**
   * The buyer properties that failed to update, if any.
   * Only present for update operation (not remove) and while errorCode is `BUYER_PROPERTIES_UPDATE_FAILED`.
   */
  failedBuyerProperties?: Maybe<VendorItemUnitBuyerPropertiesWithPrice>;
  /** The error message if the operation was not successful. */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether or not the operation was successful. */
  successfulOperation: Scalars['Boolean']['output'];
  /** The vendor item unit ID. */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrder: AcceptOrderResponse;
  addBuyerStockInventoryProduct: AddBuyerStockInventoryProductResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2ItemUnitsAdd` or `orderGuideV2BatchUpdate` instead */
  addCatalogProductsToProductList: Array<CategoryProducts>;
  addLabelToChats: Scalars['Boolean']['output'];
  /** Ensure that products are in catalog, then add them */
  addMarketingProductsToCart?: Maybe<AddMarketingProductsToCartResponse>;
  /** @deprecated Does not work for LOX Suppliers. Use `multiLocationOrderGuidesV2ItemUnitsUpdate` instead */
  addProductsToOrderGuides: AddProductsToOrderGuidesResponse;
  addSalesRep: AddSalesRepRequestToJoinResponse;
  addSellerToPurchasingBusiness: AddSellerToPurchasingBusinessResponse;
  /** Buyer Add Supplier Request */
  addSupplierRequest: BuyerAddSupplierResponse;
  addUserToChats: Scalars['Boolean']['output'];
  /** Move a lead to a different state in the sales funnel. */
  advanceSalesFunnelLead: AdvanceSalesFunnelLeadResponse;
  approveOrder: AcceptOrderResponse;
  assignOrderToUserForReview: AssignOrderToUserForReviewResponse;
  /** Assign a lead to a sales rep. */
  assignSalesFunnelLead: AssignSalesFunnelLeadResponse;
  autoPilotBugReport: AutoPilotBugReportResponse;
  automaticOrderProcessingThresholdSetting: AutomaticOrderProcessingThresholdSettingResponse;
  batchOrderConfirm?: Maybe<BatchOrderConfirmResponse>;
  /**
   * For internal use, to update the supplier of
   * all orders associated with a chat
   */
  batchUpdateOrderSupplier?: Maybe<BatchUpdateOrderSupplier>;
  billingDocumentExportCreate: BillingDocumentExportCreateResponse;
  broadcastCreate: Broadcast;
  broadcastUpdate: Broadcast;
  broadcastUpdatePurpose?: Maybe<BroadcastUpdatePurposeResult>;
  bulkDeclineOrders: BulkDeclineOrdersResponse;
  bulkSendInviteTransmission: BulkSendInviteTransmissionResponse;
  bulkSubmitOrderedProductDeliveryCheck?: Maybe<BulkOrderedProductDeliveryCheckSubmissionResponse>;
  buyerAddUser: BuyerUser;
  buyerBulkAddUser: Array<Maybe<BuyerUser>>;
  buyerCreate: Buyer;
  buyerDisableRoles: BuyerDisableRolesResponse;
  buyerRemoveUser: BuyerUser;
  buyerUpdate: Buyer;
  /** Cancel the cart. This empties out the lineItems. */
  cancelCart?: Maybe<CancelCartResponse>;
  /** Cancel an active marketing campaign */
  cancelMarketingCampaign: MarketingCampaignUpdateResponse;
  /**
   * Edits the values of a product attribute (allergen or dietary preference).
   * Can be called by: Choco Admins, users of the Supplier.
   */
  catalogAttributeUpdate: CatalogAttributeUpdateResponse;
  /** Mutation to start a catalog export job. */
  catalogExportStart: CatalogExportStartResponse;
  /** Mutation to start a catalog import job. */
  catalogImportStart: CatalogImportStartResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2CategoriesUpdate` instead */
  categoryCreate: ProductCategory;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2CategoriesUpdate` instead */
  categoryDelete: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` or `orderGuideV2ItemUnitsUpdate` instead */
  categoryProductSort: Array<CategoryProducts>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2CategoriesUpdate` instead */
  categoryUpdate: ProductCategory;
  chatCreate: Chat;
  chatDisable: Scalars['Boolean']['output'];
  chatInviteUsers: Chat;
  chatLeave?: Maybe<Scalars['ID']['output']>;
  /**
   * Admin only,
   * to update the main supplier of a chat
   * - migrate order to new supplier (bot user)
   * - add the new supplier into the chat
   * - remove the old supplier out the chat
   */
  chatMainSupplierMigrate: Scalars['Boolean']['output'];
  /**
   * Update chat prices visibility settings for a given chat.
   * Can be called by: Choco Admins, users of the Supplier to whom the chat belongs.
   */
  chatPricesVisibilityUpdate: ChatPricesVisibilityUpdateResponse;
  chatRemoveUsers: Chat;
  chatUpdate: Chat;
  /**
   * For internal use, to update the supplier of
   * a chat
   */
  chatUpdateMainSupplier: Scalars['Boolean']['output'];
  claimOnboardingChecklistReward: ClaimOnboardingChecklistRewardResponse;
  confirmAccountLinking: ConfirmAccountLinkingResponse;
  confirmDeliveryCheckReconciliationRequest?: Maybe<ConfirmDeliveryCheckReconciliationResponse>;
  /** Confirm that the email editor state has been saved using the provided S3 key and version ID. */
  confirmSaveEmailEditorState: ConfirmSaveEmailEditorStateResponse;
  connectAccount: ConnectAccountResponse;
  /**
   * connectIntegrationAdapter is legacy mutation that should be used only by Harel untill end of Hydra migration
   * In order to create new Lobster and other CUSTOM integration connections use integrationAdapterConnectionCreate instead
   */
  connectIntegrationAdapter: ConnectIntegrationAdapterResponse;
  contactsCreate?: Maybe<Array<Maybe<User>>>;
  /**
   * This is an API for Choco AI users to correct an order.
   *
   * It will create a new correction order entry information and update cache and other dependencies.
   * It will also send a event of OrderCorrected to other listeners.
   */
  correctOrder: OrderCorrectionResponse;
  /** Create buyer report schedule */
  createBuyerReportSchedule: CreateBuyerReportScheduleResponse;
  /** Create a new distributor note. */
  createDistributorNote: CreateDistributorNoteResponse;
  /** Create a new distributor task */
  createDistributorTask: CreateDistributorTaskResponse;
  /** Creates a document scan entity for a lead */
  createDocumentScan: CreateDocumentScanResponse;
  /** Create marketing campaign with different channels */
  createMarketingCampaign: MarketingCampaignUpdateResponse;
  /** Creates a menu scan entity for a lead */
  createMenuScan: CreateMenuScanResponse;
  createOrderDeliveryCheck?: Maybe<OrderDeliveryCheckCreationResponse>;
  createOrderDeliveryCheckImageUploadUrl?: Maybe<OrderDeliveryCheckImageUploadUrlResponse>;
  createOrderDeskEmailList: CreateEmailListResponse;
  createOrderUpload: CreateOrderUploadResponse;
  createProfile: CreateProfileResponse;
  createPurchasingBusiness: CreatePurchasingBusinessResponse;
  createPurchasingTransmission: CreatePurchasingTransmissionResponse;
  /** create endpoint for receiving mobile push notifications */
  createPushEndpoint?: Maybe<PushEndpointResponse>;
  /** Create endpoint for receiving mobile push notifications */
  createPushEndpointV2?: Maybe<PushEndpointResponse>;
  createReferral?: Maybe<CreateReferralResponse>;
  /** Create a new sales funnel. */
  createSalesFunnel: CreateSalesFunnelResponse;
  /**
   * Create a new lead in a sales funnel, including data about the lead, its
   * initial state, and the sales rep assigned to it.
   */
  createSalesFunnelLead: CreateSalesFunnelLeadResponse;
  /** Add an additional state at the end of the sales funnel */
  createSalesFunnelState: CreateSalesFunnelStateResponse;
  createStorageItem: CreateStorageItemResponse;
  /**
   * Creates a new Custom Catalog for a given Supplier.
   * Can be called by: Choco Admin or Supplier user with the same id
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  createSubCatalog?: Maybe<CreateSubCatalogResponse>;
  createSupplierContact: CreateSupplierContactResponse;
  /**
   * Creates new Catalog Product.
   * Does not support unit variants (will fail if there is already a product with the same `externalId`).
   * See `createSupplierProductV2` for the updated version.
   * `par` and `category` fields are ignored.
   * Can be called by: Choco Admin or Supplier user
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. See notice for `createSupplierProductV2`
   */
  createSupplierProduct: CreateUpdateSupplierProductResponse;
  /**
   * Creates new Catalog Product for a given Supplier.
   * Supports creating unit variants for Suppliers who are not in the UOM Exclusion List.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but will not get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  createSupplierProductV2: CreateUpdateSupplierProductResponse;
  creditNoteCreate: CreditNoteCreateResponse;
  /** Mutation to start a customCatalogFull import job. */
  customCatalogFullImportStart: CatalogImportStartResponse;
  /**
   * Updates the assignment of vendor item units to custom catalogs.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogsItemUnitsBatchUpdate: CustomCatalogsItemUnitsBatchUpdateResponse;
  declineOrder: DeclineOrderResponse;
  /** Delete buyer report schedule */
  deleteBuyerReportSchedule: DeleteBuyerReportScheduleResponse;
  deleteBuyerStockInventoryProducts: DeleteBuyerStockInventoryProductsResponse;
  /**
   * Deletes a deliverySetting if it is scoped to a specific chat.
   * If the mutation was a success, it returns the ID of the deleted deliverySetting.
   * If the deliverySetting was not scoped to a chat, it will return an error.
   */
  deleteChatDeliverySetting?: Maybe<DeletedChatSetting>;
  /** Delete a distributor note. */
  deleteDistributorNote: DeleteDistributorNoteResponse;
  /** Delete a distributor task */
  deleteDistributorTask: DeleteDistributorTaskResponse;
  /**
   * Completely deletes all Catalog Products for a given Supplier.
   * The operation is processed asynchronously. The products will be removed in background one by one.
   * The return number is meaningless.
   * Note that on LOX the Products may still be visible in the Order Guide it was added to as unavailable.
   * Can be called by: Choco Admin to clean catalogs.
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteEntireSupplierProduct?: Maybe<Scalars['Int']['output']>;
  deleteInventoryItems: DeleteInventoryItemsResponse;
  deleteParsedPurchaseOrders: DeleteParsedPurchaseOrdersResponse;
  /**
   * Deletes attached image of a given Catalog Product
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  deleteProductImage?: Maybe<Scalars['Int']['output']>;
  deleteProfileImage?: Maybe<User>;
  deletePurchaseOrders: DeletePurchaseOrdersResponse;
  deletePurchasingBusiness: DeletePurchasingBusinessResponse;
  /**
   * Deletes the provided Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteSubCatalog?: Maybe<DeleteSubCatalogResponse>;
  deleteSupplierNegotiatedPrices?: Maybe<DeletedSupplierNegotiatedPriceResponse>;
  /**
   * Deletes a given Catalog Product.
   * Note that on LOX the Product may still be visible in the Order Guide it was added to as unavailable.
   * Can be called by: Choco Admin to clean catalogs.
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteSupplierProduct?: Maybe<Array<Scalars['ID']['output']>>;
  directPayCustomerOnboard: DirectPayCustomerOnboardResponse;
  directPayCustomerStatusUpdate: DirectPayCustomerStatusUpdateResponse;
  directPayPaymentMethodDelete: DirectPayPaymentMethodDeleteResponse;
  directPayPaymentMethodSetDefault: DirectPayPaymentMethodSetDefaultResponse;
  directPayPaymentSubmit: DirectPayPaymentSubmitResponse;
  disconnectAccount: DisconnectAccountResponse;
  disconnectIntegrationAdapter: DisconnectIntegrationAdapterResponse;
  /** Edit buyer report schedule */
  editBuyerReportSchedule: EditBuyerReportScheduleResponse;
  /** Edit a new lead in a sales funnel. */
  editSalesFunnelLead: EditSalesFunnelLeadResponse;
  /** Creates a new SFTP user with the specified credentials and permissions. */
  erpSftpUserCreate: ErpSftpUserCreateResponse;
  /** Updates an existing SFTP user's credentials, permissions, or activation status. */
  erpSftpUserUpdate: ErpSftpUserUpdateResponse;
  /** Generate buyer report */
  generateBuyerReport: GenerateBuyerReportResponse;
  getClientDebuggableArtifactUploadUrl: GetClientDebuggableArtifactUploadUrlResponse;
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlResponse;
  /** @deprecated Does not work for LOX Suppliers. See notice for `importSupplierProductsV2` */
  importSupplierProducts: ImportSupplierProductsReport;
  /** @deprecated Does not work for LOX Suppliers. Use `catalogImportStart` instead */
  importSupplierProductsV2: ImportSupplierProductsReport;
  initInventoryDownload: InitInventoryDownloadResponse;
  initInventoryUpload: InitInventoryUploadResponse;
  initiateAccountLinking: InitiateAccountLinkingResponse;
  insertOrUpdateSupplierContact?: Maybe<InsertOrUpdateSupplierContactResponse>;
  instantPayCustomerInvitationSend: InstantPayCustomerInvitationSendResponse;
  instantPayCustomerOnboard: InstantPayCustomerOnboardResponse;
  instantPayVendorCreate: InstantPayVendorCreateResponse;
  integrationAdapterConnectionAuth: IntegrationAdapterConnectionAuthResponse;
  integrationAdapterConnectionConsent: IntegrationAdapterConnectionConsentResponse;
  integrationAdapterConnectionCreate: IntegrationAdapterConnectionCreateResponse;
  integrationAdapterConnectionUpdate: IntegrationAdapterConnectionUpdateResponse;
  integrationAdapterCreate: IntegrationAdapterCreateResponse;
  integrationAdapterUpdate: IntegrationAdapterUpdateResponse;
  integrationWebhookRetry: IntegrationWebhookRetryResponse;
  internalInviteUsers: InternalInviteUsersResponse;
  /** @deprecated use inviteUserToBuyer instead */
  inviteNonChocoUserToBuyer?: Maybe<InviteNonChocoUserToBuyerResponse>;
  inviteNonChocoUserToChat?: Maybe<Chat>;
  inviteUserToBuyer: InviteUserToBuyerResponse;
  invoiceCreate: InvoiceCreateResponse;
  legalEntityAddInstantPayCustomer: LegalEntityAddInstantPayCustomerResponse;
  markCustomerInsightsNotificationAsRead: MarkCustomerInsightsNotificationAsReadResponse;
  messageCreate: Message;
  multiLocationOrderGuidesV2ItemUnitsRemove: MultiLocationOrderGuidesV2ItemUnitsRemoveResponse;
  multiLocationOrderGuidesV2ItemUnitsUpdate: MultiLocationOrderGuidesV2ItemUnitsUpdateResponse;
  notificationCreate?: Maybe<Notification>;
  notificationPreferencesUpdate?: Maybe<NotificationPreferences>;
  /** autopilotSubscription related mutation */
  notifyAutopilotOrderCreated: AutopilotSubscriptionResponse;
  notifyBulkOrderRejected: OmnichannelOrderStatusSubscriptionResponse;
  notifyCustomerInsightsNotificationCreated: CustomerInsightsNotificationSubscriptionResponse;
  notifyOmnichannelOrderCreated: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderAccepted: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderConfirmed: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderRejected: OmnichannelOrderStatusSubscriptionResponse;
  notifyPurchaseOrderDeleted: PurchaseOrderSubscriptionResponse;
  notifyPurchaseOrderUpdated: PurchaseOrderSubscriptionResponse;
  notifyPurchasingTransmissionCreated: PurchaseOrderSubscriptionResponse;
  notifyPurchasingTransmissionProcessed: PurchaseOrderSubscriptionResponse;
  notifyTransmissionCreated: OmnichannelOrderStatusSubscriptionResponse;
  notifyTransmissionReceived: OmnichannelOrderStatusSubscriptionResponse;
  notifyTransmissionV2OrdersFullyProcessed: TransmissionV2SubscriptionResponse;
  notifyTransmissionV2Processed: TransmissionV2SubscriptionResponse;
  /** transmissionV2Subscription related mutations */
  notifyTransmissionV2Received: TransmissionV2SubscriptionResponse;
  orderConfirm?: Maybe<Message>;
  orderCreate: Order;
  orderCreateV2?: Maybe<OrderCreatedResponse>;
  orderEdit?: Maybe<OrderEditedResponse>;
  orderExportConfigCreate: OrderExportConfig;
  orderExportConfigDelete: Scalars['Boolean']['output'];
  orderExportConfigUpdate: OrderExportConfig;
  orderGuideCreated: OrderGuideCreatedResponse;
  orderGuideRequest: OrderGuideRequestResponse;
  orderGuideV2BatchUpdate: OrderGuideV2BatchUpdateResponse;
  orderGuideV2CategoriesUpdate: OrderGuideV2CategoriesUpdateResponse;
  orderGuideV2ItemUnitsAdd: OrderGuideV2ItemUnitsAddResponse;
  orderGuideV2ItemUnitsRemove: OrderGuideV2ItemUnitsRemoveResponse;
  orderGuideV2ItemUnitsUpdate: OrderGuideV2ItemUnitsUpdateResponse;
  paymentCustomerContactsUpdate: PaymentCustomerContactsUpdateResponse;
  paymentCustomerUpdateAllForLegalEntity: PaymentCustomerUpdateAllForLegalEntityResponse;
  paymentLegalEntityUpdate: PaymentLegalEntityUpdateResponse;
  paymentLinkGenerate: PaymentLinkGenerateResponse;
  paymentMethodRequest: PaymentMethodRequestResponse;
  paymentMethodRequestResend: PaymentMethodRequestResendResponse;
  /** Prepare to save the email editor state by generating an upload URL and S3 key. */
  prepareSaveEmailEditorState: PrepareSaveEmailEditorStateResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productBatchCreate: Scalars['String']['output'];
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productCreate: Product;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productDelete: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productSort: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productUpdate: Product;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  productUpdateCategory: UpdatedCategoryProduct;
  /**
   * Updates the externalId of a given Custom Product.
   * Can be called by: Choco Admin or Buyer user
   * Buyer user must be in the chat
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent. Avoid using in the, but won't get new features new code. Use `vendorItemUnitUpdate` instead
   */
  productUpdateExternalId: Product;
  referUser?: Maybe<ReferUserResponse>;
  refreshOrderDesk: OmnichannelOrdersSubcriptionResponse;
  rejectOrder: RejectOrderResponse;
  rejectOrdersById: RejectOrdersByIdResponse;
  /** Only admin can remove the blocked email and the return is a null */
  removeBlockedEmail?: Maybe<Scalars['Int']['output']>;
  /** Remove an email from the 'chat.additionalEmails' list across all chats */
  removeCCEmailFromChats: RemoveCcEmailFromChatsReport;
  removeEmailFromBuyerReportSchedule?: Maybe<RemoveEmailFromBuyerReportScheduleResponse>;
  removeLabelFromChats: Scalars['Boolean']['output'];
  removeOrderDeskEmail: OrderDeskRemovedEmailResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `multiLocationOrderGuidesV2ItemUnitsRemove` instead */
  removeProductsFromOrderGuides: RemoveProductsFromOrderGuidesResponse;
  removeSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  removeUserFromChats: Scalars['Boolean']['output'];
  /** Rename an existing state in the sales funnel */
  renameSalesFunnelState: RenameSalesFunnelStateResponse;
  requestToJoinBuyer: RequestToJoinBuyerResponse;
  retryOrderProcessing: RetryOrderProcessingResponse;
  /**
   * Add a phone number to Twilio's Safelist.
   * A phone number that is safe listed will be able to receive OTPs from Twilio
   *   even if its country is geo-blocked and will never be blocked by Twilio's FraudGuard.
   */
  safelistTwilioUser: SafelistTwilioUserResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` or `orderGuideV2ItemUnitsAdd` instead */
  selectProductForOrderGuide: SelectProductForOrderGuideResponse;
  selectProductsForOrderGuide: SelectProductsForOrderGuideResponse;
  /**
   * Send email marketing campaign to all contacts, to be deprecated when other channels are supported
   * @deprecated use sendMarketingCampaign instead
   */
  sendEmailMarketingCampaignToAll: MarketingCampaignUpdateResponse;
  /**
   * Send email marketing campaign to specific chats, to be deprecated when other channels are supported
   * @deprecated use sendMarketingCampaign instead
   */
  sendEmailMarketingCampaignToChats: MarketingCampaignUpdateResponse;
  /** Invite Transmission */
  sendInviteTransmission: SendInviteTransmissionResponse;
  /** Send marketing campaign to different channels */
  sendMarketingCampaign: MarketingCampaignUpdateResponse;
  /** Send marketing campaign to different channels */
  sendMarketingCampaignV2: MarketingCampaignUpdateResponse;
  sendSyntheticSmsMessage: SendSyntheticSmsMessageResponse;
  sendSyntheticWhatsAppMessage: SendSyntheticWhatsAppMessageResponse;
  /** Create or update marketing email sender configuration */
  setMarketingEmailSender: SetMarketingEmailSenderResponse;
  /**
   * Sets the isTest field of order to true. You cannot set the value back to false.
   * Is accessible only by admin
   */
  setOrderAsTest: SetOrderAsTestResponse;
  /**
   * Set or update order override permissions for a user in a specific supplier context.
   * This allows admins to configure which validation rules a user can bypass when reviewing orders.
   */
  setUserOrderOverridePermissions: SetUserOrderOverridePermissionsResponse;
  settlementReportCreate: SettlementReportCreateResponse;
  shortenUrl: Scalars['String']['output'];
  /** Starts a document scan */
  startDocumentScan: UpdateDocumentScanResponse;
  startExportPurchaseOrderJob: StartExportPurchaseOrderJobResponse;
  /** Starts a menu scan */
  startMenuScan: UpdateMenuScanResponse;
  submitBuyerStockCount: BuyerStockCountResponse;
  /** Submit the cart for checkout. This creates an order from the line items in the cart. */
  submitCart?: Maybe<CartSubmissionResponse>;
  submitOrderDeliveryCheck?: Maybe<OrderDeliveryCheckSubmissionResponse>;
  submitOrderedProductDeliveryCheck?: Maybe<OrderedProductDeliveryCheckSubmissionResponse>;
  submitStockCountSession: SubmitStockCountSessionResponse;
  /** @deprecated With the successful rollout of BAS + “Add sales rep” flow in place, it is time to deprecate the Add Supplier Form and replace it with a much simpler contact customer support UX. */
  supplierAddRequest: SupplierAddRequestResponse;
  supplierCreate: Supplier;
  /** Get in touch form for suppliers to request a callback from Ops for contracts. */
  supplierGetInTouchRequest?: Maybe<SupplierGetInTouchRequestResponse>;
  /** @deprecated use supplierInviteUsersV2 instead */
  supplierInviteUser: SupplierInviteUserResponse;
  /** @deprecated use supplierInviteUsersV2 instead */
  supplierInviteUsers: SupplierInviteUserResponse;
  supplierInviteUsersV2: SupplierInviteUserResponse;
  /** Allow SupplierAdmins to remove user (supplierAdmin/SalesReps) from team */
  supplierRemoveUser: User;
  /** smart order specific supplier settings */
  supplierSetting: SupplierSettingResponse;
  supplierUpdate: Supplier;
  /** API for vendor team management */
  supplierUserCreate?: Maybe<User>;
  supplierUserRemove: SupplierUserRemoveResponse;
  /**
   * Sync user data to Cognito. To be used when a user state on Cognito is not properly synced after an organic signup or admin creation.
   * Be careful when triggering this mutation, as it executes admin operations towards Cognito's API.
   *  When used to sync inactive users, Cognito will start treating them as active for a billing month, which will incur additional costs.
   */
  syncCognitoUser: SyncCognitoUserResponse;
  triggerProductMatching: TriggerProductMatchingResponse;
  unassignUserFromOrderToReview: UnassignUserFromOrderToReviewResponse;
  /** @deprecated Does not work for LOX Suppliers */
  undoMultiLocationOrderGuideTransaction: UndoMultiLocationOrderGuideTransactionResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2BatchUpdate` instead */
  updateBuyerInventoryProduct: UpdateBuyerInventoryProductResponse;
  updateBuyerStockInventoryProduct: UpdateBuyerStockInventoryProductResponse;
  updateBuyerUserChats: UpdateBuyerUserChatsResponse;
  /** update the cart items. */
  updateCart?: Maybe<CartUpdateResponse>;
  updateChatEnabled: Scalars['Boolean']['output'];
  updateChatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  /** Update supplier chat-level notification preferences */
  updateChatNotificationPreferencesV2?: Maybe<ChatNotificationPreferences>;
  updateChatOrderingSettings?: Maybe<ChatOrderingSettingsUpdateResponse>;
  /** Update a distributor note. */
  updateDistributorNote: UpdateDistributorNoteResponse;
  /** Update an existing distributor task */
  updateDistributorTask: UpdateDistributorTaskResponse;
  /** Update the status of an existing distributor task */
  updateDistributorTaskStatus: UpdateDistributorTaskStatusResponse;
  /** Update document scan attachments */
  updateDocumentScanAttachments: UpdateDocumentScanResponse;
  updateInventoryItem: UpdateInventoryItemResponse;
  /**
   * Update invoiced product
   * @deprecated No longer supported since Jun 2024
   */
  updateInvoicedProduct: UpdateInvoicedProductResponse;
  /** Update marketing campaign with attachments which are already uploaded in S3 */
  updateMarketingCampaignAttachments: MarketingCampaignUpdateResponse;
  /** Update chat message content for the marketing campaign */
  updateMarketingCampaignChatMessageContent: MarketingCampaignUpdateResponse;
  /** Update email content for the marketing campaign */
  updateMarketingCampaignEmailContent: MarketingCampaignUpdateResponse;
  /** Update the email HTML and template URI for the campaign, to be used for email compilation in backend */
  updateMarketingCampaignEmailTemplateUri: MarketingCampaignUpdateResponse;
  /** Update home promo content for the marketing campaign */
  updateMarketingCampaignHomePromoContent: MarketingCampaignUpdateResponse;
  /** Update marketing campaign title and channels */
  updateMarketingCampaignInfo: MarketingCampaignUpdateResponse;
  /** Update preferred products content for the marketing campaign */
  updateMarketingCampaignPreferredProductsContent: MarketingCampaignUpdateResponse;
  /** Update marketing campaign with vendor item units */
  updateMarketingCampaignVendorItemUnits: MarketingCampaignUpdateResponse;
  /** Update menu scan attachments */
  updateMenuScanAttachments: UpdateMenuScanResponse;
  /**
   * For internal use, to update a users
   * notificationPreferences ID when a users role is updated
   */
  updateNotificationUserId?: Maybe<NotificationPreferences>;
  updatePendingUser: UpdatePendingUserResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2ItemUnitsUpdate` or `orderGuideV2BatchUpdate` instead */
  updateProductVariantsInOrderGuide: UpdateProductVariantsInOrderGuideResponse;
  updatePurchaseOrder: UpdatePurchaseOrderResponse;
  updatePurchasingBusiness: UpdatePurchasingBusinessResponse;
  updateRequestToJoin: UpdateJoinRequestResponse;
  /** Update the archive status of a lead in a sales funnel. */
  updateSalesFunnelLeadArchiveStatus: UpdateSalesFunnelLeadArchiveStatusResponse;
  /** Updates the order of the states in the sales funnel. */
  updateSalesFunnelStateOrder: UpdateSalesFunnelStateOrderResponse;
  updateStorageItem: UpdateStorageItemResponse;
  /**
   * Updates the name of a given Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  updateSubCatalog?: Maybe<UpdateSubCatalogResponse>;
  /**
   * Changes the set of Chats assigned to a given Custom Catalog.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but will not get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  updateSubCatalogChats: UpdateSubCatalogChatsResponse;
  updateSupplierAccessPackage: SupplierUpdateAccessPackageResponse;
  updateSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  updateSupplierContact: UpdateSupplierContactResponse;
  /** Admin/Supplier Admin only */
  updateSupplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  /**
   * Changes a specific field of a given Supplier Product.
   * Assumes that the supplier is not in the UOM Exclusion List, allows multiple products to have the same externalId if they have different units.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  updateSupplierProduct: CreateUpdateSupplierProductResponse;
  /**
   * Partially updates a given Supplier Product.
   * Refer to the input type documentation for the specific field by field information.
   * Assumes that the supplier is not in the UOM Exclusion List, allows multiple products to have the same externalId if they have different units.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  updateSupplierProductV2: CreateUpdateSupplierProductResponse;
  updateSupplierUserChats: SupplierUserUpdateChatsResponse;
  updateSupplierUserRoles?: Maybe<User>;
  /**
   * This is an API for Choco admins to update the "progressStatus" of transmissions.
   *
   * When "processed"" is selected, it transitions to "progressStatus" to "processed",
   * When "failed" OR "partiallyFailed" is selected and no order already exist for the transmission, it transitions to "failed",
   * When "failed" OR "partiallyFailed" is selected and at least one order already exist for the transmission, it transitions to "partiallyFailed",
   * Else, a "Unsupported" warning is returned
   */
  updateTransmissionProgressStatus: ListProcessingTransmissionsResponse;
  /** @deprecated Does not work for LOX Suppliers. See notice for `uploadSubCatalogProductsV2` */
  uploadSubCatalogProducts: UploadSubCatalogProductsResponse;
  /** @deprecated Does not work for LOX Suppliers */
  uploadSubCatalogProductsV2: UploadSubCatalogProductsResponse;
  upsertStockCountSessionItems?: Maybe<UpsertStockCountSessionItemsResponse>;
  /** @deprecated use updateSupplierUserRoles instead */
  userAddRole?: Maybe<User>;
  /** Admin Only, confirm pending users on cognito */
  userConfirm: Scalars['Boolean']['output'];
  userCreate?: Maybe<User>;
  userLeadCreate?: Maybe<UserLead>;
  /** @deprecated use updateSupplierUserRoles instead */
  userRemoveRole?: Maybe<User>;
  userRequestToDelete: UserRequestToDeleteResponse;
  userUpdate?: Maybe<User>;
  vendorAccountCreate: VendorAccountCreateResponse;
  /**
   * Create new image identifiers and prepares the image upload links for given categories.
   * Each category can only have a single image.
   * Note that the image is category-specific and cannot be shared between categories.
   * The image upload process works like this:
   * 1. Use this mutation to request image ids and upload urls.
   * 2. Upload images to the provided urls (check the docs for `uploadUrl` response field for more info).
   * 3. Call `vendorItemCategoriesUpdate` to associate the uploaded images with the categories.
   * Unassigned images will be eventually deleted.
   * Can be called by: Choco Admins, users of the Supplier owning the categories.
   */
  vendorItemCategoriesImagesUpload: VendorItemCategoriesImagesUploadResponse;
  /**
   * Partially updates given catalog categories.
   * Can be called by: Choco Admins, users of the Supplier owning the categories.
   */
  vendorItemCategoriesUpdate: VendorItemCategoriesUpdateResponse;
  /**
   * Creates a new Custom Product with additional buyer properties.
   * Can be called by: Choco Admins, users of this Buyer.
   */
  vendorItemCustomCreate: VendorItemCustomCreateResponse;
  /**
   * Updates a Custom Product with its buyer properties.
   * Can be called by: Choco Admins, users of the Buyer that owns the custom product.
   */
  vendorItemCustomUpdate: VendorItemCustomUpdateResponse;
  /**
   * Update specific buyer properties of a vendor item unit.
   * Can be called by: Choco Admins, users of this Buyer
   */
  vendorItemUnitBuyerPropertiesUpdate: VendorItemUnitBuyerPropertiesUpdateResponse;
  /**
   * Partially updates given vendor item unit buyer properties in batch.
   * Can be called by: Choco Admins, users of Buyer to whom the properties belong.
   */
  vendorItemUnitBuyerPropertiesUpdateBatch: VendorItemUnitBuyerPropertiesUpdateBatchResponse;
  /**
   * Changes the customer-specific price of the vendor item unit for a given buyer.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item unit.
   */
  vendorItemUnitCustomerSpecificPriceUpdate: VendorItemUnitCustomerSpecificPriceUpdateResponse;
  /**
   * Partially updates a given vendor item unit.
   * Can be called by: Choco Admins, users of the Supplier owning the item unit.
   */
  vendorItemUnitUpdate: VendorItemUnitUpdateResponse;
  /**
   * Create new image identifiers and prepares the image upload links for given vendor item units.
   * Note that the image is unit-specific and cannot be shared between units.
   * The image upload process works like this:
   * 1. Use this mutation to request image ids and upload urls.
   * 2. Upload images to the provided urls (check the docs for `uploadUrl` response field for more info)
   * 3. Call `vendorItemUnitsUpdate` to associate the uploaded images with the vendor item units and specify the correct order.
   * Unassigned images will be eventually deleted.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item units.
   */
  vendorItemUnitsImagesUpload: VendorItemUnitsImagesUploadResponse;
  /**
   * Partially updates given vendor item units.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item units.
   */
  vendorItemUnitsUpdate: VendorItemUnitsUpdateResponse;
};


export type MutationAcceptOrderArgs = {
  acceptedOrder: AcceptOrderInput;
  id: Scalars['ID']['input'];
};


export type MutationAddBuyerStockInventoryProductArgs = {
  input: AddBuyerStockInventoryProductInput;
};


export type MutationAddCatalogProductsToProductListArgs = {
  catalogProductList: Array<ProductsCategoryInput>;
  chatId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddLabelToChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationAddMarketingProductsToCartArgs = {
  chatId: Scalars['ID']['input'];
  products: Array<AddMarketingProductsToCartInput>;
};


export type MutationAddProductsToOrderGuidesArgs = {
  input: AddProductsToOrderGuidesInput;
};


export type MutationAddSalesRepArgs = {
  input?: InputMaybe<AddSalesRepRequestToJoinInput>;
};


export type MutationAddSellerToPurchasingBusinessArgs = {
  input: AddSellerToPurchasingBusinessInput;
};


export type MutationAddSupplierRequestArgs = {
  input: BuyerAddSupplierInput;
};


export type MutationAddUserToChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdvanceSalesFunnelLeadArgs = {
  input: AdvanceSalesFunnelLeadInput;
};


export type MutationApproveOrderArgs = {
  approvedOrder: AcceptOrderInput;
  id: Scalars['ID']['input'];
};


export type MutationAssignOrderToUserForReviewArgs = {
  input: AssignOrderToUserForReviewInput;
};


export type MutationAssignSalesFunnelLeadArgs = {
  input: AssignSalesFunnelLeadInput;
};


export type MutationAutoPilotBugReportArgs = {
  input: AutoPilotBugReportInput;
};


export type MutationAutomaticOrderProcessingThresholdSettingArgs = {
  input: AutomaticOrderProcessingThresholdSettingInput;
};


export type MutationBatchOrderConfirmArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchUpdateOrderSupplierArgs = {
  input: BatchUpdateOrderSupplierInput;
};


export type MutationBillingDocumentExportCreateArgs = {
  input: BillingDocumentExportCreateInput;
};


export type MutationBroadcastCreateArgs = {
  broadcastInput: BroadcastInput;
};


export type MutationBroadcastUpdateArgs = {
  broadcastInput: BroadcastInput;
  id: Scalars['ID']['input'];
};


export type MutationBroadcastUpdatePurposeArgs = {
  id: Scalars['ID']['input'];
  purpose: BroadcastPurposeInput;
};


export type MutationBulkDeclineOrdersArgs = {
  input: BulkDeclineOrdersInput;
};


export type MutationBulkSendInviteTransmissionArgs = {
  input: BulkSendInviteTransmissionInput;
};


export type MutationBulkSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<BulkSubmitOrderedProductDeliveryCheckInput>;
};


export type MutationBuyerAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  input?: InputMaybe<BuyerUserInput>;
  userId: Scalars['ID']['input'];
};


export type MutationBuyerBulkAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  userRoles: Array<BuyerUserRoleInput>;
};


export type MutationBuyerCreateArgs = {
  buyer: BuyerCreateInput;
};


export type MutationBuyerDisableRolesArgs = {
  buyerId: Scalars['ID']['input'];
};


export type MutationBuyerRemoveUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationBuyerUpdateArgs = {
  buyer: BuyerUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationCancelCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CancelCartOptionsInput;
};


export type MutationCancelMarketingCampaignArgs = {
  input: CancelMarketingCampaignInput;
};


export type MutationCatalogAttributeUpdateArgs = {
  input: CatalogAttributeUpdateInput;
};


export type MutationCatalogExportStartArgs = {
  input: CatalogExportStartInput;
};


export type MutationCatalogImportStartArgs = {
  input: CatalogImportStartInput;
};


export type MutationCategoryCreateArgs = {
  category: CategoryInput;
  chatId: Scalars['ID']['input'];
};


export type MutationCategoryDeleteArgs = {
  categoryIds: Array<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
};


export type MutationCategoryProductSortArgs = {
  categorizedProductList: Array<ProductsCategoryInput>;
  chatId: Scalars['ID']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCategoryUpdateArgs = {
  category: CategoryInput;
  chatId: Scalars['ID']['input'];
};


export type MutationChatCreateArgs = {
  chat: ChatCreateInput;
};


export type MutationChatDisableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatInviteUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationChatLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatMainSupplierMigrateArgs = {
  chatId: Scalars['ID']['input'];
  supplierUserId: Scalars['ID']['input'];
};


export type MutationChatPricesVisibilityUpdateArgs = {
  input: ChatPricesVisibilityUpdateInput;
};


export type MutationChatRemoveUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationChatUpdateArgs = {
  chat: ChatUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationChatUpdateMainSupplierArgs = {
  chatId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationClaimOnboardingChecklistRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmAccountLinkingArgs = {
  input: ConfirmAccountLinkingInput;
};


export type MutationConfirmDeliveryCheckReconciliationRequestArgs = {
  deliveryCheckReconciliationRequestId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationConfirmSaveEmailEditorStateArgs = {
  input: ConfirmSaveEmailEditorStateInput;
};


export type MutationConnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationConnectIntegrationAdapterArgs = {
  input: ConnectIntegrationAdapterInput;
};


export type MutationContactsCreateArgs = {
  numbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCorrectOrderArgs = {
  input: OrderCorrectionInput;
};


export type MutationCreateBuyerReportScheduleArgs = {
  input: CreateBuyerReportScheduleInput;
};


export type MutationCreateDistributorNoteArgs = {
  input: CreateDistributorNoteInput;
};


export type MutationCreateDistributorTaskArgs = {
  input: CreateDistributorTaskInput;
};


export type MutationCreateDocumentScanArgs = {
  input: CreateDocumentScanInput;
};


export type MutationCreateMarketingCampaignArgs = {
  input: CreateMarketingCampaignInput;
};


export type MutationCreateMenuScanArgs = {
  input: CreateMenuScanInput;
};


export type MutationCreateOrderDeliveryCheckArgs = {
  input: CreateOrderDeliveryCheckInput;
};


export type MutationCreateOrderDeliveryCheckImageUploadUrlArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCreateOrderDeskEmailListArgs = {
  input: CreateOrderDeskEmailList;
};


export type MutationCreateOrderUploadArgs = {
  input: CreateOrderUploadInput;
};


export type MutationCreateProfileArgs = {
  user: CreateProfileInput;
};


export type MutationCreatePurchasingBusinessArgs = {
  input: PurchasingBusinessInput;
};


export type MutationCreatePurchasingTransmissionArgs = {
  input: PurchasingTransmissionInput;
};


export type MutationCreatePushEndpointArgs = {
  input?: InputMaybe<CreatePushEndpointInput>;
};


export type MutationCreatePushEndpointV2Args = {
  input?: InputMaybe<CreatePushEndpointInput>;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateSalesFunnelArgs = {
  input: CreateSalesFunnelInput;
};


export type MutationCreateSalesFunnelLeadArgs = {
  input: CreateSalesFunnelLeadInput;
};


export type MutationCreateSalesFunnelStateArgs = {
  input: CreateSalesFunnelStateInput;
};


export type MutationCreateStorageItemArgs = {
  input: CreateStorageItemInput;
};


export type MutationCreateSubCatalogArgs = {
  name: Scalars['String']['input'];
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSupplierContactArgs = {
  supplierContact: CreateSupplierContactInput;
};


export type MutationCreateSupplierProductArgs = {
  product: ProductInput;
};


export type MutationCreateSupplierProductV2Args = {
  product: SupplierProductInput;
};


export type MutationCreditNoteCreateArgs = {
  input: CreditNoteCreateInput;
};


export type MutationCustomCatalogFullImportStartArgs = {
  input: CustomCatalogFullStartInput;
};


export type MutationCustomCatalogsItemUnitsBatchUpdateArgs = {
  input: CustomCatalogsItemUnitsBatchUpdateInput;
};


export type MutationDeclineOrderArgs = {
  input: DeclineOrderInput;
};


export type MutationDeleteBuyerReportScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteBuyerStockInventoryProductsArgs = {
  input: DeleteBuyerStockInventoryProductsInput;
};


export type MutationDeleteChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteDistributorNoteArgs = {
  input: DeleteDistributorNoteInput;
};


export type MutationDeleteDistributorTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEntireSupplierProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInventoryItemsArgs = {
  input: DeleteInventoryItemsInput;
};


export type MutationDeleteParsedPurchaseOrdersArgs = {
  input: DeleteParsedPurchaseOrdersInput;
};


export type MutationDeleteProductImageArgs = {
  input: DeleteProductImageInput;
};


export type MutationDeleteProfileImageArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeletePurchaseOrdersArgs = {
  input: DeletePurchaseOrdersInput;
};


export type MutationDeletePurchasingBusinessArgs = {
  input: DeletePurchasingBusinessInput;
};


export type MutationDeleteSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierNegotiatedPricesArgs = {
  buyerId: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDeleteSupplierProductArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDirectPayCustomerOnboardArgs = {
  input: DirectPayCustomerOnboardInput;
};


export type MutationDirectPayCustomerStatusUpdateArgs = {
  input: DirectPayCustomerStatusUpdateInput;
};


export type MutationDirectPayPaymentMethodDeleteArgs = {
  input: DirectPayPaymentMethodDeleteInput;
};


export type MutationDirectPayPaymentMethodSetDefaultArgs = {
  input: DirectPayPaymentMethodSetDefaultInput;
};


export type MutationDirectPayPaymentSubmitArgs = {
  input: DirectPayPaymentSubmitInput;
};


export type MutationDisconnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationDisconnectIntegrationAdapterArgs = {
  input: DisconnectIntegrationAdapterInput;
};


export type MutationEditBuyerReportScheduleArgs = {
  input: EditBuyerReportScheduleInput;
};


export type MutationEditSalesFunnelLeadArgs = {
  input: EditSalesFunnelLeadInput;
};


export type MutationErpSftpUserCreateArgs = {
  input: ErpSftpUserCreateInput;
};


export type MutationErpSftpUserUpdateArgs = {
  input: ErpSftpUserUpdateInput;
};


export type MutationGenerateBuyerReportArgs = {
  input: GenerateBuyerReportInput;
};


export type MutationGetClientDebuggableArtifactUploadUrlArgs = {
  getClientDebuggableArtifactUploadUrl: GetClientDebuggableArtifactUploadUrlInput;
};


export type MutationGetOrderGuideUploadUrlArgs = {
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlInput;
};


export type MutationImportSupplierProductsArgs = {
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
  products?: InputMaybe<Array<AdminProductInput>>;
  supplierId: Scalars['ID']['input'];
};


export type MutationImportSupplierProductsV2Args = {
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationInitInventoryDownloadArgs = {
  input: InitInventoryDownloadInput;
};


export type MutationInitInventoryUploadArgs = {
  input: InitInventoryUploadInput;
};


export type MutationInitiateAccountLinkingArgs = {
  input: InitiateAccountLinkingInput;
};


export type MutationInsertOrUpdateSupplierContactArgs = {
  input: InsertOrUpdateSupplierContactInput;
};


export type MutationInstantPayCustomerInvitationSendArgs = {
  input: InstantPayCustomerInvitationSendInput;
};


export type MutationInstantPayCustomerOnboardArgs = {
  input: InstantPayCustomerOnboardInput;
};


export type MutationInstantPayVendorCreateArgs = {
  input: InstantPayVendorCreateInput;
};


export type MutationIntegrationAdapterConnectionAuthArgs = {
  input: IntegrationAdapterConnectionAuthInput;
};


export type MutationIntegrationAdapterConnectionConsentArgs = {
  input: IntegrationAdapterConnectionConsentInput;
};


export type MutationIntegrationAdapterConnectionCreateArgs = {
  input: IntegrationAdapterConnectionCreateInput;
};


export type MutationIntegrationAdapterConnectionUpdateArgs = {
  input: IntegrationAdapterConnectionUpdateInput;
};


export type MutationIntegrationAdapterCreateArgs = {
  input: IntegrationAdapterCreateInput;
};


export type MutationIntegrationAdapterUpdateArgs = {
  input: IntegrationAdapterUpdateInput;
};


export type MutationIntegrationWebhookRetryArgs = {
  input: IntegrationWebhookRetryInput;
};


export type MutationInternalInviteUsersArgs = {
  botUserId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  invitorUserId: Scalars['ID']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationInviteNonChocoUserToBuyerArgs = {
  buyerId: Scalars['ID']['input'];
  input?: InputMaybe<InviteUserToBuyerInput>;
  phone: Scalars['String']['input'];
};


export type MutationInviteNonChocoUserToChatArgs = {
  chatId: Scalars['ID']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationInviteUserToBuyerArgs = {
  buyerId: Scalars['ID']['input'];
  input: InviteUserToBuyerInputV2;
};


export type MutationInvoiceCreateArgs = {
  input: InvoiceCreateInput;
};


export type MutationLegalEntityAddInstantPayCustomerArgs = {
  input: LegalEntityAddInstantPayCustomerInput;
};


export type MutationMarkCustomerInsightsNotificationAsReadArgs = {
  input: MarkCustomerInsightsNotificationAsReadInput;
};


export type MutationMessageCreateArgs = {
  chatId: Scalars['ID']['input'];
  message: MessageInput;
  order?: InputMaybe<OrderInput>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMultiLocationOrderGuidesV2ItemUnitsRemoveArgs = {
  input: MultiLocationOrderGuidesV2ItemUnitsRemoveInput;
};


export type MutationMultiLocationOrderGuidesV2ItemUnitsUpdateArgs = {
  input: MultiLocationOrderGuidesV2ItemUnitsUpdateInput;
};


export type MutationNotificationCreateArgs = {
  messageId: Scalars['ID']['input'];
  notificationDirectives?: InputMaybe<NotificationDirectivesInput>;
  userId: Scalars['ID']['input'];
};


export type MutationNotificationPreferencesUpdateArgs = {
  input?: InputMaybe<NotificationPreferencesInput>;
};


export type MutationNotifyAutopilotOrderCreatedArgs = {
  orderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationNotifyBulkOrderRejectedArgs = {
  omnichannelOrderIds: Array<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyCustomerInsightsNotificationCreatedArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};


export type MutationNotifyOmnichannelOrderCreatedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
};


export type MutationNotifyOrderAcceptedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyOrderConfirmedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyOrderRejectedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyPurchaseOrderDeletedArgs = {
  buyerId: Scalars['ID']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationNotifyPurchaseOrderUpdatedArgs = {
  buyerId: Scalars['ID']['input'];
  purchaseOrderId: Scalars['ID']['input'];
};


export type MutationNotifyPurchasingTransmissionCreatedArgs = {
  buyerId: Scalars['ID']['input'];
  purchasingTransmissionId: Scalars['ID']['input'];
};


export type MutationNotifyPurchasingTransmissionProcessedArgs = {
  buyerId: Scalars['ID']['input'];
  purchasingTransmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionCreatedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionReceivedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionV2OrdersFullyProcessedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionIds: Array<Scalars['ID']['input']>;
};


export type MutationNotifyTransmissionV2ProcessedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionV2ReceivedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderCreateArgs = {
  chatId: Scalars['ID']['input'];
  order: OrderInput;
};


export type MutationOrderCreateV2Args = {
  chatId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  order: OrderCreateV2Input;
};


export type MutationOrderEditArgs = {
  editedOrderInput: OrderEditInput;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderExportConfigCreateArgs = {
  orderConfig: OrderExportConfigCreateInput;
  supplierId: Scalars['ID']['input'];
};


export type MutationOrderExportConfigDeleteArgs = {
  supplierId: Scalars['ID']['input'];
};


export type MutationOrderExportConfigUpdateArgs = {
  orderConfig: OrderExportConfigUpdateInput;
  supplierId: Scalars['ID']['input'];
};


export type MutationOrderGuideCreatedArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationOrderGuideRequestArgs = {
  orderGuideRequest: OrderGuideRequestInput;
};


export type MutationOrderGuideV2BatchUpdateArgs = {
  input: OrderGuideV2BatchUpdateInput;
};


export type MutationOrderGuideV2CategoriesUpdateArgs = {
  input: OrderGuideV2CategoryUpdateInput;
};


export type MutationOrderGuideV2ItemUnitsAddArgs = {
  input: OrderGuideV2ItemUnitsAddInput;
};


export type MutationOrderGuideV2ItemUnitsRemoveArgs = {
  input: OrderGuideV2ItemUnitsRemoveInput;
};


export type MutationOrderGuideV2ItemUnitsUpdateArgs = {
  input: OrderGuideV2ItemUnitsUpdateInput;
};


export type MutationPaymentCustomerContactsUpdateArgs = {
  input: PaymentCustomerContactsUpdateInput;
};


export type MutationPaymentCustomerUpdateAllForLegalEntityArgs = {
  input: PaymentCustomerUpdateAllForLegalEntityInput;
};


export type MutationPaymentLegalEntityUpdateArgs = {
  input: PaymentLegalEntityUpdateInput;
};


export type MutationPaymentLinkGenerateArgs = {
  input: PaymentLinkGenerateInput;
};


export type MutationPaymentMethodRequestArgs = {
  input: PaymentMethodRequestInput;
};


export type MutationPaymentMethodRequestResendArgs = {
  input: PaymentMethodRequestResendInput;
};


export type MutationPrepareSaveEmailEditorStateArgs = {
  input: PrepareSaveEmailEditorStateInput;
};


export type MutationProductBatchCreateArgs = {
  chatId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enableCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
};


export type MutationProductCreateArgs = {
  chatId: Scalars['ID']['input'];
  product: ProductInput;
};


export type MutationProductDeleteArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductSortArgs = {
  chatId: Scalars['ID']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductUpdateArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationProductUpdateCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationProductUpdateExternalIdArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationReferUserArgs = {
  input: ReferUserInput;
};


export type MutationRefreshOrderDeskArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationRejectOrderArgs = {
  input: RejectOrderInput;
};


export type MutationRejectOrdersByIdArgs = {
  input: RejectOrdersByIdInput;
};


export type MutationRemoveBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRemoveCcEmailFromChatsArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type MutationRemoveEmailFromBuyerReportScheduleArgs = {
  emailToRemove: Scalars['AWSEmail']['input'];
  scheduleId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveLabelFromChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationRemoveOrderDeskEmailArgs = {
  input: RemoveOrderDeskEmail;
};


export type MutationRemoveProductsFromOrderGuidesArgs = {
  input: RemoveProductsFromOrderGuidesInput;
};


export type MutationRemoveSupplierBuyerMovArgs = {
  input: Array<RemoveSupplierBuyerMovInput>;
};


export type MutationRemoveUserFromChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationRenameSalesFunnelStateArgs = {
  input: RenameSalesFunnelStateInput;
};


export type MutationRequestToJoinBuyerArgs = {
  buyerId: Scalars['String']['input'];
};


export type MutationRetryOrderProcessingArgs = {
  forceSingleOrder?: InputMaybe<Scalars['Boolean']['input']>;
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  shouldPreserveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  transmissionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSafelistTwilioUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSelectProductForOrderGuideArgs = {
  input: SelectProductForOrderGuideInput;
};


export type MutationSelectProductsForOrderGuideArgs = {
  input: SelectProductsForOrderGuideInput;
};


export type MutationSendEmailMarketingCampaignToAllArgs = {
  input: SendEmailCampaignToAllInput;
};


export type MutationSendEmailMarketingCampaignToChatsArgs = {
  input: SendEmailCampaignToChatsInput;
};


export type MutationSendInviteTransmissionArgs = {
  input: SendInviteTransmissionRequest;
};


export type MutationSendMarketingCampaignArgs = {
  input: SendMarketingCampaignInput;
};


export type MutationSendMarketingCampaignV2Args = {
  input: SendMarketingCampaignInputV2;
};


export type MutationSendSyntheticSmsMessageArgs = {
  input: SendSyntheticSmsMessageInput;
};


export type MutationSendSyntheticWhatsAppMessageArgs = {
  input: SendSyntheticWhatsAppMessageInput;
};


export type MutationSetMarketingEmailSenderArgs = {
  input: SetMarketingEmailSenderInput;
};


export type MutationSetOrderAsTestArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationSetUserOrderOverridePermissionsArgs = {
  input: SetUserOrderOverridePermissionsInput;
};


export type MutationSettlementReportCreateArgs = {
  input: SettlementReportCreateInput;
};


export type MutationShortenUrlArgs = {
  longUrl: Scalars['String']['input'];
};


export type MutationStartDocumentScanArgs = {
  input: StartDocumentScanInput;
};


export type MutationStartExportPurchaseOrderJobArgs = {
  input: StartExportPurchaseOrderJobInput;
};


export type MutationStartMenuScanArgs = {
  input: StartMenuScanInput;
};


export type MutationSubmitBuyerStockCountArgs = {
  input: SubmitBuyerStockCountInput;
};


export type MutationSubmitCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CartSubmissionOptions;
};


export type MutationSubmitOrderDeliveryCheckArgs = {
  input: SubmitOrderDeliveryCheckInput;
};


export type MutationSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<SubmitOrderedProductDeliveryCheckInput>;
};


export type MutationSubmitStockCountSessionArgs = {
  input: SubmitStockCountSessionInput;
};


export type MutationSupplierAddRequestArgs = {
  supplierAddRequest: SupplierAddRequestInput;
};


export type MutationSupplierCreateArgs = {
  supplier: SupplierCreateInput;
};


export type MutationSupplierGetInTouchRequestArgs = {
  input: SupplierGetInTouchRequestInput;
};


export type MutationSupplierInviteUserArgs = {
  chat: ChatInviteInput;
  invitee: ChatInviteRecipient;
};


export type MutationSupplierInviteUsersArgs = {
  chat: ChatInviteInput;
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationSupplierInviteUsersV2Args = {
  chat: ChatInviteInput;
  invitees: Array<ChatInviteRecipientV2>;
};


export type MutationSupplierRemoveUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSupplierSettingArgs = {
  input: SupplierSettingInput;
};


export type MutationSupplierUpdateArgs = {
  supplier: SupplierUpdateInput;
};


export type MutationSupplierUserCreateArgs = {
  input: SupplierUserCreateInput;
};


export type MutationSupplierUserRemoveArgs = {
  input: SupplierUserRemoveInput;
};


export type MutationSyncCognitoUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerProductMatchingArgs = {
  input: TriggerProductMatchingInput;
};


export type MutationUnassignUserFromOrderToReviewArgs = {
  input: UnassignUserFromOrderToReviewInput;
};


export type MutationUndoMultiLocationOrderGuideTransactionArgs = {
  input: UndoMultiLocationOrderGuideTransactionInput;
};


export type MutationUpdateBuyerInventoryProductArgs = {
  input: UpdateBuyerInventoryProductInput;
};


export type MutationUpdateBuyerStockInventoryProductArgs = {
  input: UpdateBuyerStockInventoryProductInput;
};


export type MutationUpdateBuyerUserChatsArgs = {
  input: UpdateBuyerUserChatsInput;
};


export type MutationUpdateCartArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  lineItems: Array<CartLineItemUpdateInput>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateChatEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateChatNotificationPreferencesArgs = {
  input?: InputMaybe<ChatNotificationInput>;
};


export type MutationUpdateChatNotificationPreferencesV2Args = {
  input?: InputMaybe<ChatNotificationInput>;
};


export type MutationUpdateChatOrderingSettingsArgs = {
  input: ChatOrderingSettingsInput;
};


export type MutationUpdateDistributorNoteArgs = {
  input: UpdateDistributorNoteInput;
};


export type MutationUpdateDistributorTaskArgs = {
  input: UpdateDistributorTaskInput;
};


export type MutationUpdateDistributorTaskStatusArgs = {
  input: UpdateDistributorTaskStatusInput;
};


export type MutationUpdateDocumentScanAttachmentsArgs = {
  input: UpdateDocumentScanAttachmentsInput;
};


export type MutationUpdateInventoryItemArgs = {
  input: UpdateInventoryItemInput;
};


export type MutationUpdateInvoicedProductArgs = {
  input: Array<InputMaybe<InvoicedProductInput>>;
};


export type MutationUpdateMarketingCampaignAttachmentsArgs = {
  input: UpdateCampaignAttachmentInput;
};


export type MutationUpdateMarketingCampaignChatMessageContentArgs = {
  input: UpdateMarketingCampaignChatMessageContentInput;
};


export type MutationUpdateMarketingCampaignEmailContentArgs = {
  input: UpdateEmailContentInput;
};


export type MutationUpdateMarketingCampaignEmailTemplateUriArgs = {
  input: UpdateEmailTemplateUriInput;
};


export type MutationUpdateMarketingCampaignHomePromoContentArgs = {
  input: UpdateMarketingCampaignHomePromoContentInput;
};


export type MutationUpdateMarketingCampaignInfoArgs = {
  input: UpdateMarketingCampaignInfoInput;
};


export type MutationUpdateMarketingCampaignPreferredProductsContentArgs = {
  input: UpdateMarketingCampaignPreferredProductsContentInput;
};


export type MutationUpdateMarketingCampaignVendorItemUnitsArgs = {
  input: UpdateVendorItemUnitsInput;
};


export type MutationUpdateMenuScanAttachmentsArgs = {
  input: UpdateMenuScanAttachmentsInput;
};


export type MutationUpdateNotificationUserIdArgs = {
  newUserId: Scalars['ID']['input'];
  oldUserId: Scalars['ID']['input'];
};


export type MutationUpdatePendingUserArgs = {
  input: UpdatePendingUserInput;
};


export type MutationUpdateProductVariantsInOrderGuideArgs = {
  input: UpdateProductVariantsInOrderGuideInput;
};


export type MutationUpdatePurchaseOrderArgs = {
  input: UpdatePurchaseOrderInput;
};


export type MutationUpdatePurchasingBusinessArgs = {
  input: UpdatePurchasingBusinessInput;
};


export type MutationUpdateRequestToJoinArgs = {
  input: UpdateJoinRequestInput;
};


export type MutationUpdateSalesFunnelLeadArchiveStatusArgs = {
  input: UpdateSalesFunnelLeadArchiveStatusInput;
};


export type MutationUpdateSalesFunnelStateOrderArgs = {
  input: UpdateSalesFunnelStateOrderInput;
};


export type MutationUpdateStorageItemArgs = {
  input: UpdateStorageItemInput;
};


export type MutationUpdateSubCatalogArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSubCatalogChatsArgs = {
  create: Array<SubCatalogChatInput>;
  remove: Array<SubCatalogChatInput>;
};


export type MutationUpdateSupplierAccessPackageArgs = {
  suppliers: Array<SupplierUpdateAccessPackageInput>;
};


export type MutationUpdateSupplierBuyerMovArgs = {
  input: Array<UpdateSupplierBuyerMovInput>;
};


export type MutationUpdateSupplierContactArgs = {
  input: UpdateSupplierContactInput;
};


export type MutationUpdateSupplierDeliverySettingArgs = {
  input: SupplierDeliverySettingInput;
};


export type MutationUpdateSupplierProductArgs = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateSupplierProductV2Args = {
  product: UpdateSupplierProductV2Input;
};


export type MutationUpdateSupplierUserChatsArgs = {
  input: SupplierUserUpdateChatsInput;
};


export type MutationUpdateSupplierUserRolesArgs = {
  input?: InputMaybe<UpdateSupplierUserRolesInput>;
};


export type MutationUpdateTransmissionProgressStatusArgs = {
  input: UpdateTransmissionProgressStatusInput;
};


export type MutationUploadSubCatalogProductsArgs = {
  csv: Scalars['String']['input'];
  subCatalogId: Scalars['ID']['input'];
};


export type MutationUploadSubCatalogProductsV2Args = {
  csv: Scalars['String']['input'];
  subCatalogId: Scalars['ID']['input'];
};


export type MutationUpsertStockCountSessionItemsArgs = {
  input: UpsertStockCountSessionItemsInput;
};


export type MutationUserAddRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUserConfirmArgs = {
  newUserPool: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
};


export type MutationUserCreateArgs = {
  user: UserCreateInput;
};


export type MutationUserLeadCreateArgs = {
  userLead: UserLeadInput;
};


export type MutationUserRemoveRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUserRequestToDeleteArgs = {
  input: UserRequestToDeleteInput;
};


export type MutationUserUpdateArgs = {
  user: UserUpdateInput;
};


export type MutationVendorAccountCreateArgs = {
  input: VendorAccountCreateInput;
};


export type MutationVendorItemCategoriesImagesUploadArgs = {
  input: VendorItemCategoriesImagesUploadInput;
};


export type MutationVendorItemCategoriesUpdateArgs = {
  input: VendorItemCategoriesUpdateInput;
};


export type MutationVendorItemCustomCreateArgs = {
  input: VendorItemCustomCreateInput;
};


export type MutationVendorItemCustomUpdateArgs = {
  input: VendorItemCustomUpdateInput;
};


export type MutationVendorItemUnitBuyerPropertiesUpdateArgs = {
  input: VendorItemUnitBuyerPropertiesUpdateInput;
};


export type MutationVendorItemUnitBuyerPropertiesUpdateBatchArgs = {
  input: Array<VendorItemUnitBuyerPropertiesUpdateInput>;
};


export type MutationVendorItemUnitCustomerSpecificPriceUpdateArgs = {
  input: VendorItemUnitCustomerSpecificPriceUpdateInput;
};


export type MutationVendorItemUnitUpdateArgs = {
  input: VendorItemUnitUpdateInput;
};


export type MutationVendorItemUnitsImagesUploadArgs = {
  input: VendorItemUnitsImagesUploadInput;
};


export type MutationVendorItemUnitsUpdateArgs = {
  input: VendorItemUnitsUpdateInput;
};

export type NegativeAmountError = AppsyncError & AppsyncResponse & {
  __typename?: 'NegativeAmountError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type NoCutoffSetting = {
  __typename?: 'NoCutoffSetting';
  type: NoCutoffType;
};

export type NoCutoffType =
  | 'noCutoff'
  | '%future added value';

export type NoDeliveryException = {
  __typename?: 'NoDeliveryException';
  date: Scalars['AWSDate']['output'];
  type: NoDeliveryExceptionType;
};

export type NoDeliveryExceptionType =
  | 'noDeliveryException'
  | '%future added value';

export type NoMinimumOrderableAmountProduct = {
  __typename?: 'NoMinimumOrderableAmountProduct';
  /** The product id */
  id: Scalars['String']['output'];
  /** The unit minimumFractionalAmount for this product */
  minimumOrderableAmount: Scalars['Float']['output'];
};

export type NoOrderChange = {
  __typename?: 'NoOrderChange';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type NoUnconnectedBuyers = AppsyncError & AppsyncResponse & {
  __typename?: 'NoUnconnectedBuyers';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'NotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type Notification = Node & {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  message: Message;
  /** NOTE: Resolved via response mapping template on notificationCreate!!! */
  notificationDirectives?: Maybe<NotificationDirectives>;
  userId: Scalars['ID']['output'];
};

/**
 * NOTE: All fields must match between this type and NotificationDirectivesInput.
 * NOTE: This property is resolved on notificationCreate via VTL template. The
 * response mapping template simply copies the entire value from
 * arguments.notificationDirectives on the input to the output.
 * Additional context on how the Notification should be processed by the frontend.
 */
export type NotificationDirectives = {
  __typename?: 'NotificationDirectives';
  /**
   * The frontend should not update message inbox count in response to receiving
   * this notification.
   */
  suppressInboxCountUpdate?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * NOTE: All fields must match between this type and NotificationDirectives.
 * Additional context on how the Notification should be processed by the frontend.
 */
export type NotificationDirectivesInput = {
  /**
   * The frontend should not update message inbox count in response to receiving
   * this notification.
   */
  suppressInboxCountUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  message?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPreferencesInput = {
  message: Scalars['Boolean']['input'];
  order: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/**
 * This input type can be used for create, update, or delete a MoneyV2 object
 * If NullableMoneyV2Input sent as `null`/`undefined`, it won't be touched/updated
 * If NullableMoneyV2Input sent as `{ value: null | undefined }`, it will be deleted
 * If NullableMoneyV2Input sent as `{ value : MoneyV2Input }`, it will be updated
 */
export type NullableMoneyV2Input = {
  value?: InputMaybe<MoneyV2Input>;
};

/**
 * If NullableMoneyV2InputOptional sent as null/undefined, it won't be touched/updated
 * If NullableMoneyV2InputOptional sent as { value: null/undefined }, it will be deleted
 * If NullableMoneyV2InputOptional sent as {value : MoneyV2InputOptional }, it will be updated
 */
export type NullableMoneyV2InputOptional = {
  value?: InputMaybe<MoneyV2InputOptional>;
};

export type OcoRerankedProducts = {
  __typename?: 'OCORerankedProducts';
  rankedProductsByLineItem?: Maybe<Array<RerankedLineItemProducts>>;
};

export type OmnichannelOrder = Node & {
  __typename?: 'OmnichannelOrder';
  acceptedBy?: Maybe<User>;
  acceptedContext?: Maybe<OrderAcceptedByContext>;
  acceptedProducts?: Maybe<Array<AcceptedProduct>>;
  attachmentRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  attachments?: Maybe<Array<OmnichannelOrderAttachment>>;
  autoPilotBugReport?: Maybe<AutoPilotBugReportResponse>;
  /** @deprecated Use autoPilotBugReport */
  bugReport?: Maybe<BugReport>;
  chat?: Maybe<Chat>;
  /** OrderCorrection resolved through K8s service */
  correction?: Maybe<OrderCorrection>;
  createdAt: Scalars['AWSTimestamp']['output'];
  forwardedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPerfectOrder?: Maybe<Scalars['Boolean']['output']>;
  lastReprocessedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  matchingConfidence?: Maybe<MatchingConfidence>;
  order?: Maybe<Order>;
  orderChannel?: Maybe<SupplierOrderChannel>;
  orderDeskReviewer?: Maybe<OrderDeskReviewer>;
  orderExtractionConfidenceScore?: Maybe<Scalars['Float']['output']>;
  originalOrderMediaLink: Scalars['String']['output'];
  parsedOrder: ParsedOrder;
  retryCount?: Maybe<Scalars['Int']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  status: OmnichannelOrderStatus;
  supplier: Supplier;
  transmissionId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OmnichannelOrderAttachment = Node & {
  __typename?: 'OmnichannelOrderAttachment';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  transcript?: Maybe<AudioTranscript>;
  url: Scalars['String']['output'];
};

export type OmnichannelOrderCreatedNotification = {
  __typename?: 'OmnichannelOrderCreatedNotification';
  order: OmnichannelOrder;
};

export type OmnichannelOrderDetail = {
  __typename?: 'OmnichannelOrderDetail';
  /**
   * Reference to the related chat (customer), if one was extracted for this order.
   * This can be different for different orders in the same transmission.
   */
  chat?: Maybe<ChatRef>;
  /**
   * Id of the order.
   * This is different from Choco orderId.
   */
  id: Scalars['ID']['output'];
  /** The requested delivery date for this the orders, in ISO 8601 format. */
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  /**
   * Reference to the order desk user that is currently reviewing the order.
   * This can be different for different orders in the same transmission.
   */
  reviewer?: Maybe<UserRef>;
  /** The status of the order */
  status: OmnichannelOrderStatus;
};

export type OmnichannelOrderProduct = {
  __typename?: 'OmnichannelOrderProduct';
  amount: Scalars['Float']['output'];
  extractedAmount?: Maybe<Scalars['Float']['output']>;
  product: OmnichannelProduct;
};

export type OmnichannelOrderStatus =
  | 'accepted'
  | 'archived'
  | 'blocked'
  | 'declined'
  | 'retrying'
  | 'toReview'
  | 'underReview'
  | '%future added value';

export type OmnichannelOrdersSubcriptionResponse = AuthorizationFailure | OrderDeskNotification;

export type OmnichannelProduct = {
  __typename?: 'OmnichannelProduct';
  additionalAttributes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use amount in OmnichannelOrderProduct */
  amount: Scalars['Float']['output'];
  /** @deprecated Does not work for LOX Suppliers. Use `OmnichannelProduct.vendorItemUnit` instead */
  catalogProduct?: Maybe<Product>;
  /** @deprecated Does not work for LOX Suppliers. Use `OmnichannelProduct.vendorItemUnit` instead */
  chatProduct?: Maybe<Product>;
  comment?: Maybe<Scalars['String']['output']>;
  /** original untranslated name extracted from the order */
  extractedName?: Maybe<Scalars['String']['output']>;
  extractedPrice?: Maybe<MoneyV2>;
  id?: Maybe<Scalars['ID']['output']>;
  isProductAmountCorrect?: Maybe<Scalars['Boolean']['output']>;
  isProductCorrect?: Maybe<Scalars['Boolean']['output']>;
  lineItemId: Scalars['ID']['output'];
  matchedBy?: Maybe<ProductMatchedBy>;
  /** translated version of extracted name */
  name: Scalars['String']['output'];
  packSize?: Maybe<Scalars['String']['output']>;
  parsedProductId: Scalars['ID']['output'];
  replacedProduct?: Maybe<ReplacedProduct>;
  supplierProductId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type OnboardingChecklist = {
  __typename?: 'OnboardingChecklist';
  buyerId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  items: Array<OnboardingChecklistItem>;
  rewardClaimedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  version: Scalars['String']['output'];
};

export type OnboardingChecklistBooleanValue = {
  __typename?: 'OnboardingChecklistBooleanValue';
  booleanCurrent: Scalars['Boolean']['output'];
};

export type OnboardingChecklistItem = {
  __typename?: 'OnboardingChecklistItem';
  articleId: Scalars['String']['output'];
  fallbackTranslation: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: OnboardingChecklistItemValue;
};

export type OnboardingChecklistItemValue = OnboardingChecklistBooleanValue | OnboardingChecklistNumericValue;

export type OnboardingChecklistNumericValue = {
  __typename?: 'OnboardingChecklistNumericValue';
  numericCurrent: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
};

export type OneTimeBroadcastSchedule = {
  __typename?: 'OneTimeBroadcastSchedule';
  broadcastScheduleType: BroadcastScheduleType;
  nextScheduledTimestamp: Scalars['AWSTimestamp']['output'];
  timezone: Scalars['String']['output'];
};

export type OneTimeBroadcastScheduleInput = {
  nextScheduledTimestamp: Scalars['AWSTimestamp']['input'];
};

/** Represents the opening hours of an prospect. */
export type OpeningHours = {
  __typename?: 'OpeningHours';
  daysOfWeekDescriptions: Array<Scalars['String']['output']>;
};

export type Order = Node & {
  __typename?: 'Order';
  acceptedByContext?: Maybe<OrderAcceptedByContext>;
  autoPilotBugReport?: Maybe<AutoPilotBugReportResponse>;
  body?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Buyer>;
  chat?: Maybe<Chat>;
  chatId?: Maybe<Scalars['String']['output']>;
  confirmationSource?: Maybe<ConfirmationSource>;
  confirmationTime?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** OrderCorrection resolved through K8s service */
  correction?: Maybe<OrderCorrection>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdContext?: Maybe<OrderCreatedContext>;
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  estimatedOrderTotal?: Maybe<Money>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported since Jun 2024 */
  invoice: OrderInvoice;
  /** @deprecated No longer supported since Jun 2024 */
  invoicedProducts?: Maybe<Array<Maybe<InvoicedProduct>>>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  omnichannelOrder?: Maybe<OmnichannelOrder>;
  /** omnichannel order resolved through K8s service */
  omnichannelOrderV2?: Maybe<OmnichannelOrder>;
  orderChanges?: Maybe<OrderChangeResponse>;
  orderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  orderProducts?: Maybe<Array<Maybe<OrderProduct>>>;
  /** @deprecated use status instead */
  orderSupplierStatus?: Maybe<Scalars['String']['output']>;
  orderedProducts?: Maybe<Array<Maybe<OrderedProduct>>>;
  /**
   * AWS S3 signed-url associated with the pdf for the order.
   * If a PDF already exists, it will be used; otherwise, a new one will be created.
   */
  pdf?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<OrderRestaurant>;
  status?: Maybe<OrderStatus>;
  supplier?: Maybe<User>;
  supplierRefId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  /**
   * Validation failures that were overridden during order creation.
   * Despite these failures, the order was approved with explicit override.
   *
   * Note: The type is OrderValidationFailure, but these are RESOLVED failures
   * (not blocking) because they were explicitly overridden by the user.
   */
  validationOverrides?: Maybe<Array<OrderValidationFailure>>;
};


export type OrderPdfArgs = {
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAcceptedByContext =
  | 'autoPilot'
  | 'orderReviewer'
  | '%future added value';

export type OrderAcceptedNotification = {
  __typename?: 'OrderAcceptedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderAlreadyAccepted = {
  __typename?: 'OrderAlreadyAccepted';
  acceptedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderChange = Node & {
  __typename?: 'OrderChange';
  changeData?: Maybe<OrderChangeData>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  editVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderChangeData = {
  __typename?: 'OrderChangeData';
  addedProducts?: Maybe<Array<OrderProduct>>;
  orderProducts?: Maybe<Array<OrderProduct>>;
  originalProductCount?: Maybe<Scalars['Int']['output']>;
  removedProducts?: Maybe<Array<OrderProduct>>;
};

export type OrderChangeError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderChangeError';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type OrderChangeResponse = NoOrderChange | OrderChange | OrderChangeError | OrderChangeReverted;

export type OrderChangeReverted = {
  __typename?: 'OrderChangeReverted';
  responseType: ResponseType;
};

export type OrderChannelContactInfos = {
  __typename?: 'OrderChannelContactInfos';
  orderChannelContactInfos: Array<Scalars['String']['output']>;
};

export type OrderConfirmedNotification = {
  __typename?: 'OrderConfirmedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderCorrection = {
  __typename?: 'OrderCorrection';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customer?: Maybe<ChatRef>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invalidOrder?: Maybe<OrderCorrectionInvalidOrderType>;
  omnichannelOrderId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<OrderedProductCorrection>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OrderCorrectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  invalidOrder?: InputMaybe<OrderCorrectionInvalidOrderType>;
  omnichannelOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<OrderedProductCorrectionInput>>;
};

export type OrderCorrectionInvalidOrderType =
  | 'duplicate'
  | 'multiOrder'
  | 'notAnOrder'
  | 'other'
  | 'partOfExistingOrder'
  | '%future added value';

export type OrderCorrectionResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | OrderCorrection;

export type OrderCreateV2Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use { orderedProducts } instead */
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  orderedProducts?: InputMaybe<Array<InputMaybe<OrderedProductInput>>>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  supplierRefId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderCreatedContext =
  | 'chocoAi'
  | 'chocoApp'
  | 'chocoWeb'
  | 'teamOrder'
  | 'whiteLabelApp'
  | 'whiteLabelWeb'
  | '%future added value';

export type OrderCreatedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderCreatedError';
  errorCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  noMinimumOrderableAmountProducts?: Maybe<Array<NoMinimumOrderableAmountProduct>>;
  productBuyerCommentsNotAllowed?: Maybe<Array<Scalars['String']['output']>>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
};

export type OrderCreatedResponse = AuthorizationFailure | Order | OrderCreatedError;

export type OrderDeclined = {
  __typename?: 'OrderDeclined';
  id: Scalars['ID']['output'];
};

export type OrderDeliveryCheckAlreadyCompleted = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckAlreadyCompleted';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderDeliveryCheckCreationResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckDetails | OrderDeliveryCheckExists | OrderNotFound;

export type OrderDeliveryCheckDetails = {
  __typename?: 'OrderDeliveryCheckDetails';
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  completedBy?: Maybe<User>;
  deliveryCheckReconciliationRequest?: Maybe<DeliveryCheckReconciliationRequest>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  orderedProducts: Array<Maybe<OrderedProductDeliveryCheck>>;
  status?: Maybe<OrderDeliveryCheckStatus>;
};

export type OrderDeliveryCheckExists = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckExists';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderDeliveryCheckImage = {
  __typename?: 'OrderDeliveryCheckImage';
  imageId: Scalars['String']['output'];
  imageUploadStatus: OrderDeliveryCheckImageUploadStatus;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryCheckImageNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckImageNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderDeliveryCheckImageUploadStatus =
  | 'completed'
  | 'pending'
  | '%future added value';

export type OrderDeliveryCheckImageUploadUrlResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckImageNotFound | OrderDeliveryCheckImageUploadUrlResult | OrderNotFound;

export type OrderDeliveryCheckImageUploadUrlResult = {
  __typename?: 'OrderDeliveryCheckImageUploadUrlResult';
  imageId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type OrderDeliveryCheckNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderDeliveryCheckReconciliationRequestIdNotMatched = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckReconciliationRequestIdNotMatched';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

/** Order delivery check service definitions. */
export type OrderDeliveryCheckStatus =
  | 'completed'
  | 'draft'
  | '%future added value';

export type OrderDeliveryCheckSubmissionResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckDetails | OrderDeliveryCheckNotFound | OrderDeliveryItemsMismatched | OrderNotFound;

export type OrderDeliveryDateAvailabilityFailure = {
  __typename?: 'OrderDeliveryDateAvailabilityFailure';
  earliestAvailableDate?: Maybe<Scalars['AWSDate']['output']>;
  message: Scalars['String']['output'];
};

export type OrderDeliveryDateCutoffTimeFailure = {
  __typename?: 'OrderDeliveryDateCutoffTimeFailure';
  cutoffTimeType: CutOffTimeType;
  leadTimeAdjustedCutoff: Scalars['AWSDateTime']['output'];
  message: Scalars['String']['output'];
};

export type OrderDeliveryItemsMismatched = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryItemsMismatched';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderDeskChatsConnection = Connection & {
  __typename?: 'OrderDeskChatsConnection';
  edges: Array<OrderDeskChatsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type OrderDeskChatsEdge = Edge & {
  __typename?: 'OrderDeskChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type OrderDeskEmail = {
  email: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OrderDeskEmailRemoved = {
  __typename?: 'OrderDeskEmailRemoved';
  email: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  type: OrderDestEmailListType;
};

export type OrderDeskNotification = {
  __typename?: 'OrderDeskNotification';
  omnichannelOrder: OmnichannelOrder;
  supplierId: Scalars['ID']['output'];
};

export type OrderDeskRemovedEmailResponse = AuthorizationFailure | InputValidationFailure | OrderDeskEmailRemoved;

export type OrderDeskReviewer = {
  __typename?: 'OrderDeskReviewer';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderDestEmailListType =
  | 'allow'
  | 'block'
  | '%future added value';

export type OrderEditInput = {
  productsList?: InputMaybe<Array<EditedOrderProductsInput>>;
};

export type OrderEdited = {
  __typename?: 'OrderEdited';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderEditedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderEditedError';
  errorCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
};

export type OrderEditedResponse = AuthorizationFailure | Order | OrderEditedError;

export type OrderExportChocoEdiFormat = {
  __typename?: 'OrderExportChocoEdiFormat';
  qualifier: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderExportChocoEdiFormatInput = {
  qualifier: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderExportChocoSftpUpload = {
  __typename?: 'OrderExportChocoSftpUpload';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderExportChocoSftpUploadInput = {
  path: Scalars['String']['input'];
};

export type OrderExportConfig = {
  __typename?: 'OrderExportConfig';
  orderExportFormat: OrderExportConfigFormat;
  orderExportUpload: OrderExportUploadOption;
};

export type OrderExportConfigCreateInput = {
  orderExportFormat: OrderExportFormatInput;
  orderExportUpload?: InputMaybe<OrderExportUploadInput>;
};

export type OrderExportConfigCsvFormat = {
  __typename?: 'OrderExportConfigCsvFormat';
  dateFormat?: Maybe<Scalars['String']['output']>;
  delimiter?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['Boolean']['output']>;
  quotedString?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OrderExportConfigEdiFormat = {
  __typename?: 'OrderExportConfigEdiFormat';
  choco?: Maybe<OrderExportChocoEdiFormat>;
  supplier?: Maybe<OrderExportSupplierEdiFormat>;
  template?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OrderExportConfigFormat = OrderExportConfigCsvFormat | OrderExportConfigEdiFormat | OrderExportConfigLobsterFormat;

export type OrderExportConfigLobsterFormat = {
  __typename?: 'OrderExportConfigLobsterFormat';
  type: Scalars['String']['output'];
};

export type OrderExportConfigUpdateInput = {
  orderExportFormat?: InputMaybe<OrderExportFormatInput>;
  orderExportUpload?: InputMaybe<OrderExportUploadInput>;
};

export type OrderExportCsvFormatInput = {
  template: OrderExportCsvTemplateOptions;
};

/** ORDER EXPORT CONFIG STARTS HERE .......... */
export type OrderExportCsvTemplateOptions =
  | 'NECSCsv'
  | 'StandardCsv'
  | '%future added value';

export type OrderExportEdiFormatInput = {
  choco?: InputMaybe<OrderExportChocoEdiFormatInput>;
  supplier?: InputMaybe<OrderExportSupplierEdiFormatInput>;
  template: OrderExportEdiTemplateOptions;
};

export type OrderExportEdiTemplateOptions =
  | 'CharliceProduceEdi'
  | 'CustomEdi'
  | 'UsFoodsEdi'
  | '%future added value';

export type OrderExportExternalSftpUpload = {
  __typename?: 'OrderExportExternalSftpUpload';
  forceIPv4?: Maybe<Scalars['Boolean']['output']>;
  forceIPv6?: Maybe<Scalars['Boolean']['output']>;
  host: Scalars['String']['output'];
  passphrase?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  port?: Maybe<Scalars['Int']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  readyTimeout?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type OrderExportExternalSftpUploadInput = {
  forceIPv4?: InputMaybe<Scalars['Boolean']['input']>;
  forceIPv6?: InputMaybe<Scalars['Boolean']['input']>;
  host: Scalars['String']['input'];
  passphrase?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  readyTimeout?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};

export type OrderExportFormatInput = {
  csv?: InputMaybe<OrderExportCsvFormatInput>;
  edi?: InputMaybe<OrderExportEdiFormatInput>;
  lobster?: InputMaybe<OrderExportLobsterFormatInput>;
};

export type OrderExportLobsterFormatInput = {
  path: Scalars['String']['input'];
};

export type OrderExportLobsterUpload = {
  __typename?: 'OrderExportLobsterUpload';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderExportSupplierEdiFormat = {
  __typename?: 'OrderExportSupplierEdiFormat';
  name?: Maybe<Scalars['String']['output']>;
  nameReferenceQualifier?: Maybe<Scalars['String']['output']>;
  productIdQualifier?: Maybe<Scalars['String']['output']>;
  qualifier: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderExportSupplierEdiFormatInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  nameReferenceQualifier?: InputMaybe<Scalars['String']['input']>;
  productIdQualifier?: InputMaybe<Scalars['String']['input']>;
  qualifier: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderExportUploadInput = {
  chocoSftp?: InputMaybe<OrderExportChocoSftpUploadInput>;
  externalSftp?: InputMaybe<OrderExportExternalSftpUploadInput>;
};

export type OrderExportUploadOption = OrderExportChocoSftpUpload | OrderExportExternalSftpUpload | OrderExportLobsterUpload;

export type OrderFilter = {
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
};

export type OrderGuide = {
  __typename?: 'OrderGuide';
  categories?: Maybe<Array<OrderGuideCategory>>;
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  products: OrderGuideProduct;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderGuideBannerShoppableAd = AdInterface & {
  __typename?: 'OrderGuideBannerShoppableAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The Order Guide banner image */
  orderGuideBannerImageUrl: Scalars['String']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
  /** Variants from the DX owns the OG */
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type OrderGuideCategory = Node & {
  __typename?: 'OrderGuideCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideCreated = {
  __typename?: 'OrderGuideCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideCreatedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderGuideCreatedError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderGuideCreatedResponse = OrderGuideCreatedError | OrderGuideCreatedSuccess;

export type OrderGuideCreatedSuccess = AppsyncResponse & {
  __typename?: 'OrderGuideCreatedSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type OrderGuideFailure = {
  __typename?: 'OrderGuideFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderGuideProduct = {
  __typename?: 'OrderGuideProduct';
  items?: Maybe<Array<OrderGuideProductItem>>;
  nextCursors?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderGuideProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize: Scalars['Int']['input'];
};

export type OrderGuideProductInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};

export type OrderGuideProductItem = Node & {
  __typename?: 'OrderGuideProductItem';
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.price` or `VendorItemUnit.displayProperties` or `VendorItemUnit.buyerProperties` instead */
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  categoryId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /** @deprecated Does not work for LOX Suppliers. Use `Product.deliveryDateConditions` or `VendorItemUnitOrderingProperties.deliveryDateConditions` instead */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.price` instead */
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  enabled: Scalars['Boolean']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};


export type OrderGuideProductItemBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type OrderGuideProductItemDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};


export type OrderGuideProductItemDerivedPriceForOrderGuideArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
};

export type OrderGuideRequest = {
  __typename?: 'OrderGuideRequest';
  chatId: Scalars['String']['output'];
  createOrderGuideMethod: OrderGuideRequestMethod;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  filesComment?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  requestRefId?: Maybe<Scalars['String']['output']>;
  type: OrderGuideRequestType;
  uploadedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['String']['output'];
};

export type OrderGuideRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderGuideRequestError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderGuideRequestInput = {
  chatId: Scalars['String']['input'];
  createOrderGuideMethod: OrderGuideRequestMethod;
  filesComment?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  requestRefId?: InputMaybe<Scalars['String']['input']>;
  type: OrderGuideRequestType;
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type OrderGuideRequestMethod =
  | 'emailChoco'
  | 'photoUpload'
  | '%future added value';

export type OrderGuideRequestResponse = OrderGuideRequest | OrderGuideRequestError;

export type OrderGuideRequestType =
  | 'create'
  | 'update'
  | '%future added value';

export type OrderGuideRequested = {
  __typename?: 'OrderGuideRequested';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideResponse = AuthorizationFailure | InputValidationFailure | OrderGuide | OrderGuideFailure;

/** Order guide */
export type OrderGuideV2 = Node & {
  __typename?: 'OrderGuideV2';
  /** We are only exposing the Id for now */
  id: Scalars['ID']['output'];
};

export type OrderGuideV2BatchUpdateInput = {
  /** The ID of the chat to update the order guide for. */
  chatId: Scalars['ID']['input'];
  /** If set to true, the operation will be validated but not executed. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The items to update. */
  items: Array<OrderGuideV2BatchUpdateInputItem>;
  /** The mode of the batch update. */
  mode: OrderGuideV2BatchUpdateMode;
  /** If set to true, all the input will be created as custom products */
  onlyCreateCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderGuideV2BatchUpdateInputItem = {
  /** Will be used for VendorItemUnitBuyerProperties */
  displayItemName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Will be used for VendorItemUnitBuyerProperties
   * @deprecated Use myPriceV2 instead
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  myPriceV2?: InputMaybe<NullableMoneyV2InputOptional>;
  /**
   * The name of the vendor item.
   * This will only be used if we are creating a new custom product and in that case it will be mandatory.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item will be added to it
   * else a new order guide category will be created with this name (capitalized) and the item will be added to it.,
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** Will be used for VendorItemUnitBuyerProperties */
  par?: InputMaybe<Scalars['String']['input']>;
  /**
   * Will be used to match vendor item in the catalog.
   * Mapped to vendorItem.productCode
   */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Used to match vendor item unit in the catalog.
   * Mapped to vendorItemUnit.code
   */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuideV2BatchUpdateInvalidInputItem = {
  __typename?: 'OrderGuideV2BatchUpdateInvalidInputItem';
  errorCode: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  item: OrderGuideV2BatchUpdateInvalidInputItemParams;
  reason: Scalars['String']['output'];
};

export type OrderGuideV2BatchUpdateInvalidInputItemParams = {
  __typename?: 'OrderGuideV2BatchUpdateInvalidInputItemParams';
  displayItemName?: Maybe<Scalars['String']['output']>;
  myPrice?: Maybe<MoneyV2>;
  name?: Maybe<Scalars['String']['output']>;
  orderGuideCategoryName?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
};

export type OrderGuideV2BatchUpdateMode =
  | 'AddOnly'
  | 'Replace'
  | 'Update'
  | '%future added value';

export type OrderGuideV2BatchUpdateParams = {
  __typename?: 'OrderGuideV2BatchUpdateParams';
  chatId: Scalars['ID']['output'];
  /** Whether or not the dryRun flag was set */
  dryRun: Scalars['Boolean']['output'];
  /** Whether or not the onlyAddMissingItems flag was passed */
  mode: OrderGuideV2BatchUpdateMode;
  /** Whether or not the onlyCreateCustomProducts flag was set */
  onlyCreateCustomProducts: Scalars['Boolean']['output'];
};

export type OrderGuideV2BatchUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2BatchUpdateResult;

export type OrderGuideV2BatchUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2BatchUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Summary of the updated order guide items. */
  summary: OrderGuideV2BatchUpdateSummary;
};

export type OrderGuideV2BatchUpdateSummary = {
  __typename?: 'OrderGuideV2BatchUpdateSummary';
  batchUpdateParams: OrderGuideV2BatchUpdateParams;
  /** No of VendorItems created after the update */
  createdCustomVendorItems: Scalars['Int']['output'];
  /** list of items that failed validation */
  errors: Array<OrderGuideV2BatchUpdateInvalidInputItem>;
  /** No. of items existing in the order guide before the update */
  existingOrderGuideItems: Scalars['Int']['output'];
  /** No. of new items that were added to the order guide after the update */
  newOrderGuideItems: Scalars['Int']['output'];
  /** No. of items that were removed from the order guide after the update */
  removedOrderGuideItems: Scalars['Int']['output'];
  /**
   * No. of items that were updated in the order guide after the update
   * This include update of buyer properties
   */
  updatedOrderGuideItems: Scalars['Int']['output'];
};

export type OrderGuideV2CategoriesInput = {
  excludeEmptyCategories?: InputMaybe<Scalars['Boolean']['input']>;
  includeOrderGuideSummary?: InputMaybe<Scalars['Boolean']['input']>;
  orderGuideId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInputV2>;
};

export type OrderGuideV2CategoriesResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2CategoriesResult;

export type OrderGuideV2CategoriesResult = AppsyncResponse & Connection & Page & {
  __typename?: 'OrderGuideV2CategoriesResult';
  edges: Array<OrderGuideV2CategoriesResultEdge>;
  orderGuideSummary?: Maybe<OrderGuideV2Summary>;
  pageInfo: PageInfo;
  responseType: ResponseType;
};

export type OrderGuideV2CategoriesResultEdge = Edge & {
  __typename?: 'OrderGuideV2CategoriesResultEdge';
  cursor: Scalars['String']['output'];
  node: OrderGuideV2Category;
};

export type OrderGuideV2CategoriesUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2CategoriesUpdateResult;

/** Success response of the `OrderGuideV2CategoriesUpdate` query */
export type OrderGuideV2CategoriesUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2CategoriesUpdateResult';
  /** list of categories added to the order guide */
  added: Array<OrderGuideV2Category>;
  /** list of categories not found in the order guide. */
  notFound: Array<Scalars['ID']['output']>;
  /** list of categories removed from the order guide */
  removed: Array<OrderGuideV2Category>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** list of categories updated in the order guide */
  updated: Array<OrderGuideV2Category>;
};

/** Represents a category in the order guide. */
export type OrderGuideV2Category = Node & {
  __typename?: 'OrderGuideV2Category';
  /** The unique identifier for the order guide category. */
  id: Scalars['ID']['output'];
  /** The number of vendor item units in this category. */
  itemsCount: Scalars['Int']['output'];
  /** The position of the category in the order guide. */
  listPosition?: Maybe<Rational>;
  /** The name of the order guide category. */
  name: Scalars['String']['output'];
};

export type OrderGuideV2CategoryAddInputItem = {
  /**
   * The ID of the order guide category to add to the order guide category after.
   * 0-uuid can be provided to add the category to the front.
   * if not provided the category is added to the end
   */
  afterOrderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** The order guide category name to be created */
  name: Scalars['String']['input'];
};

/**
 * Reference to the OrderGuideV2Category.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type OrderGuideV2CategoryRef = RefEdge & {
  __typename?: 'OrderGuideV2CategoryRef';
  /** The ID of the referenced object. */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<OrderGuideV2Category>;
};

export type OrderGuideV2CategoryUpdateInput = {
  /**
   * list of categories to add in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Add are applied after updates
   */
  add?: InputMaybe<Array<OrderGuideV2CategoryAddInputItem>>;
  /** The order guide to add the category items to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * list of categories to remove from the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Remove are applied after add.
   * "The products from removed categories will become uncategorized"
   */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * list of categories to re-arrange in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Updates are first applied
   */
  update?: InputMaybe<Array<OrderGuideV2CategoryUpdateInputItem>>;
};

export type OrderGuideV2CategoryUpdateInputItem = {
  /**
   * The ID of the order guide category to add to the order guide category after.
   * 0-uuid can be provided to add the category to the front.
   * if not provided the category maintains the same position
   */
  afterOrderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided the category name will be updated */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order guide categories ID to update. */
  orderGuideCategoryId: Scalars['ID']['input'];
};

/** Represents a vendor item unit. */
export type OrderGuideV2ItemUnit = Node & {
  __typename?: 'OrderGuideV2ItemUnit';
  /** The unique identifier for the vendor item unit. */
  id: Scalars['ID']['output'];
  /** The position of the item in the order guide. */
  listPosition?: Maybe<Rational>;
  /** The vendor item unit. */
  orderGuideCategory?: Maybe<OrderGuideV2CategoryRef>;
  vendorItemUnit: VendorItemUnitRef;
};

/** Input parameters for adding an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsAddInput = {
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  items: Array<OrderGuideV2ItemUnitsAddInputItem>;
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
};

/**
 * OrderGuideV2ItemUnitsAddInput item
 * If orderGuideCategoryId is provided, the item will be added to the specified category.
 * If orderGuideCategoryName is provided, the item will be added to the category with the provided name (case insensitive).
 * If both orderGuideCategoryId and orderGuideCategoryName are provided, the orderGuideCategoryId takes precedence.
 * If neither is provided, the item will be added as uncategorized.
 */
export type OrderGuideV2ItemUnitsAddInputItem = {
  /**
   * The ID of the order guide vendor item unit to add to the order guide vendor item unit after.
   * 0-uuid can be provided to move the item to the front of its category.
   * if provided the vendor unit item will belong to the same category as this
   * if the item doesn't belong to the same category, then nothing happens
   */
  afterOrderGuideItemUnitId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category to add the vendor item unit to.
   * If not provided, the item will be added as uncategorized.
   * If 0-uuid is provided, the item will be added as uncategorized.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item is added to it
   * If the new order guide category is an empty string the item will be added as uncategorized.
   * else a new order guide category is created with this name (capitalized) and the item is added to it.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitsAddResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsAddResult;

/** Success response of the `OrderGuideV2ItemUnitsAdd` query */
export type OrderGuideV2ItemUnitsAddResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsAddResult';
  /** The added order guide item units. */
  items: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Filter input for the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsFilter = {
  /**
   * If provided, only items in the category with the specified ID will be returned.
   * If the value is "00000000-0000-0000-0000-000000000000", only uncategorized items are returned.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided, only items in the category with the specified IDs will be returned.
   * The value "00000000-0000-0000-0000-000000000000" could be used to return uncategorized items.
   */
  orderGuideCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If provided and set to true, only items without a category are returned. */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for the `orderGuideItemUnits` query */
export type OrderGuideV2ItemUnitsInput = {
  /** Additional filters to narrow down the output */
  filter?: InputMaybe<OrderGuideV2ItemUnitsFilter>;
  /** The ID of the order guide to get the units for. */
  orderGuideId: Scalars['ID']['input'];
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Optional sorting parameters for the output */
  sort?: InputMaybe<OrderGuideV2SortParamsInput>;
};

/** Input parameters for removing an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsRemoveInput = {
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type OrderGuideV2ItemUnitsRemoveResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsRemoveResult;

/** Success response of the `orderGuideItemUnitsRemove` query */
export type OrderGuideV2ItemUnitsRemoveResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsRemoveResult';
  /** The removed order guide item units. */
  items: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /**
   * Whether or not the operation was successful.
   * This will always be set to `true`.
   */
  success: Scalars['Boolean']['output'];
};

export type OrderGuideV2ItemUnitsResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsResult;

/** Success response of the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'OrderGuideV2ItemUnitsResult';
  /** The edges of the response. */
  edges: Array<OrderGuideV2ItemUnitsResultEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Sorting information */
  sortedBy?: Maybe<OrderGuideV2SortParams>;
};

/** One item of the `OrderGuideV2ItemUnits` query result page */
export type OrderGuideV2ItemUnitsResultEdge = Edge & {
  __typename?: 'OrderGuideV2ItemUnitsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** An order guide item unit reference */
  node: OrderGuideV2ItemUnit;
};

export type OrderGuideV2ItemUnitsUpdateInput = {
  /**
   * list of items to add to the order guide, the maximum size should be 50
   * existing items are not changed.
   * Add are applied after updates
   */
  add?: InputMaybe<Array<OrderGuideV2ItemUnitsAddInputItem>>;
  /** The order guide to update the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * list of items to remove from the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Remove are applied after add
   */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * list of items to re-arrange in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Updates are first applied
   */
  update?: InputMaybe<Array<OrderGuideV2ItemUnitsUpdateInputItem>>;
};

export type OrderGuideV2ItemUnitsUpdateInputItem = {
  /**
   * The ID of the order guide vendor item unit to add to the order guide vendor item unit after.
   * 0-uuid can be provided to move the item to the front of its category.
   * if provided the vendor unit item will belong to the same category as this
   * if the item doesn't belong to the same category, then nothing happens
   */
  afterOrderGuideItemUnitId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category to add the vendor item unit to.
   * If not provided for add operation, the item will be added as uncategorized.
   * If not provided for update operation, the item maintains the same category.
   * 0-uuid can be provided to move item to uncategorized.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item is added to it
   * else a new order guide category is created with this name (capitalized) and the item is added to it.
   * If both this and orderGuideCategoryId are provided, the orderGuideCategoryId takes precedence.
   * Empty string can be provided to move item to uncategorized.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsUpdateResult;

export type OrderGuideV2ItemUnitsUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsUpdateResult';
  /** vendor unit items added to the order guide */
  added: Array<OrderGuideV2ItemUnit>;
  /** vendor unit items not found in the order guide */
  notFound: Array<Scalars['ID']['output']>;
  /** vendor unit items  removed from the order guide */
  removed: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** vendor unit items updated in the order guide */
  updated: Array<OrderGuideV2ItemUnit>;
};

/** Order guide reference */
export type OrderGuideV2Ref = RefEdge & {
  __typename?: 'OrderGuideV2Ref';
  id: Scalars['ID']['output'];
  node?: Maybe<OrderGuideV2>;
};

export type OrderGuideV2SortField =
  | 'AddedToOrderGuide'
  | 'CustomSort'
  | 'Name'
  | 'ProductCode'
  | '%future added value';

export type OrderGuideV2SortParams = {
  __typename?: 'OrderGuideV2SortParams';
  /** The direction results were sorted by. */
  direction: SortDirection;
  /** The field to results were sorted by. */
  field: OrderGuideV2SortField;
};

export type OrderGuideV2SortParamsInput = {
  direction: SortDirection;
  field: OrderGuideV2SortField;
};

export type OrderGuideV2Summary = {
  __typename?: 'OrderGuideV2Summary';
  allItemsCount: Scalars['Int']['output'];
  uncategorizedItemsCount: Scalars['Int']['output'];
};

export type OrderHasNoInvoice = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderHasNoInvoice';
  attachment?: Maybe<InvoiceAttachment>;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderHasOnlyAttachment = AppsyncResponse & {
  __typename?: 'OrderHasOnlyAttachment';
  attachment?: Maybe<InvoiceAttachment>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type OrderInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTeamOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
};

export type OrderInvoice = AuthorizationFailure | InputValidationFailure | Invoice | OrderHasNoInvoice | OrderHasOnlyAttachment;

export type OrderMatchingConfidence = {
  __typename?: 'OrderMatchingConfidence';
  isDeliveryDateCorrect?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderMinimumOrderableAmountFailure = {
  __typename?: 'OrderMinimumOrderableAmountFailure';
  message: Scalars['String']['output'];
  minimumOrderableAmount: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type OrderNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type OrderPreference = {
  __typename?: 'OrderPreference';
  /** @deprecated fax is no longer supported */
  fax?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['String']['output']>;
  welcomeNotificationSent?: Maybe<Scalars['AWSTimestamp']['output']>;
  whatsApp?: Maybe<Scalars['String']['output']>;
  xlsx?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderPreferenceInput = {
  /** @deprecated fax is no longer supported */
  fax?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['String']['input']>;
  welcomeNotificationSent?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  whatsApp?: InputMaybe<Scalars['String']['input']>;
  xlsx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderProcessingRetrying = {
  __typename?: 'OrderProcessingRetrying';
  message?: Maybe<Scalars['String']['output']>;
  omnichannelOrderId: Scalars['ID']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  amount: Scalars['Float']['output'];
  /** Product-level comment from the buyer */
  buyerComment?: Maybe<Scalars['String']['output']>;
  product: Product;
};

export type OrderProductAvailabilityFailure = {
  __typename?: 'OrderProductAvailabilityFailure';
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stockStatus: VendorItemUnitStockStatus;
};

export type OrderProductCutoffTimeFailure = {
  __typename?: 'OrderProductCutoffTimeFailure';
  cutoffTime: Scalars['AWSTime']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type OrderProductInput = {
  amount: Scalars['Int']['input'];
  product: ProductInput;
};

export type OrderProductLeadTimeFailure = {
  __typename?: 'OrderProductLeadTimeFailure';
  leadTimeDays: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type OrderRejected = {
  __typename?: 'OrderRejected';
  id: Scalars['ID']['output'];
};

export type OrderRejectedNotification = {
  __typename?: 'OrderRejectedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderRestaurant = Node & {
  __typename?: 'OrderRestaurant';
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  restaurantName?: Maybe<Scalars['String']['output']>;
};

export type OrderStatus =
  | 'confirmed'
  | 'created'
  | 'delivered'
  | 'pending'
  /** Order is awaiting buyer approval (PunchOut integration flow) */
  | 'pendingBuyerApproval'
  /** Order is rejected by the buyer (PunchOut integration flow) */
  | 'rejectedByBuyer'
  | '%future added value';

export type OrderUploadMediaElementInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type OrderValidationFailure = InvalidProductsFailure | OrderDeliveryDateAvailabilityFailure | OrderDeliveryDateCutoffTimeFailure | OrderMinimumOrderableAmountFailure | OrderProductAvailabilityFailure | OrderProductCutoffTimeFailure | OrderProductLeadTimeFailure;

export type OrderValidationFailures = {
  __typename?: 'OrderValidationFailures';
  validationFailures?: Maybe<Array<OrderValidationFailure>>;
};

export type OrderValidationMode =
  | 'strict'
  | 'withOverrides'
  | '%future added value';

export type OrderedProduct = {
  __typename?: 'OrderedProduct';
  amount: Scalars['Float']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  /** Product-level comment from the buyer */
  buyerComment?: Maybe<Scalars['String']['output']>;
  buyerPrice?: Maybe<Money>;
  /** Product specific instructions from the supplier */
  comment?: Maybe<Scalars['String']['output']>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayPrice?: Maybe<Money>;
  /**
   * If the property 'displayPriceBeforeDiscount' is undefined, there is no discount.
   * If it is present, the discounted price can be read from the 'displayPrice' property.
   */
  displayPriceBeforeDiscount?: Maybe<Money>;
  ean?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierPrice?: Maybe<Money>;
  unit?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  /** Only fetch this field in LOX context, In non-LOX context vendorItemUnitRef.node will always be resolved as Null. */
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type OrderedProductCorrection = {
  __typename?: 'OrderedProductCorrection';
  /** A comment to further express the correction. */
  comment?: Maybe<Scalars['String']['output']>;
  /** External ID from Supplier ERP system or similar external system for product identification */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Line item ID from CAI context to identify a specific product on a list of products */
  lineItemId?: Maybe<Scalars['String']['output']>;
  /** Name of the product */
  name: Scalars['String']['output'];
  /** The corrected price */
  price?: Maybe<MoneyV2>;
  /** Product ID from the Choco product context */
  productId: Scalars['String']['output'];
  /** Corrected quantity value for this product line item */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Unit of measurement for the product quantity (e.g., pieces, kg, liters) */
  unit?: Maybe<Scalars['String']['output']>;
};

export type OrderedProductCorrectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<MoneyV2Input>;
  productId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductDeliveryCheck = {
  __typename?: 'OrderedProductDeliveryCheck';
  /** @deprecated use deliveryCheckProblems[<item.amountDelivered>] instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  amountOrdered?: Maybe<Scalars['Float']['output']>;
  deliveryCheckProblems?: Maybe<Array<Maybe<DeliveryCheckProblem>>>;
  images?: Maybe<Array<Maybe<OrderDeliveryCheckImage>>>;
  orderId: Scalars['ID']['output'];
  orderedProductMetadata?: Maybe<OrderedProductMetadata>;
  productId: Scalars['ID']['output'];
};

export type OrderedProductDeliveryCheckProblemType =
  | 'defected'
  | 'defective'
  | 'incorrectQuantity'
  | 'missing'
  | 'other'
  | '%future added value';

export type OrderedProductDeliveryCheckSubmissionResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryItemsMismatched | OrderNotFound | OrderedProductDeliveryCheck;

export type OrderedProductInput = {
  amount: Scalars['Float']['input'];
  /** product-level comment from the buyer */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated not used anymore */
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Not used anymore for LOX vendors */
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Obtained from productId automatically for LOX vendors but still needed for non-LOX vendors */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Obtained from productId automatically for LOX vendors but still needed for non-LOX vendors */
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  /** @deprecated not used anymore */
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated not used anymore */
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Obtained from productId automatically for LOX vendors but still needed for non-LOX vendors */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductMetadata = {
  __typename?: 'OrderedProductMetadata';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type OrderedProductMetadataInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrdersBulkDeclined = {
  __typename?: 'OrdersBulkDeclined';
  ids: Array<Scalars['ID']['output']>;
};

export type OrdersRejected = {
  __typename?: 'OrdersRejected';
  ids: Array<Scalars['ID']['output']>;
};

export type OrdersToReviewConnection = Connection & {
  __typename?: 'OrdersToReviewConnection';
  edges: Array<OrdersToReviewEdge>;
  pageInfo: PageInfo;
};

export type OrdersToReviewEdge = Edge & {
  __typename?: 'OrdersToReviewEdge';
  cursor: Scalars['String']['output'];
  node: OmnichannelOrder;
};

export type OrdersToReviewInput = {
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
  supplierEntityId: Scalars['ID']['input'];
};

export type OrdersToReviewResponse = InputValidationFailure | OrdersToReviewConnection;

/** A single page response for a paginated query */
export type Page = {
  /** Items included in the page */
  edges: Array<Edge>;
  /** Information about the page */
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PageRange = {
  __typename?: 'PageRange';
  endPage: Scalars['Int']['output'];
  startPage: Scalars['Int']['output'];
};

export type PaginationDirection =
  | 'backward'
  | 'forward'
  | '%future added value';

/**
 * Input parameters for a cursor paginated query that can be traversed in both directions.
 * Only provide the parameters for the direction you want to traverse:
 * - when querying the next page, provide `first` and `after`
 * - when querying the previous page, provide `last` and `before`
 */
export type PaginationInput = {
  /**
   * Cursor from which the query should start when querying forward.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Cursor from which the query should start when querying backward.
   * Normally would be set to the `startCursor` of the next page or the cursor of the first item.
   */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of items to return in the page when querying forward */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return in the page when querying backward */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input parameters for a cursor paginated query that can be traversed in both directions. */
export type PaginationInputV2 = {
  /**
   * Cursor from which the query should start querying.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item for the forward direction,
   * or to the `startCursor` of the next page or the cursor of the first item for the backward direction.
   * If not provided, the query starts from the beginning or end depending on the direction.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Direction of the query: forward to get the next page, backward to get the previous page. */
  direction?: InputMaybe<PaginationDirection>;
  /** Maximum number of items to return in the page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ParsedLineItem = {
  __typename?: 'ParsedLineItem';
  id: Scalars['ID']['output'];
  lineItemId?: Maybe<Scalars['ID']['output']>;
  position: Scalars['Int']['output'];
  primaryProperties: LineItemPrimaryProperties;
  secondaryProperties: Array<LineItemSecondaryProperties>;
};

export type ParsedOrder = {
  __typename?: 'ParsedOrder';
  PONumber?: Maybe<Scalars['String']['output']>;
  chatMatchedBy?: Maybe<ChatMatchedBy>;
  comment?: Maybe<Scalars['String']['output']>;
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  customerPhoneNo?: Maybe<Scalars['String']['output']>;
  customerRepresentative?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** @deprecated Moved to OmnichannelOrderProduct */
  extractedAmount?: Maybe<Scalars['Float']['output']>;
  isCustomerCorrect?: Maybe<Scalars['Boolean']['output']>;
  isDeliveryDateCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPONumberCorrect?: Maybe<Scalars['Boolean']['output']>;
  matchedChatId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use products */
  matchedProducts: Array<OmnichannelProduct>;
  nearestAvailableDeliveryDate?: Maybe<Scalars['String']['output']>;
  orderReviewReason: Array<ReviewReason>;
  productCount?: Maybe<Scalars['Int']['output']>;
  products: Array<OmnichannelOrderProduct>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  restaurantAddress?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use products */
  unmatchedProducts: Array<OmnichannelProduct>;
};

export type ParsedPurchaseOrder = {
  __typename?: 'ParsedPurchaseOrder';
  buyerPONumber?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  dispatchDate?: Maybe<Scalars['String']['output']>;
  documents: Array<PurchasingDocument>;
  id: Scalars['ID']['output'];
  lineItems: Array<ParsedLineItem>;
  reviewStatus: ParsedPurchaseOrderStatus;
  seller?: Maybe<PurchasingBusiness>;
  sellerAddress?: Maybe<Scalars['String']['output']>;
  sellerApprovalNumber?: Maybe<Scalars['String']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
  sellerPONumber?: Maybe<Scalars['String']['output']>;
};

export type ParsedPurchaseOrderStatus =
  | 'accepted'
  | 'pending'
  | 'rejected'
  | '%future added value';

export type PartialLegalContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PatchStorageItemPrice = {
  currency: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
};

export type PaymentCustomerContact = {
  __typename?: 'PaymentCustomerContact';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: PaymentCustomerContactRole;
};

export type PaymentCustomerContactInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: PaymentCustomerContactRole;
};

export type PaymentCustomerContactRole =
  | 'ADDITIONAL'
  | 'MAIN'
  | '%future added value';

export type PaymentCustomerContactsUpdateFailure = {
  __typename?: 'PaymentCustomerContactsUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentCustomerContactsUpdateInput = {
  contacts: Array<PaymentCustomerContactInput>;
  paymentCustomerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentCustomerContactsUpdateResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerContactsUpdateFailure | PaymentCustomerContactsUpdateSuccess | PaymentCustomerNotFound;

export type PaymentCustomerContactsUpdateSuccess = {
  __typename?: 'PaymentCustomerContactsUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentCustomerCredit = {
  __typename?: 'PaymentCustomerCredit';
  availableBalance: MoneyV2;
  limit: MoneyV2;
};

export type PaymentCustomerDetailsInput = {
  buyerId: Scalars['ID']['input'];
  contacts: Array<PaymentCustomerContactInput>;
  name: Scalars['String']['input'];
  shippingAddress: ShippingAddressInput;
};

export type PaymentCustomerDirectPayFailure = {
  __typename?: 'PaymentCustomerDirectPayFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type PaymentCustomerDirectPayInput = {
  buyerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentCustomerDirectPayResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerDirectPayFailure | PaymentCustomerDirectPaySuccess | PaymentCustomerNotFound;

export type PaymentCustomerDirectPaySuccess = {
  __typename?: 'PaymentCustomerDirectPaySuccess';
  customer: DirectPayPaymentCustomer;
  responseType: ResponseType;
};

export type PaymentCustomerNotFound = {
  __typename?: 'PaymentCustomerNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type PaymentCustomerProfiles = {
  __typename?: 'PaymentCustomerProfiles';
  instantPayment?: Maybe<InstantPaymentCustomerProfile>;
};

export type PaymentCustomerResultEdge = {
  __typename?: 'PaymentCustomerResultEdge';
  cursor: Scalars['String']['output'];
  node: PaymentCustomerResultNode;
};

export type PaymentCustomerResultNode = {
  __typename?: 'PaymentCustomerResultNode';
  buyerId?: Maybe<Scalars['ID']['output']>;
  credit?: Maybe<PaymentCustomerCredit>;
  id: Scalars['ID']['output'];
  legalEntity?: Maybe<PaymentLegalEntity>;
  name: Scalars['String']['output'];
  profiles: PaymentCustomerProfiles;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  shippingAddressStructured?: Maybe<PaymentShippingAddress>;
};

export type PaymentCustomerSearchFilterInput = {
  externalLegalEntityId?: InputMaybe<Scalars['ID']['input']>;
  instantPaymentProfileStatus?: InputMaybe<Array<InstantPaymentProfileStatus>>;
};

export type PaymentCustomerSearchInput = {
  filter?: InputMaybe<PaymentCustomerSearchFilterInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type PaymentCustomerSearchResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerSearchSuccess;

export type PaymentCustomerSearchSuccess = {
  __typename?: 'PaymentCustomerSearchSuccess';
  edges: Array<PaymentCustomerResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType;
  total: Scalars['Int']['output'];
};

export type PaymentCustomerUpdateAllForLegalEntityFailure = {
  __typename?: 'PaymentCustomerUpdateAllForLegalEntityFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentCustomerUpdateAllForLegalEntityInput = {
  legalEntityId: Scalars['ID']['input'];
  update: PaymentCustomerUpdateDetailsInput;
};

export type PaymentCustomerUpdateAllForLegalEntityResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerUpdateAllForLegalEntityFailure | PaymentCustomerUpdateAllForLegalEntitySuccess;

export type PaymentCustomerUpdateAllForLegalEntitySuccess = {
  __typename?: 'PaymentCustomerUpdateAllForLegalEntitySuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentCustomerUpdateDetailsInput = {
  contacts: Array<PaymentCustomerContactInput>;
};

export type PaymentFeature =
  | 'BuyerPaymentsPortal'
  | '%future added value';

export type PaymentLegalAddress = {
  __typename?: 'PaymentLegalAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type PaymentLegalContact = {
  __typename?: 'PaymentLegalContact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type PaymentLegalEntity = {
  __typename?: 'PaymentLegalEntity';
  address: PaymentLegalAddress;
  contact: PaymentLegalContact;
  id: Scalars['ID']['output'];
};

export type PaymentLegalEntityUpdateDetailsInput = {
  contact?: InputMaybe<PartialLegalContactInput>;
};

export type PaymentLegalEntityUpdateFailure = {
  __typename?: 'PaymentLegalEntityUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentLegalEntityUpdateInput = {
  /** On behalf of which buyer this update is taking place */
  buyerId: Scalars['ID']['input'];
  /** The legal entity id */
  id: Scalars['ID']['input'];
  options?: InputMaybe<PaymentLegalEntityUpdateOptionsInput>;
  update: PaymentLegalEntityUpdateDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type PaymentLegalEntityUpdateOptionsInput = {
  sendInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentLegalEntityUpdateResponse = AuthorizationFailure | InputValidationFailure | PaymentLegalEntityUpdateFailure | PaymentLegalEntityUpdateSuccess;

export type PaymentLegalEntityUpdateSuccess = {
  __typename?: 'PaymentLegalEntityUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentLinkGenerateFailure = {
  __typename?: 'PaymentLinkGenerateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentLinkGenerateInput = {
  billingDocumentId: Scalars['ID']['input'];
};

export type PaymentLinkGenerateResponse = AuthorizationFailure | InputValidationFailure | PaymentLinkGenerateFailure | PaymentLinkGenerateSuccess;

export type PaymentLinkGenerateSuccess = {
  __typename?: 'PaymentLinkGenerateSuccess';
  paymentUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentMethod = CardPaymentMethod | PendingPaymentMethod;

export type PaymentMethodRequestConflictFailure = {
  __typename?: 'PaymentMethodRequestConflictFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentMethodRequestFailure = {
  __typename?: 'PaymentMethodRequestFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentMethodRequestInput = {
  buyerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentMethodRequestResendConflict = {
  __typename?: 'PaymentMethodRequestResendConflict';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentMethodRequestResendFailure = {
  __typename?: 'PaymentMethodRequestResendFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type PaymentMethodRequestResendInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type PaymentMethodRequestResendResponse = AuthorizationFailure | InputValidationFailure | PaymentMethodRequestResendConflict | PaymentMethodRequestResendFailure | PaymentMethodRequestResendSuccess;

export type PaymentMethodRequestResendSuccess = {
  __typename?: 'PaymentMethodRequestResendSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentMethodRequestResponse = AuthorizationFailure | InputValidationFailure | PaymentMethodRequestConflictFailure | PaymentMethodRequestFailure | PaymentMethodRequestSuccess;

export type PaymentMethodRequestSuccess = {
  __typename?: 'PaymentMethodRequestSuccess';
  paymentMethodId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentMethodStatus =
  | 'ACCEPTED'
  | '%future added value';

export type PaymentShippingAddress = {
  __typename?: 'PaymentShippingAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type PaymentVendor = {
  __typename?: 'PaymentVendor';
  id: Scalars['ID']['output'];
  instantPayVendorConfig?: Maybe<InstantPayVendorConfig>;
  vendorId: Scalars['ID']['output'];
};

export type PaymentVendorInput = {
  vendorId: Scalars['ID']['input'];
};

export type PaymentVendorNotFound = {
  __typename?: 'PaymentVendorNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type PaymentVendorResponse = AuthorizationFailure | InputValidationFailure | PaymentVendorNotFound | PaymentVendorSuccess;

export type PaymentVendorSuccess = {
  __typename?: 'PaymentVendorSuccess';
  paymentVendor: PaymentVendor;
};

export type PaymentsConfigSuccess = {
  __typename?: 'PaymentsConfigSuccess';
  enabledFeatures: Array<PaymentFeature>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PaymentsFeaturesConfigResponse = AuthorizationFailure | InputValidationFailure | PaymentsFeaturesConfigSuccess;

export type PaymentsFeaturesConfigSuccess = {
  __typename?: 'PaymentsFeaturesConfigSuccess';
  enabledFeatures: Array<PaymentFeature>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type PdfAttachmentRef = {
  __typename?: 'PdfAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  pageRange: PageRange;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type PendingOrdersFilterInput = {
  customerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerNotMatched?: InputMaybe<Scalars['Boolean']['input']>;
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  originalSender?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierOrderChannel?: InputMaybe<Array<SupplierOrderChannel>>;
};

export type PendingOrdersInput = {
  fetchParsedProductInfo?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PendingOrdersFilterInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  sortBy?: InputMaybe<PendingOrdersSortFields>;
  /** @deprecated Use sortBy instead. */
  sortByDeliveryDate?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  supplierEntityId: Scalars['ID']['input'];
};

export type PendingOrdersSortFields =
  | 'createdAt'
  | 'deliveryDate'
  | '%future added value';

/**
 * This represents the case before we receive the approval from the buyer.
 * This means we have not yet received the token via a webhook.
 * We don't yet know which type of method it will be so we cannot include any other information.
 */
export type PendingPaymentMethod = {
  __typename?: 'PendingPaymentMethod';
  id: Scalars['ID']['output'];
};

export type PendingUserInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PhoneNumberLineType =
  | 'landLine'
  | 'mobile'
  | 'unsupported'
  | 'voip'
  | '%future added value';

export type PhoneNumberLookup = PhoneNumberLookupError | PhoneNumberLookupSuccess;

export type PhoneNumberLookupError = {
  __typename?: 'PhoneNumberLookupError';
  errorCode: PhoneNumberLookupErrorCode;
  message: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type PhoneNumberLookupErrorCode =
  | 'genericError'
  | 'invalidPhoneNumber'
  | '%future added value';

export type PhoneNumberLookupSuccess = {
  __typename?: 'PhoneNumberLookupSuccess';
  lineType: PhoneNumberLineType;
  phoneNumber: Scalars['String']['output'];
};

/** Distributor Notes related types */
export type PlainTextBody = {
  __typename?: 'PlainTextBody';
  text: Scalars['String']['output'];
};

export type Platform =
  | 'Mobile'
  | 'Web'
  | '%future added value';

export type PredefinedBroadcastPurpose =
  | 'custom'
  | 'expiringProducts'
  | 'offerDiscounts'
  | 'promoteProducts'
  | 'stockClearance'
  | '%future added value';

/** Input type for preparing to save the email editor state. */
export type PrepareSaveEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Email editor state file details */
  emailEditorState: EmailEditorStateFileInput;
};

/** Response type for preparing to save the email editor state. */
export type PrepareSaveEmailEditorStateResponse = AuthorizationFailure | InputValidationFailure | PrepareSaveEmailEditorStateResult;

/** Success result containing the upload URL and S3 key for saving the email editor state. */
export type PrepareSaveEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'PrepareSaveEmailEditorStateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The pre-signed upload URL for the email editor state. */
  uploadUrl: Scalars['String']['output'];
  /** The S3 URI for the email editor state. */
  uri: Scalars['String']['output'];
};

/** Represents the price level of an prospect. */
export type PriceLevel =
  | 'Expensive'
  | 'Free'
  | 'Inexpensive'
  | 'Moderate'
  | 'Unspecified'
  | 'VeryExpensive'
  | '%future added value';

export type PriceSetting = {
  __typename?: 'PriceSetting';
  /** displays price of catalog products to potential buyer(s) on the Marketplace */
  displayInMarketplace: Scalars['Boolean']['output'];
  /** displays price of catalog products to buyer(s) in same chat with supplier */
  displayToCustomers: Scalars['Boolean']['output'];
};

export type PriceSettingInput = {
  displayInMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  displayToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrimaryFieldConfiguration = {
  __typename?: 'PrimaryFieldConfiguration';
  name: PrimaryLineItemFields;
};

export type PrimaryFieldConfigurationInput = {
  name: PrimaryLineItemFields;
};

export type PrimaryLineItemFields =
  | 'lineTotalPrice'
  | 'name'
  | 'packSize'
  | 'price'
  | 'productId'
  | 'quantity'
  | 'sellerProductCode'
  | 'unit'
  | '%future added value';

export type ProcessingTransmissionFilter = {
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Product = Node & {
  __typename?: 'Product';
  /** price either for chat or catalog depending on the context it is returned */
  appliedCatalogPrice?: Maybe<Scalars['Int']['output']>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  baseUnit?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.price` or `VendorItemUnit.displayProperties` or `VendorItemUnit.buyerProperties` instead */
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  category?: Maybe<ProductCategory>;
  /**
   * Retrieves chat product features based on:
   * 1. Provided chatId.
   * 2. If not provided, uses context.source._chatId.
   * Returns null if no chatId is found.
   */
  chatProductFeatures?: Maybe<ChatProductFeatures>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: Maybe<Scalars['String']['output']>;
  /** Place order for product on or before cutOffTime to ensure next day delivery */
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * Shows the earliest delivery date of a product and whether the clients should display it.
   * Can be calculate as 'earliestDeliveryDate = today + leadTime'
   * I.e. if today is the 2023-01-01 and leadTime is 2 days, then the
   * earliestDeliveryDate would be 2023-01-03.
   * If a product can not be delivered at the first available delivery date,
   * according to a supplier's delivery settings, 'showEarliestDeliveryDate' will be true.
   */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.price` instead */
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  /** An optional description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** discounted price for catalog product */
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  /** resolved in getProductsForChat */
  discountedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * Returns the URL to view the main Product image.
   * For the Supplier user, also returns the URL to upload a new Product image.
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `VendorItemUnit.images` or `vendorItemUnitsImagesUpload` instead
   */
  displayImage?: Maybe<ProductImage>;
  ean?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hasVariantsInCatalog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['AWSURL']['output']>;
  inProductList?: Maybe<Scalars['Boolean']['output']>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItemUnit.isInOrderGuide` instead */
  isSelectedInOrderGuide?: Maybe<IsSelectedInOrderGuideResponse>;
  /**
   * The number of days required for a supplier to first order a product
   * from a manufacturer before it can become available for order fulfilment
   */
  leadTime?: Maybe<Scalars['Int']['output']>;
  /** Price of item in catalog and not price that buyer will pay */
  listPrice?: Maybe<Scalars['Float']['output']>;
  minimumFractionalAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** resolved in getProductsForChat */
  negotiatedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  primaryCatalogCategory?: Maybe<Scalars['String']['output']>;
  subCatalogs?: Maybe<Array<Scalars['String']['output']>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  /**
   * Adding supplier here as we need to obtain supplier details of each catalog product
   * This is meant to be used only Marketplace for now.
   */
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  /**
   * Returns the value of the Customer-Specific Price for a given Buyer.
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `VendorItemUnit.price` instead
   */
  supplierNegotiatedPrice?: Maybe<SupplierNegotiatedPrice>;
  unit?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  uploadID?: Maybe<Scalars['String']['output']>;
  variantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** resolved in getProductsForChat */
  variantsInCatalog?: Maybe<Array<Product>>;
  variantsInProductList?: Maybe<Array<Product>>;
  /** Bridge from the old catalog Product type to the new VendorItemUnit type. */
  vendorItemUnit?: Maybe<VendorItemUnit>;
  /** Timestamps to verify product version for order creation */
  versionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
};


export type ProductBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductChatProductFeaturesArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductDerivedPriceForOrderGuideArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProductIsSelectedInOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductSupplierNegotiatedPriceArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductBuyerCommentsNotAllowedError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductBuyerCommentsNotAllowedError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** IDs of the products that have buyer comments */
  productIds: Array<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ProductCategory = Node & {
  __typename?: 'ProductCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
};

export type ProductDeliveryDateCondition = {
  __typename?: 'ProductDeliveryDateCondition';
  /** earliestDeliveryDate is sent in the timezone of the supplier */
  earliestDeliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  showEarliestDeliveryDate: Scalars['Boolean']['output'];
};

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductFilter = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  subCatalogs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductGrowthRate = {
  __typename?: 'ProductGrowthRate';
  growthRate: Scalars['String']['output'];
  orderAmountsHistory: Array<Maybe<Scalars['Int']['output']>>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  /** url of 900x900 pixel crop of product image */
  largeSquare?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of product image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of product image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url to put new product image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded product image */
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryInput>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** url to download product image */
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
  /** Product variants provided like variant1;variant2;variant3 */
  variantTypes?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLeadTimeError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductLeadTimeError';
  /** IDs of the products that cannot be delivered within the selected delivery date */
  invalidProductIds: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ProductLeadTimeFailure = {
  __typename?: 'ProductLeadTimeFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type ProductMatchedBy =
  | 'cache'
  | 'cacheV2'
  | 'externalId'
  | 'name'
  | 'search'
  | '%future added value';

export type ProductMatchingConfidence = {
  __typename?: 'ProductMatchingConfidence';
  isProductAmountCorrect?: Maybe<Scalars['Boolean']['output']>;
  isProductCorrect?: Maybe<Scalars['Boolean']['output']>;
  productId: Scalars['ID']['output'];
};

export type ProductNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ProductRef = {
  __typename?: 'ProductRef';
  id: Scalars['ID']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  node?: Maybe<Product>;
};

export type ProductSearchResult = {
  __typename?: 'ProductSearchResult';
  /** @deprecated Not returned for LOX Suppliers */
  hits: Array<Product>;
  total: Scalars['Int']['output'];
};

export type ProductsCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type ProductsUnavailableFailure = {
  __typename?: 'ProductsUnavailableFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  /** url of 1125 x 600 crop of cover photo, this is only valid for supplier coverPhoto */
  largeRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 900x900 pixel crop of profile image */
  largeSquare?: Maybe<Scalars['String']['output']>;
  /** url of 180x180 pixel crop of profile image */
  largeThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 750 x 400 crop of cover photo, this is only valid for supplier coverPhoto */
  mediumRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of profile image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 120x120 pixel crop of profile image */
  mediumThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 375 x 200 crop of cover photo, this is only valid for supplier coverPhoto */
  smallRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of profile image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url of 60x60 pixel crop of profile image */
  smallThumbnail?: Maybe<Scalars['String']['output']>;
  /** url to put new profile image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded profile image */
  url?: Maybe<Scalars['String']['output']>;
};

export type PromoPageContent = {
  __typename?: 'PromoPageContent';
  promoPageBannerImageUrl: Scalars['String']['output'];
  promoPageDescription: Scalars['String']['output'];
  promoPageTitle: Scalars['String']['output'];
};

export type PromotedVendorItemUnitVariant = {
  __typename?: 'PromotedVendorItemUnitVariant';
  /** ID of the chat context */
  chatId: Scalars['ID']['output'];
  /** ID of the supplier */
  supplierId: Scalars['ID']['output'];
  /** The specific ID of this product variant from this supplier in this chat */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type PuppyValidationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'PuppyValidationFailure';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type PurchaseOrder = Node & {
  __typename?: 'PurchaseOrder';
  buyer: PurchasingBusiness;
  buyerPONumber?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  currencyConfiguration?: Maybe<CurrencyConfiguration>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  dispatchDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSync?: Maybe<Scalars['AWSTimestamp']['output']>;
  lineItems: Array<LineItem>;
  parsedPurchaseOrders: Array<ParsedPurchaseOrder>;
  primaryLineItemFields: Array<PrimaryLineItemFields>;
  reviewStatus: PurchaseOrderReviewStatus;
  secondaryLineItemFields: Array<SecondaryLineItemFields>;
  seller?: Maybe<PurchasingBusiness>;
  sellerApprovalNumber?: Maybe<Scalars['String']['output']>;
  sellerPONumber?: Maybe<Scalars['String']['output']>;
  syncStatus: PurchaseOrderSyncStatus;
};

export type PurchaseOrderConnection = Connection & {
  __typename?: 'PurchaseOrderConnection';
  edges: Array<PurchaseOrderEdge>;
  pageInfo: PageInfo;
};

export type PurchaseOrderDeletedNotification = {
  __typename?: 'PurchaseOrderDeletedNotification';
  purchaseOrderId: Scalars['ID']['output'];
};

export type PurchaseOrderEdge = Edge & {
  __typename?: 'PurchaseOrderEdge';
  cursor: Scalars['String']['output'];
  node: PurchaseOrder;
};

export type PurchaseOrderReviewStatus =
  | 'completed'
  | 'pending'
  | 'rejected'
  | '%future added value';

export type PurchaseOrderSubscriptionResponse = AuthorizationFailure | PurchaseOrderDeletedNotification | PurchaseOrderUpdatedNotification | PurchasingTransmissionCreatedNotification | PurchasingTransmissionProcessedNotification;

export type PurchaseOrderSyncStatus =
  | 'notSynced'
  | 'partiallySynced'
  | 'synced'
  | '%future added value';

export type PurchaseOrderUpdatedNotification = {
  __typename?: 'PurchaseOrderUpdatedNotification';
  purchaseOrderId: Scalars['ID']['output'];
};

export type PurchasingBusiness = {
  __typename?: 'PurchasingBusiness';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  currencyConfiguration?: Maybe<CurrencyConfiguration>;
  externalId?: Maybe<Scalars['String']['output']>;
  fieldConfigurations: Array<FieldConfiguration>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type PurchasingBusinessInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  currencyConfiguration?: InputMaybe<CurrencyConfigurationInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fieldConfigurations?: InputMaybe<Array<FieldConfigurationInput>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PurchasingDocument = {
  __typename?: 'PurchasingDocument';
  contentType: Scalars['String']['output'];
  documentType?: Maybe<PurchasingDocumentTypes>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PurchasingDocumentTypes =
  | 'deliverySlip'
  | 'invoice'
  | 'packingList'
  | 'purchasingOrder'
  | 'purchasingOrderAcknowledgement'
  | '%future added value';

export type PurchasingTransmission = {
  __typename?: 'PurchasingTransmission';
  createdAt: Scalars['AWSTimestamp']['output'];
  documentType?: Maybe<PurchasingDocumentTypes>;
  id: Scalars['ID']['output'];
  seller?: Maybe<PurchasingBusiness>;
  status: PurchasingTransmissionStatus;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type PurchasingTransmissionCreatedNotification = {
  __typename?: 'PurchasingTransmissionCreatedNotification';
  purchasingTransmissionId: Scalars['ID']['output'];
};

export type PurchasingTransmissionFile = {
  __typename?: 'PurchasingTransmissionFile';
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PurchasingTransmissionInput = {
  documentType?: InputMaybe<PurchasingDocumentTypes>;
  mediaElements: Array<PurchasingTransmissionMediaElementInput>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  tradePartnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchasingTransmissionMediaElementInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type PurchasingTransmissionProcessedNotification = {
  __typename?: 'PurchasingTransmissionProcessedNotification';
  purchasingTransmissionId: Scalars['ID']['output'];
};

export type PurchasingTransmissionStatus =
  | 'completed'
  | 'processing'
  | '%future added value';

export type PushEndpointResponse = NotificationPreferences;

export type PushNotificationPlatform =
  | 'android'
  | 'ios'
  | '%future added value';

export type QbdCredentials = {
  __typename?: 'QbdCredentials';
  fileUrl: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type QboCustomersAndOrderGuidesToImport = {
  __typename?: 'QboCustomersAndOrderGuidesToImport';
  fileUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  billingDocumentDownloadUrl: BillingDocumentDownloadUrlResponse;
  billingDocumentExportStatus: BillingDocumentExportStatusResponse;
  billingDocumentSearch: BillingDocumentSearchResponse;
  /** only admin can access the blocked email */
  blockedEmail?: Maybe<BlockedEmail>;
  /** The max number of first is 30 */
  blockedEmails?: Maybe<BlockedEmailConnection>;
  broadcast: Broadcast;
  /**
   * Returns and searches Products in a given Supplier's catalog.
   * Can be called by: Choco Admin, user of this Supplier
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemsForVendor` or `vendorItemUnitsForVendorSearch` instead
   */
  browseCatalog: BrowseCatalogResponse;
  /**
   * Returns and searches Products for a given Chat.
   * Can be called by: Choco Admin, Supplier User or Buyer User
   * Supplier/Buyer users must be in the chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemsForChat` or `vendorItemsForChatSearch` instead
   */
  browseCatalogForChat: BrowseCatalogForChatResponse;
  bulkOrderPdf: Scalars['String']['output'];
  buyer?: Maybe<Buyer>;
  buyerBillingDocumentSearch: BuyerBillingDocumentSearchResponse;
  buyerFacets?: Maybe<Array<BuyerFacetsResponse>>;
  buyerStockCount: BuyerStockCountResponse;
  buyerStockCounts: BuyerStockCountsResponse;
  buyerStockInventory: BuyerStockInventoryResponse;
  buyerStockInventoryExportUrl: BuyerStockInventoryExportUrlResponse;
  buyerUser?: Maybe<BuyerUser>;
  buyerUsers: Array<BuyerUser>;
  /** get the cart */
  cart?: Maybe<CartResponse>;
  cartRecommendations: CartRecommendationsResponse;
  /**
   * Get list of available product attributes (allergens and dietary preferences) and their possible values for a vendor.
   * Can be called by: Choco Admins, users of the Supplier.
   */
  catalogAttributes: CatalogAttributesResponse;
  /** Query to get the current status of a catalog export job. */
  catalogExportStatus: CatalogExportStatusResponse;
  /** Query to get the current status of a catalog import job. */
  catalogImportStatus: CatalogImportStatusResponse;
  /** Query to get the catalog import template. */
  catalogImportTemplate: CatalogImportTemplateResponse;
  /** Query to get the list of catalog imports. */
  catalogImports: CatalogImportsResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2Categories` or `orderGuideV2ItemUnits` instead */
  categoryProducts: Array<CategoryProducts>;
  chat?: Maybe<Chat>;
  chatHasSupplierEmailSupport: ChatHasSupplierEmailSupportResponse;
  /** Get supplier chat-level notification preferences */
  chatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  /** Get supplier chat-level notification preferences */
  chatNotificationPreferencesV2?: Maybe<ChatNotificationPreferences>;
  /**
   * Get the prices visibility override for a chat.
   * Can be called by: Choco Admins, users of the Supplier to whom the chat belongs.
   */
  chatPricesVisibility: ChatPricesVisibilityResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2ItemUnits` instead */
  chatProducts?: Maybe<Array<Product>>;
  /**
   * return a sub catalog of chat, ACL: chat user
   * @deprecated Does not work for LOX Suppliers. Use browseCatalogForChat query instead
   */
  chatSubCatalogProducts: ChatSubCatalogProductsResponse;
  /** Get chatUsers by chatId XOR userId */
  chatUsers: Array<ChatUser>;
  /**
   * If you're logged in as an admin you need to provide a userId
   * If you're logged in as a Choco user, it returns the requested chats for _your_ userId
   */
  chats: UserChatConnection;
  /**
   * For use during the by a supplier invitation flow
   * Returns true if there is no buyer with a matching googlePlaceId
   * Returns true if there is a buyer with a matching googlePlaceId
   * and the supplier does not have a chat with that buyer
   * Returns false if a buyer exists with a matching googlePlaceId
   * and the supplier already has a chat with that buyer
   */
  checkInviteeGooglePlace: Scalars['Boolean']['output'];
  /**
   * Returns company legal details.
   * This query relies on the external Two.inc lookup ID, making it specific to Two.inc implementation.
   */
  companyDetailsTwoIncProxy: CompanyDetailsTwoIncProxyResponse;
  countSupplierChats: Scalars['Int']['output'];
  creditCheck: CreditCheckResponse;
  /**
   * Get chats assigned to a custom catalog. The result set is paginated.
   * Maximum and default page size is 50 items.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogChats: CustomCatalogChatsResponse;
  /** Query to get the current status of a customCatalog import job. */
  customCatalogFullImportStatus: CustomCatalogFullImportStatusResponse;
  /**
   * Get custom catalogs by ids
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogs: CustomCatalogsResponse;
  /**
   * Get custom catalogs for a particular vendor.
   * This result set is paginated and you can also filter by chatId.
   * Maximum and default page size is 100 items.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  customCatalogsForVendor: CustomCatalogsForVendorResponse;
  echo: EchoResponse;
  /**
   * Retrieves SFTP users based on the provided filter and pagination parameters.
   * Can be called by: Authorized users with appropriate SFTP management permissions.
   */
  erpSftpUser: ErpSftpUsersResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `catalogExportStart` instead */
  exportSupplierProducts: Array<Product>;
  fetchBuyerReportDownloadUrl: FetchBuyerReportDownloadUrlResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `vendorItemCategoriesForVendor` instead */
  fetchCatalogCategories: Array<CatalogCategory>;
  /** @deprecated Does not work for LOX Suppliers. Use `vendorItemCategoriesForChat` instead */
  fetchCatalogCategoriesForChat: FetchCatalogCategoriesForChatResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2Categories` or `orderGuideV2ItemUnits` instead */
  fetchOrderGuide: OrderGuideResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `VendorItem.units` instead */
  fetchProductVariantsForBuyer?: Maybe<Array<Product>>;
  /** Generate the quicksight embed dashboard url for an anonymous user */
  generateEmbedDashboardUrl: EmbedDashboardUrlResponse;
  /** Get ad context for a specific buyer and ad zone */
  getAdContext?: Maybe<GetAdContextResponse>;
  /** Fetch all buyer report schedules created by user */
  getAllBuyerReportSchedules: GetAllBuyerReportSchedulesResponse;
  /**
   * Admin only!
   *
   * Get all chats by buyer. Supports pagination, but only in one direction.
   */
  getAllChatsByBuyer: GetAllChatsByBuyerResponse;
  /**
   * Admin only!
   *
   * Get all chats by supplier. Supports pagination, but only in one direction.
   */
  getAllChatsBySupplier: GetAllChatsBySupplierResponse;
  /**
   * Returns the deliverySetting that is used for a specific chat.
   * This query is used by mobile applications.
   *
   * If there is only a chat setting, the chat setting will be returned.
   * If there is only a supplier setting, the supplier setting will be returned.
   * if there are both, a supplier and a chat setting, the cutoffTimes will correspond to the chat setting,
   * while the exceptions will be an aggregate of supplier and chat setting.
   *
   * If no setting exists for this chat, a default setting will be returned.
   * On this default setting, every weekday will be of type 'NoCutoff'
   */
  getAppliedChatDeliverySetting?: Maybe<AppliedChatDeliverySettingResponse>;
  /** Accepts promotion title and message and returns a list of suggested by AI products */
  getBroadcastProductsSuggestions?: Maybe<SuggestedProductResult>;
  /** @deprecated Use getContactInfos query with contactType: Buyer instead */
  getBuyerContactInfos: GetBuyerContactInfosResponse;
  getBuyerSegmentContentByChat?: Maybe<GetBuyerSegmentContentByChatResponse>;
  /** @deprecated Does not work for LOX Suppliers. Use `catalogImportStart` instead */
  getCatalogUploadUrl: GetCatalogUploadUrlResponse;
  /** Get the number of chats that have an email as an additionalEmail */
  getChatCountByCCEmail: GetChatCountByCcEmailResponse;
  getChatSuppliersByLocations: GetChatSuppliersByLocationsResponse;
  getChatsByChatIds: GetChatsByChatIdsResponse;
  /**
   * Returns Chats assigned to a given Custom Catalog
   * Can be called by: Choco Admin, Supplier User
   * Supplier must own the Custom Catalog
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `customCatalogChats` instead
   */
  getChatsForSubCatalog: GetChatsForSubCatalogResponse;
  getConnectedAccounts: GetConnectedAccountsResponse;
  getConnectedIntegrationAdapters: GetConnectedIntegrationAdaptersResponse;
  /**
   * Retrieve contact information for a specific supplier with filtering and search capabilities.
   * Supports filtering by contact type (buyer, supplier, or both) and searching by contact details.
   */
  getContactInfos: GetContactInfosResponse;
  getCustomerInsights?: Maybe<CustomerInsightsResponse>;
  getCustomerInsightsNotification?: Maybe<GetCustomerInsightsNotificationResponse>;
  getCustomerInsightsNotifications: GetCustomerInsightsNotificationsResponse;
  getCustomerLabelsV2: SupplierLabelsResponse;
  getCustomerOrdersInsights?: Maybe<CustomerOrdersInsightsResponse>;
  getCustomerOrdersInsightsV2?: Maybe<CustomerOrdersInsightsResponseV2>;
  /** Get a single distributor note by ID */
  getDistributorNote?: Maybe<GetDistributorNoteQueryResponse>;
  /** Get all distributor notes for a customer */
  getDistributorNotes?: Maybe<GetDistributorNotesQueryResponse>;
  /** Get promoted content from Dx for display in buyer apps */
  getDistributorPromotedContent: GetDistributorPromotedContentResponse;
  /** Get a single distributor task by ID */
  getDistributorTask: GetDistributorTaskResponse;
  /** Get distributor tasks based on filters */
  getDistributorTasks: GetDistributorTasksResponse;
  /** Get a document scan by id */
  getDocumentScan: GetDocumentScanResponse;
  /** get signed URL for uploading attachments */
  getDocumentScanAttachmentUploadLink: GetDocumentScanAttachmentUploadLinkResponse;
  /** Get a document scan by lead id */
  getDocumentScanList: GetDocumentScanListResponse;
  /** Retrieve the download URL for the email editor state associated with a campaign. */
  getEmailEditorState: GetEmailEditorStateResponse;
  getEmailLists: GetEmailListsResponse;
  getExportPurchaseOrderJob: GetExportPurchaseOrderJobResponse;
  getFeatureFlags: GetFeatureFlagsResponse;
  getIntegrationAdapters: GetIntegrationAdaptersResponse;
  /** Invite Transmission Status */
  getInviteTransmissionStatus: GetInviteTransmissionStatusResponse;
  /**
   * As a supplier: check if an invitee already has a choco account
   * If no: returns UserNotFound type
   * If yes: returns paginated list of buyers the invitee is connected to
   * that the supplier does not have a chat with.
   */
  getInviteeBuyers?: Maybe<GetInviteeBuyersResponse>;
  /** @deprecated No longer supported since Jun 2024 */
  getInvoiceAttachment?: Maybe<InvoiceAttachment>;
  getLastMessageFromChat?: Maybe<MessagesFromChatResult>;
  getLocationsBySupplier: LocationsBySupplierResponse;
  /** Retrieve a marketing campaign */
  getMarketingCampaign: GetMarketingCampaignResponse;
  /** Generate signed URLs for uploading html templates */
  getMarketingCampaignContentUploadLink: GetMarketingCampaignContentUploadLinkResponse;
  /** Retrieve a marketing campaign email sender for a specific supplier */
  getMarketingCampaignEmailSender: GetMarketingCampaignEmailSenderResponse;
  /** Generate signed URLs for uploading and accessing media files in the CDN */
  getMarketingCampaignMediaUploadLink: GetMediaUploadLinkResponse;
  getMarketingMessageSuggestions: MarketingMessageSuggestionsResult;
  /** Get a menu scan by id */
  getMenuScan: GetMenuScanResponse;
  /** get signed URL for uploading attachments */
  getMenuScanAttachmentUploadLink: GetMenuScanAttachmentUploadLinkResponse;
  /** Get a menu scan by lead id */
  getMenuScanList: GetMenuScanListResponse;
  getOCORerankedProducts: GetOcoRerankedProductsResponse;
  getOmniChannelOrder: GetOmniChannelOrderResponse;
  getOmniChannelOrderV2: GetOmniChannelOrderResponse;
  getOnboardingChecklist: GetOnboardingChecklistResponse;
  getOrder: GetOmniChannelOrderResponse;
  getOrderChanges?: Maybe<OrderChange>;
  /** @deprecated Use getContactInfos query with contactType: Supplier instead */
  getOrderChannelContactInfos: GetOrderChannelContactInfosResponse;
  /** Fetch entire delivery check */
  getOrderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  getOrderExcelUrl?: Maybe<Scalars['String']['output']>;
  /** For internal use, retrieves the order preference of a supplier */
  getOrderPreference?: Maybe<OrderPreference>;
  /** @deprecated Does not work for LOX Suppliers. Use `vendorItemUnits` instead */
  getProductsForChat: GetProductsForChatResponse;
  getPurchaseOrder: GetPurchaseOrderResponse;
  getPurchasingBusinessByExternalId: GetPurchasingBusinessByExternalIdResponse;
  getPurchasingPartners: GetPurchasingPartnersResponse;
  getQboCustomersAndOrderGuidesToImport: GetQboCustomersAndOrderGuidesToImportResponse;
  getReconciliationRequestPlanBySupplierId?: Maybe<GetReconciliationRequestPlanBySupplierIdResponse>;
  getReferral?: Maybe<GetReferralResponse>;
  getRequestsToJoin: GetRequestsToJoinResponse;
  getSalesFunnelDefinition?: Maybe<GetSalesFunnelDefinitionQueryResponse>;
  getSalesFunnelLead?: Maybe<GetSalesFunnelLeadQueryResponse>;
  getSalesFunnelLeads?: Maybe<GetSalesFunnelLeadsQueryResponse>;
  getSalesFunnelLeadsForMap?: Maybe<GetSalesFunnelLeadsForMapQueryResponse>;
  /** Get a prospect from a place ID. */
  getSalesFunnelProspectFromPlaceId?: Maybe<GetSalesFunnelProspectsFromPlaceIdQueryResponse>;
  /** Get prospects from a free text query. */
  getSalesFunnelProspectsFromFreeText?: Maybe<GetSalesFunnelProspectsFromFreeTextQueryResponse>;
  getSalesFunnelStatistics?: Maybe<GetSalesFunnelStatisticsQueryResponse>;
  getSalesFunnels?: Maybe<GetSalesFunnelsQueryResponse>;
  /**
   * Retrieve the leads which are nearby a given location. The
   * definition of nearby is left to policy on the backend.
   */
  getSimilarSalesFunnelLeads?: Maybe<GetSimilarSalesFunnelLeadsConnection>;
  getSmsMessageByMessageSid: GetSmsMessageByMessageSidResponse;
  getSmsMessagesFromPhoneNumber: GetSmsMessagesFromPhoneNumberResponse;
  /**
   * Returns information of a given Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `customCatalogs` instead
   */
  getSubCatalog?: Maybe<GetSubCatalogResponse>;
  /**
   * Returns Custom Catalogs assigned to a given Chat
   * Can be called by: Choco Admin, Supplier User
   * Supplier user must be in the Chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  getSubCatalogsForChat: GetSubCatalogsForChatResponse;
  getSupplierApplications: GetSupplierApplicationsResponse;
  /**
   * Returns specific Catalog Products by their IDs for a given Supplier.
   * Can be called by: Choco Admin, Supplier User
   * Supplier must own the Products
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `vendorItemUnits` instead
   */
  getSupplierProducts: GetSupplierProductsResponse;
  getTransmission?: Maybe<GetTransmissionResponse>;
  getTransmissionBySesMessageId: GetTransmissionBySesMessageIdResponse;
  /**
   * For internal use, submit list of buyer ids and a supplier id
   * Returns which buyers the supplier does not have a chat with
   */
  getUnconnectedBuyerIds: GetUnconnectedBuyerIdsResult;
  getUploadedOrder: GetUploadedOrderResponse;
  getUserIntercomCredentials: UserIntercomCredentialsResponse;
  getWhatsAppMessageByMessageSid: GetWhatsAppMessageByMessageSidResponse;
  hasUserCompletedDeliveryCheck: HasUserCompletedDeliveryCheckResponse;
  inventoryDownloadJobs: InventoryDownloadJobsResponse;
  inventorySuppliers: InventorySuppliersResponse;
  inventoryUploadJob: InventoryUploadJobResponse;
  inventoryUploadTemplate: InventoryUploadTemplateResponse;
  isUserInChat: Scalars['Boolean']['output'];
  listProcessingTransmissions: ListProcessingTransmissionsResponse;
  listPurchaseOrders: ListPurchaseOrdersResponse;
  listPurchasingTransmissions: ListPurchasingTransmissionsResponse;
  /**
   * Returns products in a given Custom Catalog.
   * Can be called by: Choco Admin, user of a Supplier to whom that Custom Catalog belongs
   * @deprecated Works partially for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user. Avoid using in the new code. Use `vendorItemsForVendor` or `vendorItemUnitsForVendorSearch` instead
   */
  listSubCatalogProducts?: Maybe<ListSubCatalogProductsResponse>;
  /**
   * Returns the available Custom Catalogs for a given Supplier.
   * Can be called by: Choco Admin, user of a Supplier whose catalogs are requested
   * @deprecated This endpoints is in the maintenace mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Use `customCatalogsForVendor` instead
   */
  listSubCatalogs?: Maybe<ListSubCatalogsResponse>;
  listTransmissions: ListTransmissionsResponse;
  lookupPhoneNumbers: LookupPhoneNumbersResponse;
  /** Retrieve all marketing campaigns of a supplier, categorized by states such as draft, active, and finished */
  marketingCampaignList: MarketingCampaignListResponse;
  message?: Maybe<Message>;
  messages: ChatMessageConnection;
  /**
   * For internal use,
   * - fetch list of messages which are not sent via email and chat
   * - fetch last messages from chat
   * This two queries are executed from choco-notification only
   * Return type is kept exactly similar to the table schema since it is used as is in choco-notification
   */
  messagesNotSentViaEmailAndChat: Array<MessagesFromChatResult>;
  metaLobby?: Maybe<MetaLobbyResponse>;
  /**
   * Get individual order by id or referenceId
   * Only one identifier should be provided
   */
  order?: Maybe<Order>;
  orderGuideV2Categories: OrderGuideV2CategoriesResponse;
  orderGuideV2ItemUnits: OrderGuideV2ItemUnitsResponse;
  ordersToReview: OrdersToReviewResponse;
  paymentCustomerDirectPay: PaymentCustomerDirectPayResponse;
  paymentCustomerSearch: PaymentCustomerSearchResponse;
  paymentVendor: PaymentVendorResponse;
  paymentsFeaturesConfig: PaymentsFeaturesConfigResponse;
  pendingOrders: OrdersToReviewResponse;
  /**
   * Returns the details of the provided Catalog or Custom Product.
   * Can be called by: Choco Admin, Supplier User, Buyer User
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  product?: Maybe<Product>;
  /** @deprecated Does not work for LOX Suppliers. Use `orderGuideV2Categories` instead */
  productListCategories?: Maybe<Array<ProductCategory>>;
  refundsList: RefundsListResponse;
  /** @deprecated use searchProducts/supplierSearch/userSearch query instead */
  search: SearchResult;
  /**
   * Query used to detect existing buyers.
   * Returns a list of buyers based on the provided criteria.
   * Does not support pagination - input parameter "first" will be ignored.
   */
  searchBuyer: SearchBuyerResponse;
  /** Internal use only */
  searchCustomerChats: SearchCustomerChats;
  searchCustomerV2: SearchCustomerResponse;
  searchOrder: SearchOrderResponse;
  searchOrderDeskCustomer: SearchOrderDeskCustomerResponse;
  /** @deprecated Does not work for LOX Suppliers. Use browseCatalog query instead */
  searchProducts?: Maybe<SearchProductsResponse>;
  /** @deprecated Does not work. The feature is no longer maintained */
  searchTaxonomyLabels?: Maybe<SearchTaxonomyLabelsResponse>;
  sendSampleSmsMessage: SendSampleSmsMessageResponse;
  settlementReport: SettlementReportResponse;
  /** @deprecated Does not work for LOX Suppliers. Use `BroadcastAttachment.products` instead */
  sharedBroadcastProducts?: Maybe<SharedBroadcastProducts>;
  stockCountSessions: StockCountSessionsResponse;
  stockCountUsers: StockCountUsersResponse;
  storageAreas: StorageAreasResponse;
  supplier?: Maybe<Supplier>;
  supplierAssortments: SupplierAssortments;
  supplierChatLabels?: Maybe<Array<ChatLabelsResult>>;
  /** Returns the available delivery dates, used in the checkout process when creating an order. */
  supplierDeliveryDateSettings?: Maybe<SupplierDeliveryDateSettingsResponse>;
  /**
   * Returns the deliverySetting for a supplier.
   * The input can be a chat- or supplier-id.
   * If the input is a chatId, the return value will be a chat-setting or null.
   */
  supplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  /**
   * Get the list of validation rules that this user can override when reviewing orders for a specific supplier.
   * Returns an empty array if no override permissions are configured.
   */
  supplierOrderOverridePermissions: SupplierOrderOverridePermissionsResponse;
  supplierSearch: SupplierSearchResponse;
  supplierSearchV2: SupplierSearchResponse;
  /** Get all transmission events of an order (ofId=orderId). Sorted by timestamp (descending). */
  transmissionEvents: Array<TransmissionEvent>;
  transmissions: TransmissionsResponse;
  user?: Maybe<User>;
  /** The query will currently be used to obtain chats for both buyer chats and user chats */
  userChats: UserChatsResponse;
  userCognitoState: UserCognitoStateResponse;
  userSearch: UserSearchResponse;
  /** @deprecated Twilio changed the behaviour of a dependency endpoint; it no longer accurate reflects the user's Twilio state */
  userTwilioState: UserTwilioStateResponse;
  /**
   * Checks if the Products are available in the given Chat.
   * Can be called by: Choco Admin, Supplier User or Buyer User
   * Supplier/Buyer users must be in the Chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  validateProductsAvailability: ValidateProductsAvailabilityResponse;
  /**
   * Looks up vendor catalog categories for a given chat based on the provided filters.
   * This query returns only the categories that are visible to the buyer and have at least one item available for this chat.
   * The results are ordered by the translated category name.
   * Maximum and default page size is 200 items.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemCategoriesForChat: VendorItemCategoriesForChatResponse;
  /**
   * Looks up vendor catalog categories for a given vendor based on the provided filters.
   * This query returns only the categories that have at least one item available for this vendor.
   * The results are ordered by the translated category name.
   * Maximum and default page size is 200 items.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  vendorItemCategoriesForVendor: VendorItemCategoriesForVendorResponse;
  /**
   * Get vendor item units by ids or legacyIds (e.g. for cart).
   * Maximum 50 ids can be provided at once.
   * Can be called by: Any user.
   */
  vendorItemUnits: VendorItemUnitsResponse;
  /**
   * Searches vendor items in the context of a Supplier catalog.
   * All units are returned in a flattened list.
   * Can be called by: Choco Admins, Supplier users.
   */
  vendorItemUnitsForVendorSearch: VendorItemsForVendorResponse;
  /**
   * Returns vendor items by their ids.
   * Can be called by: Any user.
   */
  vendorItems: VendorItemsResponse;
  /**
   * Returns count of vendor items for a given chat based on the provided filters.
   * Note that only one item per variant group is considered.
   * This corresponds to the result of the `vendorItemsForChat` query.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemsCountForChat: VendorItemsCountForChatResponse;
  /**
   * Looks up vendor items for a given chat based on the provided filters.
   * This query returns only the default units for each item, and only the default item variant for each variant group.
   * The results are ordered by the translated item name.
   * Maximum page size is 50 items. Default page size is 20 items.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemsForChat: VendorItemsForChatResponse;
  /**
   * Searches vendor items in the context of a chat.
   * Only the most relevant unit will be returned for each item.
   * Other units are available in the `vendorItem.units` field.
   * Can be called by: Choco Admins, Buyer and Supplier users from the chat.
   */
  vendorItemsForChatSearch: VendorItemsForChatResponse;
  /** @deprecated This endpoint was created temporary for the search POC. It is not maintained. */
  vendorItemsForChatSearchPOC: VendorItemsForChatResponse;
  /**
   * Looks up vendor items for a given vendor based on the provided filters.
   * This query returns all units for each item without the grouping by variantGroupCode or id.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  vendorItemsForVendor: VendorItemsForVendorResponse;
};


export type QueryBillingDocumentDownloadUrlArgs = {
  input: BillingDocumentDownloadUrlInput;
};


export type QueryBillingDocumentExportStatusArgs = {
  input: BillingDocumentExportStatusInput;
};


export type QueryBillingDocumentSearchArgs = {
  input: BillingDocumentSearchInput;
};


export type QueryBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryBlockedEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBroadcastArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryBrowseCatalogArgs = {
  input: BrowseCatalogInput;
};


export type QueryBrowseCatalogForChatArgs = {
  input: BrowseCatalogForChatInput;
};


export type QueryBulkOrderPdfArgs = {
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  orderIds: Array<Scalars['ID']['input']>;
};


export type QueryBuyerArgs = {
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBuyerBillingDocumentSearchArgs = {
  input: BuyerBillingDocumentSearchInput;
};


export type QueryBuyerStockCountArgs = {
  input: GetBuyerStockCountInput;
};


export type QueryBuyerStockCountsArgs = {
  input: GetBuyerStockCountsInput;
};


export type QueryBuyerStockInventoryArgs = {
  filter: GetBuyerStockInventoryProductsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};


export type QueryBuyerStockInventoryExportUrlArgs = {
  input: GetBuyerStockInventoryExportUrlInput;
};


export type QueryBuyerUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBuyerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCartArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryCartRecommendationsArgs = {
  input: CartRecommendationsInput;
};


export type QueryCatalogAttributesArgs = {
  input: CatalogAttributesInput;
};


export type QueryCatalogExportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCatalogImportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCatalogImportsArgs = {
  input: CatalogImportsInput;
};


export type QueryCategoryProductsArgs = {
  chatId: Scalars['ID']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryChatHasSupplierEmailSupportArgs = {
  chatId: Scalars['ID']['input'];
  checkExcludedSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatNotificationPreferencesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatNotificationPreferencesV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryChatPricesVisibilityArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatProductsArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatSubCatalogProductsArgs = {
  input?: InputMaybe<ChatSubCatalogProductsInput>;
};


export type QueryChatUsersArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCheckInviteeGooglePlaceArgs = {
  googlePlaceId: Scalars['String']['input'];
};


export type QueryCompanyDetailsTwoIncProxyArgs = {
  lookupId: Scalars['String']['input'];
};


export type QueryCountSupplierChatsArgs = {
  chatStatus?: InputMaybe<ChatStatus>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierEntityId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreditCheckArgs = {
  input: CreditCheckInput;
};


export type QueryCustomCatalogChatsArgs = {
  input: CustomCatalogChatsInput;
};


export type QueryCustomCatalogFullImportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCustomCatalogsArgs = {
  input: CustomCatalogsInput;
};


export type QueryCustomCatalogsForVendorArgs = {
  input: CustomCatalogsForVendorInput;
};


export type QueryEchoArgs = {
  input: EchoInput;
};


export type QueryErpSftpUserArgs = {
  input: ErpSftpUsersInput;
};


export type QueryExportSupplierProductsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFetchBuyerReportDownloadUrlArgs = {
  input: FetchBuyerReportDownloadUrlInput;
};


export type QueryFetchCatalogCategoriesArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFetchCatalogCategoriesForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryFetchOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
  product: OrderGuideProductArgs;
};


export type QueryFetchProductVariantsForBuyerArgs = {
  chatId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetAdContextArgs = {
  input: GetAdContextInput;
};


export type QueryGetAllBuyerReportSchedulesArgs = {
  input: GetAllBuyerReportSchedulesInput;
};


export type QueryGetAllChatsByBuyerArgs = {
  input: GetAllChatsByBuyerInput;
};


export type QueryGetAllChatsBySupplierArgs = {
  input: GetAllChatsBySupplierInput;
};


export type QueryGetAppliedChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetBroadcastProductsSuggestionsArgs = {
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBuyerContactInfosArgs = {
  input: GetBuyerContactInfosInput;
};


export type QueryGetBuyerSegmentContentByChatArgs = {
  input: GetBuyerSegmentContentByChatInput;
};


export type QueryGetCatalogUploadUrlArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetChatCountByCcEmailArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type QueryGetChatSuppliersByLocationsArgs = {
  input: GetChatSuppliersByLocationsInput;
};


export type QueryGetChatsByChatIdsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
};


export type QueryGetChatsForSubCatalogArgs = {
  subCatalogId: Scalars['ID']['input'];
};


export type QueryGetConnectedAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ConnectedAccountInput>;
};


export type QueryGetConnectedIntegrationAdaptersArgs = {
  input: GetConnectedIntegrationAdaptersInput;
};


export type QueryGetContactInfosArgs = {
  input: ContactInfosInput;
};


export type QueryGetCustomerInsightsArgs = {
  input: GetCustomerInsightsInput;
};


export type QueryGetCustomerInsightsNotificationArgs = {
  input?: InputMaybe<GetCustomerInsightsNotificationInput>;
};


export type QueryGetCustomerInsightsNotificationsArgs = {
  input: GetCustomerInsightsNotificationsInput;
};


export type QueryGetCustomerLabelsV2Args = {
  input: GetCustomerLabelsV2Input;
};


export type QueryGetCustomerOrdersInsightsArgs = {
  input: CustomerOrdersInsightsInput;
};


export type QueryGetCustomerOrdersInsightsV2Args = {
  input: CustomerOrdersInsightsInputV2;
};


export type QueryGetDistributorNoteArgs = {
  input: GetDistributorNoteQueryInput;
};


export type QueryGetDistributorNotesArgs = {
  input: GetDistributorNotesQueryInput;
};


export type QueryGetDistributorPromotedContentArgs = {
  input: GetDistributorPromotedContentInput;
};


export type QueryGetDistributorTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDistributorTasksArgs = {
  input: GetDistributorTasksInput;
};


export type QueryGetDocumentScanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentScanAttachmentUploadLinkArgs = {
  input: GetDocumentScanAttachmentUploadLinkInput;
};


export type QueryGetDocumentScanListArgs = {
  input: GetDocumentScanListInput;
};


export type QueryGetEmailEditorStateArgs = {
  input: GetEmailEditorStateInput;
};


export type QueryGetEmailListsArgs = {
  input: GetEmailListsInput;
};


export type QueryGetExportPurchaseOrderJobArgs = {
  input: GetExportPurchaseOrderJobInput;
};


export type QueryGetIntegrationAdaptersArgs = {
  input: GetIntegrationAdaptersInput;
};


export type QueryGetInviteTransmissionStatusArgs = {
  input: GetInviteTransmissionStatus;
};


export type QueryGetInviteeBuyersArgs = {
  phone: Scalars['String']['input'];
};


export type QueryGetInvoiceAttachmentArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetLastMessageFromChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetLocationsBySupplierArgs = {
  supplierEntityId: Scalars['ID']['input'];
};


export type QueryGetMarketingCampaignArgs = {
  input: GetMarketingCampaignInput;
};


export type QueryGetMarketingCampaignContentUploadLinkArgs = {
  input: GetMarketingCampaignContentUploadLinkInput;
};


export type QueryGetMarketingCampaignMediaUploadLinkArgs = {
  input: GetMediaUploadLinkInput;
};


export type QueryGetMarketingMessageSuggestionsArgs = {
  currentMessage: Scalars['String']['input'];
};


export type QueryGetMenuScanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMenuScanAttachmentUploadLinkArgs = {
  input: GetMenuScanAttachmentUploadLinkInput;
};


export type QueryGetMenuScanListArgs = {
  input: GetMenuScanListInput;
};


export type QueryGetOcoRerankedProductsArgs = {
  input: GetOcoRerankedProductsInput;
};


export type QueryGetOmniChannelOrderArgs = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOmniChannelOrderV2Args = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOnboardingChecklistArgs = {
  buyerId: Scalars['ID']['input'];
};


export type QueryGetOrderArgs = {
  input: GetOrderInput;
};


export type QueryGetOrderChangesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrderChannelContactInfosArgs = {
  input: GetOrderChannelContactInfosInput;
};


export type QueryGetOrderDeliveryCheckArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderExcelUrlArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductsForChatArgs = {
  input: GetProductsForChatInput;
};


export type QueryGetPurchaseOrderArgs = {
  input: GetPurchaseOrderInput;
};


export type QueryGetPurchasingBusinessByExternalIdArgs = {
  input: GetPurchasingBusinessByExternalIdInput;
};


export type QueryGetPurchasingPartnersArgs = {
  input: GetPurchasingPartnersInput;
};


export type QueryGetQboCustomersAndOrderGuidesToImportArgs = {
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReconciliationRequestPlanBySupplierIdArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetReferralArgs = {
  input: GetReferralInput;
};


export type QueryGetRequestsToJoinArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: GetRequestsToJoinInput;
};


export type QueryGetSalesFunnelDefinitionArgs = {
  input: GetSalesFunnelDefinitionInput;
};


export type QueryGetSalesFunnelLeadArgs = {
  input: GetSalesFunnelLeadQueryInput;
};


export type QueryGetSalesFunnelLeadsArgs = {
  input: GetSalesFunnelLeadsQueryInput;
};


export type QueryGetSalesFunnelLeadsForMapArgs = {
  input: GetSalesFunnelLeadsQueryInput;
};


export type QueryGetSalesFunnelProspectFromPlaceIdArgs = {
  input: GetSalesFunnelProspectFromPlaceIdQueryInput;
};


export type QueryGetSalesFunnelProspectsFromFreeTextArgs = {
  input: GetSalesFunnelProspectsFromFreeTextQueryInput;
};


export type QueryGetSalesFunnelStatisticsArgs = {
  input: GetSalesFunnelStatisticsQueryInput;
};


export type QueryGetSalesFunnelsArgs = {
  input: GetSalesFunnelsQueryInput;
};


export type QueryGetSimilarSalesFunnelLeadsArgs = {
  input: GetSimilarSalesFunnelLeadsQueryInput;
};


export type QueryGetSmsMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryGetSmsMessagesFromPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
};


export type QueryGetSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubCatalogsForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetSupplierApplicationsArgs = {
  query?: InputMaybe<GetSupplierApplicationsInput>;
};


export type QueryGetSupplierProductsArgs = {
  input: GetSupplierProductsInput;
};


export type QueryGetTransmissionArgs = {
  input: GetTransmissionInput;
};


export type QueryGetTransmissionBySesMessageIdArgs = {
  input?: InputMaybe<GetTransmissionBySesMessageIdInput>;
};


export type QueryGetUnconnectedBuyerIdsArgs = {
  buyerIds: Array<Scalars['String']['input']>;
  ignoreDisabledChats?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['String']['input'];
};


export type QueryGetUploadedOrderArgs = {
  uploadedOrderId: Scalars['ID']['input'];
};


export type QueryGetWhatsAppMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryHasUserCompletedDeliveryCheckArgs = {
  chatId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInventoryDownloadJobsArgs = {
  input: InventoryDownloadJobsInput;
};


export type QueryInventorySuppliersArgs = {
  input: InventorySuppliersInput;
};


export type QueryInventoryUploadJobArgs = {
  input: InventoryUploadJobInput;
};


export type QueryInventoryUploadTemplateArgs = {
  input: InventoryUploadTemplateInput;
};


export type QueryIsUserInChatArgs = {
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryListProcessingTransmissionsArgs = {
  input: ListProcessingTransmissionsInput;
};


export type QueryListPurchaseOrdersArgs = {
  input: ListPurchaseOrdersInput;
};


export type QueryListPurchasingTransmissionsArgs = {
  input: ListPurchasingTransmissionsInput;
};


export type QueryListSubCatalogProductsArgs = {
  input: ListSubCatalogProductsInput;
};


export type QueryListSubCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTransmissionsArgs = {
  input: ListTransmissionsInput;
};


export type QueryLookupPhoneNumbersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryMarketingCampaignListArgs = {
  input: MarketingCampaignListInput;
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<MessageGroupFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessagesNotSentViaEmailAndChatArgs = {
  chatId: Scalars['ID']['input'];
  isSupplier: Scalars['Boolean']['input'];
};


export type QueryMetaLobbyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderGuideV2CategoriesArgs = {
  input: OrderGuideV2CategoriesInput;
};


export type QueryOrderGuideV2ItemUnitsArgs = {
  input: OrderGuideV2ItemUnitsInput;
};


export type QueryOrdersToReviewArgs = {
  input: OrdersToReviewInput;
};


export type QueryPaymentCustomerDirectPayArgs = {
  input: PaymentCustomerDirectPayInput;
};


export type QueryPaymentCustomerSearchArgs = {
  input: PaymentCustomerSearchInput;
};


export type QueryPaymentVendorArgs = {
  input: PaymentVendorInput;
};


export type QueryPendingOrdersArgs = {
  input: PendingOrdersInput;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductListCategoriesArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryRefundsListArgs = {
  input: RefundsListInput;
};


export type QuerySearchArgs = {
  query: SearchInput;
};


export type QuerySearchBuyerArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SearchBuyerInput;
};


export type QuerySearchCustomerChatsArgs = {
  input: SearchCustomerChatsInput;
};


export type QuerySearchCustomerV2Args = {
  input: SearchCustomerV2Input;
};


export type QuerySearchOrderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SearchOrderInput;
  sort?: InputMaybe<Sort>;
};


export type QuerySearchOrderDeskCustomerArgs = {
  input: SearchOrderDeskCustomerInput;
};


export type QuerySearchProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SearchProductsInput;
};


export type QuerySearchTaxonomyLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SearchTaxonomyLabelsInput;
};


export type QuerySendSampleSmsMessageArgs = {
  input: SendSampleSmsMessageInput;
};


export type QuerySettlementReportArgs = {
  input: SettlementReportInput;
};


export type QuerySharedBroadcastProductsArgs = {
  broadcastId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};


export type QueryStockCountSessionsArgs = {
  input: StockCountSessionsInput;
  pagination?: InputMaybe<StockCountSessionsPaginationInput>;
};


export type QueryStockCountUsersArgs = {
  input: StockCountUsersInput;
};


export type QueryStorageAreasArgs = {
  input: StorageAreasInput;
};


export type QuerySupplierArgs = {
  botUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierChatLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asBotUser?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierDeliveryDateSettingsArgs = {
  chatId: Scalars['ID']['input'];
  context?: InputMaybe<DeliveryDateContext>;
};


export type QuerySupplierDeliverySettingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierOrderOverridePermissionsArgs = {
  input: SupplierOrderOverridePermissionsInput;
};


export type QuerySupplierSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SupplierSearchInput;
};


export type QuerySupplierSearchV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinateInput;
  filter?: InputMaybe<SupplierSearchV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransmissionEventsArgs = {
  ofId: Scalars['ID']['input'];
};


export type QueryTransmissionsArgs = {
  input: ListTransmissionsInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserCognitoStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: UserSearchInput;
};


export type QueryUserTwilioStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateProductsAvailabilityArgs = {
  input: ValidateProductsAvailabilityInput;
};


export type QueryVendorItemCategoriesForChatArgs = {
  input: VendorItemCategoriesForChatInput;
};


export type QueryVendorItemCategoriesForVendorArgs = {
  input: VendorItemCategoriesForVendorInput;
};


export type QueryVendorItemUnitsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryVendorItemUnitsForVendorSearchArgs = {
  input: VendorItemUnitsForVendorSearchInput;
};


export type QueryVendorItemsArgs = {
  input: VendorItemsInput;
};


export type QueryVendorItemsCountForChatArgs = {
  input: VendorItemsCountForChatInput;
};


export type QueryVendorItemsForChatArgs = {
  input: VendorItemsForChatInput;
};


export type QueryVendorItemsForChatSearchArgs = {
  input: VendorItemsForChatSearchInput;
};


export type QueryVendorItemsForChatSearchPocArgs = {
  input: VendorItemsForChatSearchInput;
};


export type QueryVendorItemsForVendorArgs = {
  input: VendorItemsForVendorInput;
};

/**
 * Exactly represents mathematical fraction: numerator/denominator.
 * Compared to Float does not have the precision issues when dealing with exact fractions.
 */
export type Rational = {
  __typename?: 'Rational';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
};

export type ReconciliationRequestConfirmed = {
  __typename?: 'ReconciliationRequestConfirmed';
  name?: Maybe<Scalars['String']['output']>;
};

export type ReconciliationRequestPlan = {
  __typename?: 'ReconciliationRequestPlan';
  name: Scalars['String']['output'];
  plan: ReconciliationRequestPlanType;
  supplierId: Scalars['ID']['output'];
};

export type ReconciliationRequestPlanBySupplierIdNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ReconciliationRequestPlanBySupplierIdNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type ReconciliationRequestPlanType =
  | 'free'
  | 'premium'
  | '%future added value';

/** Represents a rectangular geometry defined by two cartesian coordinate points. */
export type RectangleGeometry = {
  __typename?: 'RectangleGeometry';
  /** The "top right" coordinate of the rectangle. */
  northeast: Coordinate;
  /** The "bottom left" coordinate of the rectangle. */
  southwest: Coordinate;
};

/**
 * This interface defines a common schema for the reference objects.
 * A reference object can be used when there is a many-to-one relationship between entities,
 * and only the ID of the referenced object is known.
 *
 * For example:
 * If a Chat entity has a link to a Supplier, the Chat type could have
 * a field "supplier: SupplierRef" where "SupplierRef implements RefEdge".
 * The query that returns a Chat will only return "supplier: { id: chat.supplierId }" and not the full Supplier object.
 * The full Supplier object can be queried through "node" field of the "SupplierRef".
 * The resolver for the "node" field would be implemented in the supplier service.
 *
 * Using this pattern brings two benefits:
 * 1. Performance control. If the client only needs Id, it can decide not to query the "node" field.
 * 2. Domain separation. We don't need to implement the "Chat.supplier" resolver in the supplier service,
 *   and therefore keep the Supplier service unaware of the existence of the Chat›.
 */
export type RefEdge = {
  /** The ID of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<Node>;
};

export type ReferUserChatExists = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferUserChatExists';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type ReferUserInput = {
  chat: ChatCreateInput;
  referralCode: Scalars['String']['input'];
};

export type ReferUserReferralCodeNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferUserReferralCodeNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type ReferUserResponse = AuthorizationFailure | InputValidationFailure | ReferUserChatExists | ReferUserReferralCodeNotFound | ReferUserResult;

export type ReferUserResult = {
  __typename?: 'ReferUserResult';
  chat: Chat;
  cursor: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  referredUserId: Scalars['ID']['output'];
  referrerUserId: Scalars['ID']['output'];
};

export type Referral = {
  __typename?: 'Referral';
  referralCode: Scalars['String']['output'];
  referralLink: Scalars['String']['output'];
  referrerUserId: Scalars['String']['output'];
  responseType: ResponseType;
  supplier?: Maybe<Supplier>;
};

export type ReferralCodeGenerationError = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferralCodeGenerationError';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type Refund = {
  __typename?: 'Refund';
  amount: MoneyV2;
  invoiceId: Scalars['ID']['output'];
  refundType: RefundType;
};

export type RefundType =
  | 'full'
  | 'partial'
  | '%future added value';

export type RefundsListFailure = {
  __typename?: 'RefundsListFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type RefundsListInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type RefundsListResponse = AuthorizationFailure | InputValidationFailure | RefundsListFailure | RefundsListSuccess;

export type RefundsListSuccess = {
  __typename?: 'RefundsListSuccess';
  refunds: Array<Refund>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type RejectOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type RejectOrderResponse = AuthorizationFailure | InputValidationFailure | OrderRejected;

export type RejectOrdersByIdInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type RejectOrdersByIdResponse = AuthorizationFailure | InputValidationFailure | OrdersRejected;

export type RemoveCcEmailFromChatsReport = {
  __typename?: 'RemoveCCEmailFromChatsReport';
  numberOfChatsUpdated: Scalars['Int']['output'];
};

export type RemoveEmailFromBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportScheduleNotFound | EmailFromBuyerReportScheduleRemoved | EmailInBuyerReportScheduleNotFound | InputValidationFailure;

export type RemoveOrderDeskEmail = {
  email: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
  type: OrderDestEmailListType;
};

export type RemoveProductsFromOrderGuidesInput = {
  chatIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  sourceChatId: Scalars['ID']['input'];
};

export type RemoveProductsFromOrderGuidesResponse = AuthorizationFailure | InputValidationFailure | RemoveProductsFromOrderGuidesResult;

export type RemoveProductsFromOrderGuidesResult = AppsyncResponse & {
  __typename?: 'RemoveProductsFromOrderGuidesResult';
  locations: Array<LocationProductsResult>;
  responseType: ResponseType;
  transactionId: Scalars['String']['output'];
};

export type RemoveSupplierBuyerMovInput = {
  buyerId: Scalars['String']['input'];
  supplierEntityId: Scalars['String']['input'];
};

export type RenameSalesFunnelStateInput = {
  newName: Scalars['String']['input'];
  salesFunnelStateId: Scalars['ID']['input'];
};

export type RenameSalesFunnelStateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SalesFunnelDefinition;

export type ReplacedProduct = {
  __typename?: 'ReplacedProduct';
  chatProduct?: Maybe<Product>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type ReportTypes =
  | 'customerMatchingIssue'
  | 'deliveryDateIssue'
  | 'productMatchingIssue'
  | 'productQuantityIssue'
  | 'purchaseOrderNumberIssue'
  | '%future added value';

export type RequestToJoinBuyerError = AppsyncError & AppsyncResponse & {
  __typename?: 'RequestToJoinBuyerError';
  errorCode?: Maybe<RequestToJoinBuyerErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type RequestToJoinBuyerErrorCode =
  | 'buyerNotFoundError'
  | 'genericError'
  | 'userIsAlreadyConnectedToBuyerError'
  | '%future added value';

export type RequestToJoinBuyerResponse = AuthorizationFailure | RequestToJoinBuyerError | UserRequestToJoin;

export type RequestedChatActivated = {
  __typename?: 'RequestedChatActivated';
  name?: Maybe<Scalars['String']['output']>;
};

export type RequestedChatCreated = {
  __typename?: 'RequestedChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type RequestsToJoinConnection = Connection & {
  __typename?: 'RequestsToJoinConnection';
  edges: Array<UserRequestToJoinEdge>;
  total: Scalars['Int']['output'];
};

export type RerankedLineItemProducts = {
  __typename?: 'RerankedLineItemProducts';
  lineItemId: Scalars['ID']['output'];
  products: Array<RerankedProduct>;
};

export type RerankedProduct = {
  __typename?: 'RerankedProduct';
  /**
   * If feature flag `lox-graphql-migration` is enabled, `vendorItemUnit` will be returned.
   * Otherwise, `product` will be used.
   */
  product?: Maybe<Product>;
  rankedOrder: Scalars['Int']['output'];
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type ResponseType =
  | 'error'
  | 'success'
  | '%future added value';

export type RetryOrderProcessingResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrderProcessingRetrying;

export type ReviewReason =
  | 'autoPilotDisabledForCustomer'
  | 'autoPilotDisabledForSupplier'
  | 'autoPilotNotEnabled'
  | 'autopilotThresholdNotSet'
  | 'chatMatching'
  | 'customFeatureFlag'
  | 'customerMatching'
  | 'cutOffTimeMatching'
  | 'deliveryDateMatching'
  | 'internalError'
  | 'isDuplicateOrder'
  | 'isMultiOrder'
  | 'isReprocessedOrder'
  | 'lowConfidenceLevel'
  | 'minimumOrderQuantityConstraint'
  | 'minimumOrderValueConstraint'
  | 'productAvailability'
  | 'productMatching'
  | 'reviewRequired'
  | 'selectedForCalibration'
  | 'unexpected'
  | 'unexpectedlyHighProductQuantity'
  | '%future added value';

export type Role =
  | 'supplierAdmins'
  | 'supplierSalesReps'
  | '%future added value';

export type SafelistTwilioUserFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'SafelistTwilioUserFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SafelistTwilioUserResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SafelistTwilioUserFailure | SafelistTwilioUserSuccess;

export type SafelistTwilioUserSuccess = {
  __typename?: 'SafelistTwilioUserSuccess';
  message: Scalars['String']['output'];
};

export type SalesFunnelAlreadyExistsError = {
  __typename?: 'SalesFunnelAlreadyExistsError';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SalesFunnelDefinition = {
  __typename?: 'SalesFunnelDefinition';
  /** ID of the sales funnel */
  id: Scalars['ID']['output'];
  /** Definition of the state in which a new lead is created. */
  initialSalesFunnelState: SalesFunnelState;
  /** Display name of the sales funnel */
  name: Scalars['String']['output'];
  states: Array<SalesFunnelState>;
};

/** A lead in the sales funnel */
export type SalesFunnelLead = Node & {
  __typename?: 'SalesFunnelLead';
  /** The sales rep assigned to this lead */
  assignee?: Maybe<User>;
  /** The user ID of the sales rep assigned to this lead */
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  /** Business address for the lead. */
  businessAddress: Scalars['String']['output'];
  /** The name of the contact person at the business */
  businessContactName?: Maybe<Scalars['String']['output']>;
  /** The email of the business */
  businessEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the business */
  businessName: Scalars['String']['output'];
  /** The phone number of the business */
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The latest version of the comment on the lead.
   * Can be updated by anyone.
   */
  comment?: Maybe<SalesFunnelLeadComment>;
  /** The date the lead was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The name for the lead which should be displayed to the user */
  displayName: Scalars['String']['output'];
  /** Document scans associated with the lead, if they exist. */
  documentScans?: Maybe<DocumentScanConnection>;
  id: Scalars['ID']['output'];
  /** Whether the lead is archived or not */
  isArchived: Scalars['Boolean']['output'];
  /** Location data for the lead */
  location: SalesFunnelLeadLocation;
  /** Menu scans associated with the lead, if they exist. */
  menuScans?: Maybe<MenuScanConnection>;
  /**
   * A note associated with the lead. It is up to backend policy to determine
   * which note this is. Null if and only if there is no note attached to the
   * lead.
   */
  note?: Maybe<DistributorNote>;
  /** The revenue of the lead */
  revenue?: Maybe<MoneyV2>;
  /** The associated sales funnel. */
  salesFunnel?: Maybe<SalesFunnelDefinition>;
  /** The ID of the sales funnel this lead is in */
  salesFunnelId: Scalars['ID']['output'];
  /** The current state of the lead */
  salesFunnelState: SalesFunnelState;
  /** The unique identifier for the lead's current state. */
  salesFunnelStateId: Scalars['ID']['output'];
  /**
   * A task associated with the lead. It is up to backend policy to determine
   * which task this is.
   */
  task?: Maybe<DistributorTask>;
  /** The date the lead was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type SalesFunnelLeadComment = {
  __typename?: 'SalesFunnelLeadComment';
  /** The date the comment was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /** The comment text. */
  text: Scalars['String']['output'];
  /** The date the comment was last updated. */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who last updated the comment. */
  updatedBy: User;
};

/** A lead in the sales funnel for the map. Contains a reduced set of fields which are visible to all sales */
export type SalesFunnelLeadForMap = Node & {
  __typename?: 'SalesFunnelLeadForMap';
  /** The user ID of the sales rep assigned to this lead */
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  /** Business address for the lead. */
  businessAddress: Scalars['String']['output'];
  /** The name for the lead which should be displayed to the user */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the lead is archived or not */
  isArchived: Scalars['Boolean']['output'];
  /** Location data for the lead */
  location: SalesFunnelLeadLocation;
};

/**
 * Encapsulates input for filtering leads by geographic location.
 * Exactly one of the fields must be provided.
 */
export type SalesFunnelLeadGeographicFilterInput = {
  /** Filter to limit leads to those within a bounding circle. */
  boundingCircleInput?: InputMaybe<BoundingCircleInput>;
  /** Filter to limit leads to those within a bounding rectangle. */
  boundingRectangleInput?: InputMaybe<BoundingRectangleInput>;
};

export type SalesFunnelLeadGeographicIdentifier = SalesFunnelLeadGooglePlace;

export type SalesFunnelLeadGeographicIdentifierInput = {
  type: GeographicIdentifierInputType;
  value: Scalars['String']['input'];
};

export type SalesFunnelLeadGooglePlace = {
  __typename?: 'SalesFunnelLeadGooglePlace';
  googlePlaceId: Scalars['String']['output'];
};

/** Location data for a lead. */
export type SalesFunnelLeadLocation = {
  __typename?: 'SalesFunnelLeadLocation';
  /** Coordinates of the lead */
  coordinates: Coordinate;
  /** The external geographic identifier with which the lead was made. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifier;
};

/** Represents an prospect in the prospect search response. */
export type SalesFunnelProspect = {
  __typename?: 'SalesFunnelProspect';
  /** Attribution data for the prospect. If this is non-empty, it MUST be shown. */
  attributions?: Maybe<Array<Maybe<SalesFunnelProspectDataAttribution>>>;
  /** Business status of the prospect. */
  businessStatus?: Maybe<BusinessStatus>;
  /** The existing account that is associated with the prospect, if it exists. */
  connectedBuyer?: Maybe<SalesFunnelProspectConnectedBuyer>;
  /** The existing lead that is associated with the prospect, if it exists. */
  connectedLead?: Maybe<SalesFunnelProspectConnectedLead>;
  displayName: Scalars['String']['output'];
  /** Localized address of the prospect */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** Place ID from Google Places API. */
  googlePlaceId: Scalars['String']['output'];
  /**
   * Name of the place resource from Google Places API. Has format 'places/{placeId}'.
   * This is not the display name.
   */
  googlePlaceName: Scalars['String']['output'];
  /** International phone number of the prospect. Localized. */
  internationalPhoneNumber?: Maybe<Scalars['String']['output']>;
  location: Coordinate;
  /** Open now status of the prospect */
  openNow?: Maybe<Scalars['Boolean']['output']>;
  /** Contains details about opening hours. */
  openingHours?: Maybe<OpeningHours>;
  /** Photos of the prospect. */
  photos?: Maybe<Array<Maybe<SalesFunnelProspectPhoto>>>;
  /** Price level of the prospect. */
  priceLevel?: Maybe<PriceLevel>;
  /** An element of the types array that is considered the primary type. This is not localized. */
  primaryType?: Maybe<Scalars['String']['output']>;
  /** Localized display name of the primary type. */
  primaryTypeDisplayName?: Maybe<Scalars['String']['output']>;
  /** Aggregate rating of the prospect. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Summary of the prospect. Localized. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Types of the prospect. These are not localized. */
  types: Array<Scalars['String']['output']>;
  /** Number of user ratings for the prospect. */
  userRatingCount?: Maybe<Scalars['Int']['output']>;
  /** The viewport that contains the prospect. */
  viewport?: Maybe<RectangleGeometry>;
  /** Website of the prospect. */
  website?: Maybe<Scalars['String']['output']>;
};

/** Represents an existing account in the prospect search response. */
export type SalesFunnelProspectConnectedBuyer = {
  __typename?: 'SalesFunnelProspectConnectedBuyer';
  /** The buyer ID of the existing account. */
  buyerId: Scalars['ID']['output'];
};

/** Represents an existing lead in the prospect search response. */
export type SalesFunnelProspectConnectedLead = {
  __typename?: 'SalesFunnelProspectConnectedLead';
  /** The supplier ID of the existing lead. */
  lead: SalesFunnelLeadForMap;
  /** The lead ID of the existing lead. */
  leadId: Scalars['ID']['output'];
};

/** Represents the attribution data for an prospect. */
export type SalesFunnelProspectDataAttribution = {
  __typename?: 'SalesFunnelProspectDataAttribution';
  /** The name of the provider of the prospect. */
  provider?: Maybe<Scalars['String']['output']>;
  /** The URI of the provider. */
  providerUri?: Maybe<Scalars['String']['output']>;
};

/** Represents a photo of an prospect. */
export type SalesFunnelProspectPhoto = {
  __typename?: 'SalesFunnelProspectPhoto';
  /** The attribution data for the photo. */
  attributions?: Maybe<Array<Maybe<SalesFunnelProspectPhotoAttribution>>>;
  /** The height of the photo in pixels. */
  heightPx?: Maybe<Scalars['Int']['output']>;
  resource: GoogleProspectPhotoDetails;
  /** The width of the photo in pixels. */
  widthPx?: Maybe<Scalars['Int']['output']>;
};

/** Represents the attribution data for an prospect photo. */
export type SalesFunnelProspectPhotoAttribution = {
  __typename?: 'SalesFunnelProspectPhotoAttribution';
  /** The name of the provider. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The URI of the profile photo of the provider. */
  photoUri?: Maybe<Scalars['String']['output']>;
  /** The URI of the provider. */
  uri?: Maybe<Scalars['String']['output']>;
};

export type SalesFunnelProspectsMetadata = {
  __typename?: 'SalesFunnelProspectsMetadata';
  /** The boundingRectangle that contains all the prospects. */
  boundingRectangle?: Maybe<RectangleGeometry>;
};

/** Represents the response for a prospect search query. */
export type SalesFunnelProspectsResults = {
  __typename?: 'SalesFunnelProspectsResults';
  /** Metadata about the prospects. */
  metadata?: Maybe<SalesFunnelProspectsMetadata>;
  /** The prospects that match the query. */
  prospects: Array<SalesFunnelProspect>;
};

/** A state in the sales funnel */
export type SalesFunnelState = {
  __typename?: 'SalesFunnelState';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The style of the state as it is displayed on the frontend. */
  style: SalesFunnelStyle;
  /**
   * Thin-client version - tell clients what next valid state is so
   * they don't have to implicitly compute it based on order of states
   * on the Funnel definition.
   */
  validNextStates: Array<Scalars['ID']['output']>;
};

/** Defines the color of the chip (RGBA in hex) used to display the sales funnel state. */
export type SalesFunnelStateHexColor = {
  __typename?: 'SalesFunnelStateHexColor';
  /** The background color of the chip in hex format. */
  color: Scalars['String']['output'];
};

/** The statistics for a sales funnel state. */
export type SalesFunnelStateStatistics = {
  __typename?: 'SalesFunnelStateStatistics';
  /** The number of leads in this state. */
  count: Scalars['Int']['output'];
  /** The ID of the state. */
  id: Scalars['ID']['output'];
  /** The name of the state. */
  name: Scalars['String']['output'];
  /** The total revenue value for leads in this state. */
  revenueValue?: Maybe<MoneyV2>;
  /** The style of the state as it is displayed on the frontend. */
  style: SalesFunnelStyle;
};

/** The statistics for a sales funnel. */
export type SalesFunnelStatistics = {
  __typename?: 'SalesFunnelStatistics';
  /** The number of leads in each state of the sales funnel. */
  salesFunnelStateStatistics: Array<SalesFunnelStateStatistics>;
};

/** Defines the style of the sales funnel as it is displayed on the frontend. */
export type SalesFunnelStyle = {
  __typename?: 'SalesFunnelStyle';
  /** The background color of the state. */
  backgroundColor: SalesFunnelStateHexColor;
};

export type SalesRepDetails = {
  __typename?: 'SalesRepDetails';
  chatId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderPreference: Array<AddSalesRepOrderPref>;
  phoneNumber: Scalars['String']['output'];
};

export type ScheduledBuyerReportFrequency =
  | 'daily'
  | 'monthly'
  | 'weekly'
  | '%future added value';

export type ScheduledBuyerReportTimeframeType =
  | 'absolute'
  | 'relative'
  | '%future added value';

export type SearchBuyerConnection = Connection & {
  __typename?: 'SearchBuyerConnection';
  edges: Array<BuyerEdge>;
  total: Scalars['Int']['output'];
};

export type SearchBuyerFilter = {
  googlePlaceAddressId: Scalars['String']['input'];
  googlePlaceEstablishment?: InputMaybe<GooglePlaceEstablishment>;
};

export type SearchBuyerFilterV2 = {
  /** Buyers will be filtered by distance to a reference coordinate */
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export type SearchBuyerInput = {
  /** @deprecated use filterV2 instead */
  filter?: InputMaybe<SearchBuyerFilter>;
  filterV2?: InputMaybe<SearchBuyerFilterV2>;
};

export type SearchBuyerResponse = AuthorizationFailure | InputValidationFailure | SearchBuyerConnection;

export type SearchCustomerChats = AuthorizationFailure | CustomerChatsConnection | InputValidationFailure;

export type SearchCustomerChatsInput = {
  filter?: InputMaybe<SearchCustomerV2Filter>;
  pagination?: InputMaybe<SearchCustomerV2Pagination>;
  searchTerm: Scalars['String']['input'];
  sort?: InputMaybe<SearchCustomerV2Sort>;
  supplierId: Scalars['String']['input'];
};

export type SearchCustomerResponse = AuthorizationFailure | CustomerChatsConnection | InputValidationFailure;

export type SearchCustomerV2DateRange = {
  end?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  start?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type SearchCustomerV2Filter = {
  churnStatus?: InputMaybe<Array<ChatChurnStatus>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  lastOrderDate?: InputMaybe<SearchCustomerV2DateRange>;
  maxOneChatPerBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  orderFrequency?: InputMaybe<Array<ChatChurnOrderFrequency>>;
  orderingTrend?: InputMaybe<Array<ChatChurnOrdersTrend>>;
  status?: InputMaybe<SearchCustomerV2FilterStatus>;
  withBuyerUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchCustomerV2FilterStatus = {
  exclude?: InputMaybe<Array<ChatStatus>>;
  include?: InputMaybe<Array<ChatStatus>>;
};

export type SearchCustomerV2Input = {
  filter?: InputMaybe<SearchCustomerV2Filter>;
  pagination?: InputMaybe<SearchCustomerV2Pagination>;
  searchTerm: Scalars['String']['input'];
  sort?: InputMaybe<SearchCustomerV2Sort>;
};

export type SearchCustomerV2Pagination = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCustomerV2Sort = {
  field: SearchCustomerV2SortField;
  order: SortOrder;
};

export type SearchCustomerV2SortField =
  | 'lastOrderDate'
  | 'name'
  | '%future added value';

export type SearchEntity = Broadcast | Buyer | Chat | Message | Order | Product | Supplier | User;

export type SearchEntityType =
  | 'broadcast'
  | 'buyer'
  | 'chat'
  | 'message'
  | 'order'
  | 'product'
  | 'supplier'
  | 'user'
  | '%future added value';

export type SearchFilter = {
  broadcast?: InputMaybe<BroadcastFilter>;
  buyer?: InputMaybe<BuyerFilter>;
  chat?: InputMaybe<ChatFilter>;
  order?: InputMaybe<OrderFilter>;
  product?: InputMaybe<ProductFilter>;
  supplier?: InputMaybe<SupplierFilter>;
  user?: InputMaybe<UserFilter>;
};

export type SearchInput = {
  filter?: InputMaybe<SearchFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<SearchEntityType>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<SearchEntity>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: SearchEntityType;
};

export type SearchOrderConnection = Connection & {
  __typename?: 'SearchOrderConnection';
  edges: Array<SearchOrderEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchOrderDeskCustomerInput = {
  paginationInput?: InputMaybe<PaginationInput>;
  searchTerm: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export type SearchOrderDeskCustomerResponse = AuthorizationFailure | InputValidationFailure | OrderDeskChatsConnection;

export type SearchOrderEdge = Edge & {
  __typename?: 'SearchOrderEdge';
  cursor: Scalars['String']['output'];
  node: Order;
};

export type SearchOrderInput = {
  acceptedByContext?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chatLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryFromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  deliveryToTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  externalCustomerNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  hasDeliveryComment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  orderedVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type SearchOrderResponse = AuthorizationFailure | InputValidationFailure | SearchOrderConnection;

export type SearchProductsConnection = Connection & {
  __typename?: 'SearchProductsConnection';
  edges: Array<SearchProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchProductsEdge = Edge & {
  __typename?: 'SearchProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type SearchProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'SearchProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SearchProductsInput = {
  filter?: InputMaybe<ProductFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type SearchProductsResponse = SearchProductsConnection | SearchProductsError;

export type SearchResult = {
  __typename?: 'SearchResult';
  hits: Array<SearchItem>;
  total: Scalars['Int']['output'];
};

export type SearchSupplierConnection = Connection & {
  __typename?: 'SearchSupplierConnection';
  edges: Array<SupplierSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchTaxonomyLabelsConnection = Connection & {
  __typename?: 'SearchTaxonomyLabelsConnection';
  edges: Array<SearchTaxonomyLabelsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchTaxonomyLabelsEdge = Edge & {
  __typename?: 'SearchTaxonomyLabelsEdge';
  cursor: Scalars['String']['output'];
  node: TaxonomyLabel;
};

export type SearchTaxonomyLabelsError = AppsyncError & AppsyncResponse & {
  __typename?: 'SearchTaxonomyLabelsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SearchTaxonomyLabelsInput = {
  locale: Scalars['String']['input'];
  search: Scalars['String']['input'];
};

export type SearchTaxonomyLabelsResponse = SearchTaxonomyLabelsConnection | SearchTaxonomyLabelsError;

export type SecondaryFieldConfiguration = {
  __typename?: 'SecondaryFieldConfiguration';
  name: SecondaryLineItemFields;
};

export type SecondaryFieldConfigurationInput = {
  name: SecondaryLineItemFields;
};

export type SecondaryLineItemFields =
  | 'animalIdOrReferenceNumber'
  | 'countryOfBirth'
  | 'countryOfOrigin'
  | 'countryOfRearing'
  | 'cuttingCountry'
  | 'cuttingEstablishmentNumber'
  | 'lotCode'
  | 'name'
  | 'originStatement'
  | 'packagingDescription'
  | 'price'
  | 'productId'
  | 'slaughterCountry'
  | 'slaughterEstablishmentNumber'
  | 'unit'
  | 'weightKg'
  | '%future added value';

export type SelectProductForOrderGuideInput = {
  buyerProduct?: InputMaybe<BuyerProductInput>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type SelectProductForOrderGuideResponse = AuthorizationFailure | InputValidationFailure | SelectProductForOrderGuideSuccess;

export type SelectProductForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductForOrderGuideSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType;
};

export type SelectProductsForOrderGuideInput = {
  chatId: Scalars['ID']['input'];
  products: Array<OrderGuideProductInput>;
};

export type SelectProductsForOrderGuideResponse = AuthorizationFailure | SelectProductsForOrderGuideSuccess;

export type SelectProductsForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductsForOrderGuideSuccess';
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
  /** Always ResponseType.success */
  responseType: ResponseType;
};

/** Input type for sending email marketing campaign to all contacts of a supplier */
export type SendEmailCampaignToAllInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Input type for sending email marketing campaign to all contacts of specific chats */
export type SendEmailCampaignToChatsInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Chat IDs to send the email campaign to */
  chatIds: Array<Scalars['String']['input']>;
};

export type SendInviteTransmissionRequest = {
  channel: InviteChannel;
  invitedToEntityId: Scalars['String']['input'];
  inviteeEntityId?: InputMaybe<Scalars['String']['input']>;
  inviteeEntityName?: InputMaybe<Scalars['String']['input']>;
  inviteeId: Scalars['String']['input'];
  inviteeName?: InputMaybe<Scalars['String']['input']>;
  invitorEntityName: Scalars['String']['input'];
  invitorId: Scalars['String']['input'];
  invitorUserName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SendInviteTransmissionResponse = AuthorizationFailure | InputValidationFailure | InviteTransmission;

/** Input type for sending marketing campaign to different channels */
export type SendMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Target rules to be used for the marketing campaign recipients */
  target: MarketingCampaignTargetInput;
};

/** Input type for sending marketing campaign to different channels */
export type SendMarketingCampaignInputV2 = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Target rules to be used for the marketing campaign recipients */
  target: MarketingCampaignTargetInputV2;
};

export type SendSampleSmsMessageFailure = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageFailure';
  errorMessage: Scalars['String']['output'];
  responseType: ResponseType;
};

/** Input to sendSampleSmsMessage */
export type SendSampleSmsMessageInput = {
  /** Optional media attachments */
  mediaUrls?: InputMaybe<Array<SendSampleSmsMessageMediaInput>>;
  /** Body of the sms to send. */
  messageBody: Scalars['String']['input'];
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSampleSmsMessageMediaInput = {
  mediaUrl: Scalars['String']['input'];
};

export type SendSampleSmsMessageResponse = AuthorizationFailure | InputValidationFailure | SendSampleSmsMessageFailure | SendSampleSmsMessageSuccess;

export type SendSampleSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageSuccess';
  messageSid: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type SendSyntheticSmsMessageInput = {
  /** AccountSid number */
  accountSid?: InputMaybe<Scalars['String']['input']>;
  /** Body of the sms to send. */
  body: Scalars['String']['input'];
  /** Sender phone number */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticSmsMessageMediaInput>>;
  /** The messageSid of the sms message to send a synthetic response to */
  messageSid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSyntheticSmsMessageMediaInput = {
  mediaContentType: Scalars['String']['input'];
  mediaUrl: Scalars['String']['input'];
};

export type SendSyntheticSmsMessageResponse = AuthorizationFailure | InputValidationFailure | SendSyntheticSmsMessageSuccess;

export type SendSyntheticSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticSmsMessageSuccess';
  messageSid: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SendSyntheticWhatsAppMessageInput = {
  /** Body of the WhatsApp message to send. */
  body: Scalars['String']['input'];
  /** Sender phone number */
  from: Scalars['String']['input'];
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticWhatsAppMessageMediaInput>>;
  /**
   * The messageSid of the WhatsApp message message to send a synthetic response to.
   * Must begin with prefix TEST_.
   */
  messageSid: Scalars['String']['input'];
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageMediaInput = {
  contentType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageResponse = AuthorizationFailure | InputValidationFailure | SendSyntheticWhatsAppMessageSuccess;

export type SendSyntheticWhatsAppMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticWhatsAppMessageSuccess';
  messageSid: Scalars['String']['output'];
  responseType: ResponseType;
};

/** Input type for setting marketing email sender configuration */
export type SetMarketingEmailSenderInput = {
  /** The company details including name and address for legal compliance */
  companyDetails: Scalars['String']['input'];
  /** Footer links for email templates (up to 4 links) */
  footerLinks?: InputMaybe<Array<MarketingEmailSenderFooterLinkInput>>;
  /** The email address for reply-to field */
  replyToEmail: Scalars['AWSEmail']['input'];
  /** The display name for reply-to field */
  replyToName: Scalars['String']['input'];
  /** The display name of the sender */
  senderName: Scalars['String']['input'];
};

/** Response type for setting a marketing email sender */
export type SetMarketingEmailSenderResponse = AuthorizationFailure | InputValidationFailure | SetMarketingEmailSenderResult;

/** Success result for setting marketing email sender */
export type SetMarketingEmailSenderResult = AppsyncResponse & {
  __typename?: 'SetMarketingEmailSenderResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** The created or updated email sender configuration */
  sender: MarketingCampaignEmailSender;
};

export type SetOrderAsTestResponse = InputValidationFailure | TestOrderResponse;

export type SetUserOrderOverridePermissionsInput = {
  /** The ID of the supplier context where these permissions apply */
  supplierId: Scalars['ID']['input'];
  /** The ID of the user to set override permissions for */
  userId: Scalars['ID']['input'];
  /**
   * The list of validation rules this user can override.
   * Pass an empty array to remove all override permissions for this user-supplier combination.
   */
  validationRules: Array<ValidationRule>;
};

export type SetUserOrderOverridePermissionsResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UserOrderOverridePermissions;

export type SettlementReportCreateInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type SettlementReportCreateResponse = AuthorizationFailure | InputValidationFailure | SettlementReportCreateSuccess;

export type SettlementReportCreateSuccess = {
  __typename?: 'SettlementReportCreateSuccess';
  reportId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type SettlementReportInput = {
  reportId: Scalars['ID']['input'];
};

export type SettlementReportResponse = AuthorizationFailure | InputValidationFailure | SettlementReportSuccess;

export type SettlementReportSuccess = {
  __typename?: 'SettlementReportSuccess';
  /** Empty if the report is not ready yet */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type SharedBroadcastProducts = {
  __typename?: 'SharedBroadcastProducts';
  categories?: Maybe<Array<ProductCategory>>;
  productCountInProductList?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Product>>;
};

export type ShippingAddressInput = {
  city: Scalars['String']['input'];
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};

export type SingleDayDeliveryExceptionType =
  | 'singleDayDeliveryException'
  | '%future added value';

export type SingleDayDeliveryExceptionWithCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithCutoff';
  cutoffType: WithCutoffType;
  date: Scalars['AWSDate']['output'];
  leadTimeAdjustedCutoff: Scalars['AWSDateTime']['output'];
  type: SingleDayDeliveryExceptionType;
  updateBehavior: DeliverySettingExceptionUpdateBehavior;
};

export type SingleDayDeliveryExceptionWithoutCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithoutCutoff';
  cutoffType: NoCutoffType;
  date: Scalars['AWSDate']['output'];
  type: SingleDayDeliveryExceptionType;
  updateBehavior: DeliverySettingExceptionUpdateBehavior;
};

export type SmsMessage = {
  __typename?: 'SmsMessage';
  accountSid: Scalars['String']['output'];
  apiVersion?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  from: Scalars['String']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  mediaElements?: Maybe<Array<SmsMessageMedia>>;
  messageSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  smsMessageId: Scalars['String']['output'];
  smsStatus?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
  toCity?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type SmsMessageMedia = {
  __typename?: 'SmsMessageMedia';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
};

export type Sort = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export type SortCartBy =
  | 'alphabetical'
  | 'orderGuide'
  | '%future added value';

export type SortDirection =
  | 'ASC'
  | 'DESC'
  | '%future added value';

export type SortOrder =
  | 'asc'
  | 'desc'
  | '%future added value';

export type StartDocumentScanInput = {
  documentScanId: Scalars['ID']['input'];
};

export type StartExportPurchaseOrderJobFailure = {
  __typename?: 'StartExportPurchaseOrderJobFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type StartExportPurchaseOrderJobInput = {
  purchaseOrderId: Scalars['ID']['input'];
};

export type StartExportPurchaseOrderJobResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | StartExportPurchaseOrderJobFailure | StartExportPurchaseOrderJobSuccess;

export type StartExportPurchaseOrderJobSuccess = {
  __typename?: 'StartExportPurchaseOrderJobSuccess';
  job: ExportPurchaseOrderJob;
  purchaseOrderId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type StartMenuScanInput = {
  menuScanId: Scalars['ID']['input'];
};

export type StartOffSet = {
  __typename?: 'StartOffSet';
  milliseconds: Scalars['Int']['output'];
};

export type StockCountItemInput = {
  /** The negative value (e.g. -1) will cause the item to be removed from the session. */
  quantity: Scalars['Float']['input'];
  storageItemId: Scalars['ID']['input'];
};

export type StockCountSession = {
  __typename?: 'StockCountSession';
  countDetails?: Maybe<CountDetails>;
  id: Scalars['ID']['output'];
  itemsCounted: Scalars['Int']['output'];
  itemsTotal: Scalars['Int']['output'];
  status: StockCountSessionEnum;
  submittedById?: Maybe<Scalars['ID']['output']>;
  submittedDate?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type StockCountSessionEnum =
  | 'completed'
  | 'draft'
  | '%future added value';

export type StockCountSessionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If status is not provided then all buyer sessions (draft and completed) will be returned.
   * If status "draft" is provided then only draft sessions for the corresponding user will be returned.
   * If status "completed" is provided then only completed sessions for all users of the requested buyer will be returned.
   */
  status?: InputMaybe<Array<StockCountSessionEnum>>;
};

export type StockCountSessionsInput = {
  buyerId: Scalars['ID']['input'];
  filter?: InputMaybe<StockCountSessionsFilter>;
};

export type StockCountSessionsPaginationInfo = {
  __typename?: 'StockCountSessionsPaginationInfo';
  currentPage: Scalars['Int']['output'];
  lastPage: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StockCountSessionsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type StockCountSessionsResponse = AuthorizationFailure | InputValidationFailure | StockCountSessionsSuccess;

export type StockCountSessionsSuccess = {
  __typename?: 'StockCountSessionsSuccess';
  paginationInfo: StockCountSessionsPaginationInfo;
  responseType?: Maybe<ResponseType>;
  stockCountSessions: Array<StockCountSession>;
};

export type StockCountUser = {
  __typename?: 'StockCountUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StockCountUsersInput = {
  buyerId: Scalars['ID']['input'];
};

export type StockCountUsersResponse = AuthorizationFailure | StockCountUsersSuccess;

export type StockCountUsersSuccess = {
  __typename?: 'StockCountUsersSuccess';
  users: Array<StockCountUser>;
};

export type StockItem = {
  __typename?: 'StockItem';
  estimatedValueInCents?: Maybe<StockItemPrice>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<StockItemPrice>;
  quantity: Scalars['Float']['output'];
  storageItemId: Scalars['ID']['output'];
  unit: Scalars['String']['output'];
};

export type StockItemPrice = {
  __typename?: 'StockItemPrice';
  currency: Scalars['String']['output'];
  priceInCents: Scalars['Int']['output'];
};

export type StorageArea = {
  __typename?: 'StorageArea';
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  storageItems: Array<StorageItem>;
};


export type StorageAreaStorageItemsArgs = {
  input?: InputMaybe<StorageAreaStorageItemsInput>;
};

export type StorageAreaStorageItemsInput = {
  filter?: InputMaybe<StorageItemsFilter>;
};

export type StorageAreasInput = {
  buyerId: Scalars['ID']['input'];
};

export type StorageAreasResponse = AuthorizationFailure | InputValidationFailure | StorageAreasSuccess;

export type StorageAreasSuccess = {
  __typename?: 'StorageAreasSuccess';
  responseType?: Maybe<ResponseType>;
  storageAreas: Array<StorageArea>;
};

export type StorageItem = {
  __typename?: 'StorageItem';
  count?: Maybe<StorageItemCount>;
  id: Scalars['ID']['output'];
  inventoryItem: InventoryItem;
  position: Scalars['Float']['output'];
  price?: Maybe<ItemPrice>;
  unit?: Maybe<ItemUnit>;
};

export type StorageItemCount = {
  __typename?: 'StorageItemCount';
  dateCounted: Scalars['AWSTimestamp']['output'];
  inStock: Scalars['Float']['output'];
};

export type StorageItemsFilter = {
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubCatalog = Node & {
  __typename?: 'SubCatalog';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplierEntityId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SubCatalogChat = {
  __typename?: 'SubCatalogChat';
  chatId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<EntityIdentity>;
  subCatalogId: Scalars['ID']['output'];
};

export type SubCatalogChatInput = {
  chatId: Scalars['ID']['input'];
  subCatalogId: Scalars['ID']['input'];
};

export type SubCatalogConnection = Connection & {
  __typename?: 'SubCatalogConnection';
  edges: Array<SubCatalogEdge>;
};

export type SubCatalogEdge = Edge & {
  __typename?: 'SubCatalogEdge';
  cursor: Scalars['String']['output'];
  node: SubCatalog;
};

export type SubCatalogNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'SubCatalogNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SubmitBuyerStockCountInput = {
  buyerId: Scalars['ID']['input'];
};

export type SubmitOrderDeliveryCheckInput = {
  deliveryCheckReconciliationRequest?: InputMaybe<DeliveryCheckReconciliationRequestInput>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type SubmitOrderedProductDeliveryCheckInput = {
  /** @deprecated use deliveryCheckProblems[<item.amountDelivered>] instead */
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId: Scalars['ID']['input'];
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
  productId: Scalars['ID']['input'];
};

export type SubmitStockCountSessionFailure = {
  __typename?: 'SubmitStockCountSessionFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SubmitStockCountSessionInput = {
  buyerId: Scalars['ID']['input'];
  stockCountSessionId: Scalars['ID']['input'];
};

export type SubmitStockCountSessionResponse = AuthorizationFailure | InputValidationFailure | SubmitStockCountSessionFailure | SubmitStockCountSessionSuccess;

export type SubmitStockCountSessionSuccess = {
  __typename?: 'SubmitStockCountSessionSuccess';
  responseType: ResponseType;
};

export type Subscription = {
  __typename?: 'Subscription';
  autopilotSubscription?: Maybe<AutopilotSubscriptionResponse>;
  omnichannelOrderStatusSubscription?: Maybe<OmnichannelOrderStatusSubscriptionResponse>;
  omnichannelOrdersSubcription?: Maybe<OmnichannelOrdersSubcriptionResponse>;
  onCustomerInsightsNotificationSubscription?: Maybe<CustomerInsightsNotificationSubscriptionResponse>;
  onNotificationCreate?: Maybe<Notification>;
  purchaseOrderSubscription?: Maybe<PurchaseOrderSubscriptionResponse>;
  transmissionV2Subscription?: Maybe<TransmissionV2SubscriptionResponse>;
};


export type SubscriptionAutopilotSubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOmnichannelOrderStatusSubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOmnichannelOrdersSubcriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOnCustomerInsightsNotificationSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionOnNotificationCreateArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionPurchaseOrderSubscriptionArgs = {
  buyerId: Scalars['ID']['input'];
};


export type SubscriptionTransmissionV2SubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};

export type SuggestedProduct = Node & {
  __typename?: 'SuggestedProduct';
  id: Scalars['ID']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent or user is a supplier user, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  product?: Maybe<Product>;
};

export type SuggestedProductConnection = Connection & {
  __typename?: 'SuggestedProductConnection';
  edges?: Maybe<Array<SuggestedProductEdge>>;
  total: Scalars['Int']['output'];
};

export type SuggestedProductEdge = Edge & {
  __typename?: 'SuggestedProductEdge';
  cursor: Scalars['String']['output'];
  node: SuggestedProduct;
};

export type SuggestedProductResult = AuthorizationFailure | GetSuggestedProductsErrorResponse | InputValidationFailure | SuggestedProductSuccessResponse;

export type SuggestedProductSuccessResponse = AppsyncResponse & {
  __typename?: 'SuggestedProductSuccessResponse';
  products: SuggestedProductConnection;
  responseType: ResponseType;
};

export type Supplier = Node & {
  __typename?: 'Supplier';
  accessPackage: AccessPackage;
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: Maybe<Scalars['Boolean']['output']>;
  allowCustomProducts: Scalars['Boolean']['output'];
  allowCustomerAcquisition?: Maybe<Scalars['Boolean']['output']>;
  allowEcommercePoNumber?: Maybe<Scalars['Boolean']['output']>;
  allowInvoiceOrderGuidePhotoUpload?: Maybe<Scalars['Boolean']['output']>;
  allowOnlyOneActiveVariant?: Maybe<Scalars['Boolean']['output']>;
  allowOrderedProductMerging?: Maybe<Scalars['Boolean']['output']>;
  /** Returns Supplier Level or Buyer Level MOV */
  appliedMinimumOrderValue?: Maybe<MinimumOrderValueResponse>;
  botUser?: Maybe<User>;
  botUserId: Scalars['String']['output'];
  /**
   * Number of Products in the catalog of this Supplier
   * @deprecated This endpoint is in the maintenance mode. It works correctly for LOX Suppliers only when the `x-choco-is-lox: true` header is sent, but it won't get new features. Avoid using in the new code. Use `Chat.hasVendorCatalog` or `vendorItemsForVendor` instead.
   */
  catalogProductsCount?: Maybe<Scalars['Int']['output']>;
  chocoAiSupplierSetting?: Maybe<SupplierSetting>;
  contactEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  coverPhoto?: Maybe<ProfileImage>;
  customerNumberMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: Maybe<Scalars['String']['output']>;
  defaultSubCatalog?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  deliveryDateMandatory: Scalars['Boolean']['output'];
  /** delivery settings of suppliers which was previously used from supplierDeliverySetting query */
  deliverySetting?: Maybe<SupplierDeliverySetting>;
  deliveryZones?: Maybe<Array<DeliveryZone>>;
  /** short description of supplier to be shown during supplier discovery */
  description?: Maybe<Scalars['String']['output']>;
  disableCustomerNumberEdits?: Maybe<Scalars['Boolean']['output']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: Maybe<Scalars['Boolean']['output']>;
  hasCoverPhoto?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Works correctly for LOX Suppliers only when the `x-choco-is-lox` header is sent or user is a supplier user. Avoid using in the new code. Use `vendorItemsForVendor` instead */
  hasEnabledCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  hasEnabledFractionalUnits?: Maybe<Scalars['Boolean']['output']>;
  hasProfilePhoto?: Maybe<Scalars['Boolean']['output']>;
  /** this value is duplicate of hasEnabledCatalogProducts, added for data analysis */
  hasValidCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  hideMyPrice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  integration: Array<IntegrationOption>;
  /** indicates whether a supplier can be discovered via search */
  isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled: Scalars['Boolean']['output'];
  isIntegrated?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled: Scalars['Boolean']['output'];
  /** True if supplier is a test supplier on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  minOrder?: Maybe<MinOrder>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noDefaultCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use Public API to export orders */
  orderExportFormat?: Maybe<OrderExportConfigFormat>;
  /** @deprecated use Public API to export orders */
  orderExportUpload?: Maybe<OrderExportUploadOption>;
  phone?: Maybe<Scalars['String']['output']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: Maybe<PriceSetting>;
  primaryAssortment?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  secondaryAssortments?: Maybe<Array<Scalars['String']['output']>>;
  sortCartBy?: Maybe<SortCartBy>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Paginated list of users connected to the supplier */
  users?: Maybe<SupplierUserConnection>;
};


export type SupplierAppliedMinimumOrderValueArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type SupplierUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierAddRequest = {
  __typename?: 'SupplierAddRequest';
  buyerId: Scalars['String']['output'];
  chat?: Maybe<UserChatEdge>;
  /** keeping the chatId for backwards compaitblity */
  chatId?: Maybe<Scalars['String']['output']>;
  createChat?: Maybe<Scalars['Boolean']['output']>;
  createOrderGuideMethod: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  existingCustomer: Scalars['Boolean']['output'];
  filesComment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderDeskEmailAddress?: Maybe<Scalars['String']['output']>;
  orderDeskFaxNumber?: Maybe<Scalars['String']['output']>;
  orderDeskPhoneNumber?: Maybe<Scalars['String']['output']>;
  ordersUsingWebShop?: Maybe<Scalars['Boolean']['output']>;
  requestRefId?: Maybe<Scalars['String']['output']>;
  salesRepEmailAddress?: Maybe<Scalars['String']['output']>;
  salesRepName?: Maybe<Scalars['String']['output']>;
  salesRepPhoneCallNumber?: Maybe<Scalars['String']['output']>;
  salesRepPhoneNumber?: Maybe<Scalars['String']['output']>;
  salesRepTextNumber?: Maybe<Scalars['String']['output']>;
  salesRepWhatsAppNumber?: Maybe<Scalars['String']['output']>;
  supplierCompanyName: Scalars['String']['output'];
  supplierRefId?: Maybe<Scalars['String']['output']>;
  uploadedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['String']['output'];
};

export type SupplierAddRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierAddRequestError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SupplierAddRequestInput = {
  addBuyerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  buyerId: Scalars['String']['input'];
  createChat?: InputMaybe<Scalars['Boolean']['input']>;
  createOrderGuideMethod: Scalars['String']['input'];
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  existingCustomer: Scalars['Boolean']['input'];
  filesComment?: InputMaybe<Scalars['String']['input']>;
  orderDeskEmailAddress?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated fax is no longer supported */
  orderDeskFaxNumber?: InputMaybe<Scalars['String']['input']>;
  orderDeskPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ordersUsingWebShop?: InputMaybe<Scalars['Boolean']['input']>;
  quietRequest?: InputMaybe<Scalars['Boolean']['input']>;
  requestRefId?: InputMaybe<Scalars['String']['input']>;
  salesRepEmailAddress?: InputMaybe<Scalars['String']['input']>;
  salesRepName?: InputMaybe<Scalars['String']['input']>;
  salesRepPhoneCallNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepTextNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepWhatsAppNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName: Scalars['String']['input'];
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type SupplierAddRequestResponse = SupplierAddRequest | SupplierAddRequestError;

export type SupplierApplications = {
  __typename?: 'SupplierApplications';
  apps: Array<ApplicationData>;
};

export type SupplierChatVendorItemUnitVariant = {
  __typename?: 'SupplierChatVendorItemUnitVariant';
  /** ID of the chat context */
  chatId: Scalars['ID']['output'];
  /** The specific ID of this product variant from this supplier in this chat */
  featuredVendorItemUnitId: Scalars['ID']['output'];
  /** Priority order for this variant, the lower the number, the higher the priority (1 is the highest prio) */
  priority: Scalars['Int']['output'];
  /** ID of the supplier */
  supplierId: Scalars['ID']['output'];
};

export type SupplierChatsConnection = {
  __typename?: 'SupplierChatsConnection';
  /** Null cursor indicates the end of the list. */
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<SupplierChatsEdge>;
};

export type SupplierChatsEdge = {
  __typename?: 'SupplierChatsEdge';
  node: Chat;
};

export type SupplierContact = {
  __typename?: 'SupplierContact';
  phoneNumber: Scalars['String']['output'];
  requireOrderReview?: Maybe<Scalars['Boolean']['output']>;
  supplierEntityId: Scalars['ID']['output'];
};

export type SupplierCreateInput = {
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  allowEcommercePoNumber?: InputMaybe<Scalars['Boolean']['input']>;
  allowInvoiceOrderGuidePhotoUpload?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderedProductMerging?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableCustomerNumberEdits?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  integration: Array<IntegrationOptionInput>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** set this flag to enroll this supplier as a test supplier on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  minOrder?: InputMaybe<MinOrderInput>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortCartBy?: InputMaybe<SortCartBy>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierDeliveryDateSettings = {
  __typename?: 'SupplierDeliveryDateSettings';
  availableDeliveryDates: Array<AvailableDeliveryDate>;
  /**
   * CutOffTime configuration for supplier
   * @deprecated Use 'availableDeliveryDates'
   */
  cutOffTime?: Maybe<CutOffTime>;
  /**
   * Available delivery dates for supplier within the next 30 days in UTC && YYYY-MM-DD format
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  /**
   * delivery days of the week -> Sunday - Saturday : 0 - 6
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
};

export type SupplierDeliveryDateSettingsResponse = SupplierDeliveryDateSettings | SupplierDeliverySettingsNotFound | SupplierNotFound;

export type SupplierDeliverySetting = {
  __typename?: 'SupplierDeliverySetting';
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cutoffTimes & cutoffType */
  cutOffTime?: Maybe<CutOffTime>;
  cutoffTimes: WeekdayBasedCutoffSettings;
  /** This field aggregates the cutoffType for each provided day. If the type is not the same for all the provided days, it will be null. */
  cutoffType?: Maybe<CutOffTimeType>;
  /**
   * Sunday - Saturday : 0 - 6
   * @deprecated Use cutoffTimes
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  exceptions?: Maybe<Array<DeliverySettingException>>;
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['output'];
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: Maybe<Scalars['Boolean']['output']>;
  scope: SupplierDeliverySettingScope;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
  /** @deprecated Use scope */
  type: SupplierDeliverySettingType;
};

export type SupplierDeliverySettingInput = {
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use cutoffTimes & cutoffType */
  cutOffTime?: InputMaybe<CutOffTimeInput>;
  /** Please provide either cutoffTimes or exceptions */
  cutoffTimes?: InputMaybe<WeekdayBasedCutoffSettingsInput>;
  /**
   * Sunday - Saturday : 0 - 6
   * @deprecated Use cutoffTimes
   */
  deliveryDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  exceptions?: InputMaybe<Array<DeliveryExceptionInput>>;
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['input'];
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<SupplierDeliverySettingScope>;
  type: SupplierDeliverySettingType;
};

export type SupplierDeliverySettingScope =
  | 'chat'
  | 'supplier'
  | '%future added value';

export type SupplierDeliverySettingType =
  | 'chat'
  | 'supplier'
  | '%future added value';

export type SupplierDeliverySettingsNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierDeliverySettingsNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  supplier?: Maybe<Supplier>;
};

export type SupplierFilter = {
  coordinates?: InputMaybe<CoordinateInput>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierGetInTouchRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierGetInTouchRequestError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SupplierGetInTouchRequestInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGetInTouchRequestResponse = SupplierGetInTouchRequestError | SupplierGetInTouchRequestSuccess;

export type SupplierGetInTouchRequestSuccess = AppsyncResponse & {
  __typename?: 'SupplierGetInTouchRequestSuccess';
  errors: Array<SupplierUpdateError>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type SupplierInviteError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierInviteError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

/** ORDER EXPORT CONFIG ENDS HERE ......... */
export type SupplierInviteResponseEntity = Chat | InvalidInvitedPhoneNumber | SupplierInviteError | User;

export type SupplierInviteUserResponse = {
  __typename?: 'SupplierInviteUserResponse';
  chatUsers: Array<Maybe<ChatUser>>;
  inviteResponse: Array<Maybe<SupplierInviteResponseEntity>>;
};

export type SupplierLabelsList = {
  __typename?: 'SupplierLabelsList';
  labels: Array<ChatLabel>;
};

export type SupplierLabelsResponse = AuthorizationFailure | InputValidationFailure | SupplierLabelsList;

export type SupplierNegotiatedPrice = {
  __typename?: 'SupplierNegotiatedPrice';
  createdAt: Scalars['AWSTimestamp']['output'];
  price: Money;
  updatedAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

export type SupplierNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SupplierOrderChannel =
  | 'app'
  | 'easyUpload'
  | 'email'
  | 'sms'
  | 'upload'
  | 'whatsApp'
  | 'whatsapp'
  | '%future added value';

export type SupplierOrderOverridePermissionsInput = {
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SupplierOrderOverridePermissionsResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UserOrderOverridePermissions;

export type SupplierProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
  unit: Scalars['String']['input'];
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSearchEdge = Edge & {
  __typename?: 'SupplierSearchEdge';
  cursor: Scalars['String']['output'];
  node: Supplier;
};

export type SupplierSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierSearchInput = {
  filter?: InputMaybe<SupplierSearchFilter>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSearchResponse = AuthorizationFailure | InputValidationFailure | SearchSupplierConnection;

export type SupplierSearchV2Filter = {
  assortments?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCompanyName?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocale?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderTransmission?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSetting = {
  __typename?: 'SupplierSetting';
  autoPilotEnabled?: Maybe<Scalars['Boolean']['output']>;
  automaticProductReplacementEnabled?: Maybe<Scalars['Boolean']['output']>;
  autopilotThreshold?: Maybe<AutopilotThreshold>;
  blockedAutoPilotCustomers: BlockedAutoPilotCustomersConnection;
  blockedCustomerCount: Scalars['Int']['output'];
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  prepMethods?: Maybe<Array<Scalars['String']['output']>>;
  supplierId: Scalars['ID']['output'];
};


export type SupplierSettingBlockedAutoPilotCustomersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type SupplierSettingInput = {
  autopilotThreshold?: InputMaybe<AutomationLevel>;
  enableAutoPilot?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoPilotForCustomers?: InputMaybe<Array<Scalars['ID']['input']>>;
  enableAutomaticProductReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  prepMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  requireOrderReviewForCustomers?: InputMaybe<Array<Scalars['ID']['input']>>;
  supplierId: Scalars['ID']['input'];
};

export type SupplierSettingResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SupplierSetting;

export type SupplierUpdateAccessPackageError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierUpdateAccessPackageError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type SupplierUpdateAccessPackageInput = {
  accessPackage: AccessPackage;
  supplierId: Scalars['String']['input'];
};

export type SupplierUpdateAccessPackageResponse = SupplierUpdateAccessPackageError | SupplierUpdateAccessPackageSuccess;

export type SupplierUpdateAccessPackageSuccess = AppsyncResponse & {
  __typename?: 'SupplierUpdateAccessPackageSuccess';
  errors: Array<SupplierUpdateError>;
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type SupplierUpdateError = {
  __typename?: 'SupplierUpdateError';
  message: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
};

export type SupplierUpdateInput = {
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only definable for Premium and LeadGen suppliers */
  allowCustomerAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  allowEcommercePoNumber?: InputMaybe<Scalars['Boolean']['input']>;
  allowInvoiceOrderGuidePhotoUpload?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderedProductMerging?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableCustomerNumberEdits?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  integration?: InputMaybe<Array<IntegrationOptionInput>>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minOrder?: InputMaybe<MinOrderInput>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortCartBy?: InputMaybe<SortCartBy>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierUserConnection = Connection & {
  __typename?: 'SupplierUserConnection';
  edges?: Maybe<Array<SupplierUserEdge>>;
};

export type SupplierUserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SupplierUserEdge = Edge & {
  __typename?: 'SupplierUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SupplierUserRemoveInput = {
  userId: Scalars['String']['input'];
};

export type SupplierUserRemoveResponse = AppsyncResponse & {
  __typename?: 'SupplierUserRemoveResponse';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type SupplierUserUpdateChatsInput = {
  addTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};

export type SupplierUserUpdateChatsResponse = {
  __typename?: 'SupplierUserUpdateChatsResponse';
  addedTo: Array<Maybe<Scalars['String']['output']>>;
  removedFrom: Array<Maybe<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

export type SupplierVendorItemUnitVariant = SupplierChatVendorItemUnitVariant;

export type SyncCognitoUserFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'SyncCognitoUserFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type SyncCognitoUserResponse = AuthorizationFailure | NotFoundError | SyncCognitoUserFailure | SyncCognitoUserSuccess;

export type SyncCognitoUserSuccess = {
  __typename?: 'SyncCognitoUserSuccess';
  state: UserCognitoState;
};

/** Rule to target all contacts of a supplier */
export type TargetAll = {
  __typename?: 'TargetAll';
  /** Type rule to target all contact channels of the supplier (value e.g.: contactEmails) */
  type: Scalars['String']['output'];
};

/** Rule to target specific chat users of the supplier */
export type TargetChatUsers = {
  __typename?: 'TargetChatUsers';
  /** Chat users target for the campaign */
  chatUsers: Array<ChatUsers>;
};

/** Rule to target specific chats of the supplier */
export type TargetChats = {
  __typename?: 'TargetChats';
  /** Chat IDs to target for the campaign */
  chatIds: Array<Scalars['String']['output']>;
};

export type TaxonomyLabel = Node & {
  __typename?: 'TaxonomyLabel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TeamCartExists = {
  __typename?: 'TeamCartExists';
  /** The current team cart for this chat, including updated item counts */
  cart: Cart;
};

export type TeamCartNotFound = {
  __typename?: 'TeamCartNotFound';
  /** Dummy message to make type nonempty, can be ignored */
  dummyMessage?: Maybe<Scalars['String']['output']>;
};

export type TestOrderResponse = {
  __typename?: 'TestOrderResponse';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type TextAttachmentRef = {
  __typename?: 'TextAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  textRange: TextBlockLocator;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type TextBlockLocator = {
  __typename?: 'TextBlockLocator';
  end: TextCursor;
  start: TextCursor;
};

export type TextCursor = {
  __typename?: 'TextCursor';
  column: Scalars['Int']['output'];
  line: Scalars['Int']['output'];
};

export type Transmission = Node & {
  __typename?: 'Transmission';
  attachmentOrderRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  attachments?: Maybe<Array<TransmissionAttachment>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  executionUrl?: Maybe<ExecutionUrlOutput>;
  forwarder: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  omniChannelOrderIds?: Maybe<Array<Scalars['ID']['output']>>;
  omnichannelOrders: Array<OmnichannelOrder>;
  originalMediaLink: Scalars['String']['output'];
  processorInformation: TransmissionProcessorInformation;
  progressStatus: TransmissionProgressStatus;
  providerId: Scalars['ID']['output'];
  receivedAt: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  status: TransmissionStatus;
};

export type TransmissionAttachment = Node & {
  __typename?: 'TransmissionAttachment';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  omnichannelOrderId?: Maybe<Scalars['ID']['output']>;
  ordersRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  transcript?: Maybe<AudioTranscript>;
  url: Scalars['String']['output'];
};

export type TransmissionConnection = Connection & {
  __typename?: 'TransmissionConnection';
  edges: Array<TransmissionEdge>;
  pageInfo: PageInfo;
};

export type TransmissionCreatedNotification = {
  __typename?: 'TransmissionCreatedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: Transmission;
};

export type TransmissionEdge = Edge & {
  __typename?: 'TransmissionEdge';
  cursor: Scalars['String']['output'];
  node: Transmission;
};

export type TransmissionEvent = Node & {
  __typename?: 'TransmissionEvent';
  /** A concatenation of ofId:timestamp:toType:to:newState (NOT a UUID), which uniquely IDs every transmission */
  id: Scalars['ID']['output'];
  isDeliveryEvent?: Maybe<Scalars['Boolean']['output']>;
  isFailureEvent?: Maybe<Scalars['Boolean']['output']>;
  /** arbitrary metadata, e.g. email bounce details */
  metaData?: Maybe<Scalars['AWSJSON']['output']>;
  /** e.g. Send, Delivery, Bounce, Read, ... */
  newState: Scalars['String']['output'];
  /** e.g. an orderId for ofIdType: order */
  ofId: Scalars['ID']['output'];
  ofIdType: TransmissionOfType;
  timestamp: Scalars['AWSDateTime']['output'];
  /** e.g. an email address for toType: email */
  to: Scalars['String']['output'];
  toType: TransmissionToType;
};

export type TransmissionFilter = {
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNotMatched?: InputMaybe<Scalars['Boolean']['input']>;
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  originalSender?: InputMaybe<Array<Scalars['String']['input']>>;
  processingStatus?: InputMaybe<Array<InputMaybe<TransmissionProcessingStatus>>>;
  status?: InputMaybe<TransmissionStatus>;
  supplierOrderChannel?: InputMaybe<Array<SupplierOrderChannel>>;
};

export type TransmissionOfType =
  | 'order'
  | '%future added value';

export type TransmissionProcessingStatus =
  | 'allPendingReview'
  | 'allReviewed'
  | 'mixed'
  | '%future added value';

export type TransmissionProcessorInformation = {
  __typename?: 'TransmissionProcessorInformation';
  lastProcessedAt: Scalars['AWSTimestamp']['output'];
  processedCount: Scalars['Int']['output'];
};

export type TransmissionProgressStatus =
  | 'failed'
  | 'partiallyFailed'
  | 'processed'
  | 'processing'
  | '%future added value';

export type TransmissionReceivedNotification = {
  __typename?: 'TransmissionReceivedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: Transmission;
};

export type TransmissionSortFields =
  | 'createdAt'
  | 'earliestDeliveryDate'
  | '%future added value';

export type TransmissionStatus =
  | 'allowed'
  | 'blocked'
  | '%future added value';

export type TransmissionToType =
  | 'email'
  | 'integrations'
  | 'lobster'
  | 'sms'
  | 'whatsapp'
  | '%future added value';

export type TransmissionV2 = Node & {
  __typename?: 'TransmissionV2';
  /** Attachments included with this transmission, such as files, documents, media or transcripts. */
  attachments?: Maybe<Array<TransmissionAttachment>>;
  /** The earliest requested delivery date across all the orders within this transmission, in ISO 8601 format. */
  earliestDeliveryDate?: Maybe<Scalars['String']['output']>;
  /** The URL of the execution workflow */
  executionUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The intermediary or service that forwarded this transmission on behalf of the sender.
   * In most cases, it is the source DX used to proxy the requests.
   * Eg: customer@cx.com -> order@dx.com -> od-<supplierId>@choco.app
   */
  forwarder: Scalars['String']['output'];
  /**
   * Id of the transmission.
   * A transmission is a unit of ordering request. A single transmission can result in one or more others.
   */
  id: Scalars['ID']['output'];
  /** The total number of orders in this transmission. */
  numberOfOrders: Scalars['Int']['output'];
  /** Minor details about the order used for displaying preview banner in the order review screen. */
  omnichannelOrderDetails: Array<OmnichannelOrderDetail>;
  /** A link to the original media content associated with this transmission. */
  originalMediaLink: Scalars['String']['output'];
  /** Information about how many times the transmission has been processed and the last time it was processed. */
  processorInformation: TransmissionProcessorInformation;
  /** The progress state of the transmission, detailing its processing phase. */
  progressStatus: TransmissionProgressStatus;
  /** Id of the source of the transmission. E.g.: Message ID for email (SES). */
  providerId: Scalars['ID']['output'];
  /** The ISO 8601 datetime when this transmission was received by the system (the executor). */
  receivedAt: Scalars['String']['output'];
  /** The original sender of this transmission. */
  sender: Scalars['String']['output'];
  /** The block state of the transmission in the processing workflow. */
  status: TransmissionStatus;
  /** The aggregate count of products across all orders in this transmission. */
  totalNumberOfProducts: Scalars['Int']['output'];
};

export type TransmissionV2Connection = Connection & {
  __typename?: 'TransmissionV2Connection';
  edges: Array<TransmissionV2Edge>;
  pageInfo: PageInfo;
};

export type TransmissionV2Edge = Edge & {
  __typename?: 'TransmissionV2Edge';
  cursor: Scalars['String']['output'];
  node: TransmissionV2;
};

export type TransmissionV2OrdersFullyProcessedNotification = {
  __typename?: 'TransmissionV2OrdersFullyProcessedNotification';
  supplierId: Scalars['ID']['output'];
  transmissionIds: Array<Scalars['ID']['output']>;
};

export type TransmissionV2ProcessedNotification = {
  __typename?: 'TransmissionV2ProcessedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: TransmissionV2;
};

export type TransmissionV2ReceivedNotification = {
  __typename?: 'TransmissionV2ReceivedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: TransmissionV2;
};

export type TransmissionsResponse = AuthorizationFailure | InputValidationFailure | TransmissionV2Connection;

export type TriggerProductMatchingInput = {
  chatId: Scalars['ID']['input'];
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerProductMatchingResponse = AuthorizationFailure | InputValidationFailure | OmnichannelOrder;

/**
 * The status of the user in Twilio.
 *   Ok - User's phone number is not geo blocked
 *   GeoBlocked - User's phone number belongs to a country that is blocked by VerifyV2 GeoPermissions
 *
 * Note: Right now Twilio's API does not support checking if a number was blocked by FraudGuard.
 * So even if the status returns Ok, it's possible that the number is blocked and can only be checked on Twilio's dashboard.
 */
export type TwilioStatus =
  | 'GeoBlocked'
  | 'Ok'
  | '%future added value';

export type UnassignUserFromOrderToReviewInput = {
  omnichannelOrderId: Scalars['ID']['input'];
};

export type UnassignUserFromOrderToReviewResponse = UnassignUserFromOrderToReviewResponseError | UnassignUserFromOrderToReviewResponseSuccess;

export type UnassignUserFromOrderToReviewResponseError = AppsyncError & AppsyncResponse & {
  __typename?: 'UnassignUserFromOrderToReviewResponseError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UnassignUserFromOrderToReviewResponseSuccess = {
  __typename?: 'UnassignUserFromOrderToReviewResponseSuccess';
  omnichannelOrderId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type UnavailableProductType = {
  __typename?: 'UnavailableProductType';
  availability?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type UnconnectedBuyers = {
  __typename?: 'UnconnectedBuyers';
  /** List of buyer ids supplier is not connected with */
  buyerIds: Array<Scalars['String']['output']>;
};

export type UndoMultiLocationOrderGuideTransactionInput = {
  transactionId: Scalars['ID']['input'];
};

export type UndoMultiLocationOrderGuideTransactionResponse = AuthorizationFailure | InputValidationFailure | UndoMultiLocationOrderGuideTransactionResult;

export type UndoMultiLocationOrderGuideTransactionResult = AppsyncResponse & {
  __typename?: 'UndoMultiLocationOrderGuideTransactionResult';
  failedLocationIds: Array<Maybe<Scalars['ID']['output']>>;
  responseType: ResponseType;
  succeededLocationIds: Array<Maybe<Scalars['ID']['output']>>;
};

export type UnknownFailure = {
  __typename?: 'UnknownFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type UnsupportedIntegrationAdapterType = AppsyncError & AppsyncResponse & {
  __typename?: 'UnsupportedIntegrationAdapterType';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type UpdateBuyerInventoryProductInput = {
  chatId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
  productId: Scalars['ID']['input'];
};

export type UpdateBuyerInventoryProductResponse = AuthorizationFailure | BuyerInventoryProduct | InputValidationFailure;

export type UpdateBuyerStockInventoryProductFailure = {
  __typename?: 'UpdateBuyerStockInventoryProductFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UpdateBuyerStockInventoryProductInput = {
  buyerId: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuyerStockInventoryProductResponse = AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound | UpdateBuyerStockInventoryProductFailure;

export type UpdateBuyerUserChatsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateBuyerUserChatsError';
  errorCode?: Maybe<UpdateBuyerUserChatsErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UpdateBuyerUserChatsErrorCode =
  | 'genericError'
  | '%future added value';

export type UpdateBuyerUserChatsInput = {
  addTo?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerId: Scalars['String']['input'];
  removeFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type UpdateBuyerUserChatsResponse = AuthorizationFailure | InputValidationFailure | UpdateBuyerUserChatsError | UpdateBuyerUserChatsSuccess;

export type UpdateBuyerUserChatsSuccess = {
  __typename?: 'UpdateBuyerUserChatsSuccess';
  addedTo: Array<Maybe<Scalars['String']['output']>>;
  removedFrom: Array<Maybe<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

/** Input type for updating attachments for a marketing campaign */
export type UpdateCampaignAttachmentInput = {
  /** Marketing campaign attachments */
  attachments: Array<CampaignAttachmentInput>;
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/**
 * Input for updating an existing note.
 * Note, this upsert operation updates all parameters provided. There are no partial updates.
 * Note: target entity is not needed as the note already contains this information.
 */
export type UpdateDistributorNoteInput = {
  /** New plain-text content for the note */
  noteBody: Scalars['String']['input'];
  /** The ID of the note to update */
  noteId: Scalars['ID']['input'];
  /** Title for the note. Null indicates that the title should be removed. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDistributorNoteResponse = AuthorizationFailure | DistributorNoteUpdateResult | InputValidationFailure | NotFoundError;

/** Input for updating an existing distributor task */
export type UpdateDistributorTaskInput = {
  /** Optional objective/goal */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt: DistributorTaskDueAtInput;
  /** ID of task to update */
  id: Scalars['ID']['input'];
  /** Title of the task */
  title: Scalars['String']['input'];
};

export type UpdateDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

/** Input for updating the status of an existing distributor task */
export type UpdateDistributorTaskStatusInput = {
  /** ID of task to update */
  id: Scalars['ID']['input'];
  /** New status for the task */
  status: DistributorTaskStatus;
};

export type UpdateDistributorTaskStatusResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type UpdateDocumentScanAttachmentsInput = {
  attachments: Array<DocumentScanAttachmentInput>;
  documentScanId: Scalars['ID']['input'];
};

export type UpdateDocumentScanResponse = AuthorizationFailure | DocumentScanUpdateResult | InputValidationFailure | NotFoundError;

/** Input type for updating email content for a marketing campaign */
export type UpdateEmailContentInput = {
  /** Email body message */
  bodyMessage: Scalars['String']['input'];
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Email image URL */
  imageURL?: InputMaybe<Scalars['String']['input']>;
  /** Email subject */
  subject: Scalars['String']['input'];
  /** Email title */
  title: Scalars['String']['input'];
};

/** Input type for updating the email template and HTML URI. Info is used by the backend for email compilation. */
export type UpdateEmailTemplateUriInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** S3 URI for the email HTML content */
  htmlUri: Scalars['String']['input'];
};

export type UpdateInventoryItemFailure = {
  __typename?: 'UpdateInventoryItemFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType?: Maybe<ResponseType>;
};

export type UpdateInventoryItemInput = {
  buyerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  patch: UpdateInventoryItemInputPatch;
};

export type UpdateInventoryItemInputPatch = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInventoryItemResponse = AuthorizationFailure | InputValidationFailure | UpdateInventoryItemFailure | UpdateInventoryItemSuccess;

export type UpdateInventoryItemSuccess = {
  __typename?: 'UpdateInventoryItemSuccess';
  inventoryItem: InventoryItem;
  responseType?: Maybe<ResponseType>;
};

export type UpdateInvoicedProductResponse = AuthorizationFailure | InputValidationFailure | InvoicedProducts;

export type UpdateJoinRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateJoinRequestError';
  errorCode?: Maybe<UpdateJoinRequestErrorCode>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type UpdateJoinRequestErrorCode =
  | 'genericError'
  | 'notAllowedJoinRequestUpdate'
  | 'notFoundJoinRequest'
  | '%future added value';

export type UpdateJoinRequestInput = {
  id: Scalars['ID']['input'];
  status: JoinRequestAllowedUpdateStatus;
};

export type UpdateJoinRequestResponse = AuthorizationFailure | InputValidationFailure | UpdateJoinRequestError | UpdateJoinRequestSuccess;

export type UpdateJoinRequestSuccess = {
  __typename?: 'UpdateJoinRequestSuccess';
  id: Scalars['String']['output'];
  status: JoinRequestAllowedUpdateStatus;
};

export type UpdateLineItemInput = {
  id: Scalars['ID']['input'];
  parsedLineItemId?: InputMaybe<Scalars['ID']['input']>;
  primaryProperties?: InputMaybe<UpdateLineItemPrimaryPropertiesInput>;
  secondaryProperties?: InputMaybe<Array<UpdateLineItemSecondaryPropertiesInput>>;
};

export type UpdateLineItemPrimaryPropertiesInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyV2Input>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sellerProductCode?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLineItemSecondaryPropertiesInput = {
  animalIdOrReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  countryOfBirth?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  countryOfRearing?: InputMaybe<Scalars['String']['input']>;
  cuttingCountry?: InputMaybe<Scalars['String']['input']>;
  cuttingEstablishmentNumber?: InputMaybe<Scalars['String']['input']>;
  lotCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originStatement?: InputMaybe<Scalars['String']['input']>;
  packagingDescription?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  slaughterCountry?: InputMaybe<Scalars['String']['input']>;
  slaughterEstablishmentNumber?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  weightKg?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating email chat message content for a marketing campaign */
export type UpdateMarketingCampaignChatMessageContentInput = {
  /** Email image URL */
  attachments?: InputMaybe<Array<CampaignAttachmentInput>>;
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Chat Message */
  message: Scalars['String']['input'];
};

/** Input type for updating home promo content for a marketing campaign */
export type UpdateMarketingCampaignHomePromoContentInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Home promo display image for the banner */
  displayImage?: InputMaybe<CampaignAttachmentInput>;
  /** Home promo display title shown to buyers */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Home promo ordering image for the detail page */
  orderingImage?: InputMaybe<CampaignAttachmentInput>;
  /** Home promo ordering message for the detail page */
  orderingMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a marketing campaign title and channels */
export type UpdateMarketingCampaignInfoInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Channels to be used for the marketing campaign */
  channels: Array<CampaignChannel>;
  /** Title of the marketing campaign as seen by the supplier */
  title: Scalars['String']['input'];
};

/** Input type for updating preferred products content for a marketing campaign */
export type UpdateMarketingCampaignPreferredProductsContentInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Preferred products title shown to buyers */
  title: Scalars['String']['input'];
};

export type UpdateMenuScanAttachmentsInput = {
  attachments: Array<MenuScanAttachmentInput>;
  menuScanId: Scalars['ID']['input'];
};

export type UpdateMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScanUpdateResult | NotFoundError;

export type UpdatePendingUserInput = {
  chatId: Scalars['String']['input'];
  user: PendingUserInput;
};

export type UpdatePendingUserResponse = AuthorizationFailure | User;

export type UpdateProductVariantsInOrderGuideInput = {
  categoryId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  selectedVariantIds: Array<Scalars['ID']['input']>;
  /** The variant which the user was navigated from while changing the unit in OG */
  sourceVariantId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductVariantsInOrderGuideResponse = AuthorizationFailure | InputValidationFailure | UpdateProductVariantsInOrderGuideSuccess;

export type UpdateProductVariantsInOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'UpdateProductVariantsInOrderGuideSuccess';
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
  responseType: ResponseType;
};

export type UpdatePurchaseOrderFailure = {
  __typename?: 'UpdatePurchaseOrderFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UpdatePurchaseOrderInput = {
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  buyerPONumber?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  dispatchDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<UpdateLineItemInput>>;
  sellerApprovalNumber?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  sellerPONumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePurchaseOrderResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UpdatePurchaseOrderFailure | UpdatePurchaseOrderSuccess;

export type UpdatePurchaseOrderSuccess = {
  __typename?: 'UpdatePurchaseOrderSuccess';
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrderId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type UpdatePurchasingBusinessFailure = {
  __typename?: 'UpdatePurchasingBusinessFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UpdatePurchasingBusinessInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  currencyConfiguration?: InputMaybe<CurrencyConfigurationInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fieldConfigurations?: InputMaybe<Array<FieldConfigurationInput>>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePurchasingBusinessResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UpdatePurchasingBusinessFailure | UpdatePurchasingBusinessSuccess;

export type UpdatePurchasingBusinessSuccess = {
  __typename?: 'UpdatePurchasingBusinessSuccess';
  business: PurchasingBusiness;
  businessId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

/** Input for the updateSalesFunnelLeadArchiveStatus mutation. */
export type UpdateSalesFunnelLeadArchiveStatusInput = {
  /** True to archive the lead, false to unarchive it */
  isArchived: Scalars['Boolean']['input'];
  /** The ID of the lead to archive or unarchive */
  leadId: Scalars['ID']['input'];
};

export type UpdateSalesFunnelLeadArchiveStatusResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type UpdateSalesFunnelStateOrderInput = {
  salesFunnelId: Scalars['ID']['input'];
  /** The new order of the sales funnel states. Must contain all states. */
  salesFunnelStateIdOrder: Array<Scalars['ID']['input']>;
};

export type UpdateSalesFunnelStateOrderResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelDefinition;

export type UpdateStorageItemFailure = {
  __typename?: 'UpdateStorageItemFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType?: Maybe<ResponseType>;
};

export type UpdateStorageItemInput = {
  buyerId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  patch: UpdateStorageItemInputPatch;
};

export type UpdateStorageItemInputPatch = {
  price?: InputMaybe<PatchStorageItemPrice>;
  storageAreaId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageItemResponse = AuthorizationFailure | InputValidationFailure | UpdateStorageItemFailure | UpdateStorageItemSuccess;

export type UpdateStorageItemSuccess = {
  __typename?: 'UpdateStorageItemSuccess';
  responseType?: Maybe<ResponseType>;
  storageItem: StorageItem;
};

export type UpdateSubCatalogChatsResponse = AuthorizationFailure | UpdateSubCatalogChatsResult;

export type UpdateSubCatalogChatsResult = {
  __typename?: 'UpdateSubCatalogChatsResult';
  errors: Array<InvalidSubCatalogChat>;
  subCatalogChats?: Maybe<UpdateSubCatalogChatsSummary>;
};

export type UpdateSubCatalogChatsSummary = {
  __typename?: 'UpdateSubCatalogChatsSummary';
  created: Array<SubCatalogChat>;
  removed: Array<SubCatalogChat>;
};

export type UpdateSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UpdateSupplierBuyerMovInput = {
  amount: Scalars['Int']['input'];
  buyerId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  supplierEntityId: Scalars['String']['input'];
};

export type UpdateSupplierContactInput = {
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  requireOrderReview?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId: Scalars['ID']['input'];
};

export type UpdateSupplierContactResponse = AuthorizationFailure | InputValidationFailure | SupplierContact;

export type UpdateSupplierProductV2Input = {
  /** @deprecated This field is ignored. Set `cost` and `conversionFactor` and the `basePrice` will be calculated automatically */
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated This field is ignored. Set `invoiceUit` */
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** How many invoiceUnits are in the main unit. Not touched if not provided */
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * Keep in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   *
   * Not touched if not provided
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code. Not touched if not provided */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to 00:00 to unset */
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  /** Not touched if not provided */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC. Not touched if not provided. Set to an empty string to unset */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not touched if not provided */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** Not touched if not provided. Set to an empty string to unset */
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to 0 to unset */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum ordering quantity, i.e. how many units of the Product should be ordered for the order to be allowed. Not touched if not provided. Set to 0 to unset. */
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Not touched if not provided */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Country code in ISO alpha2Code e.g. DE for Germany. Not touched if not provided */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  packSize?: InputMaybe<Scalars['String']['input']>;
  /**
   * Arbitrary code that combines Products as unit variants.
   * All products with the same `parentId` are considered unit variants.
   */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to an empty string to unset */
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to an empty string to unset */
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN. Not touched if not provided. Set to an empty string to unset */
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierUserRolesInput = {
  /** Only one role is allowed. */
  rolesToAdd: Array<Role>;
  /**
   * All existing roles are overridden by the one specified in rolesToAdd.
   * @deprecated this property is ignored because a supplier user can only have one role.
   */
  rolesToRemove?: InputMaybe<Array<Role>>;
  userId: Scalars['String']['input'];
};

export type UpdateTransmissionProgressStatusInput = {
  progressStatus: TransmissionProgressStatus;
  transmissionIds: Array<Scalars['String']['input']>;
};

/** Input type for updating vendor item units for a marketing campaign */
export type UpdateVendorItemUnitsInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Product vendorItemUnitIds from LOX */
  vendorItemUnitIds: Array<Scalars['String']['input']>;
};

export type UpdatedCategoryProduct = {
  __typename?: 'UpdatedCategoryProduct';
  categoryId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
};

export type UploadSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UploadSubCatalogProductsError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UploadSubCatalogProductsResponse = UploadSubCatalogProductsError | UploadSubCatalogProductsResult;

export type UploadSubCatalogProductsResult = {
  __typename?: 'UploadSubCatalogProductsResult';
  submittedProductsCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadedOrder = {
  __typename?: 'UploadedOrder';
  chatId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  mediaElements: Array<UploadedOrderMediaElement>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  uploadedOrderId: Scalars['ID']['output'];
  uploaderUserId: Scalars['ID']['output'];
};

export type UploadedOrderMediaElement = {
  __typename?: 'UploadedOrderMediaElement';
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpsertStockCountSessionItemsError = {
  __typename?: 'UpsertStockCountSessionItemsError';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type UpsertStockCountSessionItemsInput = {
  buyerId: Scalars['ID']['input'];
  items: Array<StockCountItemInput>;
};

export type UpsertStockCountSessionItemsResponse = AuthorizationFailure | InputValidationFailure | UpsertStockCountSessionItemsError | UpsertStockCountSessionItemsSuccess;

export type UpsertStockCountSessionItemsSuccess = {
  __typename?: 'UpsertStockCountSessionItemsSuccess';
  responseType: ResponseType;
  stockCountSessionId: Scalars['ID']['output'];
};

export type User = Node & {
  __typename?: 'User';
  birthdate?: Maybe<Scalars['AWSDate']['output']>;
  botUser?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated user {Query.buyerUsers} relationship instead */
  businessName?: Maybe<Scalars['String']['output']>;
  buyers?: Maybe<UserBuyerConnection>;
  challengeByEmail?: Maybe<Scalars['Boolean']['output']>;
  chats: UserChatConnection;
  /** To enable user login with daily code */
  chocoUser?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use user { paginatedContacts } instead */
  contacts?: Maybe<Array<Maybe<User>>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdContext?: Maybe<UserCreatedContext>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasAcceptedTermsAndConditions: Scalars['Boolean']['output'];
  hasRequestedToBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** filename of image for internal use only */
  image?: Maybe<Scalars['String']['output']>;
  /** @deprecated not supported due to the migration to Invite Flow V2 */
  inviteData?: Maybe<InviteInfo>;
  inviteTransmissions?: Maybe<Array<InviteTransmission>>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy: Scalars['Boolean']['output'];
  /** this flag is to enable proper data report on a user */
  isTest?: Maybe<Scalars['Boolean']['output']>;
  linkedSupplier?: Maybe<Supplier>;
  locale?: Maybe<Scalars['String']['output']>;
  loginEmail?: Maybe<Scalars['String']['output']>;
  loginMethod?: Maybe<LoginMethod>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Get the list of validation rules that this user can override when reviewing orders for a specific supplier.
   * Returns an empty array if no override permissions are configured.
   */
  orderOverridePermissions?: Maybe<Array<ValidationRule>>;
  orderPreference?: Maybe<OrderPreference>;
  paginatedContacts: UserUserConnection;
  paginatedSuppliers: UserUserConnection;
  pending?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
  phoneNumberType?: Maybe<UserPhoneType>;
  position?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
  referral?: Maybe<GetReferralResponse>;
  role?: Maybe<Array<Maybe<Role>>>;
  /** submittedGetIntouchRequest: always false if the user is a buyer user, and true if the user is a supplier user and has made a request to be contacted for premium details at least once */
  submittedGetIntouchRequest?: Maybe<Scalars['Boolean']['output']>;
  supplier: Scalars['Boolean']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  suppliers?: Maybe<Array<Maybe<User>>>;
  translationLanguage?: Maybe<Scalars['String']['output']>;
};


export type UserBuyersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserOrderOverridePermissionsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type UserPaginatedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPaginatedSuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAddedToChat = {
  __typename?: 'UserAddedToChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserBuyerConnection = Connection & {
  __typename?: 'UserBuyerConnection';
  edges: Array<UserBuyerEdge>;
};

export type UserBuyerEdge = Edge & {
  __typename?: 'UserBuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserCartAction =
  | 'add'
  | 'cancel'
  | 'create'
  | 'remove'
  | 'submit'
  /**
   * update the buyer comment for a line item.
   * if you are adding/removing a product item with a comment, you should use the add/remove action instead.
   */
  | 'updateBuyerComment'
  | '%future added value';

export type UserCartItemOperation = {
  __typename?: 'UserCartItemOperation';
  action: UserCartAction;
  orderId?: Maybe<Scalars['String']['output']>;
};

export type UserChatConnection = Connection & {
  __typename?: 'UserChatConnection';
  edges?: Maybe<Array<UserChatEdge>>;
};

export type UserChatEdge = Edge & {
  __typename?: 'UserChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

/**
 * Errors thrown by userChats
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type UserChatsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UserChatsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UserChatsResponse = UserChatConnection | UserChatsError;

export type UserCognitoState = {
  __typename?: 'UserCognitoState';
  cognitoUsers?: Maybe<CognitoStateUsers>;
  status: CognitoSyncStatus;
};

export type UserCognitoStateResponse = AuthorizationFailure | NotFoundError | UserCognitoState;

export type UserCreateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  botUser?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  chocoUser: Scalars['Boolean']['input'];
  createdContext?: InputMaybe<UserCreatedContext>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** @deprecated use profileImage { uploadUrl } from type User */
  image?: InputMaybe<Scalars['String']['input']>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMethod?: InputMaybe<LoginMethod>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedContext =
  | 'addSalesRep'
  | 'buyerConcierge'
  | 'buyerInviteTeam'
  | 'customerMassAccountCreator'
  | 'federated'
  | 'organicSignUp'
  | 'supplierInviteTeam'
  | 'supplierInvitesBuyer'
  | 'userCreatedFromAdmin'
  | '%future added value';

export type UserFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserHasReferralCode = AppsyncError & AppsyncResponse & {
  __typename?: 'UserHasReferralCode';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export type UserIntercomCredentialsFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'UserIntercomCredentialsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type UserIntercomCredentialsResponse = UserIntercomCredentialsFailure | UserIntercomCredentialsSuccess;

export type UserIntercomCredentialsSuccess = {
  __typename?: 'UserIntercomCredentialsSuccess';
  androidHash: Scalars['String']['output'];
  iosHash: Scalars['String']['output'];
  webHash: Scalars['String']['output'];
};

export type UserLead = {
  __typename?: 'UserLead';
  phoneNumber: Scalars['String']['output'];
  requestCount?: Maybe<Scalars['Int']['output']>;
  requests?: Maybe<Array<Maybe<UserLeadRequest>>>;
};

export type UserLeadInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  referrer?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UserLeadRequest = {
  __typename?: 'UserLeadRequest';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserLobbyBuyerConnection = Connection & {
  __typename?: 'UserLobbyBuyerConnection';
  edges?: Maybe<Array<UserLobbyBuyerEdge>>;
};

export type UserLobbyBuyerEdge = Edge & {
  __typename?: 'UserLobbyBuyerEdge';
  cursor: Scalars['String']['output'];
  node: LobbyBuyer;
};

export type UserOrderOverridePermissions = {
  __typename?: 'UserOrderOverridePermissions';
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  validationRules: Array<ValidationRule>;
};

export type UserPhoneType =
  | 'landline'
  | 'mobile'
  | 'noinfo'
  | 'voip'
  | '%future added value';

export type UserRef = RefEdge & {
  __typename?: 'UserRef';
  /** Id of the referenced user */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual user by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<User>;
};

export type UserRemovedFromChat = {
  __typename?: 'UserRemovedFromChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserRequestToDeleteDetails = {
  __typename?: 'UserRequestToDeleteDetails';
  success: Scalars['Boolean']['output'];
};

export type UserRequestToDeleteInput = {
  userId: Scalars['ID']['input'];
};

export type UserRequestToDeleteResponse = AuthorizationFailure | UserRequestToDeleteDetails;

export type UserRequestToJoin = Node & {
  __typename?: 'UserRequestToJoin';
  buyerId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  isReviewerAdmin?: Maybe<Scalars['Boolean']['output']>;
  requestType?: Maybe<UserRequestToJoinType>;
  requestedBy: Scalars['String']['output'];
  reviewerUserId?: Maybe<Scalars['String']['output']>;
  salesRepInput?: Maybe<SalesRepDetails>;
  status: JoinRequestStatus;
  supplierEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type UserRequestToJoinEdge = Edge & {
  __typename?: 'UserRequestToJoinEdge';
  cursor: Scalars['String']['output'];
  node: UserRequestToJoin;
};

export type UserRequestToJoinType =
  | 'addSalesRep'
  | 'joinBuyer'
  | '%future added value';

export type UserSearchConnection = Connection & {
  __typename?: 'UserSearchConnection';
  edges: Array<UserSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type UserSearchEdge = Edge & {
  __typename?: 'UserSearchEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSearchInput = {
  filter?: InputMaybe<UserSearchFilter>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type UserSearchResponse = AuthorizationFailure | InputValidationFailure | UserSearchConnection;

export type UserTwilioState = {
  __typename?: 'UserTwilioState';
  status?: Maybe<TwilioStatus>;
};

export type UserTwilioStateError = AppsyncError & AppsyncResponse & {
  __typename?: 'UserTwilioStateError';
  message: Scalars['String']['output'];
  responseType: ResponseType;
};

export type UserTwilioStateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UserTwilioState | UserTwilioStateError;

export type UserUpdateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  challengeByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  chocoUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  /** @deprecated use profileImage { uploadUrl } from type User */
  image?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UserUserConnection = Connection & {
  __typename?: 'UserUserConnection';
  edges?: Maybe<Array<UserUserEdge>>;
};

export type UserUserEdge = Edge & {
  __typename?: 'UserUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UsersList = {
  __typename?: 'UsersList';
  userIds: Array<Scalars['String']['output']>;
};

export type ValidateProductsAvailabilityInput = {
  chatId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type ValidateProductsAvailabilityResponse = AuthorizationFailure | ChatNotFoundError | InputValidationFailure | SupplierNotFound | ValidateProductsAvailabilityResult;

export type ValidateProductsAvailabilityResult = {
  __typename?: 'ValidateProductsAvailabilityResult';
  notFound?: Maybe<Array<Scalars['String']['output']>>;
  unavailableForChat?: Maybe<Array<Scalars['ID']['output']>>;
  unavailableForSupplier?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ValidationError = AppsyncError & AppsyncResponse & {
  __typename?: 'ValidationError';
  invalidFields?: Maybe<Array<FieldValidationError>>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

/**
 * Validation rules that can be overridden by users with special permissions.
 * These represent order validation checks that normally prevent order processing.
 */
export type ValidationRule =
  | 'deliveryDateAvailability'
  | 'deliveryDateCutoffTime'
  | 'invalidProduct'
  | 'minimumOrderableAmount'
  | 'productAvailability'
  | 'productCutoffTime'
  | 'productLeadTime'
  | '%future added value';

export type VendorAccountCreateFailure = {
  __typename?: 'VendorAccountCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType;
};

export type VendorAccountCreateInput = {
  /** The id of the vendor in the external payment system (e.g. Two inc - merchantId) */
  externalVendorId: Scalars['String']['input'];
  /** The Choco supplierId */
  vendorId: Scalars['String']['input'];
};

export type VendorAccountCreateResponse = AuthorizationFailure | InputValidationFailure | VendorAccountCreateFailure | VendorAccountCreateSuccess;

export type VendorAccountCreateSuccess = {
  __typename?: 'VendorAccountCreateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType;
};

export type VendorContactInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Represents a specific item in a vendor catalog. */
export type VendorItem = Node & {
  __typename?: 'VendorItem';
  /**
   * Brand name of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the most nested categories that this item belongs to.
   * E.g. the sub-category if the item is assigned to a sub-category.
   */
  categories: Array<VendorItemCategory>;
  /** @deprecated Use the `categories` field instead */
  category?: Maybe<VendorItemCategory>;
  /**
   * Extended description of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  description: Scalars['String']['output'];
  /**
   * Set to true if the item has more variants.
   * This field is not used yet.
   */
  hasVariants: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Set to true if the item was created by the buyer, not vendor. */
  isCustomVendorItem: Scalars['Boolean']['output'];
  /**
   * Name of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  name: Scalars['String']['output'];
  /** ISO 3166 alpha-2 country code of the country where the item came from. */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `VendorItemUnit.productCode` instead */
  productCode?: Maybe<Scalars['String']['output']>;
  /** Returns the units of the item according to the provided filter */
  units: Array<VendorItemUnit>;
  /** Count of units that this item has */
  unitsCount: Scalars['Int']['output'];
  /**
   * Variant group that this item belongs to as an item variant.
   * This field is not used yet.
   */
  variantGroup?: Maybe<VendorItemVariantGroup>;
};


/** Represents a specific item in a vendor catalog. */
export type VendorItemUnitsArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};


/** Represents a specific item in a vendor catalog. */
export type VendorItemUnitsCountArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};

/** Filter input for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatFilter = {
  /** If provided, only categories of the items that have the given stock status will be returned. By default, out-of-stock or discontinued items are excluded. */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus>>;
  /**
   * If provided, only returns categories which are the direct children of the provided category.
   * If the value is "00000000-0000-0000-0000-000000000000", then behaves the same as "rootCategories: true".
   */
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided and set to true, only returns top-level categories, i.e. the ones which do not have a parent.
   * If set to false, does nothing.
   */
  rootCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If provided, only returns categories that have items assigned directly to them or assigned to any of the child/nested categories.
   * @deprecated This is now the default behavior for this query
   */
  withItemsNested?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the categories that have at least one visible item for a given chat
   * via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filter to narrow down the list of the returned categories */
  filter?: InputMaybe<VendorItemCategoriesForChatFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose catalog categories are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCategoriesForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesForChatSuccess;

/** One category of the `vendorItemCategoriesForChat` query result page */
export type VendorItemCategoriesForChatResultEdge = Edge & {
  __typename?: 'VendorItemCategoriesForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemCategory;
};

/** Success response of the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemCategoriesForChatSuccess';
  edges: Array<VendorItemCategoriesForChatResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Filter input for the `vendorItemCategoriesForVendor` query */
export type VendorItemCategoriesForVendorFilter = {
  /** If provided, only returns categories which are the direct children of the provided category. */
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided and set to true, only returns top-level categories, i.e. the ones which do not have a parent.
   * If set to false, does nothing.
   */
  rootCategories?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorItemCategoriesForVendorInput = {
  /** Additional filter to narrow down the list of the returned categories */
  filter?: InputMaybe<VendorItemCategoriesForVendorFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose catalog categories are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCategoriesForVendorResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesForVendorSuccess;

export type VendorItemCategoriesForVendorResultEdge = Edge & {
  __typename?: 'VendorItemCategoriesForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemCategory;
};

export type VendorItemCategoriesForVendorSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemCategoriesForVendorSuccess';
  edges: Array<VendorItemCategoriesForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type VendorItemCategoriesImagesUploadInput = {
  categoryIds: Array<Scalars['ID']['input']>;
};

export type VendorItemCategoriesImagesUploadResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesImagesUploadResult;

export type VendorItemCategoriesImagesUploadResult = AppsyncResponse & {
  __typename?: 'VendorItemCategoriesImagesUploadResult';
  categories: Array<VendorItemCategoriesImagesUploadResultCategory>;
  responseType: ResponseType;
};

export type VendorItemCategoriesImagesUploadResultCategory = {
  __typename?: 'VendorItemCategoriesImagesUploadResultCategory';
  category: VendorItemCategoryRef;
  image: VendorItemCategoriesImagesUploadResultImage;
};

export type VendorItemCategoriesImagesUploadResultImage = {
  __typename?: 'VendorItemCategoriesImagesUploadResultImage';
  /**
   * ID of the image. Use this to associate the image with the vendor item unit
   * by calling the `vendorItemCategoriesUpdate` mutation after the image is uploaded.
   */
  imageId: Scalars['ID']['output'];
  /**
   * URL where the image file should be uploaded to.
   * To upload the file, make the `POST` request to this URL.
   * Use `Content-Type: multipart/form-data`. Provide body in the `FormData` format.
   * There should only be a single binary field named `file` in the form data content.
   *
   * @example
   * ```typescript
   * const formData = new FormData();
   * formData.append('file', file); // where `file` is a File object
   * const response = await fetch(uploadUrl, {
   * method: 'POST',
   * body: formData,
   * });
   * ```
   */
  uploadUrl: Scalars['String']['output'];
};

export type VendorItemCategoriesUpdateInput = {
  categories: Array<VendorItemCategoryUpdateInput>;
};

export type VendorItemCategoriesUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesUpdateResult;

export type VendorItemCategoriesUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemCategoriesUpdateResult';
  categories: Array<VendorItemCategoryRef>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/** Represents a category in a vendor catalog. */
export type VendorItemCategory = Node & {
  __typename?: 'VendorItemCategory';
  id: Scalars['ID']['output'];
  /** The image associated with the vendor item category. */
  image?: Maybe<VendorItemCategoryImage>;
  /**
   * The number of category items including the items of all nested subcategories.
   * Only one item from each variant group is counted which corresponds
   * to the result of the vendorItemsForChat query.
   */
  itemsCountForChat: Scalars['Int']['output'];
  /**
   * Name of the category.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  name: Scalars['String']['output'];
  /** Reference to the direct parent category in case of the nested category structure. */
  parentCategory?: Maybe<VendorItemCategoryRef>;
  /**
   * Reference to the The list of all parents of the current category up to the root category,
   * starting from the direct parent.
   */
  parentCategoryChain: Array<VendorItemCategory>;
};


/** Represents a category in a vendor catalog. */
export type VendorItemCategoryItemsCountForChatArgs = {
  chatId: Scalars['ID']['input'];
};

/**
 * VendorItemCategoryImage represents VendorItemCategory image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemCategoryImage = {
  __typename?: 'VendorItemCategoryImage';
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
};

/**
 * Reference to the VendorItemCategory.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemCategoryRef = RefEdge & {
  __typename?: 'VendorItemCategoryRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemCategory>;
};

export type VendorItemCategoryUpdateInput = {
  categoryId: Scalars['ID']['input'];
  /**
   * ID of the main category image.
   *
   * To create an image, use the `vendorItemCategoriesImagesUpload` mutation.
   * Image must be dedicated to this category.
   *
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorItemCustomBuyerPropertiesInput = {
  chatId: Scalars['ID']['input'];
  /**
   * If sent as null/undefined, it won't be touched/updated
   * If sent as { value: null/undefined }, it will be deleted
   * If sent as { value: MoneyV2Input }, it will be updated
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  /**
   * If sent as null/undefined, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  par?: InputMaybe<Scalars['String']['input']>;
};

export type VendorItemCustomCreateInput = {
  /** ID of the Buyer that manages the item */
  buyerId: Scalars['ID']['input'];
  /** Additional buyer properties */
  buyerProperties?: InputMaybe<VendorItemCustomBuyerPropertiesInput>;
  /** Name of the item */
  name: Scalars['String']['input'];
  /** Product code of the item */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Name of the item unit */
  unit: Scalars['String']['input'];
  /** ID of the Supplier with which the item will be associated */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCustomCreateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCustomCreateResult;

export type VendorItemCustomCreateResult = AppsyncResponse & {
  __typename?: 'VendorItemCustomCreateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  unit: VendorItemUnit;
};

export type VendorItemCustomUpdateInput = {
  buyerProperties?: InputMaybe<VendorItemCustomBuyerPropertiesInput>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as valid value, it will be updated
   * Empty string is not allowed
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as valid value, it will be updated
   * Empty string is not allowed
   */
  unit?: InputMaybe<Scalars['String']['input']>;
  vendorItemId: Scalars['ID']['input'];
};

export type VendorItemCustomUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCustomUpdateResult;

export type VendorItemCustomUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemCustomUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  unit: VendorItemUnit;
};

/**
 * Reference to the VendorItem.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemRef = RefEdge & {
  __typename?: 'VendorItemRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItem>;
};

/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnit = Node & {
  __typename?: 'VendorItemUnit';
  /** The product attributes (allergens and dietary preferences) associated with the vendor item unit. */
  attributes?: Maybe<Array<VendorItemUnitAttribute>>;
  /**
   * Intended for buyer facing frontends:
   * Frontend-specific availability/orderability status of the unit in the context of a given chat.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  availability?: Maybe<VendorItemUnitAvailability>;
  /**
   * Intended for buyer facing frontends:
   * Frontend-specific availability/orderability status of the unit.
   * @deprecated Use the `availability` field instead
   */
  availabilityStatus: VendorItemUnitAvailabilityStatus;
  /** The base unit of item. */
  baseUnit?: Maybe<VendorItemUnit>;
  /**
   * The buyer properties of the vendor item unit.
   * `null` is returned if the vendorItemUnit has no buyer properties.
   * Can be called by: Choco Admins, users of the Buyer to whom the properties belong and related Supplier users.
   */
  buyerProperties?: Maybe<VendorItemUnitBuyerProperties>;
  /** Customer specific information about the product resolved by the Smart Order Service */
  chatProductFeatures?: Maybe<ChatProductFeatures>;
  /**
   * Short code of the unit that is used for matching units during imports.
   * Usually will be set to either `productCode` or `productCode#name` combination,
   * or an internal identifier from the Supplier's ERP.
   */
  code: Scalars['String']['output'];
  /**
   * The display properties of the vendor item unit.
   * These properties are computed out of other properties of the unit and are intended for display purposes.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  displayProperties?: Maybe<VendorItemUnitDisplayProperties>;
  /** The external links associated with the vendor item unit. */
  externalLinks?: Maybe<Array<VendorItemUnitExternalLink>>;
  /**
   * Conversion factor of this unit to its base unit.
   * E.g. if base unit is "g" and this unit is "kg" with a factor "1000", then 1 kg is 1000 g.
   */
  factor: Rational;
  id: Scalars['ID']['output'];
  /**
   * The images associated with the vendor item unit.
   * First image is the main image.
   */
  images: Array<VendorItemUnitImage>;
  /**
   * The information about the inventory of this vendor item unit in the Supplier's warehouse.
   * `null` is returned if the Vendor Item Unit has no inventory data.
   * Can be called by: Choco Admins, users of Supplier owning the unit.
   */
  inventoryData?: Maybe<VendorItemUnitInventoryData>;
  /** Flags if the unit is the base unit for the vendor item */
  isBase: Scalars['Boolean']['output'];
  /**
   * Intended for vendor facing frontends:
   * If `true`, then the unit is not visible in a Chat unless added to a Custom Catalog assigned to it.
   */
  isHiddenByDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Queries the given order guide by Id to determine if the unit is added to it.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat to which the OG is assigned.
   */
  isInOrderGuide: Scalars['Boolean']['output'];
  /** Flags if the unit is available for ordering by buyers. */
  isOrdering: Scalars['Boolean']['output'];
  /** Unit-level override for the item description. If this is set it should be displayed instead of the `VendorItem.description` */
  itemDescriptionOverride?: Maybe<Scalars['String']['output']>;
  /** Unit-level override for the item name. If this is set it should be displayed instead of the `VendorItem.name` */
  itemNameOverride?: Maybe<Scalars['String']['output']>;
  /**
   * Unique identifier of the Product connected to this unit in the old catalog system.
   * Use this when coordinating data with the old catalog queries and mutations.
   * May be an arbitrary string. If not set, fallback to the `id` field, like this: `legacyId ?? id`.
   */
  legacyId?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the unit intended for display to buyers.
   * Can be stored in multiple languages. The returned language is determined by the `Accept-Language` header and available translations.
   */
  name: Scalars['String']['output'];
  orderGuideItemUnit?: Maybe<OrderGuideV2ItemUnit>;
  /**
   * The ordering properties of the vendor item unit.
   * `null` is returned if the vendorItemUnit has no ordering properties.
   */
  orderingProperties?: Maybe<VendorItemUnitOrderingProperties>;
  /**
   * Describes the content of one unit in more detail.
   * Can be stored in multiple languages. The returned language is determined by the `Accept-Language` header and available translations.
   * Formerly called "packSize".
   */
  packagingDescription: Scalars['String']['output'];
  /**
   * The price of the unit.
   * `null` can be returned if the price is not defined or the user do not have access to it.
   */
  price?: Maybe<VendorItemUnitPriceSet>;
  /**
   * This is a short code for the item which is meaningful to the vendor.
   * This field is commonly displayed in Choco as "Product ID", however it is not guaranteed to be unique.
   * It is intended to be consumed by humans and not for technical reasons such as matching.
   * Formerly called "externalId".
   */
  productCode?: Maybe<Scalars['String']['output']>;
  /**
   * Intended for vendor facing frontends: The stock status of the unit.
   * Note that the stock status is not automatically connected to the inventory data.
   */
  stockStatus: VendorItemUnitStockStatus;
  /** Reference to a vendor item that this unit belongs to. */
  vendorItem: VendorItemRef;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitAvailabilityArgs = {
  chatId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitBuyerPropertiesArgs = {
  input: VendorItemUnitBuyerPropertiesInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitChatProductFeaturesArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitDisplayPropertiesArgs = {
  input: VendorItemUnitDisplayPropertiesInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitIsInOrderGuideArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitOrderGuideItemUnitArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitPriceArgs = {
  input?: InputMaybe<VendorItemUnitPriceInput>;
};

export type VendorItemUnitAttribute = {
  __typename?: 'VendorItemUnitAttribute';
  /**
   * Unique identifier of the attribute. Always equal to the value of the `attribute` field.
   * Included for compatibility; do not use if not required.
   */
  id: Scalars['ID']['output'];
  type: CatalogAttributeType;
  values: Array<CatalogAttributeValue>;
};

/**
 * Input for specifying attribute values for a vendor item unit.
 * Exactly one of `valueCodes` or `valueIds` must be provided, not both or neither.
 */
export type VendorItemUnitAttributeInput = {
  type: CatalogAttributeType;
  /**
   * List of value codes for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of value IDs for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemUnitAvailability = {
  __typename?: 'VendorItemUnitAvailability';
  status: VendorItemUnitAvailabilityStatus;
};

/** Computed availability status for the VendorItemUnit that is intended for buyer facing frontends */
export type VendorItemUnitAvailabilityStatus =
  /** This unit is available for ordering but the stock status is unknown */
  | 'Available'
  /**
   * This unit is not available for ordering because it is discontinued
   * and will not return to the catalog in the observable future.
   */
  | 'Discontinued'
  /** This unit is available for ordering and is in stock */
  | 'InStock'
  /** This unit is not available for ordering because it is out of stock */
  | 'OutOfStock'
  /** This unit is not available for ordering for the unknown reason */
  | 'Unavailable'
  | '%future added value';

export type VendorItemUnitBuyerProperties = {
  __typename?: 'VendorItemUnitBuyerProperties';
  /** Override for the name of the item that only this Buyer will see. */
  displayItemName?: Maybe<Scalars['String']['output']>;
  /**
   * This ID filed is computed as `${vendorItemUnitId}:${buyerId}:${chatId}`.
   * Only intended for the frontend caching and watching.
   */
  id: Scalars['ID']['output'];
  /** Free-form text value specifying how many units of the item Buyer wants to keep in stock. */
  par?: Maybe<Scalars['String']['output']>;
};

export type VendorItemUnitBuyerPropertiesInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};

export type VendorItemUnitBuyerPropertiesUpdateBatchResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitBuyerPropertiesUpdateBatchResult;

export type VendorItemUnitBuyerPropertiesUpdateBatchResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitBuyerPropertiesUpdateBatchResult';
  /** The updated buyer properties of the vendor item unit in the order there were sent. */
  buyerProperties: Array<VendorItemUnitBuyerProperties>;
  /** Response type will will be `success` if all updates succeeded, otherwise it will be `failure` */
  responseType: ResponseType;
};

/**
 * Input for updating buyer properties of a vendor item unit.
 * Check the `VendorItemUnitBuyerProperties` type for more details on the fields.
 */
export type VendorItemUnitBuyerPropertiesUpdateInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  displayItemName?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as `{ value: null | undefined }`, it will be deleted
   * If sent as `{ value : MoneyV2Input }`, it will be updated
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  par?: InputMaybe<Scalars['String']['input']>;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitBuyerPropertiesUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitBuyerPropertiesUpdateResult;

export type VendorItemUnitBuyerPropertiesUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitBuyerPropertiesUpdateResult';
  /** The updated buyer properties of the vendor item unit */
  buyerProperties: VendorItemUnitBuyerProperties;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/**
 * This type is created to bundle buyer price with buyer properties
 * It is intended to phase out VendorItemUnitBuyerProperties in favor of this type
 * and return this whenever the buyer properties is requested.
 */
export type VendorItemUnitBuyerPropertiesWithPrice = {
  __typename?: 'VendorItemUnitBuyerPropertiesWithPrice';
  displayItemName?: Maybe<Scalars['String']['output']>;
  myPrice?: Maybe<MoneyV2>;
  par?: Maybe<Scalars['String']['output']>;
};

export type VendorItemUnitCustomerSpecificPriceUpdateInput = {
  buyerId: Scalars['ID']['input'];
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as `{ value: null | undefined }`, it will be deleted
   * If sent as `{ value : MoneyV2Input }`, it will be updated
   */
  price?: InputMaybe<NullableMoneyV2Input>;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitCustomerSpecificPriceUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitCustomerSpecificPriceUpdateResult;

export type VendorItemUnitCustomerSpecificPriceUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitCustomerSpecificPriceUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  vendorItemUnit: VendorItemUnitRef;
};

export type VendorItemUnitDisplayProperties = {
  __typename?: 'VendorItemUnitDisplayProperties';
  /**
   * The description of the item unit.
   * This field will be `VendorItemUnit.itemDescriptionOverride` || `VendorItem.description`.
   */
  itemDescription: Scalars['String']['output'];
  /**
   * The display name of the item unit.
   * If the user is a buyer user, this field will be `vendorItemUnit.buyerProperties.displayItemName` || `VendorItemUnit.itemNameOverride` || `VendorItem.name`.
   * If the user is a supplier user, this field will be `VendorItemUnit.itemNameOverride` || `VendorItem.name`.
   */
  itemName: Scalars['String']['output'];
};

export type VendorItemUnitDisplayPropertiesInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** External link for a vendor item unit */
export type VendorItemUnitExternalLink = {
  __typename?: 'VendorItemUnitExternalLink';
  /** Unique identifier of the external link */
  id: Scalars['ID']['output'];
  /** Title of the external link */
  title: Scalars['String']['output'];
  /** Translations for the external link title */
  translations?: Maybe<Array<VendorItemUnitExternalLinkTranslation>>;
  /** URL of the external link */
  url: Scalars['String']['output'];
};

/** Input for creating or updating an external link */
export type VendorItemUnitExternalLinkInput = {
  /** Translations for the external link title */
  translations?: InputMaybe<Array<VendorItemUnitExternalLinkTranslationInput>>;
  /** URL of the external link */
  url: Scalars['String']['input'];
};

/** External link translation */
export type VendorItemUnitExternalLinkTranslation = {
  __typename?: 'VendorItemUnitExternalLinkTranslation';
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['output'];
  /** Title in the specified locale */
  title: Scalars['String']['output'];
};

/** Input for external link translation */
export type VendorItemUnitExternalLinkTranslationInput = {
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['input'];
  /** Title in the specified locale */
  title: Scalars['String']['input'];
};

/**
 * VendorItemUnitImage represents VendorItemUnit image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemUnitImage = {
  __typename?: 'VendorItemUnitImage';
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
};

export type VendorItemUnitImagesUploadInput = {
  /**
   * Number of images to create for the unit.
   * If not provided, the default value is 1
   */
  imagesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the vendor item unit for which images are requested. */
  vendorItemUnitId: Scalars['ID']['input'];
};

/** Inventory data for a VendorItemUnit, with stock quantities. */
export type VendorItemUnitInventoryData = {
  __typename?: 'VendorItemUnitInventoryData';
  /**
   * Computed field representing the total available stock that can be allocated or promised.
   * If the `onPurchaseOrderDeliveryDate` is set, then the quantity is in this field is assumed to be at that date.
   */
  availableStock?: Maybe<Decimal>;
  id: Scalars['ID']['output'];
  /** Timestamp of the latest inventory update */
  lastUpdatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The physical quantity of the item unit currently available in the warehouse as of now. */
  onHandQuantity?: Maybe<Decimal>;
  /** The quantity of the vendor item unit that has been ordered but has not yet been deducted from on-hand stock. */
  onOrderQuantity?: Maybe<Decimal>;
  /**
   * Expected delivery date for the current purchase order from the producer.
   * If null, the delivery date is unknown.
   */
  onPurchaseOrderDeliveryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  /**
   * The quantity of the vendor item unit that has been ordered by the distributor
   * and is being delivered by the producer.
   */
  onPurchaseOrderQuantity?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type VendorItemUnitOrderingProperties = {
  __typename?: 'VendorItemUnitOrderingProperties';
  /**
   * The time of day that the item unit should be ordered by in order to be delivered on the same day
   * or on the closest day according to the lead time.
   * This is always returned in a Supplier Timezone.
   * If unset then there is no limitation.
   */
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * `deliveryDateConditions` retrieves the earliest possible delivery date for a product and determines whether this date should be displayed to clients. This is calculated based on several factors:
   * - `leadTime`: The amount of time for a product to be ready for delivery.
   * - `cutoffTime`: The latest time an order can be placed to be shipped on the same day.
   * - `supplier delivery settings`: These settings may include factors like supplier's working days, holidays, and other conditions that could affect the delivery date.
   */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  id: Scalars['ID']['output'];
  /**
   * The number of days this item unit should be ordered in advance.
   * If unset then the item unit can be ordered on the same day.
   */
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  /**
   * The minimum fraction step that the item unit can be ordered in,
   * e.g. 0.05 would mean that the item unit can be ordered in increments of 0.05.
   * If unset then the item unit can only be ordered in whole numbers.
   */
  minimumFractionalQuantity?: Maybe<Decimal>;
  /**
   * The minimum quantity of the item unit that can be ordered.
   * This value represents the smallest amount that a customer can purchase.
   * For example, if set to 5, customers must order at least 5 units of this item.
   * If unset, there is no minimum ordering quantity enforced.
   */
  minimumOrderingQuantity?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};


export type VendorItemUnitOrderingPropertiesDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};

export type VendorItemUnitPriceInput = {
  /**
   * If the price is queried by a buyer user, this field must be populated with the buyer ID, otherwise the price will be returned as null
   * If the price is queried by a vendor user in context of a chat, this field must be populated with the buyer ID
   */
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** A chat in which context the price is requested. If the chatId is not provided, the price will be returned as null for buyer users. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided, only returns prices which are valid at the requested datetime, if not provided, only the prices valid now are returned */
  validityDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type VendorItemUnitPriceSet = Node & {
  __typename?: 'VendorItemUnitPriceSet';
  /** The buyer price for the unit */
  buyerPrice?: Maybe<MoneyV2>;
  /** The display base price for the unit */
  displayBasePrice?: Maybe<MoneyV2>;
  /** The display base price before applying the discount */
  displayBasePriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The display catalog price for the unit */
  displayCatalogPrice?: Maybe<MoneyV2>;
  /** The display catalog price before applying the discount */
  displayCatalogPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The display price for the unit */
  displayPrice: MoneyV2;
  /** The display price before applying the discount */
  displayPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** VendorItemUnitPriceSet ID */
  id: Scalars['ID']['output'];
};

/**
 * Reference to the VendorItemUnit.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemUnitRef = {
  __typename?: 'VendorItemUnitRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemUnit>;
};

/**
 * Stock status of the vendor item unit.
 * Determines whether the item unit is available for ordering on a catalog level.
 * Availability may be further restricted by the supplier, chat or custom catalog settings.
 */
export type VendorItemUnitStockStatus =
  | 'Discontinued'
  | 'InStock'
  | 'OutOfStock'
  | '%future added value';

export type VendorItemUnitUpdateFailure = {
  __typename?: 'VendorItemUnitUpdateFailure';
  failureType: VendorItemUnitUpdateFailureType;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type VendorItemUnitUpdateFailureType = AuthorizationFailure | InputValidationFailure | UnknownFailure;

/**
 * Changes that will be applied to the vendor item unit.
 * If a field is omitted, it will not be touched.
 * Check the `VendorItemUnit` type for documentation of the fields.
 */
export type VendorItemUnitUpdateInput = {
  /**
   * List of attributes to update for the vendor item unit.
   * If the field is not provided or the list is empty, the existing attributes will not be changed.
   * If the list is not empty, the assigned values for provided attributes will be completely replaced with the new ones, but attributes which are not provided will not be changed.
   */
  attributes?: InputMaybe<Array<VendorItemUnitAttributeInput>>;
  /**
   * List of external links to update for the vendor item unit.
   * If the field is not provided, the existing external links will not be changed.
   * If the list is empty, all external links will be removed.
   * If the list is not empty, the existing external links will be completely replaced with the new ones.
   */
  externalLinks?: InputMaybe<Array<VendorItemUnitExternalLinkInput>>;
  /**
   * List of image IDs that should be associated with the item unit.
   * First image in the list is considered the main image.
   * To create an image, use the `vendorItemUnitsImagesUpload` mutation.
   * Image must be dedicated to this vendor item unit.
   *
   * If the field is not provided, the existing images will not be changed.
   * If the list is empty, all images will be removed.
   * If the list is not empty, the existing images will be completely replaced with the new ones.
   */
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  stockStatus?: InputMaybe<VendorItemUnitStockStatus>;
  /** ID of the vendor item unit to update. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitUpdateResult;

export type VendorItemUnitUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  unit: VendorItemUnit;
};

/** Filter input for the `VendorItem.units` field */
export type VendorItemUnitsFilter = {
  /**
   * When provided and set to true, returns only the units that are available for ordering.
   * Does nothing if set to false.
   */
  isOrdering?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorItemUnitsForVendorSearchFilter = {
  /** When specified, only items that are linked to the given custom catalog will be returned, */
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /** When specified, returns items based on their hidden by default status, including those hidden or not hidden depending on the value provided. */
  isHiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** When specified, only items that have the given stock status will be returned. */
  stockStatus?: InputMaybe<VendorItemUnitStockStatus>;
  /**
   * If multiple categories are provided, items from all of them are returned.
   * Can be set to 0-uuid to get "uncategorized"
   */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemUnitsForVendorSearchInput = {
  filter?: InputMaybe<VendorItemUnitsForVendorSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorItemUnitsImagesUploadInput = {
  /** Units for which images are requested. */
  units: Array<VendorItemUnitImagesUploadInput>;
};

export type VendorItemUnitsImagesUploadResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsImagesUploadResult;

export type VendorItemUnitsImagesUploadResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitsImagesUploadResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  units: Array<VendorItemUnitsImagesUploadResultUnit>;
};

export type VendorItemUnitsImagesUploadResultImage = {
  __typename?: 'VendorItemUnitsImagesUploadResultImage';
  /**
   * ID of the image. Use this to associate the image with the vendor item unit
   * by calling the `vendorItemUnitsUpdate` mutation after the image is uploaded.
   */
  imageId: Scalars['ID']['output'];
  /**
   * URL where the image file should be uploaded to.
   * To upload the file, make the `POST` request to this URL.
   * Use `Content-Type: multipart/form-data`. Provide body in the `FormData` format.
   * There should only be a single binary field named `file` in the form data content.
   *
   * @example
   * ```typescript
   * const formData = new FormData();
   * formData.append('file', file); // where `file` is a File object
   * const response = await fetch(uploadUrl, {
   *   method: 'POST',
   *   body: formData,
   * });
   * ```
   */
  uploadUrl: Scalars['String']['output'];
};

export type VendorItemUnitsImagesUploadResultUnit = {
  __typename?: 'VendorItemUnitsImagesUploadResultUnit';
  images: Array<VendorItemUnitsImagesUploadResultImage>;
  vendorItemUnit: VendorItemUnitRef;
};

export type VendorItemUnitsResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsResult;

export type VendorItemUnitsResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitsResult';
  itemUnits: Array<VendorItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type VendorItemUnitsUpdateInput = {
  units: Array<VendorItemUnitUpdateInput>;
};

export type VendorItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsUpdateResult;

export type VendorItemUnitsUpdateResult = {
  __typename?: 'VendorItemUnitsUpdateResult';
  failures?: Maybe<Array<VendorItemUnitUpdateFailure>>;
  updatedUnits?: Maybe<Array<VendorItemUnit>>;
};

/** A variant group is a set of items that are similar to each other but have different properties. */
export type VendorItemVariantGroup = Node & {
  __typename?: 'VendorItemVariantGroup';
  /**
   * Code of the variant group that is meaningful to the vendor.
   * Note that this is not a technical property and it can be filled by humans.
   */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Filter input for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatFilter = {
  /** If provided, only items that have the given stock status will be counted. By default, out-of-stock or discontinued items are excluded. */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus>>;
  /**
   * if true only counts items without a category
   * if false returns the total count of vendor items in the chat
   */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat
   * via a custom catalog or default catalog relationship are counted.
   */
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsCountForChatFilter>;
  /** Id of the vendor whose catalog items are being counted */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsCountForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemsCountForChatSuccess;

/** Success response of the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsCountForChatSuccess';
  count: Scalars['Int']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

/**
 * Filter input for the `vendorItemsForChat` query
 * Note: If both "vendorItemCategoryId" and "vendorItemCategoryAncestorId" filters are provided, they are both applied independently and combined with an "AND"
 */
export type VendorItemsForChatFilterInput = {
  /** Filter by product attributes (allergens and dietary preferences). */
  attributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /** If provided, only items that have the given stock status will be returned. */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus>>;
  /**
   * If provided, only items that have the given barcode (EAN or UPC) will be returned.
   * The barcode should be valid EAN or UPC, otherwise a validation error will be returned.
   */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** If provided, only items with the given `variantGroupCode` will be returned. */
  variantGroupCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * If the value is "00000000-0000-0000-0000-000000000000", only items that are not linked to any category are returned;
   * else only items belonging to the category with a given ID or any of its subcategories will be returned.
   */
  vendorItemCategoryAncestorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If the value is "00000000-0000-0000-0000-000000000000", only items that are not linked to any category are returned;
   * else only items directly linked to this category will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input parameters for the `vendorItemsForChat` query */
export type VendorItemsForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<VendorItemsForChatFilterInput>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose items are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemsForChatSuccess;

/** One item of the `vendorItemsForChat` query result page */
export type VendorItemsForChatResultEdge = Edge & {
  __typename?: 'VendorItemsForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

export type VendorItemsForChatSearchFilter = {
  /** If provided, only items that have the given stock status will be returned. By default, out-of-stock or discontinued items are excluded. */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus>>;
  /**
   * The ID of the order guide category to filter by.
   * If provided, only items in the specified category will be returned.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the order guide to get the items for. */
  orderGuideId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If multiple categories are provided, items from all of them are returned.
   * Can be set to 0-uuid to get "uncategorized"
   */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemsForChatSearchInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsForChatSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Success response of the `vendorItemsForChat` query */
export type VendorItemsForChatSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemsForChatSuccess';
  edges: Array<VendorItemsForChatResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Metadata related to the result set. Will only be present on search endpoints. */
  searchMetadata?: Maybe<CatalogSearchMetadata>;
};

/**
 * The filter can be applied to vendor items.
 * Note: If both "vendorItemCategoryIds" and "vendorItemCategoryAncestorIds" filters are provided, they are both applied independently and combined with an "AND"
 */
export type VendorItemsForVendorFilter = {
  /** Filter by product attributes (allergens and dietary preferences). */
  attributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /** When specified, only items that are linked to the given custom catalog will be returned. */
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /** When specified, returns items based on their hidden by default status, including those hidden or not hidden depending on the value provided. */
  isHiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** When specified, only items that have the given stock status will be returned. */
  status?: InputMaybe<VendorItemUnitStockStatus>;
  /** When specified, only items belonging to the given category or its descendants will be returned. */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If the array has the value "00000000-0000-0000-0000-000000000000", items that are not linked to any category are also returned;
   * else only items directly linked to the given categories will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input parameters for the `vendorItemsForVendor` query */
export type VendorItemsForVendorInput = {
  filter?: InputMaybe<VendorItemsForVendorFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  sort?: InputMaybe<VendorItemsForVendorSort>;
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsForVendorResponse = AuthorizationFailure | InputValidationFailure | VendorItemsForVendorResult;

/** Success response of the `vendorItemsForVendor` query */
export type VendorItemsForVendorResult = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemsForVendorResult';
  edges: Array<VendorItemsForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
  /** Metadata related to the result set. Will only be present on search endpoints. */
  searchMetadata?: Maybe<CatalogSearchMetadata>;
  /** The total number of items matching the filter criteria. */
  totalCount: Scalars['Int']['output'];
};

export type VendorItemsForVendorResultEdge = Edge & {
  __typename?: 'VendorItemsForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

/** Sorting parameters for VendorItems, indicating the field and the direction of order. */
export type VendorItemsForVendorSort = {
  field: VendorItemsForVendorSortField;
  order: SortOrder;
};

/** Sort fields available for organizing VendorItems results. */
export type VendorItemsForVendorSortField =
  | 'name'
  | 'productCode'
  | 'unitName'
  | '%future added value';

/** Input parameters for the `vendorItems` query */
export type VendorItemsInput = {
  /** An array of the item ids to fetch. Maximum 50 items can be fetched at a time. */
  ids: Array<Scalars['ID']['input']>;
};

export type VendorItemsResponse = AuthorizationFailure | InputValidationFailure | VendorItemsSuccess;

/** Success response of the `vendorItems` query */
export type VendorItemsSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsSuccess';
  /**
   * Items that are fetched.
   * If the item is not found, it is not included in the list.
   */
  items: Array<VendorItem>;
  /** Response type will always be set to `success` */
  responseType: ResponseType;
};

export type WebHomePageBannerInfoFullWidthContent = {
  __typename?: 'WebHomePageBannerInfoFullWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
  squareBannerImageUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebHomePageBannerInfoHalfWidthContent = {
  __typename?: 'WebHomePageBannerInfoHalfWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
};

export type WebHomePageBannerShoppableFullWidthContent = {
  __typename?: 'WebHomePageBannerShoppableFullWidthContent';
  chat?: Maybe<Chat>;
  horizontalBannerImageUrl: Scalars['String']['output'];
  promoPageContent: PromoPageContent;
  squareBannerImageUrl: Scalars['String']['output'];
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type WebHomePageBannerShoppableHalfWidthContent = {
  __typename?: 'WebHomePageBannerShoppableHalfWidthContent';
  chat?: Maybe<Chat>;
  promoPageContent: PromoPageContent;
  squareBannerImageUrl: Scalars['String']['output'];
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type WebHomePagePopupInfoFullPageContent = {
  __typename?: 'WebHomePagePopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebPostOrderPopupInfoFullPageContent = {
  __typename?: 'WebPostOrderPopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebhookAuthenticationInput = {
  type: WebhookAuthenticationType;
};

export type WebhookAuthenticationType =
  | 'BASIC'
  | 'SIGNATURE'
  | '%future added value';

export type WeekdayBasedCutoffSettings = {
  __typename?: 'WeekdayBasedCutoffSettings';
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  fri?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  mon?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sat?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sun?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  thu?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  tue?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  wed?: Maybe<CutoffSetting>;
};

export type WeekdayBasedCutoffSettingsInput = {
  fri?: InputMaybe<CutoffSettingInput>;
  mon?: InputMaybe<CutoffSettingInput>;
  sat?: InputMaybe<CutoffSettingInput>;
  sun?: InputMaybe<CutoffSettingInput>;
  thu?: InputMaybe<CutoffSettingInput>;
  tue?: InputMaybe<CutoffSettingInput>;
  wed?: InputMaybe<CutoffSettingInput>;
};

export type WhatsAppMessage = {
  __typename?: 'WhatsAppMessage';
  accountSid: Scalars['String']['output'];
  apiVersion?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  forwarded?: Maybe<Scalars['Boolean']['output']>;
  frequentlyForwarded?: Maybe<Scalars['Boolean']['output']>;
  from: Scalars['String']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  mediaElements?: Maybe<Array<WhatsAppMessageMedia>>;
  messageSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  originalRepliedMessageSender?: Maybe<Scalars['String']['output']>;
  originalRepliedMessageSid?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  to: Scalars['String']['output'];
  toCity?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
  whatsAppMessageId: Scalars['String']['output'];
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
  whatsappId?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppMessageMedia = {
  __typename?: 'WhatsAppMessageMedia';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
};

export type WithCutoffSetting = {
  __typename?: 'WithCutoffSetting';
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime: Scalars['AWSTime']['output'];
  /** in days */
  leadTime: Scalars['Int']['output'];
  type: WithCutoffType;
};

export type WithCutoffType =
  | 'flexible'
  | 'strict'
  | '%future added value';

export type Word = {
  __typename?: 'Word';
  start: StartOffSet;
  word: Scalars['String']['output'];
};

export type XlsxAttachmentRef = {
  __typename?: 'XlsxAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  sheetName?: Maybe<Scalars['String']['output']>;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type AutopilotSubscriptionResponse = AuthorizationFailure | AutopilotOrderCreatedNotification;

export type CreateSubCatalogResponse = CreateSubCatalogError | SubCatalog;

export type DeleteSubCatalogResponse = DeleteSubCatalogError | DeleteSubCatalogSuccess;

export type InviteNonChocoUserToBuyerResponse = BuyerNotFound | BuyerUser | ExistingInvitedUser | InvitorNotFound | PuppyValidationFailure;

export type OmnichannelOrderStatusSubscriptionResponse = AuthorizationFailure | BulkOrderRejectedNotification | OmnichannelOrderCreatedNotification | OrderAcceptedNotification | OrderConfirmedNotification | OrderRejectedNotification | TransmissionCreatedNotification | TransmissionReceivedNotification;

export type SupplierAssortments = {
  __typename?: 'supplierAssortments';
  assortments: Array<Scalars['String']['output']>;
};

export type TransmissionV2SubscriptionResponse = AuthorizationFailure | TransmissionV2OrdersFullyProcessedNotification | TransmissionV2ProcessedNotification | TransmissionV2ReceivedNotification;

export type UpdateSubCatalogResponse = SubCatalog | UpdateSubCatalogError;

export type BuyerDetailsBaseFragmentFragment = { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null };

export type BuyerDetailsFragmentFragment = { __typename?: 'Buyer', rolesEnabled?: boolean | null, status?: BuyerStatus | null, createdContext?: BuyerCreatedContext | null, id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null };

export type BuyerSearchFragmentFragment = { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null };

export type BuyerSearchItemFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type BuyersPageBuyerFragmentFragment = { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type BuyersPageBuyerDetailsFragmentFragment = { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type UserRequestToJoinFragmentFragment = { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } };

export type AddUserToChatsMutationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddUserToChatsMutationMutation = { __typename?: 'Mutation', addUserToChats: boolean };

export type BuyerAddUserMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  buyerUserInput?: InputMaybe<BuyerUserInput>;
}>;


export type BuyerAddUserMutationMutation = { __typename?: 'Mutation', buyerAddUser: { __typename?: 'BuyerUser', buyerId: string, userId: string, role?: string | null } };

export type BuyerDisableRolesMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type BuyerDisableRolesMutationMutation = { __typename?: 'Mutation', buyerDisableRoles: { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null } | { __typename?: 'NotFoundError', responseType: ResponseType, message?: string | null } };

export type BuyerEnableRolesMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type BuyerEnableRolesMutationMutation = { __typename?: 'Mutation', buyerDisableRoles: { __typename: 'Buyer', id: string, rolesEnabled?: boolean | null } | { __typename: 'NotFoundError', responseType: ResponseType, message?: string | null } };

export type BuyerRemoveUserMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type BuyerRemoveUserMutationMutation = { __typename?: 'Mutation', buyerRemoveUser: { __typename?: 'BuyerUser', buyerId: string, userId: string, buyer?: { __typename?: 'Buyer', rolesEnabled?: boolean | null } | null } };

export type BuyersPageCreateBuyerMutationVariables = Exact<{
  buyerInput: BuyerCreateInput;
}>;


export type BuyersPageCreateBuyerMutation = { __typename?: 'Mutation', buyerCreate: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type BuyersPageUpdateBuyerMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  buyerInput: BuyerUpdateInput;
}>;


export type BuyersPageUpdateBuyerMutation = { __typename?: 'Mutation', buyerUpdate: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type CreateBuyerMutationMutationVariables = Exact<{
  buyerCreateInput: BuyerCreateInput;
}>;


export type CreateBuyerMutationMutation = { __typename?: 'Mutation', buyerCreate: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } };

export type CreateUserMutationMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;


export type CreateUserMutationMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, phone: string, isTest?: boolean | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, fax?: string | null, sms?: string | null, whatsApp?: string | null } | null } | null };

export type CreateUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, phone: string, isTest?: boolean | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, fax?: string | null, sms?: string | null, whatsApp?: string | null } | null };

export type RemoveUserFromChatsMutationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUserFromChatsMutationMutation = { __typename?: 'Mutation', removeUserFromChats: boolean };

export type EditBuyerMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  buyerUpdateInput: BuyerUpdateInput;
}>;


export type EditBuyerMutationMutation = { __typename?: 'Mutation', buyerUpdate: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } };

export type UpdateRequestToJoinMutationMutationVariables = Exact<{
  input: UpdateJoinRequestInput;
}>;


export type UpdateRequestToJoinMutationMutation = { __typename?: 'Mutation', updateRequestToJoin: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'UpdateJoinRequestError', message?: string | null } | { __typename: 'UpdateJoinRequestSuccess', id: string, status: JoinRequestAllowedUpdateStatus } };

export type UpdateJoinRequestSuccessFragmentFragment = { __typename: 'UpdateJoinRequestSuccess', id: string, status: JoinRequestAllowedUpdateStatus };

export type BuyersPageGetBuyerDetailsQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type BuyersPageGetBuyerDetailsQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null };

export type BuyersPageSearchBuyersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type BuyersPageSearchBuyersQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type GetBuyerDetailsQueryQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type GetBuyerDetailsQueryQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', rolesEnabled?: boolean | null, status?: BuyerStatus | null, createdContext?: BuyerCreatedContext | null, id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } | null };

export type GetBuyerEntityChatsQueryQueryVariables = Exact<{
  buyerEntityId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyerEntityChatsQueryQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type BuyerSearchChatItemFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type BuyerSearchChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null };

export type GetBuyerFacetsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuyerFacetsQueryQuery = { __typename?: 'Query', buyerFacets?: Array<{ __typename?: 'BuyerFacetsResponse', country?: string | null, cities?: Array<{ __typename?: 'CityWithOffsets', city?: string | null, utcOffsets?: Array<number | null> | null }> | null }> | null };

export type BuyerFacetFragmentFragment = { __typename?: 'BuyerFacetsResponse', country?: string | null, cities?: Array<{ __typename?: 'CityWithOffsets', city?: string | null, utcOffsets?: Array<number | null> | null }> | null };

export type GetBuyerUsersQueryQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBuyerUsersQueryQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } }> } | null } | null };

export type BuyerUsersBuyerFragmentFragment = { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } }> } | null };

export type BuyerUserEdgeFragmentFragment = { __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type BuyerUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type GetRequestsToJoinQueryVariables = Exact<{
  buyerId: Scalars['String']['input'];
  statusFilter?: InputMaybe<JoinRequestStatus>;
}>;


export type GetRequestsToJoinQuery = { __typename?: 'Query', getRequestsToJoin: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'RequestsToJoinConnection', edges: Array<{ __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } }> } };

export type RequestsToJoinConnectionFragmentFragment = { __typename?: 'RequestsToJoinConnection', edges: Array<{ __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } }> };

export type RequestToJoinEdgeFragmentFragment = { __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } };

export type GetBuyersQueryQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyersQueryQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type UserSearchQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  query: UserSearchInput;
}>;


export type UserSearchQueryQuery = { __typename?: 'Query', userSearch: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string } }> } };

export type UserSearchConnectionFragmentFragment = { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string } }> };

export type UserSearchEdgeFragmentFragment = { __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string } };

export type UserSearchUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, phone: string };

export type UserSearchInputValidationFailureFragment = { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType };

export type UserSearchAuthorizationFailureFragment = { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType };

export type ChatDetailsFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null };

export type ChatSupplierUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null };

export type ChatUsersFragmentFragment = { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } };

export type ChatUserEdgeFragmentFragment = { __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } };

export type ChatUserFragmentFragment = { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null };

export type DeliverySettingFragmentFragment = { __typename?: 'SupplierDeliverySetting', id: string, cutoffType?: CutOffTimeType | null, cutoffTimes: { __typename?: 'WeekdayBasedCutoffSettings', mon?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } };

export type HistoryUserFragmentFragment = { __typename?: 'User', name?: string | null, phone: string };

export type ChatIntegrationEmailOptionFragmentFragment = { __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null };

export type OrderPreferenceFragmentFragment = { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null };

export type SubCatalogsForChatFragmentFragment = { __typename?: 'GetSubCatalogsForChatResult', subCatalogs: Array<{ __typename?: 'SubCatalog', id: string, name: string }> };

export type SubCatalogForChatDataFragmentFragment = { __typename?: 'SubCatalog', id: string, name: string };

export type AddChatUsersDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddChatUsersDataMutationMutation = { __typename?: 'Mutation', chatInviteUsers: { __typename: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type ChatPricesVisibilityUpdateMutationVariables = Exact<{
  input: ChatPricesVisibilityUpdateInput;
}>;


export type ChatPricesVisibilityUpdateMutation = { __typename?: 'Mutation', chatPricesVisibilityUpdate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type AddChatUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddChatUsersMutation = { __typename?: 'Mutation', chatInviteUsers: { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type RemoveChatUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveChatUsersMutation = { __typename?: 'Mutation', chatRemoveUsers: { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type UpdateDeliverySettingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cutoffTimes: WeekdayBasedCutoffSettingsInput;
}>;


export type UpdateDeliverySettingMutation = { __typename?: 'Mutation', updateSupplierDeliverySetting?: { __typename?: 'SupplierDeliverySetting', id: string } | null };

export type DeleteChatDeliverySettingMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type DeleteChatDeliverySettingMutation = { __typename?: 'Mutation', deleteChatDeliverySetting?: { __typename?: 'DeletedChatSetting', id: string } | null };

export type RemoveCcEmailFromChatsDataMutationVariables = Exact<{
  email: Scalars['AWSEmail']['input'];
}>;


export type RemoveCcEmailFromChatsDataMutation = { __typename?: 'Mutation', removeCCEmailFromChats: { __typename?: 'RemoveCCEmailFromChatsReport', numberOfChatsUpdated: number } };

export type UpdateSubCatalogChatsMutationVariables = Exact<{
  create: Array<SubCatalogChatInput> | SubCatalogChatInput;
  remove: Array<SubCatalogChatInput> | SubCatalogChatInput;
}>;


export type UpdateSubCatalogChatsMutation = { __typename?: 'Mutation', updateSubCatalogChats: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'UpdateSubCatalogChatsResult', errors: Array<{ __typename?: 'InvalidSubCatalogChat', subCatalogId: string, reason?: string | null }> } };

export type UpdateSubCatalogChatsResultFragmentFragment = { __typename?: 'UpdateSubCatalogChatsResult', errors: Array<{ __typename?: 'InvalidSubCatalogChat', subCatalogId: string, reason?: string | null }> };

export type UpdateSupplierBuyerMovMutationVariables = Exact<{
  input: Array<UpdateSupplierBuyerMovInput> | UpdateSupplierBuyerMovInput;
}>;


export type UpdateSupplierBuyerMovMutation = { __typename?: 'Mutation', updateSupplierBuyerMov?: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'MinimumOrderValueFailure', message?: string | null } | { __typename: 'MinimumOrderValueUpdate', success: boolean } | null };

export type RemoveSupplierBuyerMovMutationVariables = Exact<{
  input: Array<RemoveSupplierBuyerMovInput> | RemoveSupplierBuyerMovInput;
}>;


export type RemoveSupplierBuyerMovMutation = { __typename?: 'Mutation', removeSupplierBuyerMov?: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'MinimumOrderValueFailure', message?: string | null } | { __typename: 'MinimumOrderValueUpdate', success: boolean } | null };

export type ChatUpdateDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type ChatUpdateDataMutationMutation = { __typename?: 'Mutation', chatUpdate: { __typename: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null } };

export type UpdateChatDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatDataMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null } };

export type UpdateChatBasicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatBasicMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string } };

export type UpdateChatEnabledDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateChatEnabledDataMutationMutation = { __typename?: 'Mutation', updateChatEnabled: boolean };

export type UpdateChatNotificationPreferencesDataMutationMutationVariables = Exact<{
  input?: InputMaybe<ChatNotificationInput>;
}>;


export type UpdateChatNotificationPreferencesDataMutationMutation = { __typename?: 'Mutation', updateChatNotificationPreferences?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatPricesVisibilityUpdateMutationMutationVariables = Exact<{
  input: ChatPricesVisibilityUpdateInput;
}>;


export type ChatPricesVisibilityUpdateMutationMutation = { __typename?: 'Mutation', chatPricesVisibilityUpdate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type UpdateChatSettingsDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatSettingsDataMutationMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null } };

export type UpdateDeliverySettingMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cutoffTimes: WeekdayBasedCutoffSettingsInput;
}>;


export type UpdateDeliverySettingMutationMutation = { __typename?: 'Mutation', updateSupplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string } | null };

export type ChatHistoryDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatHistoryDataQuery = { __typename?: 'Query', messages: { __typename?: 'ChatMessageConnection', edges?: Array<{ __typename?: 'ChatMessageEdge', node: { __typename?: 'Message', id: string, body: string, createdAt: number, user: { __typename?: 'User', name?: string | null, phone: string }, attachment?: { __typename?: 'BroadcastAttachment' } | { __typename?: 'Event' } | { __typename?: 'Media', url?: string | null } | null, chat: { __typename?: 'Chat', supplier?: { __typename?: 'User', name?: string | null, phone: string } | null }, order?: { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null } | null } }> | null } };

export type HistoryMessageFragmentFragment = { __typename?: 'Message', id: string, body: string, createdAt: number, user: { __typename?: 'User', name?: string | null, phone: string }, attachment?: { __typename?: 'BroadcastAttachment' } | { __typename?: 'Event' } | { __typename?: 'Media', url?: string | null } | null, chat: { __typename?: 'Chat', supplier?: { __typename?: 'User', name?: string | null, phone: string } | null }, order?: { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null } | null };

export type HistoryOrderFragmentFragment = { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null };

export type HistoryOrderProductFragmentFragment = { __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } };

export type HistoryProductFragmentFragment = { __typename?: 'Product', id: string, unit?: string | null, name: string };

export type ChatSearchDataQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  searchEntity?: InputMaybe<SearchEntityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type ChatSearchDataQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type ChatSearchEntityFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type ChatSearchChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } };

export type SearchBuyersForChatQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type SearchBuyersForChatQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, displayName?: string | null, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type SearchSuppliersForChatQueryVariables = Exact<{
  keywords?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SearchSuppliersForChatQuery = { __typename?: 'Query', supplierSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'SearchSupplierConnection', edges: Array<{ __typename?: 'SupplierSearchEdge', node: { __typename?: 'Supplier', id: string, referenceId: string, customerNumberMandatory?: boolean | null, botUser?: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null } | null } }> } };

export type SearchUsersForChatQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type SearchUsersForChatQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', customerNumberMandatory?: boolean | null, botUser?: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null } | null } | null } | null }> } };

export type GetBuyerUsersQueryVariables = Exact<{
  buyerEntityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBuyerUsersQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', id: string, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string, email?: string | null, supplier: boolean } }> } | null } | null };

export type CreateChatMutationVariables = Exact<{
  chat: ChatCreateInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', chatCreate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, status: ChatStatus, enabled: boolean, activatedAt?: number | null, buyer?: { __typename?: 'Buyer', id: string, name: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, name: string } | null } };

export type ListSubCatalogsQueryVariables = Exact<{
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListSubCatalogsQuery = { __typename?: 'Query', listSubCatalogs?: { __typename?: 'SubCatalogConnection', edges: Array<{ __typename?: 'SubCatalogEdge', cursor: string, node: { __typename?: 'SubCatalog', id: string, name: string, supplierEntityId: string } }> } | { __typename?: 'ValidationError' } | null };

export type GetChatCountByCcEmailDataQueryVariables = Exact<{
  email: Scalars['AWSEmail']['input'];
}>;


export type GetChatCountByCcEmailDataQuery = { __typename?: 'Query', getChatCountByCCEmail: { __typename?: 'AuthorizationFailure' } | { __typename?: 'GetChatCountByCCEmailReport', numberOfChats: number } };

export type ChatCountByCcEmailReportFragmentFragment = { __typename?: 'GetChatCountByCCEmailReport', numberOfChats: number };

export type GetChatDataQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
  withProducts?: InputMaybe<Scalars['Boolean']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChatDataQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', status: ChatStatus, subCatalogId?: string | null, isPuppy?: boolean | null, id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, createdBy?: { __typename?: 'CreatedBy', createdContext?: CreatedContext | null } | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null }, products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null } | null, getSubCatalogsForChat: { __typename?: 'AuthorizationFailure' } | { __typename?: 'ChatNotFoundError' } | { __typename?: 'GetSubCatalogsForChatResult', subCatalogs: Array<{ __typename?: 'SubCatalog', id: string, name: string }> } };

export type ChatDataFragmentFragment = { __typename?: 'Chat', status: ChatStatus, subCatalogId?: string | null, isPuppy?: boolean | null, id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, type?: ChatType | null, createdBy?: { __typename?: 'CreatedBy', createdContext?: CreatedContext | null } | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, email?: string | null, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null }, products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null };

export type CustomerDetailsChatSupplierFragment = { __typename?: 'Supplier', id: string, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null };

export type CreatedContextFragmentFragment = { __typename?: 'CreatedBy', createdContext?: CreatedContext | null };

export type ChatProductsFragmentFragment = { __typename?: 'Chat', products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null };

export type ChatNotificationPreferencesDataQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type ChatNotificationPreferencesDataQuery = { __typename?: 'Query', chatNotificationPreferences?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatPricesVisibilityQueryQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type ChatPricesVisibilityQueryQuery = { __typename?: 'Query', chatPricesVisibility: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename: 'InputValidationFailure', message?: string | null } };

export type SupplierDeliverySettingQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierDeliverySettingQueryQuery = { __typename?: 'Query', supplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string, cutoffType?: CutOffTimeType | null, cutoffTimes: { __typename?: 'WeekdayBasedCutoffSettings', mon?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } } | null };

export type IntegrationEmailOptionFragmentFragment = { __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null };

export type IntegrationWhatsAppOptionFragmentFragment = { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string };

export type IntegrationSmsOptionFragmentFragment = { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string };

export type PageInfoFragmentFragment = { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string };

export type SupplierDetailsFragmentFragment = { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, hideMyPrice?: boolean | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption' } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null };

export type SearchSupplierEdgeFragmentFragment = { __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, hideMyPrice?: boolean | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption' } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } };

export type SearchSupplierConnectionFragmentFragment = { __typename: 'SearchSupplierConnection', total: number, edges: Array<{ __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, hideMyPrice?: boolean | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption' } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string } };

export type SupplierAssortmentsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierAssortmentsDataQuery = { __typename?: 'Query', supplierAssortments: { __typename: 'supplierAssortments', assortments: Array<string> } };

export type SupplierDeliverySettingFragmentFragment = { __typename: 'SupplierDeliverySetting', id: string, deliveryDays?: Array<number> | null, cutoffType?: CutOffTimeType | null, cutOffTime?: { __typename: 'CutOffTime', time: string, type: CutOffTimeType } | null, cutoffTimes: { __typename: 'WeekdayBasedCutoffSettings', mon?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } };

export type SupplierDeliverySettingDataQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type SupplierDeliverySettingDataQuery = { __typename?: 'Query', supplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string, deliveryDays?: Array<number> | null, cutoffType?: CutOffTimeType | null, cutOffTime?: { __typename: 'CutOffTime', time: string, type: CutOffTimeType } | null, cutoffTimes: { __typename: 'WeekdayBasedCutoffSettings', mon?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } } | null };

export type GetSupplierDetailsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSupplierDetailsDataQuery = { __typename?: 'Query', supplier?: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, hideMyPrice?: boolean | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption' } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } | null };

export type SupplierSearchDataQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SupplierSearchDataQuery = { __typename?: 'Query', supplierSearch: { __typename: 'AuthorizationFailure' } | { __typename: 'InputValidationFailure' } | { __typename: 'SearchSupplierConnection', total: number, edges: Array<{ __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, hideMyPrice?: boolean | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption' } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string } } };

export type UsersPageUserSearchConnectionFragmentFragment = { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } }> };

export type UsersPageUserSearchEdgeFragmentFragment = { __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } };

export type UsersPageUserSearchFragmentFragment = { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type UsersPageUserDetailsFragmentFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, isTest?: boolean | null, chocoUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type UsersPageCreateUserFragmentFragment = { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null, url?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type AddUserToChatsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddUserToChatsMutation = { __typename?: 'Mutation', addUserToChats: boolean };

export type UsersPageBuyerAddUserMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  input?: InputMaybe<BuyerUserInput>;
}>;


export type UsersPageBuyerAddUserMutation = { __typename?: 'Mutation', buyerAddUser: { __typename?: 'BuyerUser', buyer?: { __typename?: 'Buyer', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type UsersPageBuyerRemoveUserMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UsersPageBuyerRemoveUserMutation = { __typename?: 'Mutation', buyerRemoveUser: { __typename?: 'BuyerUser', buyer?: { __typename?: 'Buyer', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type UsersPageCreateUserMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;


export type UsersPageCreateUserMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null, url?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type UsersPageDeleteUserMutationVariables = Exact<{
  input: UserRequestToDeleteInput;
}>;


export type UsersPageDeleteUserMutation = { __typename?: 'Mutation', userRequestToDelete: { __typename?: 'AuthorizationFailure' } | { __typename?: 'UserRequestToDeleteDetails', success: boolean } };

export type UsersPageUserConfirmMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type UsersPageUserConfirmMutation = { __typename?: 'Mutation', userConfirm: boolean };

export type RemoveUserFromChatsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUserFromChatsMutation = { __typename?: 'Mutation', removeUserFromChats: boolean };

export type SafelistTwilioUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SafelistTwilioUserMutation = { __typename?: 'Mutation', safelistTwilioUser: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'InputValidationFailure', message?: string | null, responseType: ResponseType, invalidFields?: Array<{ __typename: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'SafelistTwilioUserFailure', responseType: ResponseType, failureMessage: string } | { __typename: 'SafelistTwilioUserSuccess', successMessage: string } };

export type SupplierAddUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  withRoles: Scalars['Boolean']['input'];
}>;


export type SupplierAddUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, orderPreference?: { __typename: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null } | null };

export type UserDetailsFragmentFragment = { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, orderPreference?: { __typename: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null };

export type SupplierRemoveUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  withRoles: Scalars['Boolean']['input'];
}>;


export type SupplierRemoveUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, orderPreference?: { __typename: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null } | null };

export type SyncCognitoUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncCognitoUserMutation = { __typename?: 'Mutation', syncCognitoUser: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'SyncCognitoUserFailure', responseType: ResponseType, failureMessage: string } | { __typename: 'SyncCognitoUserSuccess', state: { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null } } };

export type UsersPageUpdateUserMutationVariables = Exact<{
  userUpdateInput: UserUpdateInput;
}>;


export type UsersPageUpdateUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type UserRemoveRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  role: Role;
}>;


export type UserRemoveRoleMutation = { __typename?: 'Mutation', userRemoveRole?: { __typename: 'User', id: string, role?: Array<Role | null> | null } | null };

export type GetBuyerEntityChatsQueryVariables = Exact<{
  buyerEntityId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyerEntityChatsQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type BuyerEntityChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null } | null };

export type BuyerChatUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null };

export type UsersPageGetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UsersPageGetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, isTest?: boolean | null, chocoUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type CognitoStateFragmentFragment = { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null };

export type CognitoUserFragmentFragment = { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> };

export type GetUserCognitoStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserCognitoStateQuery = { __typename?: 'Query', userCognitoState: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null } };

export type GetUserTwilioStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserTwilioStateQuery = { __typename?: 'Query', userTwilioState: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'InputValidationFailure', message?: string | null, responseType: ResponseType, invalidFields?: Array<{ __typename: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'UserTwilioState', status?: TwilioStatus | null } | { __typename: 'UserTwilioStateError', responseType: ResponseType, ErrorMessage: string } };

export type UsersPageSearchBuyerEntityQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type UsersPageSearchBuyerEntityQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, rolesEnabled?: boolean | null, fullAddress: string } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type UsersPageBuyerEntityFragmentFragment = { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, rolesEnabled?: boolean | null, fullAddress: string };

export type SearchSuppliersQueryVariables = Exact<{
  keywords: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SearchSuppliersQuery = { __typename?: 'Query', supplierSearch: { __typename: 'AuthorizationFailure' } | { __typename: 'InputValidationFailure' } | { __typename: 'SearchSupplierConnection', edges: Array<{ __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } }> } };

export type UsersPageSearchSupplierConnectionFragmentFragment = { __typename: 'SearchSupplierConnection', edges: Array<{ __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } }> };

export type UsersPageSupplierSearchEdgeFragmentFragment = { __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } };

export type UsersPageSearchSupplierFragmentFragment = { __typename: 'Supplier', id: string, name: string };

export type UsersPageSearchUsersQueryVariables = Exact<{
  query: UserSearchInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersPageSearchUsersQuery = { __typename?: 'Query', userSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } }> } };

export const BuyerDetailsBaseFragmentFragmentDoc = gql`
    fragment BuyerDetailsBaseFragment on Buyer {
  id
  name
  referenceId
  fullAddress
  addressComment: deliveryComment
  addressSource
  googlePlaceId
  googlePlaceAddressId
  latitude
  longitude
  country
  city
  utcOffset
  isTest
  isPuppy
  displayName
  profileImage {
    uploadUrl
    url
  }
}
    `;
export const BuyerDetailsFragmentFragmentDoc = gql`
    fragment BuyerDetailsFragment on Buyer {
  ...BuyerDetailsBaseFragment
  rolesEnabled
  status
  createdContext
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export const BuyerSearchFragmentFragmentDoc = gql`
    fragment BuyerSearchFragment on Buyer {
  id
  name
  status
  referenceId
  displayName
  fullAddress
  city
  country
}
    `;
export const BuyerSearchItemFragmentFragmentDoc = gql`
    fragment BuyerSearchItemFragment on SearchItem {
  entity {
    ...BuyerSearchFragment
  }
}
    ${BuyerSearchFragmentFragmentDoc}`;
export const BuyersPageBuyerFragmentFragmentDoc = gql`
    fragment BuyersPageBuyerFragment on Buyer {
  id
  name
  status
  referenceId
  displayName
  fullAddress
  deliveryComment
  city
  country
  isTest
  isPuppy
  rolesEnabled
  profileImage {
    url
  }
  createdAt
}
    `;
export const BuyersPageBuyerDetailsFragmentFragmentDoc = gql`
    fragment BuyersPageBuyerDetailsFragment on Buyer {
  ...BuyersPageBuyerFragment
  addressSource
  addressLatitude: latitude
  addressLongitude: longitude
  addressUTCOffset: utcOffset
  addressGooglePlaceId: googlePlaceId
  addressGoogleAddressId: googlePlaceAddressId
  createdContext
}
    ${BuyersPageBuyerFragmentFragmentDoc}`;
export const CreateUserFragmentFragmentDoc = gql`
    fragment CreateUserFragment on User {
  id
  name
  email
  locale
  phone
  isTest
  orderPreference {
    pdf
    xlsx
    fax
    sms
    whatsApp
  }
}
    `;
export const UpdateJoinRequestSuccessFragmentFragmentDoc = gql`
    fragment UpdateJoinRequestSuccessFragment on UpdateJoinRequestSuccess {
  __typename
  id
  status
}
    `;
export const BuyerSearchChatFragmentFragmentDoc = gql`
    fragment BuyerSearchChatFragment on Chat {
  id
  chatName
  supplier {
    id
    name
    linkedSupplier {
      id
      name
    }
    profileImage {
      url
    }
  }
  isUserInChat(userId: $userId)
}
    `;
export const BuyerSearchChatItemFragmentFragmentDoc = gql`
    fragment BuyerSearchChatItemFragment on SearchItem {
  entity {
    ...BuyerSearchChatFragment
  }
}
    ${BuyerSearchChatFragmentFragmentDoc}`;
export const BuyerFacetFragmentFragmentDoc = gql`
    fragment BuyerFacetFragment on BuyerFacetsResponse {
  country
  cities {
    city
    utcOffsets
  }
}
    `;
export const BuyerUserFragmentFragmentDoc = gql`
    fragment BuyerUserFragment on User {
  id
  name
  phone
  profileImage {
    url
  }
}
    `;
export const BuyerUserEdgeFragmentFragmentDoc = gql`
    fragment BuyerUserEdgeFragment on BuyerUserEdge {
  node {
    ...BuyerUserFragment
  }
  role
}
    ${BuyerUserFragmentFragmentDoc}`;
export const BuyerUsersBuyerFragmentFragmentDoc = gql`
    fragment BuyerUsersBuyerFragment on Buyer {
  id
  rolesEnabled
  users(first: $first) {
    edges {
      ...BuyerUserEdgeFragment
    }
  }
}
    ${BuyerUserEdgeFragmentFragmentDoc}`;
export const UserRequestToJoinFragmentFragmentDoc = gql`
    fragment UserRequestToJoinFragment on UserRequestToJoin {
  id
  supplierEntityId
  status
  user {
    name
    email
    phone
    id
  }
}
    `;
export const RequestToJoinEdgeFragmentFragmentDoc = gql`
    fragment RequestToJoinEdgeFragment on UserRequestToJoinEdge {
  cursor
  node {
    ...UserRequestToJoinFragment
  }
}
    ${UserRequestToJoinFragmentFragmentDoc}`;
export const RequestsToJoinConnectionFragmentFragmentDoc = gql`
    fragment RequestsToJoinConnectionFragment on RequestsToJoinConnection {
  edges {
    ...RequestToJoinEdgeFragment
  }
}
    ${RequestToJoinEdgeFragmentFragmentDoc}`;
export const UserSearchUserFragmentFragmentDoc = gql`
    fragment UserSearchUserFragment on User {
  id
  name
  phone
}
    `;
export const UserSearchEdgeFragmentFragmentDoc = gql`
    fragment UserSearchEdgeFragment on UserSearchEdge {
  node {
    ...UserSearchUserFragment
  }
}
    ${UserSearchUserFragmentFragmentDoc}`;
export const UserSearchConnectionFragmentFragmentDoc = gql`
    fragment UserSearchConnectionFragment on UserSearchConnection {
  total
  edges {
    ...UserSearchEdgeFragment
  }
}
    ${UserSearchEdgeFragmentFragmentDoc}`;
export const UserSearchInputValidationFailureFragmentDoc = gql`
    fragment UserSearchInputValidationFailure on InputValidationFailure {
  message
  responseType
}
    `;
export const UserSearchAuthorizationFailureFragmentDoc = gql`
    fragment UserSearchAuthorizationFailure on AuthorizationFailure {
  message
  responseType
}
    `;
export const DeliverySettingFragmentFragmentDoc = gql`
    fragment DeliverySettingFragment on SupplierDeliverySetting {
  id
  cutoffTimes {
    mon {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    tue {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    wed {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    thu {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    fri {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    sat {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    sun {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
  }
  cutoffType
}
    `;
export const SubCatalogForChatDataFragmentFragmentDoc = gql`
    fragment SubCatalogForChatDataFragment on SubCatalog {
  id
  name
}
    `;
export const SubCatalogsForChatFragmentFragmentDoc = gql`
    fragment SubCatalogsForChatFragment on GetSubCatalogsForChatResult {
  subCatalogs {
    ...SubCatalogForChatDataFragment
  }
}
    ${SubCatalogForChatDataFragmentFragmentDoc}`;
export const UpdateSubCatalogChatsResultFragmentFragmentDoc = gql`
    fragment UpdateSubCatalogChatsResultFragment on UpdateSubCatalogChatsResult {
  errors {
    subCatalogId
    reason
  }
}
    `;
export const HistoryUserFragmentFragmentDoc = gql`
    fragment HistoryUserFragment on User {
  name
  phone
}
    `;
export const HistoryProductFragmentFragmentDoc = gql`
    fragment HistoryProductFragment on Product {
  id
  unit
  name
}
    `;
export const HistoryOrderProductFragmentFragmentDoc = gql`
    fragment HistoryOrderProductFragment on OrderProduct {
  amount
  product {
    ...HistoryProductFragment
  }
}
    ${HistoryProductFragmentFragmentDoc}`;
export const HistoryOrderFragmentFragmentDoc = gql`
    fragment HistoryOrderFragment on Order {
  id
  createdAt
  body
  referenceId
  status
  orderSupplierStatus
  supplier {
    ...HistoryUserFragment
  }
  user {
    ...HistoryUserFragment
  }
  orderProducts {
    ...HistoryOrderProductFragment
  }
}
    ${HistoryUserFragmentFragmentDoc}
${HistoryOrderProductFragmentFragmentDoc}`;
export const HistoryMessageFragmentFragmentDoc = gql`
    fragment HistoryMessageFragment on Message {
  id
  body
  createdAt
  user {
    ...HistoryUserFragment
  }
  attachment {
    ... on Media {
      url
    }
  }
  chat {
    supplier {
      ...HistoryUserFragment
    }
  }
  order {
    ...HistoryOrderFragment
  }
}
    ${HistoryUserFragmentFragmentDoc}
${HistoryOrderFragmentFragmentDoc}`;
export const OrderPreferenceFragmentFragmentDoc = gql`
    fragment OrderPreferenceFragment on OrderPreference {
  whatsApp
  sms
  fax
}
    `;
export const ChatUserFragmentFragmentDoc = gql`
    fragment ChatUserFragment on User {
  id
  name
  phone
  botUser
  linkedSupplier {
    id
    hasEnabledCatalogProducts
  }
  supplier
  ... on User @include(if: $withAllUserFields) {
    email
    locale
    createdAt
    orderPreference {
      ...OrderPreferenceFragment
    }
  }
}
    ${OrderPreferenceFragmentFragmentDoc}`;
export const ChatUserEdgeFragmentFragmentDoc = gql`
    fragment ChatUserEdgeFragment on ChatUserEdge {
  node {
    ...ChatUserFragment
  }
}
    ${ChatUserFragmentFragmentDoc}`;
export const ChatUsersFragmentFragmentDoc = gql`
    fragment ChatUsersFragment on Chat {
  id
  users(first: $first) {
    edges {
      ...ChatUserEdgeFragment
    }
  }
}
    ${ChatUserEdgeFragmentFragmentDoc}`;
export const ChatSearchChatFragmentFragmentDoc = gql`
    fragment ChatSearchChatFragment on Chat {
  id
  chatName
  restaurantName
  deliveryAddress
  enabled
  type
  customerNumber
  buyer {
    id
    name
    referenceId
    fullAddress
  }
  supplier {
    id
    name
    phone
    botUser
    linkedSupplier {
      id
      referenceId
      name
    }
  }
  ...ChatUsersFragment
}
    ${ChatUsersFragmentFragmentDoc}`;
export const ChatSearchEntityFragmentFragmentDoc = gql`
    fragment ChatSearchEntityFragment on SearchItem {
  entity {
    ...ChatSearchChatFragment
  }
}
    ${ChatSearchChatFragmentFragmentDoc}`;
export const ChatCountByCcEmailReportFragmentFragmentDoc = gql`
    fragment ChatCountByCcEmailReportFragment on GetChatCountByCCEmailReport {
  numberOfChats
}
    `;
export const ChatIntegrationEmailOptionFragmentFragmentDoc = gql`
    fragment ChatIntegrationEmailOptionFragment on IntegrationEmailOption {
  complaintEmails
  orderEmails
  messageEmails
}
    `;
export const ChatSupplierUserFragmentFragmentDoc = gql`
    fragment ChatSupplierUserFragment on User {
  id
  name
  locale
  phone
  email
  chocoUser
  supplier
  linkedSupplier {
    id
    customerNumberMandatory
    referenceId
    name
    hasEnabledCatalogProducts
    allowCustomProducts
    accessPackage
    integration {
      ...ChatIntegrationEmailOptionFragment
    }
  }
}
    ${ChatIntegrationEmailOptionFragmentFragmentDoc}`;
export const ChatDetailsFragmentFragmentDoc = gql`
    fragment ChatDetailsFragment on Chat {
  id
  chatName
  restaurantName
  deliveryAddress
  customerNumber
  additionalEmails
  enabled
  type
  supplier {
    ...ChatSupplierUserFragment
  }
}
    ${ChatSupplierUserFragmentFragmentDoc}`;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  id
  unit
  name
  par
  price
  externalId
  supplierId
  buyerInventoryProduct(chatId: $chatId) {
    name
    price {
      currency
      amount
    }
  }
  supplierNegotiatedPrice(buyerId: $buyerId) {
    price {
      amount
      currency
    }
  }
}
    `;
export const ChatProductsFragmentFragmentDoc = gql`
    fragment ChatProductsFragment on Chat {
  products @include(if: $withProducts) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;
export const CreatedContextFragmentFragmentDoc = gql`
    fragment CreatedContextFragment on CreatedBy {
  createdContext
}
    `;
export const CustomerDetailsChatSupplierFragmentDoc = gql`
    fragment CustomerDetailsChatSupplier on Supplier {
  id
  appliedMinimumOrderValue {
    ... on MinimumOrderValue {
      type
      minimumOrderValue {
        price {
          amount
          currency
          decimalPlaces
        }
      }
      formattedMinimumOrderValue
    }
    ... on MinimumOrderValueFailure {
      message
      responseType
    }
    ... on AuthorizationFailure {
      message
      responseType
    }
    ... on InputValidationFailure {
      message
      responseType
    }
  }
}
    `;
export const ChatDataFragmentFragmentDoc = gql`
    fragment ChatDataFragment on Chat {
  ...ChatDetailsFragment
  ...ChatUsersFragment
  ...ChatProductsFragment
  status
  createdBy {
    ...CreatedContextFragment
  }
  subCatalogId
  isPuppy
  buyer {
    id
    name
    referenceId
    fullAddress
  }
  supplierEntity {
    ...CustomerDetailsChatSupplier
  }
}
    ${ChatDetailsFragmentFragmentDoc}
${ChatUsersFragmentFragmentDoc}
${ChatProductsFragmentFragmentDoc}
${CreatedContextFragmentFragmentDoc}
${CustomerDetailsChatSupplierFragmentDoc}`;
export const IntegrationEmailOptionFragmentFragmentDoc = gql`
    fragment IntegrationEmailOptionFragment on IntegrationEmailOption {
  type
  xlsx
  pdf
  complaintEmails
  orderEmails
  messageEmails
  __typename
}
    `;
export const IntegrationWhatsAppOptionFragmentFragmentDoc = gql`
    fragment IntegrationWhatsAppOptionFragment on IntegrationWhatsAppOption {
  type
  phone
  __typename
}
    `;
export const IntegrationSmsOptionFragmentFragmentDoc = gql`
    fragment IntegrationSmsOptionFragment on IntegrationSmsOption {
  type
  phone
  __typename
}
    `;
export const SupplierDetailsFragmentFragmentDoc = gql`
    fragment SupplierDetailsFragment on Supplier {
  id
  referenceId
  sortCartBy
  name
  description
  primaryAssortment
  secondaryAssortments
  contactEmails
  deliveryZones {
    name
    points {
      latitude
      longitude
      __typename
    }
    __typename
  }
  coverPhoto {
    url
    uploadUrl
    __typename
  }
  locale
  isPuppy
  isTest
  isDiscoverable
  isIntegrated
  deliveryCosts
  minOrderAmount
  allowCustomProducts
  allowCustomerAcquisition
  allowOnlyOneActiveVariant
  allowBuyerComment
  allowInvoiceOrderGuidePhotoUpload
  deliveryDateMandatory
  customerNumberMandatory
  timezone
  hasEnabledCatalogProducts
  hasEnabledFractionalUnits
  hasValidCatalogProducts
  noDefaultCatalog
  defaultSubCatalog
  accessPackage
  disableCustomerNumberEdits
  allowOrderedProductMerging
  priceSetting {
    displayInMarketplace
    displayToCustomers
    __typename
  }
  integration {
    ...IntegrationEmailOptionFragment
    ...IntegrationWhatsAppOptionFragment
    ...IntegrationSmsOptionFragment
    __typename
  }
  botUser {
    id
    profileImage {
      uploadUrl
      mediumSquare
      __typename
    }
    __typename
  }
  minOrder {
    price {
      currency
      amount
      __typename
    }
    __typename
  }
  hideMyPrice
  __typename
}
    ${IntegrationEmailOptionFragmentFragmentDoc}
${IntegrationWhatsAppOptionFragmentFragmentDoc}
${IntegrationSmsOptionFragmentFragmentDoc}`;
export const SearchSupplierEdgeFragmentFragmentDoc = gql`
    fragment SearchSupplierEdgeFragment on SupplierSearchEdge {
  node {
    ...SupplierDetailsFragment
    __typename
  }
  __typename
}
    ${SupplierDetailsFragmentFragmentDoc}`;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
  __typename
}
    `;
export const SearchSupplierConnectionFragmentFragmentDoc = gql`
    fragment SearchSupplierConnectionFragment on SearchSupplierConnection {
  total
  edges {
    ...SearchSupplierEdgeFragment
    __typename
  }
  pageInfo {
    ...PageInfoFragment
    __typename
  }
  __typename
}
    ${SearchSupplierEdgeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
export const SupplierDeliverySettingFragmentFragmentDoc = gql`
    fragment SupplierDeliverySettingFragment on SupplierDeliverySetting {
  id
  deliveryDays
  cutOffTime {
    time
    type
    __typename
  }
  cutoffType
  cutoffTimes {
    mon {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    tue {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    wed {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    thu {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    fri {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    sat {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    sun {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
    `;
export const UsersPageUserSearchFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchFragment on User {
  id
  name
  pending
  hasRequestedToBeDeleted
  email
  locale
  loginMethod
  phone
  createdAt
  supplier
  linkedSupplier {
    id
    name
  }
  isPuppy
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
  }
  buyers(first: 30) {
    edges {
      node {
        id
        name
        referenceId
        fullAddress
        rolesEnabled
      }
      role
    }
  }
}
    `;
export const UsersPageUserSearchEdgeFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchEdgeFragment on UserSearchEdge {
  cursor
  node {
    ...UsersPageUserSearchFragment
  }
}
    ${UsersPageUserSearchFragmentFragmentDoc}`;
export const UsersPageUserSearchConnectionFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchConnectionFragment on UserSearchConnection {
  total
  edges {
    ...UsersPageUserSearchEdgeFragment
  }
}
    ${UsersPageUserSearchEdgeFragmentFragmentDoc}`;
export const UsersPageUserDetailsFragmentFragmentDoc = gql`
    fragment UsersPageUserDetailsFragment on User {
  id
  name
  email
  locale
  loginMethod
  phone
  createdAt
  pending
  hasRequestedToBeDeleted
  supplier
  isTest
  chocoUser
  profileImage {
    url
    uploadUrl
    mediumSquare
  }
  linkedSupplier {
    id
    name
    referenceId
  }
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
  }
  buyers(first: 30) {
    edges {
      node {
        id
        name
        referenceId
        fullAddress
        rolesEnabled
      }
      role
    }
  }
}
    `;
export const UsersPageCreateUserFragmentFragmentDoc = gql`
    fragment UsersPageCreateUserFragment on User {
  ...UsersPageUserDetailsFragment
  profileImage {
    uploadUrl
    mediumSquare
  }
  isTest
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;
export const UserDetailsFragmentFragmentDoc = gql`
    fragment UserDetailsFragment on User {
  id
  name
  pending
  locale
  phone
  phoneNumberType
  image
  loginEmail
  email
  supplier
  chocoUser
  createdAt
  supplierId
  challengeByEmail
  loginMethod
  role @include(if: $withRoles)
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
    __typename
  }
  linkedSupplier {
    id
    name
    referenceId
    __typename
  }
  __typename
}
    `;
export const BuyerChatUserFragmentFragmentDoc = gql`
    fragment BuyerChatUserFragment on User {
  id
  name
  linkedSupplier {
    id
    name
  }
}
    `;
export const BuyerEntityChatFragmentFragmentDoc = gql`
    fragment BuyerEntityChatFragment on Chat {
  id
  chatName
  supplier {
    ...BuyerChatUserFragment
  }
  isUserInChat(userId: $userId)
}
    ${BuyerChatUserFragmentFragmentDoc}`;
export const CognitoUserFragmentFragmentDoc = gql`
    fragment CognitoUserFragment on CognitoStateUser {
  attributes {
    name
    value
  }
  groups
  status
}
    `;
export const CognitoStateFragmentFragmentDoc = gql`
    fragment CognitoStateFragment on UserCognitoState {
  __typename
  status
  cognitoUsers {
    email {
      ...CognitoUserFragment
    }
    phone {
      ...CognitoUserFragment
    }
  }
}
    ${CognitoUserFragmentFragmentDoc}`;
export const UsersPageBuyerEntityFragmentFragmentDoc = gql`
    fragment UsersPageBuyerEntityFragment on Buyer {
  id
  name
  referenceId
  rolesEnabled
  fullAddress
}
    `;
export const UsersPageSearchSupplierFragmentFragmentDoc = gql`
    fragment UsersPageSearchSupplierFragment on Supplier {
  id
  name
  __typename
}
    `;
export const UsersPageSupplierSearchEdgeFragmentFragmentDoc = gql`
    fragment UsersPageSupplierSearchEdgeFragment on SupplierSearchEdge {
  cursor
  node {
    ...UsersPageSearchSupplierFragment
    __typename
  }
  __typename
}
    ${UsersPageSearchSupplierFragmentFragmentDoc}`;
export const UsersPageSearchSupplierConnectionFragmentFragmentDoc = gql`
    fragment UsersPageSearchSupplierConnectionFragment on SearchSupplierConnection {
  edges {
    ...UsersPageSupplierSearchEdgeFragment
    __typename
  }
  __typename
}
    ${UsersPageSupplierSearchEdgeFragmentFragmentDoc}`;
export const AddUserToChatsMutationDocument = gql`
    mutation AddUserToChatsMutation($userId: ID!, $chatIds: [ID!]!) {
  addUserToChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type AddUserToChatsMutationMutationFn = ApolloReactCommon.MutationFunction<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>;

/**
 * __useAddUserToChatsMutationMutation__
 *
 * To run a mutation, you first call `useAddUserToChatsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToChatsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToChatsMutationMutation, { data, loading, error }] = useAddUserToChatsMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useAddUserToChatsMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>(AddUserToChatsMutationDocument, options);
      }
export type AddUserToChatsMutationMutationHookResult = ReturnType<typeof useAddUserToChatsMutationMutation>;
export type AddUserToChatsMutationMutationResult = ApolloReactCommon.MutationResult<AddUserToChatsMutationMutation>;
export type AddUserToChatsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>;
export const BuyerAddUserMutationDocument = gql`
    mutation BuyerAddUserMutation($buyerId: ID!, $userId: ID!, $buyerUserInput: BuyerUserInput) {
  buyerAddUser(buyerId: $buyerId, userId: $userId, input: $buyerUserInput) {
    buyerId
    userId
    role
  }
}
    `;
export type BuyerAddUserMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>;

/**
 * __useBuyerAddUserMutationMutation__
 *
 * To run a mutation, you first call `useBuyerAddUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerAddUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerAddUserMutationMutation, { data, loading, error }] = useBuyerAddUserMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      buyerUserInput: // value for 'buyerUserInput'
 *   },
 * });
 */
export function useBuyerAddUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>(BuyerAddUserMutationDocument, options);
      }
export type BuyerAddUserMutationMutationHookResult = ReturnType<typeof useBuyerAddUserMutationMutation>;
export type BuyerAddUserMutationMutationResult = ApolloReactCommon.MutationResult<BuyerAddUserMutationMutation>;
export type BuyerAddUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>;
export const BuyerDisableRolesMutationDocument = gql`
    mutation BuyerDisableRolesMutation($buyerId: ID!) {
  buyerDisableRoles(buyerId: $buyerId) {
    ... on Buyer {
      id
      rolesEnabled
    }
    ... on NotFoundError {
      responseType
      message
    }
  }
}
    `;
export type BuyerDisableRolesMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>;

/**
 * __useBuyerDisableRolesMutationMutation__
 *
 * To run a mutation, you first call `useBuyerDisableRolesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerDisableRolesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerDisableRolesMutationMutation, { data, loading, error }] = useBuyerDisableRolesMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useBuyerDisableRolesMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>(BuyerDisableRolesMutationDocument, options);
      }
export type BuyerDisableRolesMutationMutationHookResult = ReturnType<typeof useBuyerDisableRolesMutationMutation>;
export type BuyerDisableRolesMutationMutationResult = ApolloReactCommon.MutationResult<BuyerDisableRolesMutationMutation>;
export type BuyerDisableRolesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>;
export const BuyerEnableRolesMutationDocument = gql`
    mutation BuyerEnableRolesMutation($buyerId: ID!) {
  buyerDisableRoles(buyerId: $buyerId) {
    ... on Buyer {
      id
      rolesEnabled
      __typename
    }
    ... on NotFoundError {
      responseType
      message
      __typename
    }
    __typename
  }
}
    `;
export type BuyerEnableRolesMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerEnableRolesMutationMutation, BuyerEnableRolesMutationMutationVariables>;

/**
 * __useBuyerEnableRolesMutationMutation__
 *
 * To run a mutation, you first call `useBuyerEnableRolesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerEnableRolesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerEnableRolesMutationMutation, { data, loading, error }] = useBuyerEnableRolesMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useBuyerEnableRolesMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerEnableRolesMutationMutation, BuyerEnableRolesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerEnableRolesMutationMutation, BuyerEnableRolesMutationMutationVariables>(BuyerEnableRolesMutationDocument, options);
      }
export type BuyerEnableRolesMutationMutationHookResult = ReturnType<typeof useBuyerEnableRolesMutationMutation>;
export type BuyerEnableRolesMutationMutationResult = ApolloReactCommon.MutationResult<BuyerEnableRolesMutationMutation>;
export type BuyerEnableRolesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerEnableRolesMutationMutation, BuyerEnableRolesMutationMutationVariables>;
export const BuyerRemoveUserMutationDocument = gql`
    mutation BuyerRemoveUserMutation($buyerId: ID!, $userId: ID!) {
  buyerRemoveUser(buyerId: $buyerId, userId: $userId) {
    buyerId
    userId
    buyer {
      rolesEnabled
    }
  }
}
    `;
export type BuyerRemoveUserMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>;

/**
 * __useBuyerRemoveUserMutationMutation__
 *
 * To run a mutation, you first call `useBuyerRemoveUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRemoveUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRemoveUserMutationMutation, { data, loading, error }] = useBuyerRemoveUserMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBuyerRemoveUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>(BuyerRemoveUserMutationDocument, options);
      }
export type BuyerRemoveUserMutationMutationHookResult = ReturnType<typeof useBuyerRemoveUserMutationMutation>;
export type BuyerRemoveUserMutationMutationResult = ApolloReactCommon.MutationResult<BuyerRemoveUserMutationMutation>;
export type BuyerRemoveUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>;
export const BuyersPageCreateBuyerDocument = gql`
    mutation BuyersPageCreateBuyer($buyerInput: BuyerCreateInput!) {
  buyerCreate(buyer: $buyerInput) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;
export type BuyersPageCreateBuyerMutationFn = ApolloReactCommon.MutationFunction<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>;

/**
 * __useBuyersPageCreateBuyerMutation__
 *
 * To run a mutation, you first call `useBuyersPageCreateBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageCreateBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyersPageCreateBuyerMutation, { data, loading, error }] = useBuyersPageCreateBuyerMutation({
 *   variables: {
 *      buyerInput: // value for 'buyerInput'
 *   },
 * });
 */
export function useBuyersPageCreateBuyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>(BuyersPageCreateBuyerDocument, options);
      }
export type BuyersPageCreateBuyerMutationHookResult = ReturnType<typeof useBuyersPageCreateBuyerMutation>;
export type BuyersPageCreateBuyerMutationResult = ApolloReactCommon.MutationResult<BuyersPageCreateBuyerMutation>;
export type BuyersPageCreateBuyerMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>;
export const BuyersPageUpdateBuyerDocument = gql`
    mutation BuyersPageUpdateBuyer($buyerId: ID!, $buyerInput: BuyerUpdateInput!) {
  buyerUpdate(id: $buyerId, buyer: $buyerInput) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;
export type BuyersPageUpdateBuyerMutationFn = ApolloReactCommon.MutationFunction<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>;

/**
 * __useBuyersPageUpdateBuyerMutation__
 *
 * To run a mutation, you first call `useBuyersPageUpdateBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageUpdateBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyersPageUpdateBuyerMutation, { data, loading, error }] = useBuyersPageUpdateBuyerMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      buyerInput: // value for 'buyerInput'
 *   },
 * });
 */
export function useBuyersPageUpdateBuyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>(BuyersPageUpdateBuyerDocument, options);
      }
export type BuyersPageUpdateBuyerMutationHookResult = ReturnType<typeof useBuyersPageUpdateBuyerMutation>;
export type BuyersPageUpdateBuyerMutationResult = ApolloReactCommon.MutationResult<BuyersPageUpdateBuyerMutation>;
export type BuyersPageUpdateBuyerMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>;
export const CreateBuyerMutationDocument = gql`
    mutation CreateBuyerMutation($buyerCreateInput: BuyerCreateInput!) {
  buyerCreate(buyer: $buyerCreateInput) {
    ...BuyerDetailsBaseFragment
  }
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export type CreateBuyerMutationMutationFn = ApolloReactCommon.MutationFunction<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>;

/**
 * __useCreateBuyerMutationMutation__
 *
 * To run a mutation, you first call `useCreateBuyerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerMutationMutation, { data, loading, error }] = useCreateBuyerMutationMutation({
 *   variables: {
 *      buyerCreateInput: // value for 'buyerCreateInput'
 *   },
 * });
 */
export function useCreateBuyerMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>(CreateBuyerMutationDocument, options);
      }
export type CreateBuyerMutationMutationHookResult = ReturnType<typeof useCreateBuyerMutationMutation>;
export type CreateBuyerMutationMutationResult = ApolloReactCommon.MutationResult<CreateBuyerMutationMutation>;
export type CreateBuyerMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>;
export const CreateUserMutationDocument = gql`
    mutation CreateUserMutation($userInput: UserCreateInput!) {
  userCreate(user: $userInput) {
    ...CreateUserFragment
  }
}
    ${CreateUserFragmentFragmentDoc}`;
export type CreateUserMutationMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutationMutation, CreateUserMutationMutationVariables>;

/**
 * __useCreateUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = useCreateUserMutationMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutationMutation, CreateUserMutationMutationVariables>(CreateUserMutationDocument, options);
      }
export type CreateUserMutationMutationHookResult = ReturnType<typeof useCreateUserMutationMutation>;
export type CreateUserMutationMutationResult = ApolloReactCommon.MutationResult<CreateUserMutationMutation>;
export type CreateUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>;
export const RemoveUserFromChatsMutationDocument = gql`
    mutation RemoveUserFromChatsMutation($userId: ID!, $chatIds: [ID!]!) {
  removeUserFromChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type RemoveUserFromChatsMutationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>;

/**
 * __useRemoveUserFromChatsMutationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromChatsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromChatsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromChatsMutationMutation, { data, loading, error }] = useRemoveUserFromChatsMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useRemoveUserFromChatsMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>(RemoveUserFromChatsMutationDocument, options);
      }
export type RemoveUserFromChatsMutationMutationHookResult = ReturnType<typeof useRemoveUserFromChatsMutationMutation>;
export type RemoveUserFromChatsMutationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromChatsMutationMutation>;
export type RemoveUserFromChatsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>;
export const EditBuyerMutationDocument = gql`
    mutation EditBuyerMutation($id: ID!, $buyerUpdateInput: BuyerUpdateInput!) {
  buyerUpdate(id: $id, buyer: $buyerUpdateInput) {
    ...BuyerDetailsBaseFragment
  }
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export type EditBuyerMutationMutationFn = ApolloReactCommon.MutationFunction<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>;

/**
 * __useEditBuyerMutationMutation__
 *
 * To run a mutation, you first call `useEditBuyerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBuyerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBuyerMutationMutation, { data, loading, error }] = useEditBuyerMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      buyerUpdateInput: // value for 'buyerUpdateInput'
 *   },
 * });
 */
export function useEditBuyerMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>(EditBuyerMutationDocument, options);
      }
export type EditBuyerMutationMutationHookResult = ReturnType<typeof useEditBuyerMutationMutation>;
export type EditBuyerMutationMutationResult = ApolloReactCommon.MutationResult<EditBuyerMutationMutation>;
export type EditBuyerMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>;
export const UpdateRequestToJoinMutationDocument = gql`
    mutation UpdateRequestToJoinMutation($input: UpdateJoinRequestInput!) {
  updateRequestToJoin(input: $input) {
    ...UpdateJoinRequestSuccessFragment
    ... on AuthorizationFailure {
      message
    }
    ... on InputValidationFailure {
      message
    }
    ... on UpdateJoinRequestError {
      message
    }
  }
}
    ${UpdateJoinRequestSuccessFragmentFragmentDoc}`;
export type UpdateRequestToJoinMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>;

/**
 * __useUpdateRequestToJoinMutationMutation__
 *
 * To run a mutation, you first call `useUpdateRequestToJoinMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestToJoinMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestToJoinMutationMutation, { data, loading, error }] = useUpdateRequestToJoinMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRequestToJoinMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>(UpdateRequestToJoinMutationDocument, options);
      }
export type UpdateRequestToJoinMutationMutationHookResult = ReturnType<typeof useUpdateRequestToJoinMutationMutation>;
export type UpdateRequestToJoinMutationMutationResult = ApolloReactCommon.MutationResult<UpdateRequestToJoinMutationMutation>;
export type UpdateRequestToJoinMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>;
export const BuyersPageGetBuyerDetailsDocument = gql`
    query BuyersPageGetBuyerDetails($buyerId: ID!) {
  buyer(id: $buyerId) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;

/**
 * __useBuyersPageGetBuyerDetailsQuery__
 *
 * To run a query within a React component, call `useBuyersPageGetBuyerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageGetBuyerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersPageGetBuyerDetailsQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useBuyersPageGetBuyerDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables> & ({ variables: BuyersPageGetBuyerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
      }
export function useBuyersPageGetBuyerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
        }
export function useBuyersPageGetBuyerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
        }
export type BuyersPageGetBuyerDetailsQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsQuery>;
export type BuyersPageGetBuyerDetailsLazyQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsLazyQuery>;
export type BuyersPageGetBuyerDetailsSuspenseQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsSuspenseQuery>;
export type BuyersPageGetBuyerDetailsQueryResult = ApolloReactCommon.QueryResult<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>;
export const BuyersPageSearchBuyersDocument = gql`
    query BuyersPageSearchBuyers($searchTerm: String!, $size: Int, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: buyer, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      entity {
        ...BuyersPageBuyerFragment
      }
    }
  }
}
    ${BuyersPageBuyerFragmentFragmentDoc}`;

/**
 * __useBuyersPageSearchBuyersQuery__
 *
 * To run a query within a React component, call `useBuyersPageSearchBuyersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageSearchBuyersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersPageSearchBuyersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBuyersPageSearchBuyersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables> & ({ variables: BuyersPageSearchBuyersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
      }
export function useBuyersPageSearchBuyersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
        }
export function useBuyersPageSearchBuyersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
        }
export type BuyersPageSearchBuyersQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersQuery>;
export type BuyersPageSearchBuyersLazyQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersLazyQuery>;
export type BuyersPageSearchBuyersSuspenseQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersSuspenseQuery>;
export type BuyersPageSearchBuyersQueryResult = ApolloReactCommon.QueryResult<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>;
export const GetBuyerDetailsQueryDocument = gql`
    query GetBuyerDetailsQuery($buyerId: ID!) {
  buyer(id: $buyerId) {
    ...BuyerDetailsFragment
  }
}
    ${BuyerDetailsFragmentFragmentDoc}`;

/**
 * __useGetBuyerDetailsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerDetailsQueryQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useGetBuyerDetailsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables> & ({ variables: GetBuyerDetailsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
      }
export function useGetBuyerDetailsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
        }
export function useGetBuyerDetailsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
        }
export type GetBuyerDetailsQueryQueryHookResult = ReturnType<typeof useGetBuyerDetailsQueryQuery>;
export type GetBuyerDetailsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerDetailsQueryLazyQuery>;
export type GetBuyerDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerDetailsQuerySuspenseQuery>;
export type GetBuyerDetailsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>;
export const GetBuyerEntityChatsQueryDocument = gql`
    query GetBuyerEntityChatsQuery($buyerEntityId: String!, $userId: ID!, $offset: Int = 0, $filter: SearchFilter) {
  search(
    query: {search: $buyerEntityId, type: chat, size: 30, offset: $offset, filter: $filter}
  ) {
    hits {
      ...BuyerSearchChatItemFragment
    }
    total
  }
}
    ${BuyerSearchChatItemFragmentFragmentDoc}`;

/**
 * __useGetBuyerEntityChatsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerEntityChatsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerEntityChatsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerEntityChatsQueryQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyerEntityChatsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables> & ({ variables: GetBuyerEntityChatsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
      }
export function useGetBuyerEntityChatsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
        }
export function useGetBuyerEntityChatsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
        }
export type GetBuyerEntityChatsQueryQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQueryQuery>;
export type GetBuyerEntityChatsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQueryLazyQuery>;
export type GetBuyerEntityChatsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQuerySuspenseQuery>;
export type GetBuyerEntityChatsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>;
export const GetBuyerFacetsQueryDocument = gql`
    query GetBuyerFacetsQuery {
  buyerFacets {
    ...BuyerFacetFragment
  }
}
    ${BuyerFacetFragmentFragmentDoc}`;

/**
 * __useGetBuyerFacetsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerFacetsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerFacetsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerFacetsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBuyerFacetsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
      }
export function useGetBuyerFacetsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
        }
export function useGetBuyerFacetsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
        }
export type GetBuyerFacetsQueryQueryHookResult = ReturnType<typeof useGetBuyerFacetsQueryQuery>;
export type GetBuyerFacetsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerFacetsQueryLazyQuery>;
export type GetBuyerFacetsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerFacetsQuerySuspenseQuery>;
export type GetBuyerFacetsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>;
export const GetBuyerUsersQueryDocument = gql`
    query GetBuyerUsersQuery($buyerId: ID!, $first: Int = 50) {
  buyer(id: $buyerId) {
    ...BuyerUsersBuyerFragment
  }
}
    ${BuyerUsersBuyerFragmentFragmentDoc}`;

/**
 * __useGetBuyerUsersQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerUsersQueryQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetBuyerUsersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables> & ({ variables: GetBuyerUsersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
      }
export function useGetBuyerUsersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
        }
export function useGetBuyerUsersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
        }
export type GetBuyerUsersQueryQueryHookResult = ReturnType<typeof useGetBuyerUsersQueryQuery>;
export type GetBuyerUsersQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerUsersQueryLazyQuery>;
export type GetBuyerUsersQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerUsersQuerySuspenseQuery>;
export type GetBuyerUsersQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>;
export const GetRequestsToJoinDocument = gql`
    query GetRequestsToJoin($buyerId: String!, $statusFilter: JoinRequestStatus) {
  getRequestsToJoin(
    query: {buyerId: $buyerId, filter: {status: $statusFilter}}
    first: 30
  ) {
    ...RequestsToJoinConnectionFragment
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${RequestsToJoinConnectionFragmentFragmentDoc}`;

/**
 * __useGetRequestsToJoinQuery__
 *
 * To run a query within a React component, call `useGetRequestsToJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsToJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsToJoinQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetRequestsToJoinQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables> & ({ variables: GetRequestsToJoinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
      }
export function useGetRequestsToJoinLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
        }
export function useGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
        }
export type GetRequestsToJoinQueryHookResult = ReturnType<typeof useGetRequestsToJoinQuery>;
export type GetRequestsToJoinLazyQueryHookResult = ReturnType<typeof useGetRequestsToJoinLazyQuery>;
export type GetRequestsToJoinSuspenseQueryHookResult = ReturnType<typeof useGetRequestsToJoinSuspenseQuery>;
export type GetRequestsToJoinQueryResult = ApolloReactCommon.QueryResult<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>;
export const GetBuyersQueryDocument = gql`
    query GetBuyersQuery($searchTerm: String!, $size: Int, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: buyer, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      ...BuyerSearchItemFragment
    }
  }
}
    ${BuyerSearchItemFragmentFragmentDoc}`;

/**
 * __useGetBuyersQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyersQueryQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables> & ({ variables: GetBuyersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
      }
export function useGetBuyersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
        }
export function useGetBuyersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
        }
export type GetBuyersQueryQueryHookResult = ReturnType<typeof useGetBuyersQueryQuery>;
export type GetBuyersQueryLazyQueryHookResult = ReturnType<typeof useGetBuyersQueryLazyQuery>;
export type GetBuyersQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyersQuerySuspenseQuery>;
export type GetBuyersQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>;
export const UserSearchQueryDocument = gql`
    query UserSearchQuery($first: Int, $query: UserSearchInput!) {
  userSearch(first: $first, query: $query) {
    ...UserSearchConnectionFragment
    ...UserSearchInputValidationFailure
    ...UserSearchAuthorizationFailure
  }
}
    ${UserSearchConnectionFragmentFragmentDoc}
${UserSearchInputValidationFailureFragmentDoc}
${UserSearchAuthorizationFailureFragmentDoc}`;

/**
 * __useUserSearchQueryQuery__
 *
 * To run a query within a React component, call `useUserSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserSearchQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables> & ({ variables: UserSearchQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
      }
export function useUserSearchQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
        }
export function useUserSearchQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
        }
export type UserSearchQueryQueryHookResult = ReturnType<typeof useUserSearchQueryQuery>;
export type UserSearchQueryLazyQueryHookResult = ReturnType<typeof useUserSearchQueryLazyQuery>;
export type UserSearchQuerySuspenseQueryHookResult = ReturnType<typeof useUserSearchQuerySuspenseQuery>;
export type UserSearchQueryQueryResult = ApolloReactCommon.QueryResult<UserSearchQueryQuery, UserSearchQueryQueryVariables>;
export const AddChatUsersDataMutationDocument = gql`
    mutation AddChatUsersDataMutation($id: ID!, $userIds: [ID]!, $first: Int = 30, $withAllUserFields: Boolean = true) {
  chatInviteUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
    __typename
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type AddChatUsersDataMutationMutationFn = ApolloReactCommon.MutationFunction<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>;

/**
 * __useAddChatUsersDataMutationMutation__
 *
 * To run a mutation, you first call `useAddChatUsersDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatUsersDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatUsersDataMutationMutation, { data, loading, error }] = useAddChatUsersDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useAddChatUsersDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>(AddChatUsersDataMutationDocument, options);
      }
export type AddChatUsersDataMutationMutationHookResult = ReturnType<typeof useAddChatUsersDataMutationMutation>;
export type AddChatUsersDataMutationMutationResult = ApolloReactCommon.MutationResult<AddChatUsersDataMutationMutation>;
export type AddChatUsersDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>;
export const ChatPricesVisibilityUpdateDocument = gql`
    mutation ChatPricesVisibilityUpdate($input: ChatPricesVisibilityUpdateInput!) {
  chatPricesVisibilityUpdate(input: $input) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type ChatPricesVisibilityUpdateMutationFn = ApolloReactCommon.MutationFunction<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>;

/**
 * __useChatPricesVisibilityUpdateMutation__
 *
 * To run a mutation, you first call `useChatPricesVisibilityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPricesVisibilityUpdateMutation, { data, loading, error }] = useChatPricesVisibilityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatPricesVisibilityUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>(ChatPricesVisibilityUpdateDocument, options);
      }
export type ChatPricesVisibilityUpdateMutationHookResult = ReturnType<typeof useChatPricesVisibilityUpdateMutation>;
export type ChatPricesVisibilityUpdateMutationResult = ApolloReactCommon.MutationResult<ChatPricesVisibilityUpdateMutation>;
export type ChatPricesVisibilityUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>;
export const AddChatUsersDocument = gql`
    mutation AddChatUsers($id: ID!, $userIds: [ID]!, $first: Int = 30, $withAllUserFields: Boolean = true) {
  chatInviteUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type AddChatUsersMutationFn = ApolloReactCommon.MutationFunction<AddChatUsersMutation, AddChatUsersMutationVariables>;

/**
 * __useAddChatUsersMutation__
 *
 * To run a mutation, you first call `useAddChatUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatUsersMutation, { data, loading, error }] = useAddChatUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useAddChatUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddChatUsersMutation, AddChatUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddChatUsersMutation, AddChatUsersMutationVariables>(AddChatUsersDocument, options);
      }
export type AddChatUsersMutationHookResult = ReturnType<typeof useAddChatUsersMutation>;
export type AddChatUsersMutationResult = ApolloReactCommon.MutationResult<AddChatUsersMutation>;
export type AddChatUsersMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChatUsersMutation, AddChatUsersMutationVariables>;
export const RemoveChatUsersDocument = gql`
    mutation RemoveChatUsers($id: ID!, $userIds: [ID!]!, $first: Int = 30, $withAllUserFields: Boolean = true) {
  chatRemoveUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type RemoveChatUsersMutationFn = ApolloReactCommon.MutationFunction<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>;

/**
 * __useRemoveChatUsersMutation__
 *
 * To run a mutation, you first call `useRemoveChatUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChatUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChatUsersMutation, { data, loading, error }] = useRemoveChatUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useRemoveChatUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>(RemoveChatUsersDocument, options);
      }
export type RemoveChatUsersMutationHookResult = ReturnType<typeof useRemoveChatUsersMutation>;
export type RemoveChatUsersMutationResult = ApolloReactCommon.MutationResult<RemoveChatUsersMutation>;
export type RemoveChatUsersMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>;
export const UpdateDeliverySettingDocument = gql`
    mutation UpdateDeliverySetting($id: ID!, $cutoffTimes: WeekdayBasedCutoffSettingsInput!) {
  updateSupplierDeliverySetting(
    input: {id: $id, type: chat, scope: chat, cutoffTimes: $cutoffTimes}
  ) {
    id
  }
}
    `;
export type UpdateDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>;

/**
 * __useUpdateDeliverySettingMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverySettingMutation, { data, loading, error }] = useUpdateDeliverySettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cutoffTimes: // value for 'cutoffTimes'
 *   },
 * });
 */
export function useUpdateDeliverySettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>(UpdateDeliverySettingDocument, options);
      }
export type UpdateDeliverySettingMutationHookResult = ReturnType<typeof useUpdateDeliverySettingMutation>;
export type UpdateDeliverySettingMutationResult = ApolloReactCommon.MutationResult<UpdateDeliverySettingMutation>;
export type UpdateDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>;
export const DeleteChatDeliverySettingDocument = gql`
    mutation DeleteChatDeliverySetting($chatId: ID!) {
  deleteChatDeliverySetting(chatId: $chatId) {
    id
  }
}
    `;
export type DeleteChatDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>;

/**
 * __useDeleteChatDeliverySettingMutation__
 *
 * To run a mutation, you first call `useDeleteChatDeliverySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatDeliverySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatDeliverySettingMutation, { data, loading, error }] = useDeleteChatDeliverySettingMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useDeleteChatDeliverySettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>(DeleteChatDeliverySettingDocument, options);
      }
export type DeleteChatDeliverySettingMutationHookResult = ReturnType<typeof useDeleteChatDeliverySettingMutation>;
export type DeleteChatDeliverySettingMutationResult = ApolloReactCommon.MutationResult<DeleteChatDeliverySettingMutation>;
export type DeleteChatDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>;
export const RemoveCcEmailFromChatsDataDocument = gql`
    mutation RemoveCCEmailFromChatsData($email: AWSEmail!) {
  removeCCEmailFromChats(email: $email) {
    numberOfChatsUpdated
  }
}
    `;
export type RemoveCcEmailFromChatsDataMutationFn = ApolloReactCommon.MutationFunction<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>;

/**
 * __useRemoveCcEmailFromChatsDataMutation__
 *
 * To run a mutation, you first call `useRemoveCcEmailFromChatsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCcEmailFromChatsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCcEmailFromChatsDataMutation, { data, loading, error }] = useRemoveCcEmailFromChatsDataMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveCcEmailFromChatsDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>(RemoveCcEmailFromChatsDataDocument, options);
      }
export type RemoveCcEmailFromChatsDataMutationHookResult = ReturnType<typeof useRemoveCcEmailFromChatsDataMutation>;
export type RemoveCcEmailFromChatsDataMutationResult = ApolloReactCommon.MutationResult<RemoveCcEmailFromChatsDataMutation>;
export type RemoveCcEmailFromChatsDataMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>;
export const UpdateSubCatalogChatsDocument = gql`
    mutation UpdateSubCatalogChats($create: [SubCatalogChatInput!]!, $remove: [SubCatalogChatInput!]!) {
  updateSubCatalogChats(create: $create, remove: $remove) {
    ...UpdateSubCatalogChatsResultFragment
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${UpdateSubCatalogChatsResultFragmentFragmentDoc}`;
export type UpdateSubCatalogChatsMutationFn = ApolloReactCommon.MutationFunction<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>;

/**
 * __useUpdateSubCatalogChatsMutation__
 *
 * To run a mutation, you first call `useUpdateSubCatalogChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubCatalogChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubCatalogChatsMutation, { data, loading, error }] = useUpdateSubCatalogChatsMutation({
 *   variables: {
 *      create: // value for 'create'
 *      remove: // value for 'remove'
 *   },
 * });
 */
export function useUpdateSubCatalogChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>(UpdateSubCatalogChatsDocument, options);
      }
export type UpdateSubCatalogChatsMutationHookResult = ReturnType<typeof useUpdateSubCatalogChatsMutation>;
export type UpdateSubCatalogChatsMutationResult = ApolloReactCommon.MutationResult<UpdateSubCatalogChatsMutation>;
export type UpdateSubCatalogChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>;
export const UpdateSupplierBuyerMovDocument = gql`
    mutation UpdateSupplierBuyerMov($input: [UpdateSupplierBuyerMovInput!]!) {
  updateSupplierBuyerMov(input: $input) {
    ... on MinimumOrderValueUpdate {
      __typename
      success
    }
    ... on MinimumOrderValueFailure {
      __typename
      message
    }
    ... on InputValidationFailure {
      __typename
      message
    }
    ... on AuthorizationFailure {
      __typename
      message
    }
  }
}
    `;
export type UpdateSupplierBuyerMovMutationFn = ApolloReactCommon.MutationFunction<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>;

/**
 * __useUpdateSupplierBuyerMovMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierBuyerMovMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierBuyerMovMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierBuyerMovMutation, { data, loading, error }] = useUpdateSupplierBuyerMovMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierBuyerMovMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>(UpdateSupplierBuyerMovDocument, options);
      }
export type UpdateSupplierBuyerMovMutationHookResult = ReturnType<typeof useUpdateSupplierBuyerMovMutation>;
export type UpdateSupplierBuyerMovMutationResult = ApolloReactCommon.MutationResult<UpdateSupplierBuyerMovMutation>;
export type UpdateSupplierBuyerMovMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>;
export const RemoveSupplierBuyerMovDocument = gql`
    mutation RemoveSupplierBuyerMov($input: [RemoveSupplierBuyerMovInput!]!) {
  removeSupplierBuyerMov(input: $input) {
    ... on MinimumOrderValueUpdate {
      __typename
      success
    }
    ... on MinimumOrderValueFailure {
      __typename
      message
    }
    ... on InputValidationFailure {
      __typename
      message
    }
    ... on AuthorizationFailure {
      __typename
      message
    }
  }
}
    `;
export type RemoveSupplierBuyerMovMutationFn = ApolloReactCommon.MutationFunction<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>;

/**
 * __useRemoveSupplierBuyerMovMutation__
 *
 * To run a mutation, you first call `useRemoveSupplierBuyerMovMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSupplierBuyerMovMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSupplierBuyerMovMutation, { data, loading, error }] = useRemoveSupplierBuyerMovMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSupplierBuyerMovMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>(RemoveSupplierBuyerMovDocument, options);
      }
export type RemoveSupplierBuyerMovMutationHookResult = ReturnType<typeof useRemoveSupplierBuyerMovMutation>;
export type RemoveSupplierBuyerMovMutationResult = ApolloReactCommon.MutationResult<RemoveSupplierBuyerMovMutation>;
export type RemoveSupplierBuyerMovMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>;
export const ChatUpdateDataMutationDocument = gql`
    mutation ChatUpdateDataMutation($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    ...ChatDetailsFragment
    __typename
  }
}
    ${ChatDetailsFragmentFragmentDoc}`;
export type ChatUpdateDataMutationMutationFn = ApolloReactCommon.MutationFunction<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>;

/**
 * __useChatUpdateDataMutationMutation__
 *
 * To run a mutation, you first call `useChatUpdateDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatUpdateDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatUpdateDataMutationMutation, { data, loading, error }] = useChatUpdateDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useChatUpdateDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>(ChatUpdateDataMutationDocument, options);
      }
export type ChatUpdateDataMutationMutationHookResult = ReturnType<typeof useChatUpdateDataMutationMutation>;
export type ChatUpdateDataMutationMutationResult = ApolloReactCommon.MutationResult<ChatUpdateDataMutationMutation>;
export type ChatUpdateDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>;
export const UpdateChatDataDocument = gql`
    mutation UpdateChatData($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    ...ChatDetailsFragment
  }
}
    ${ChatDetailsFragmentFragmentDoc}`;
export type UpdateChatDataMutationFn = ApolloReactCommon.MutationFunction<UpdateChatDataMutation, UpdateChatDataMutationVariables>;

/**
 * __useUpdateChatDataMutation__
 *
 * To run a mutation, you first call `useUpdateChatDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatDataMutation, { data, loading, error }] = useUpdateChatDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatDataMutation, UpdateChatDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatDataMutation, UpdateChatDataMutationVariables>(UpdateChatDataDocument, options);
      }
export type UpdateChatDataMutationHookResult = ReturnType<typeof useUpdateChatDataMutation>;
export type UpdateChatDataMutationResult = ApolloReactCommon.MutationResult<UpdateChatDataMutation>;
export type UpdateChatDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatDataMutation, UpdateChatDataMutationVariables>;
export const UpdateChatBasicDocument = gql`
    mutation UpdateChatBasic($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    id
  }
}
    `;
export type UpdateChatBasicMutationFn = ApolloReactCommon.MutationFunction<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>;

/**
 * __useUpdateChatBasicMutation__
 *
 * To run a mutation, you first call `useUpdateChatBasicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatBasicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatBasicMutation, { data, loading, error }] = useUpdateChatBasicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatBasicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>(UpdateChatBasicDocument, options);
      }
export type UpdateChatBasicMutationHookResult = ReturnType<typeof useUpdateChatBasicMutation>;
export type UpdateChatBasicMutationResult = ApolloReactCommon.MutationResult<UpdateChatBasicMutation>;
export type UpdateChatBasicMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>;
export const UpdateChatEnabledDataMutationDocument = gql`
    mutation UpdateChatEnabledDataMutation($id: ID!, $enabled: Boolean!) {
  updateChatEnabled(id: $id, enabled: $enabled)
}
    `;
export type UpdateChatEnabledDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>;

/**
 * __useUpdateChatEnabledDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatEnabledDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatEnabledDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatEnabledDataMutationMutation, { data, loading, error }] = useUpdateChatEnabledDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateChatEnabledDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>(UpdateChatEnabledDataMutationDocument, options);
      }
export type UpdateChatEnabledDataMutationMutationHookResult = ReturnType<typeof useUpdateChatEnabledDataMutationMutation>;
export type UpdateChatEnabledDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatEnabledDataMutationMutation>;
export type UpdateChatEnabledDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>;
export const UpdateChatNotificationPreferencesDataMutationDocument = gql`
    mutation UpdateChatNotificationPreferencesDataMutation($input: ChatNotificationInput) {
  updateChatNotificationPreferences(input: $input) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;
export type UpdateChatNotificationPreferencesDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>;

/**
 * __useUpdateChatNotificationPreferencesDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatNotificationPreferencesDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatNotificationPreferencesDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatNotificationPreferencesDataMutationMutation, { data, loading, error }] = useUpdateChatNotificationPreferencesDataMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatNotificationPreferencesDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>(UpdateChatNotificationPreferencesDataMutationDocument, options);
      }
export type UpdateChatNotificationPreferencesDataMutationMutationHookResult = ReturnType<typeof useUpdateChatNotificationPreferencesDataMutationMutation>;
export type UpdateChatNotificationPreferencesDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatNotificationPreferencesDataMutationMutation>;
export type UpdateChatNotificationPreferencesDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>;
export const ChatPricesVisibilityUpdateMutationDocument = gql`
    mutation ChatPricesVisibilityUpdateMutation($input: ChatPricesVisibilityUpdateInput!) {
  chatPricesVisibilityUpdate(input: $input) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type ChatPricesVisibilityUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>;

/**
 * __useChatPricesVisibilityUpdateMutationMutation__
 *
 * To run a mutation, you first call `useChatPricesVisibilityUpdateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityUpdateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPricesVisibilityUpdateMutationMutation, { data, loading, error }] = useChatPricesVisibilityUpdateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatPricesVisibilityUpdateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>(ChatPricesVisibilityUpdateMutationDocument, options);
      }
export type ChatPricesVisibilityUpdateMutationMutationHookResult = ReturnType<typeof useChatPricesVisibilityUpdateMutationMutation>;
export type ChatPricesVisibilityUpdateMutationMutationResult = ApolloReactCommon.MutationResult<ChatPricesVisibilityUpdateMutationMutation>;
export type ChatPricesVisibilityUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>;
export const UpdateChatSettingsDataMutationDocument = gql`
    mutation UpdateChatSettingsDataMutation($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    ...ChatDetailsFragment
  }
}
    ${ChatDetailsFragmentFragmentDoc}`;
export type UpdateChatSettingsDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>;

/**
 * __useUpdateChatSettingsDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatSettingsDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatSettingsDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatSettingsDataMutationMutation, { data, loading, error }] = useUpdateChatSettingsDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatSettingsDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>(UpdateChatSettingsDataMutationDocument, options);
      }
export type UpdateChatSettingsDataMutationMutationHookResult = ReturnType<typeof useUpdateChatSettingsDataMutationMutation>;
export type UpdateChatSettingsDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatSettingsDataMutationMutation>;
export type UpdateChatSettingsDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>;
export const UpdateDeliverySettingMutationDocument = gql`
    mutation UpdateDeliverySettingMutation($id: ID!, $cutoffTimes: WeekdayBasedCutoffSettingsInput!) {
  updateSupplierDeliverySetting(
    input: {id: $id, type: chat, scope: chat, cutoffTimes: $cutoffTimes}
  ) {
    id
    __typename
  }
}
    `;
export type UpdateDeliverySettingMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>;

/**
 * __useUpdateDeliverySettingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverySettingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverySettingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverySettingMutationMutation, { data, loading, error }] = useUpdateDeliverySettingMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cutoffTimes: // value for 'cutoffTimes'
 *   },
 * });
 */
export function useUpdateDeliverySettingMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>(UpdateDeliverySettingMutationDocument, options);
      }
export type UpdateDeliverySettingMutationMutationHookResult = ReturnType<typeof useUpdateDeliverySettingMutationMutation>;
export type UpdateDeliverySettingMutationMutationResult = ApolloReactCommon.MutationResult<UpdateDeliverySettingMutationMutation>;
export type UpdateDeliverySettingMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>;
export const ChatHistoryDataDocument = gql`
    query ChatHistoryData($id: ID!) {
  messages(chatId: $id, first: 50) {
    edges {
      node {
        ...HistoryMessageFragment
      }
    }
  }
}
    ${HistoryMessageFragmentFragmentDoc}`;

/**
 * __useChatHistoryDataQuery__
 *
 * To run a query within a React component, call `useChatHistoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHistoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHistoryDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatHistoryDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables> & ({ variables: ChatHistoryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
      }
export function useChatHistoryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
        }
export function useChatHistoryDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
        }
export type ChatHistoryDataQueryHookResult = ReturnType<typeof useChatHistoryDataQuery>;
export type ChatHistoryDataLazyQueryHookResult = ReturnType<typeof useChatHistoryDataLazyQuery>;
export type ChatHistoryDataSuspenseQueryHookResult = ReturnType<typeof useChatHistoryDataSuspenseQuery>;
export type ChatHistoryDataQueryResult = ApolloReactCommon.QueryResult<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>;
export const ChatSearchDataDocument = gql`
    query ChatSearchData($searchTerm: String!, $searchEntity: SearchEntityType = chat, $first: Int = 30, $size: Int = 50, $offset: Int = 0, $withAllUserFields: Boolean = false, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: $searchEntity, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      ...ChatSearchEntityFragment
    }
  }
}
    ${ChatSearchEntityFragmentFragmentDoc}`;

/**
 * __useChatSearchDataQuery__
 *
 * To run a query within a React component, call `useChatSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSearchDataQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      searchEntity: // value for 'searchEntity'
 *      first: // value for 'first'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      withAllUserFields: // value for 'withAllUserFields'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChatSearchDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables> & ({ variables: ChatSearchDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
      }
export function useChatSearchDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
        }
export function useChatSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
        }
export type ChatSearchDataQueryHookResult = ReturnType<typeof useChatSearchDataQuery>;
export type ChatSearchDataLazyQueryHookResult = ReturnType<typeof useChatSearchDataLazyQuery>;
export type ChatSearchDataSuspenseQueryHookResult = ReturnType<typeof useChatSearchDataSuspenseQuery>;
export type ChatSearchDataQueryResult = ApolloReactCommon.QueryResult<ChatSearchDataQuery, ChatSearchDataQueryVariables>;
export const SearchBuyersForChatDocument = gql`
    query SearchBuyersForChat($searchTerm: String!, $size: Int = 30, $filter: SearchFilter) {
  search(query: {search: $searchTerm, type: buyer, size: $size, filter: $filter}) {
    hits {
      entity {
        ... on Buyer {
          id
          name
          referenceId
          fullAddress
          displayName
          city
          country
        }
      }
    }
  }
}
    `;

/**
 * __useSearchBuyersForChatQuery__
 *
 * To run a query within a React component, call `useSearchBuyersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyersForChatQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchBuyersForChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables> & ({ variables: SearchBuyersForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
      }
export function useSearchBuyersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
        }
export function useSearchBuyersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
        }
export type SearchBuyersForChatQueryHookResult = ReturnType<typeof useSearchBuyersForChatQuery>;
export type SearchBuyersForChatLazyQueryHookResult = ReturnType<typeof useSearchBuyersForChatLazyQuery>;
export type SearchBuyersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchBuyersForChatSuspenseQuery>;
export type SearchBuyersForChatQueryResult = ApolloReactCommon.QueryResult<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>;
export const SearchSuppliersForChatDocument = gql`
    query SearchSuppliersForChat($keywords: String = "", $filter: SupplierSearchFilter) {
  supplierSearch(query: {keywords: $keywords, filter: $filter}) {
    ... on SearchSupplierConnection {
      edges {
        node {
          id
          referenceId
          customerNumberMandatory
          botUser {
            id
            name
            phone
            supplier
            botUser
            email
            orderPreference {
              whatsApp
              sms
              fax
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchSuppliersForChatQuery__
 *
 * To run a query within a React component, call `useSearchSuppliersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuppliersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuppliersForChatQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuppliersForChatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
      }
export function useSearchSuppliersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
        }
export function useSearchSuppliersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
        }
export type SearchSuppliersForChatQueryHookResult = ReturnType<typeof useSearchSuppliersForChatQuery>;
export type SearchSuppliersForChatLazyQueryHookResult = ReturnType<typeof useSearchSuppliersForChatLazyQuery>;
export type SearchSuppliersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchSuppliersForChatSuspenseQuery>;
export type SearchSuppliersForChatQueryResult = ApolloReactCommon.QueryResult<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>;
export const SearchUsersForChatDocument = gql`
    query SearchUsersForChat($search: String!, $limit: Int = 30, $filter: SearchFilter) {
  search(query: {search: $search, type: user, size: $limit, filter: $filter}) {
    hits {
      entity {
        ... on User {
          id
          name
          phone
          supplier
          botUser
          email
          orderPreference {
            whatsApp
            sms
            fax
          }
          linkedSupplier {
            customerNumberMandatory
            botUser {
              id
              name
              phone
              supplier
              botUser
              email
              orderPreference {
                whatsApp
                sms
                fax
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchUsersForChatQuery__
 *
 * To run a query within a React component, call `useSearchUsersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersForChatQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchUsersForChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables> & ({ variables: SearchUsersForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
      }
export function useSearchUsersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
        }
export function useSearchUsersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
        }
export type SearchUsersForChatQueryHookResult = ReturnType<typeof useSearchUsersForChatQuery>;
export type SearchUsersForChatLazyQueryHookResult = ReturnType<typeof useSearchUsersForChatLazyQuery>;
export type SearchUsersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchUsersForChatSuspenseQuery>;
export type SearchUsersForChatQueryResult = ApolloReactCommon.QueryResult<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>;
export const GetBuyerUsersDocument = gql`
    query GetBuyerUsers($buyerEntityId: ID!, $first: Int = 150, $after: String) {
  buyer(id: $buyerEntityId) {
    id
    users(first: $first, after: $after) {
      edges {
        node {
          id
          name
          phone
          email
          supplier
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuyerUsersQuery__
 *
 * To run a query within a React component, call `useGetBuyerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerUsersQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBuyerUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables> & ({ variables: GetBuyerUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
      }
export function useGetBuyerUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
        }
export function useGetBuyerUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
        }
export type GetBuyerUsersQueryHookResult = ReturnType<typeof useGetBuyerUsersQuery>;
export type GetBuyerUsersLazyQueryHookResult = ReturnType<typeof useGetBuyerUsersLazyQuery>;
export type GetBuyerUsersSuspenseQueryHookResult = ReturnType<typeof useGetBuyerUsersSuspenseQuery>;
export type GetBuyerUsersQueryResult = ApolloReactCommon.QueryResult<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>;
export const CreateChatDocument = gql`
    mutation CreateChat($chat: ChatCreateInput!) {
  chatCreate(chat: $chat) {
    id
    chatName
    restaurantName
    status
    enabled
    activatedAt
    buyer {
      id
      name
    }
    supplierEntity {
      id
      name
    }
  }
}
    `;
export type CreateChatMutationFn = ApolloReactCommon.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = ApolloReactCommon.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const ListSubCatalogsDocument = gql`
    query ListSubCatalogs($supplierEntityId: String, $first: Int, $after: String) {
  listSubCatalogs(
    supplierEntityId: $supplierEntityId
    first: $first
    after: $after
  ) {
    ... on SubCatalogConnection {
      edges {
        cursor
        node {
          id
          name
          supplierEntityId
        }
      }
    }
  }
}
    `;

/**
 * __useListSubCatalogsQuery__
 *
 * To run a query within a React component, call `useListSubCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubCatalogsQuery({
 *   variables: {
 *      supplierEntityId: // value for 'supplierEntityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListSubCatalogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
      }
export function useListSubCatalogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
        }
export function useListSubCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
        }
export type ListSubCatalogsQueryHookResult = ReturnType<typeof useListSubCatalogsQuery>;
export type ListSubCatalogsLazyQueryHookResult = ReturnType<typeof useListSubCatalogsLazyQuery>;
export type ListSubCatalogsSuspenseQueryHookResult = ReturnType<typeof useListSubCatalogsSuspenseQuery>;
export type ListSubCatalogsQueryResult = ApolloReactCommon.QueryResult<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>;
export const GetChatCountByCcEmailDataDocument = gql`
    query GetChatCountByCCEmailData($email: AWSEmail!) {
  getChatCountByCCEmail(email: $email) {
    ...ChatCountByCcEmailReportFragment
  }
}
    ${ChatCountByCcEmailReportFragmentFragmentDoc}`;

/**
 * __useGetChatCountByCcEmailDataQuery__
 *
 * To run a query within a React component, call `useGetChatCountByCcEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatCountByCcEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatCountByCcEmailDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetChatCountByCcEmailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables> & ({ variables: GetChatCountByCcEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
      }
export function useGetChatCountByCcEmailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
        }
export function useGetChatCountByCcEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
        }
export type GetChatCountByCcEmailDataQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataQuery>;
export type GetChatCountByCcEmailDataLazyQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataLazyQuery>;
export type GetChatCountByCcEmailDataSuspenseQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataSuspenseQuery>;
export type GetChatCountByCcEmailDataQueryResult = ApolloReactCommon.QueryResult<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>;
export const GetChatDataDocument = gql`
    query GetChatData($chatId: ID!, $first: Int = 30, $withAllUserFields: Boolean = false, $withProducts: Boolean = true, $buyerId: String) {
  chat(id: $chatId) {
    ...ChatDataFragment
  }
  getSubCatalogsForChat(chatId: $chatId) {
    ...SubCatalogsForChatFragment
  }
}
    ${ChatDataFragmentFragmentDoc}
${SubCatalogsForChatFragmentFragmentDoc}`;

/**
 * __useGetChatDataQuery__
 *
 * To run a query within a React component, call `useGetChatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatDataQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *      withProducts: // value for 'withProducts'
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useGetChatDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables> & ({ variables: GetChatDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
      }
export function useGetChatDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
        }
export function useGetChatDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
        }
export type GetChatDataQueryHookResult = ReturnType<typeof useGetChatDataQuery>;
export type GetChatDataLazyQueryHookResult = ReturnType<typeof useGetChatDataLazyQuery>;
export type GetChatDataSuspenseQueryHookResult = ReturnType<typeof useGetChatDataSuspenseQuery>;
export type GetChatDataQueryResult = ApolloReactCommon.QueryResult<GetChatDataQuery, GetChatDataQueryVariables>;
export const ChatNotificationPreferencesDataDocument = gql`
    query ChatNotificationPreferencesData($chatId: ID!) {
  chatNotificationPreferences(id: $chatId) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useChatNotificationPreferencesDataQuery__
 *
 * To run a query within a React component, call `useChatNotificationPreferencesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatNotificationPreferencesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatNotificationPreferencesDataQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatNotificationPreferencesDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables> & ({ variables: ChatNotificationPreferencesDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
      }
export function useChatNotificationPreferencesDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
        }
export function useChatNotificationPreferencesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
        }
export type ChatNotificationPreferencesDataQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataQuery>;
export type ChatNotificationPreferencesDataLazyQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataLazyQuery>;
export type ChatNotificationPreferencesDataSuspenseQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataSuspenseQuery>;
export type ChatNotificationPreferencesDataQueryResult = ApolloReactCommon.QueryResult<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>;
export const ChatPricesVisibilityQueryDocument = gql`
    query ChatPricesVisibilityQuery($chatId: ID!) {
  chatPricesVisibility(chatId: $chatId) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
      __typename
    }
    ... on InputValidationFailure {
      message
      __typename
    }
    ... on AuthorizationFailure {
      message
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useChatPricesVisibilityQueryQuery__
 *
 * To run a query within a React component, call `useChatPricesVisibilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatPricesVisibilityQueryQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatPricesVisibilityQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables> & ({ variables: ChatPricesVisibilityQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
      }
export function useChatPricesVisibilityQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
        }
export function useChatPricesVisibilityQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
        }
export type ChatPricesVisibilityQueryQueryHookResult = ReturnType<typeof useChatPricesVisibilityQueryQuery>;
export type ChatPricesVisibilityQueryLazyQueryHookResult = ReturnType<typeof useChatPricesVisibilityQueryLazyQuery>;
export type ChatPricesVisibilityQuerySuspenseQueryHookResult = ReturnType<typeof useChatPricesVisibilityQuerySuspenseQuery>;
export type ChatPricesVisibilityQueryQueryResult = ApolloReactCommon.QueryResult<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>;
export const SupplierDeliverySettingQueryDocument = gql`
    query SupplierDeliverySettingQuery($id: ID!) {
  supplierDeliverySetting(id: $id) {
    ...DeliverySettingFragment
    __typename
  }
}
    ${DeliverySettingFragmentFragmentDoc}`;

/**
 * __useSupplierDeliverySettingQueryQuery__
 *
 * To run a query within a React component, call `useSupplierDeliverySettingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDeliverySettingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDeliverySettingQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupplierDeliverySettingQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables> & ({ variables: SupplierDeliverySettingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
      }
export function useSupplierDeliverySettingQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
        }
export function useSupplierDeliverySettingQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
        }
export type SupplierDeliverySettingQueryQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQueryQuery>;
export type SupplierDeliverySettingQueryLazyQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQueryLazyQuery>;
export type SupplierDeliverySettingQuerySuspenseQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQuerySuspenseQuery>;
export type SupplierDeliverySettingQueryQueryResult = ApolloReactCommon.QueryResult<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>;
export const SupplierAssortmentsDataDocument = gql`
    query SupplierAssortmentsData {
  supplierAssortments {
    assortments
    __typename
  }
}
    `;

/**
 * __useSupplierAssortmentsDataQuery__
 *
 * To run a query within a React component, call `useSupplierAssortmentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierAssortmentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierAssortmentsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplierAssortmentsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
      }
export function useSupplierAssortmentsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
        }
export function useSupplierAssortmentsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
        }
export type SupplierAssortmentsDataQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataQuery>;
export type SupplierAssortmentsDataLazyQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataLazyQuery>;
export type SupplierAssortmentsDataSuspenseQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataSuspenseQuery>;
export type SupplierAssortmentsDataQueryResult = ApolloReactCommon.QueryResult<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>;
export const SupplierDeliverySettingDataDocument = gql`
    query SupplierDeliverySettingData($supplierId: ID!) {
  supplierDeliverySetting(id: $supplierId) {
    ...SupplierDeliverySettingFragment
    __typename
  }
}
    ${SupplierDeliverySettingFragmentFragmentDoc}`;

/**
 * __useSupplierDeliverySettingDataQuery__
 *
 * To run a query within a React component, call `useSupplierDeliverySettingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDeliverySettingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDeliverySettingDataQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierDeliverySettingDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables> & ({ variables: SupplierDeliverySettingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
      }
export function useSupplierDeliverySettingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
        }
export function useSupplierDeliverySettingDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
        }
export type SupplierDeliverySettingDataQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataQuery>;
export type SupplierDeliverySettingDataLazyQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataLazyQuery>;
export type SupplierDeliverySettingDataSuspenseQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataSuspenseQuery>;
export type SupplierDeliverySettingDataQueryResult = ApolloReactCommon.QueryResult<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>;
export const GetSupplierDetailsDataDocument = gql`
    query GetSupplierDetailsData($id: ID!) {
  supplier(id: $id) {
    ...SupplierDetailsFragment
    __typename
  }
}
    ${SupplierDetailsFragmentFragmentDoc}`;

/**
 * __useGetSupplierDetailsDataQuery__
 *
 * To run a query within a React component, call `useGetSupplierDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierDetailsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupplierDetailsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables> & ({ variables: GetSupplierDetailsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
      }
export function useGetSupplierDetailsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
        }
export function useGetSupplierDetailsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
        }
export type GetSupplierDetailsDataQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataQuery>;
export type GetSupplierDetailsDataLazyQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataLazyQuery>;
export type GetSupplierDetailsDataSuspenseQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataSuspenseQuery>;
export type GetSupplierDetailsDataQueryResult = ApolloReactCommon.QueryResult<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>;
export const SupplierSearchDataDocument = gql`
    query SupplierSearchData($search: String!, $first: Int, $before: String, $after: String, $filter: SupplierSearchFilter) {
  supplierSearch(
    query: {keywords: $search, filter: $filter}
    first: $first
    before: $before
    after: $after
  ) {
    ...SearchSupplierConnectionFragment
    __typename
  }
}
    ${SearchSupplierConnectionFragmentFragmentDoc}`;

/**
 * __useSupplierSearchDataQuery__
 *
 * To run a query within a React component, call `useSupplierSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierSearchDataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSupplierSearchDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables> & ({ variables: SupplierSearchDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
      }
export function useSupplierSearchDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
        }
export function useSupplierSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
        }
export type SupplierSearchDataQueryHookResult = ReturnType<typeof useSupplierSearchDataQuery>;
export type SupplierSearchDataLazyQueryHookResult = ReturnType<typeof useSupplierSearchDataLazyQuery>;
export type SupplierSearchDataSuspenseQueryHookResult = ReturnType<typeof useSupplierSearchDataSuspenseQuery>;
export type SupplierSearchDataQueryResult = ApolloReactCommon.QueryResult<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>;
export const AddUserToChatsDocument = gql`
    mutation AddUserToChats($userId: ID!, $chatIds: [ID!]!) {
  addUserToChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type AddUserToChatsMutationFn = ApolloReactCommon.MutationFunction<AddUserToChatsMutation, AddUserToChatsMutationVariables>;

/**
 * __useAddUserToChatsMutation__
 *
 * To run a mutation, you first call `useAddUserToChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToChatsMutation, { data, loading, error }] = useAddUserToChatsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useAddUserToChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToChatsMutation, AddUserToChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToChatsMutation, AddUserToChatsMutationVariables>(AddUserToChatsDocument, options);
      }
export type AddUserToChatsMutationHookResult = ReturnType<typeof useAddUserToChatsMutation>;
export type AddUserToChatsMutationResult = ApolloReactCommon.MutationResult<AddUserToChatsMutation>;
export type AddUserToChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToChatsMutation, AddUserToChatsMutationVariables>;
export const UsersPageBuyerAddUserDocument = gql`
    mutation UsersPageBuyerAddUser($buyerId: ID!, $userId: ID!, $input: BuyerUserInput) {
  buyerAddUser(buyerId: $buyerId, userId: $userId, input: $input) {
    buyer {
      id
    }
    user {
      id
    }
  }
}
    `;
export type UsersPageBuyerAddUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>;

/**
 * __useUsersPageBuyerAddUserMutation__
 *
 * To run a mutation, you first call `useUsersPageBuyerAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageBuyerAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageBuyerAddUserMutation, { data, loading, error }] = useUsersPageBuyerAddUserMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersPageBuyerAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>(UsersPageBuyerAddUserDocument, options);
      }
export type UsersPageBuyerAddUserMutationHookResult = ReturnType<typeof useUsersPageBuyerAddUserMutation>;
export type UsersPageBuyerAddUserMutationResult = ApolloReactCommon.MutationResult<UsersPageBuyerAddUserMutation>;
export type UsersPageBuyerAddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>;
export const UsersPageBuyerRemoveUserDocument = gql`
    mutation UsersPageBuyerRemoveUser($buyerId: ID!, $userId: ID!) {
  buyerRemoveUser(buyerId: $buyerId, userId: $userId) {
    buyer {
      id
    }
    user {
      id
    }
  }
}
    `;
export type UsersPageBuyerRemoveUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>;

/**
 * __useUsersPageBuyerRemoveUserMutation__
 *
 * To run a mutation, you first call `useUsersPageBuyerRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageBuyerRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageBuyerRemoveUserMutation, { data, loading, error }] = useUsersPageBuyerRemoveUserMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersPageBuyerRemoveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>(UsersPageBuyerRemoveUserDocument, options);
      }
export type UsersPageBuyerRemoveUserMutationHookResult = ReturnType<typeof useUsersPageBuyerRemoveUserMutation>;
export type UsersPageBuyerRemoveUserMutationResult = ApolloReactCommon.MutationResult<UsersPageBuyerRemoveUserMutation>;
export type UsersPageBuyerRemoveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>;
export const UsersPageCreateUserDocument = gql`
    mutation UsersPageCreateUser($userInput: UserCreateInput!) {
  userCreate(user: $userInput) {
    ...UsersPageCreateUserFragment
  }
}
    ${UsersPageCreateUserFragmentFragmentDoc}`;
export type UsersPageCreateUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>;

/**
 * __useUsersPageCreateUserMutation__
 *
 * To run a mutation, you first call `useUsersPageCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageCreateUserMutation, { data, loading, error }] = useUsersPageCreateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUsersPageCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>(UsersPageCreateUserDocument, options);
      }
export type UsersPageCreateUserMutationHookResult = ReturnType<typeof useUsersPageCreateUserMutation>;
export type UsersPageCreateUserMutationResult = ApolloReactCommon.MutationResult<UsersPageCreateUserMutation>;
export type UsersPageCreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>;
export const UsersPageDeleteUserDocument = gql`
    mutation UsersPageDeleteUser($input: UserRequestToDeleteInput!) {
  userRequestToDelete(input: $input) {
    ... on UserRequestToDeleteDetails {
      success
    }
  }
}
    `;
export type UsersPageDeleteUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>;

/**
 * __useUsersPageDeleteUserMutation__
 *
 * To run a mutation, you first call `useUsersPageDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageDeleteUserMutation, { data, loading, error }] = useUsersPageDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersPageDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>(UsersPageDeleteUserDocument, options);
      }
export type UsersPageDeleteUserMutationHookResult = ReturnType<typeof useUsersPageDeleteUserMutation>;
export type UsersPageDeleteUserMutationResult = ApolloReactCommon.MutationResult<UsersPageDeleteUserMutation>;
export type UsersPageDeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>;
export const UsersPageUserConfirmDocument = gql`
    mutation UsersPageUserConfirm($phone: String!) {
  userConfirm(newUserPool: false, phone: $phone)
}
    `;
export type UsersPageUserConfirmMutationFn = ApolloReactCommon.MutationFunction<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>;

/**
 * __useUsersPageUserConfirmMutation__
 *
 * To run a mutation, you first call `useUsersPageUserConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageUserConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageUserConfirmMutation, { data, loading, error }] = useUsersPageUserConfirmMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUsersPageUserConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>(UsersPageUserConfirmDocument, options);
      }
export type UsersPageUserConfirmMutationHookResult = ReturnType<typeof useUsersPageUserConfirmMutation>;
export type UsersPageUserConfirmMutationResult = ApolloReactCommon.MutationResult<UsersPageUserConfirmMutation>;
export type UsersPageUserConfirmMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>;
export const RemoveUserFromChatsDocument = gql`
    mutation RemoveUserFromChats($userId: ID!, $chatIds: [ID!]!) {
  removeUserFromChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type RemoveUserFromChatsMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>;

/**
 * __useRemoveUserFromChatsMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromChatsMutation, { data, loading, error }] = useRemoveUserFromChatsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useRemoveUserFromChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>(RemoveUserFromChatsDocument, options);
      }
export type RemoveUserFromChatsMutationHookResult = ReturnType<typeof useRemoveUserFromChatsMutation>;
export type RemoveUserFromChatsMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromChatsMutation>;
export type RemoveUserFromChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>;
export const SafelistTwilioUserDocument = gql`
    mutation SafelistTwilioUser($id: ID!) {
  safelistTwilioUser(id: $id) {
    ... on SafelistTwilioUserSuccess {
      __typename
      successMessage: message
    }
    ... on SafelistTwilioUserFailure {
      __typename
      failureMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on InputValidationFailure {
      message
      responseType
      invalidFields {
        fieldName
        reason
        __typename
      }
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    `;
export type SafelistTwilioUserMutationFn = ApolloReactCommon.MutationFunction<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>;

/**
 * __useSafelistTwilioUserMutation__
 *
 * To run a mutation, you first call `useSafelistTwilioUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSafelistTwilioUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [safelistTwilioUserMutation, { data, loading, error }] = useSafelistTwilioUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafelistTwilioUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>(SafelistTwilioUserDocument, options);
      }
export type SafelistTwilioUserMutationHookResult = ReturnType<typeof useSafelistTwilioUserMutation>;
export type SafelistTwilioUserMutationResult = ApolloReactCommon.MutationResult<SafelistTwilioUserMutation>;
export type SafelistTwilioUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>;
export const SupplierAddUserDocument = gql`
    mutation SupplierAddUser($userId: String!, $supplierId: String, $withRoles: Boolean!) {
  userUpdate(user: {id: $userId, supplierId: $supplierId}) {
    ...UserDetailsFragment
    __typename
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type SupplierAddUserMutationFn = ApolloReactCommon.MutationFunction<SupplierAddUserMutation, SupplierAddUserMutationVariables>;

/**
 * __useSupplierAddUserMutation__
 *
 * To run a mutation, you first call `useSupplierAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierAddUserMutation, { data, loading, error }] = useSupplierAddUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      supplierId: // value for 'supplierId'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useSupplierAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SupplierAddUserMutation, SupplierAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SupplierAddUserMutation, SupplierAddUserMutationVariables>(SupplierAddUserDocument, options);
      }
export type SupplierAddUserMutationHookResult = ReturnType<typeof useSupplierAddUserMutation>;
export type SupplierAddUserMutationResult = ApolloReactCommon.MutationResult<SupplierAddUserMutation>;
export type SupplierAddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SupplierAddUserMutation, SupplierAddUserMutationVariables>;
export const SupplierRemoveUserDocument = gql`
    mutation SupplierRemoveUser($userId: String!, $withRoles: Boolean!) {
  userUpdate(user: {id: $userId, supplierId: null}) {
    ...UserDetailsFragment
    __typename
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type SupplierRemoveUserMutationFn = ApolloReactCommon.MutationFunction<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>;

/**
 * __useSupplierRemoveUserMutation__
 *
 * To run a mutation, you first call `useSupplierRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierRemoveUserMutation, { data, loading, error }] = useSupplierRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useSupplierRemoveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>(SupplierRemoveUserDocument, options);
      }
export type SupplierRemoveUserMutationHookResult = ReturnType<typeof useSupplierRemoveUserMutation>;
export type SupplierRemoveUserMutationResult = ApolloReactCommon.MutationResult<SupplierRemoveUserMutation>;
export type SupplierRemoveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>;
export const SyncCognitoUserDocument = gql`
    mutation SyncCognitoUser($id: ID!) {
  syncCognitoUser(id: $id) {
    ... on SyncCognitoUserSuccess {
      __typename
      state {
        ...CognitoStateFragment
      }
    }
    ... on SyncCognitoUserFailure {
      __typename
      failureMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    ${CognitoStateFragmentFragmentDoc}`;
export type SyncCognitoUserMutationFn = ApolloReactCommon.MutationFunction<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>;

/**
 * __useSyncCognitoUserMutation__
 *
 * To run a mutation, you first call `useSyncCognitoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCognitoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCognitoUserMutation, { data, loading, error }] = useSyncCognitoUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncCognitoUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>(SyncCognitoUserDocument, options);
      }
export type SyncCognitoUserMutationHookResult = ReturnType<typeof useSyncCognitoUserMutation>;
export type SyncCognitoUserMutationResult = ApolloReactCommon.MutationResult<SyncCognitoUserMutation>;
export type SyncCognitoUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>;
export const UsersPageUpdateUserDocument = gql`
    mutation UsersPageUpdateUser($userUpdateInput: UserUpdateInput!) {
  userUpdate(user: $userUpdateInput) {
    ...UsersPageUserDetailsFragment
    isTest
  }
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;
export type UsersPageUpdateUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>;

/**
 * __useUsersPageUpdateUserMutation__
 *
 * To run a mutation, you first call `useUsersPageUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageUpdateUserMutation, { data, loading, error }] = useUsersPageUpdateUserMutation({
 *   variables: {
 *      userUpdateInput: // value for 'userUpdateInput'
 *   },
 * });
 */
export function useUsersPageUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>(UsersPageUpdateUserDocument, options);
      }
export type UsersPageUpdateUserMutationHookResult = ReturnType<typeof useUsersPageUpdateUserMutation>;
export type UsersPageUpdateUserMutationResult = ApolloReactCommon.MutationResult<UsersPageUpdateUserMutation>;
export type UsersPageUpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>;
export const UserRemoveRoleDocument = gql`
    mutation UserRemoveRole($userId: String!, $role: Role!) {
  userRemoveRole(userId: $userId, role: $role) {
    id
    role
    __typename
  }
}
    `;
export type UserRemoveRoleMutationFn = ApolloReactCommon.MutationFunction<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>;

/**
 * __useUserRemoveRoleMutation__
 *
 * To run a mutation, you first call `useUserRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveRoleMutation, { data, loading, error }] = useUserRemoveRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserRemoveRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>(UserRemoveRoleDocument, options);
      }
export type UserRemoveRoleMutationHookResult = ReturnType<typeof useUserRemoveRoleMutation>;
export type UserRemoveRoleMutationResult = ApolloReactCommon.MutationResult<UserRemoveRoleMutation>;
export type UserRemoveRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>;
export const GetBuyerEntityChatsDocument = gql`
    query GetBuyerEntityChats($buyerEntityId: String!, $userId: ID!, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $buyerEntityId, type: chat, size: 50, offset: $offset, sort: {field: "title.keyword", order: asc}, filter: $filter}
  ) {
    hits {
      entity {
        ...BuyerEntityChatFragment
      }
    }
    total
  }
}
    ${BuyerEntityChatFragmentFragmentDoc}`;

/**
 * __useGetBuyerEntityChatsQuery__
 *
 * To run a query within a React component, call `useGetBuyerEntityChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerEntityChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerEntityChatsQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyerEntityChatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables> & ({ variables: GetBuyerEntityChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
      }
export function useGetBuyerEntityChatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
        }
export function useGetBuyerEntityChatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
        }
export type GetBuyerEntityChatsQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQuery>;
export type GetBuyerEntityChatsLazyQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsLazyQuery>;
export type GetBuyerEntityChatsSuspenseQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsSuspenseQuery>;
export type GetBuyerEntityChatsQueryResult = ApolloReactCommon.QueryResult<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>;
export const UsersPageGetUserDocument = gql`
    query UsersPageGetUser($id: ID!) {
  user(id: $id) {
    ...UsersPageUserDetailsFragment
  }
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;

/**
 * __useUsersPageGetUserQuery__
 *
 * To run a query within a React component, call `useUsersPageGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersPageGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables> & ({ variables: UsersPageGetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
      }
export function useUsersPageGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
        }
export function useUsersPageGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
        }
export type UsersPageGetUserQueryHookResult = ReturnType<typeof useUsersPageGetUserQuery>;
export type UsersPageGetUserLazyQueryHookResult = ReturnType<typeof useUsersPageGetUserLazyQuery>;
export type UsersPageGetUserSuspenseQueryHookResult = ReturnType<typeof useUsersPageGetUserSuspenseQuery>;
export type UsersPageGetUserQueryResult = ApolloReactCommon.QueryResult<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>;
export const GetUserCognitoStateDocument = gql`
    query GetUserCognitoState($id: ID!) {
  userCognitoState(id: $id) {
    ...CognitoStateFragment
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    ${CognitoStateFragmentFragmentDoc}`;

/**
 * __useGetUserCognitoStateQuery__
 *
 * To run a query within a React component, call `useGetUserCognitoStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCognitoStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCognitoStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCognitoStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables> & ({ variables: GetUserCognitoStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
      }
export function useGetUserCognitoStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
        }
export function useGetUserCognitoStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
        }
export type GetUserCognitoStateQueryHookResult = ReturnType<typeof useGetUserCognitoStateQuery>;
export type GetUserCognitoStateLazyQueryHookResult = ReturnType<typeof useGetUserCognitoStateLazyQuery>;
export type GetUserCognitoStateSuspenseQueryHookResult = ReturnType<typeof useGetUserCognitoStateSuspenseQuery>;
export type GetUserCognitoStateQueryResult = ApolloReactCommon.QueryResult<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>;
export const GetUserTwilioStateDocument = gql`
    query GetUserTwilioState($id: ID!) {
  userTwilioState(id: $id) {
    ... on UserTwilioState {
      status
      __typename
    }
    ... on UserTwilioStateError {
      __typename
      ErrorMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on InputValidationFailure {
      message
      responseType
      invalidFields {
        fieldName
        reason
        __typename
      }
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetUserTwilioStateQuery__
 *
 * To run a query within a React component, call `useGetUserTwilioStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTwilioStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTwilioStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserTwilioStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables> & ({ variables: GetUserTwilioStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
      }
export function useGetUserTwilioStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
        }
export function useGetUserTwilioStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
        }
export type GetUserTwilioStateQueryHookResult = ReturnType<typeof useGetUserTwilioStateQuery>;
export type GetUserTwilioStateLazyQueryHookResult = ReturnType<typeof useGetUserTwilioStateLazyQuery>;
export type GetUserTwilioStateSuspenseQueryHookResult = ReturnType<typeof useGetUserTwilioStateSuspenseQuery>;
export type GetUserTwilioStateQueryResult = ApolloReactCommon.QueryResult<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>;
export const UsersPageSearchBuyerEntityDocument = gql`
    query UsersPageSearchBuyerEntity($searchTerm: String!, $size: Int = 30, $filter: SearchFilter) {
  search(query: {search: $searchTerm, type: buyer, size: $size, filter: $filter}) {
    hits {
      entity {
        ...UsersPageBuyerEntityFragment
      }
    }
  }
}
    ${UsersPageBuyerEntityFragmentFragmentDoc}`;

/**
 * __useUsersPageSearchBuyerEntityQuery__
 *
 * To run a query within a React component, call `useUsersPageSearchBuyerEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageSearchBuyerEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageSearchBuyerEntityQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersPageSearchBuyerEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables> & ({ variables: UsersPageSearchBuyerEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
      }
export function useUsersPageSearchBuyerEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
        }
export function useUsersPageSearchBuyerEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
        }
export type UsersPageSearchBuyerEntityQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntityQuery>;
export type UsersPageSearchBuyerEntityLazyQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntityLazyQuery>;
export type UsersPageSearchBuyerEntitySuspenseQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntitySuspenseQuery>;
export type UsersPageSearchBuyerEntityQueryResult = ApolloReactCommon.QueryResult<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>;
export const SearchSuppliersDocument = gql`
    query SearchSuppliers($keywords: String!, $limit: Int = 30, $filter: SupplierSearchFilter) {
  supplierSearch(first: $limit, query: {keywords: $keywords, filter: $filter}) {
    ...UsersPageSearchSupplierConnectionFragment
    __typename
  }
}
    ${UsersPageSearchSupplierConnectionFragmentFragmentDoc}`;

/**
 * __useSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuppliersQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuppliersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables> & ({ variables: SearchSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
      }
export function useSearchSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
export function useSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
export type SearchSuppliersQueryHookResult = ReturnType<typeof useSearchSuppliersQuery>;
export type SearchSuppliersLazyQueryHookResult = ReturnType<typeof useSearchSuppliersLazyQuery>;
export type SearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useSearchSuppliersSuspenseQuery>;
export type SearchSuppliersQueryResult = ApolloReactCommon.QueryResult<SearchSuppliersQuery, SearchSuppliersQueryVariables>;
export const UsersPageSearchUsersDocument = gql`
    query UsersPageSearchUsers($query: UserSearchInput!, $limit: Int, $after: String) {
  userSearch(first: $limit, after: $after, query: $query) {
    ...UsersPageUserSearchConnectionFragment
  }
}
    ${UsersPageUserSearchConnectionFragmentFragmentDoc}`;

/**
 * __useUsersPageSearchUsersQuery__
 *
 * To run a query within a React component, call `useUsersPageSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUsersPageSearchUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables> & ({ variables: UsersPageSearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
      }
export function useUsersPageSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
        }
export function useUsersPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
        }
export type UsersPageSearchUsersQueryHookResult = ReturnType<typeof useUsersPageSearchUsersQuery>;
export type UsersPageSearchUsersLazyQueryHookResult = ReturnType<typeof useUsersPageSearchUsersLazyQuery>;
export type UsersPageSearchUsersSuspenseQueryHookResult = ReturnType<typeof useUsersPageSearchUsersSuspenseQuery>;
export type UsersPageSearchUsersQueryResult = ApolloReactCommon.QueryResult<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>;